// --- Execution Guard ---
if (window.variantBuilderScriptLoaded) {
    console.warn("variant-builder.js: Script already loaded. Halting redundant execution.");
} else {
    window.variantBuilderScriptLoaded = true;
    // console.log("variant-builder.js: First execution flag set.");

    // console.log('variant-builder.js: Script start V2.18.00 - Phase 1'); // Updated version marker

    // --- Global State and Configuration ---
    let buildState = {
step: 1, buildType: null, ridingStyle: null, ridingStyleDisplay: null,
spokeInterface: null,       // I9-SYSTEM: null until the customer chooses in Step 1, then 'standard' (classic J-Bend / Straight Pull) or 'system' (Industry Nine System)
system: null,               // I9-SYSTEM: { v:1, studioOpened, studio } for System builds, null otherwise (see assets/i9-system.js)
standardStudio: null,       // STANDARD-STUDIO: { v:1, studioOpened, studio, wheels } for Standard builds that use the Studio (see assets/standard-studio.js)
customerSupplied: {
    front: { rim: false, hub: false },
    rear: { rim: false, hub: false },
},
tubelessTapeInstalled: true,
estimatedLeadTime: 0,
specs: { // MODIFIED KEYS HERE
            frontWheelSize: null, rearWheelSize: null,
            frontSpokeCount: null, rearSpokeCount: null,
            brakeStyle: null,
            frontHubSpacing: null, // Was frontAxle
            rearHubSpacing: null,  // Was rearAxle
            freehubType: null,    // Was freehub
            systemHub: null       // I9-SYSTEM: 'Hydra2' | 'Solix' for System builds
        },
        components: { frontRim: null, rearRim: null, frontHub: null, rearHub: null, frontSpokes: null, rearSpokes: null, frontNipples: null, rearNipples: null, frontValveStem: null, rearValveStem: null, rearComponentFreehub: null },
        selectedOptionalAddons: {}, // Stores selected addons, keyed for uniqueness
        subtotal: 0, buildId: `${Math.floor(100000 + Math.random() * 900000)}`,
        _ui: {
            step2AutoSelected: {},
            hasProgressedPastStep1: false,
            activeVendor: {
                frontRim: null, rearRim: null,
                frontHub: null, rearHub: null,
                frontSpokes: null, rearSpokes: null,
                frontNipples: null, rearNipples: null,
                frontValveStem: null, rearValveStem: null
            },
            showRimBrakeRims: false,
            isChangingComponent: null,
            valveStemExplicitlyRemoved: { front: false, rear: false },
            hasChanges: false,
            originalCartItemKeys: null,
            inEditMode: false, 
            qbMaterial: 'Aluminum',
            qbGoal: 'Best Value',
            qbFrontDepthMin: 0,
            qbFrontDepthMax: 35,
            qbRearDepthMin: 0,
            qbRearDepthMax: 35
        }
    };
    const config = { storefrontApiToken: null };
    // Near line 40, with the other cache variables
    let allRimProductsCache = []; let allHubProductsCache = []; let allSpokeProductsCache = []; let allNippleProductsCache = []; let allValveStemProductsCache = []; let allFreehubComponentProductsCache = []; let vendorLogoMap = {};
    let preconfiguredPriceCache = {};

    // --- Spacing Normalization Helper ---
const normalizeSpacing = (str) => {
    if (!str) return "";
    return str.toString()
        .replace(/[\u00D7\u2715]/g, 'x') // Replace multiplication signs (×) with regular x
        .replace(/\s+/g, ' ')           // Collapse multiple spaces into one
        .trim()
        .toLowerCase();
};

// --- Freehub Translation Dictionary ---
const FREEHUB_EQUIVALENCE = {
    "SRAM XD": ["XD", "SRAM XD"],
    "XD": ["XD", "SRAM XD"],
    "SRAM XDR": ["XD-R", "XDR", "SRAM XDR"],
    "XDR": ["XD-R", "XDR", "SRAM XDR"],
    "Shimano HG": ["HG", "Shimano HG"],
    "HG": ["HG", "Shimano HG"],
    "Shimano HG Road": ["HG-R", "HGR", "Shimano HG Road"],
    "HG-R": ["HG-R", "HGR", "Shimano HG Road"],
    "Shimano MicroSpline": ["MS", "MicroSpline", "Shimano MicroSpline", "Shimano MS"],
    "MS": ["MS", "MicroSpline", "Shimano MicroSpline", "Shimano MS"],
    "Shimano MicroSpline Road": ["MS-R", "MSR", "Shimano MicroSpline Road"],
    "MS-R": ["MS-R", "MSR", "Shimano MicroSpline Road"],
    "Campy 11/12s": ["Campy", "Campagnolo", "Campy 11/12s"],
    "Campy N3W": ["N3W", "Campy N3W", "Campagnolo N3W"]
};

const isFreehubCompatible = (requestedType, hubAvailableArray) => {
    if (!requestedType) return true; 
    if (!hubAvailableArray || !Array.isArray(hubAvailableArray)) return false;
    const validBackendStrings = FREEHUB_EQUIVALENCE[requestedType] || [requestedType];
    return hubAvailableArray.some(avail => validBackendStrings.includes(avail));
};

    let updateQuickBuildAvailability;

    // --- DEBUGGING EXPOSURE (Add this) ---
    window.debugBuilder = {
        get rims() { return allRimProductsCache; },
        get state() { return buildState; }
    };

const DISCOUNT_CONFIG = {
    ITEM_COUNT_GOAL: 8,
    ITEM_COUNT_NUDGE_START: 6,
    DISCOUNT_PERCENTAGE: 10,
    DISCOUNT_CODE: 'LOAMLABS10',
    SYSTEM_DISCOUNT_CODE: 'SYSTEM10' // the store's separate automatic 10% for System builds (Shopify shows it under this name in the cart and at checkout)
};
  
const LEAD_TIME_CONFIG = {
    // Your standard in-house build time in business days.
    BUILD_TIME_DAYS: 3
};
    
/**
 * Checks for a 'prebuild' hash in the URL on page load.
 * If found, decompresses the data and merges it into the initial buildState.
 * @returns {boolean} - Returns true if a prebuild hash was handled, otherwise false.
 */
const handlePrebuildState = () => {
  if (window.location.hash && window.location.hash.startsWith('#prebuild=')) {
    console.log('%c[Builder] Found #prebuild hash in URL.', 'color: #03a9f4; font-weight: bold;');
    const encodedData = window.location.hash.substring(10);
    history.replaceState(null, document.title, window.location.pathname + window.location.search);

    try {
      const decodedDataString = decodeURIComponent(encodedData.replace(/\+/g, ' '));
      console.log('[Builder] Decoded Data String:', decodedDataString);

      if (!decodedDataString || decodedDataString.trim() === '{}') {
        console.warn("Pre-build data from URL was empty ('{}'). Ignoring. Check product page Liquid template.");
        return false;
      }
      
      const prebuildState = JSON.parse(decodedDataString);
      console.log('[Builder] Parsed Pre-build State Object:', prebuildState);

      // PRESET-BUILDS: a System preset from a product page (assets/preset-builds.js). Interface, specs and the preset block are adopted; Step 2 opens next (see the init sequence).
      const presetClean = window.PresetBuilds ? window.PresetBuilds.fromPrebuild(prebuildState) : null;
      if (presetClean && window.PresetBuilds.adopt(presetClean)) { updateStep1VisualFeedback(); validateStep1(); return true; }

      if (prebuildState && (prebuildState.selections || prebuildState.startComponent)) {
        if (prebuildState.selections && prebuildState.selections.step1) {
            buildState.ridingStyle = prebuildState.selections.step1.ridingStyle || null;
            buildState.ridingStyleDisplay = prebuildState.selections.step1.ridingStyleDisplay || null;
            buildState.buildType = prebuildState.selections.step1.buildType || null;
        }
        if (prebuildState.selections && prebuildState.selections.step2) {
          // [DEBUG] Log the state of specs BEFORE the assignment
          console.log('%c[DEBUG] buildState.specs BEFORE assignment:', 'color: #orange;', JSON.parse(JSON.stringify(buildState.specs)));
          console.log('%c[DEBUG] Incoming prebuildState.selections.step2:', 'color: #orange;', prebuildState.selections.step2);

          if (Array.isArray(prebuildState.selections.step2.brakeStyle)) {
            prebuildState.selections.step2.brakeStyle = prebuildState.selections.step2.brakeStyle[0];
          }
          Object.assign(buildState.specs, prebuildState.selections.step2);

          // [DEBUG] Log the state of specs AFTER the assignment
          console.log('%c[DEBUG] buildState.specs AFTER assignment:', 'color: #00A36C;', JSON.parse(JSON.stringify(buildState.specs)));
        }
        if (prebuildState.startComponent) {
          buildState.startComponent = prebuildState.startComponent;
        }
        
        buildState.spokeInterface = 'standard'; // I9-SYSTEM: "Build with this" links come from Standard products and carry no interface: Standard is preselected (every other arrival has none selected)

        console.log("Pre-build state successfully loaded. Final buildState:", buildState);

        updateStep1VisualFeedback();
        validateStep1();

        return true;
      } else {
        console.warn("Parsed pre-build data was invalid. Ignoring.");
        return false;
      }
    } catch (error) {
      console.error('Failed to parse pre-build state from URL hash:', error);
    }
  }

  return false;
};

    let componentFetchPromises = {
        rims: null,
        hubs: null,
        spokes: null,
        nipples: null,
        valves: null,
        freehubs: null
        // Rims are handled by their own loadAndFilterRims logic for now
    };

    let step3PreRenderPromise = null;

    const PLACEHOLDER_PRODUCT_VARIANT_ID = 'gid://shopify/ProductVariant/51500432228659'; // LoamLabs Custom Wheel Build (for line item properties)

    const BERD_HUB_INSERTS_PRODUCT_VARIANT_ID = '51500644598067'; // Numeric ID: 51500644598067
    const BERD_HUB_INSERTS_PRICE = 64.99; // Price in dollars for display/subtotal calc

    const ASSEMBLY_SERVICE_VARIANT_IDS_MAP = { // Maps conceptual price to actual GID
        '20.00': 'gid://shopify/ProductVariant/51777290764595',
        '30.00': 'gid://shopify/ProductVariant/51777290797363',
        '40.00': 'gid://shopify/ProductVariant/51504906535219',
        '50.00': 'gid://shopify/ProductVariant/51504906567987',
        '60.00': 'gid://shopify/ProductVariant/51504906600755', // Default
        '70.00': 'gid://shopify/ProductVariant/51504906633523',
        '80.00': 'gid://shopify/ProductVariant/51504906666291',
        '90.00': 'gid://shopify/ProductVariant/52391641219379',
        '100.00': 'gid://shopify/ProductVariant/51786323165491',
        '120.00': 'gid://shopify/ProductVariant/51568864887091'
    };

    const ASSEMBLY_SERVICE_PRICES_BY_GID = { // Maps GID to price in dollars
        'gid://shopify/ProductVariant/51777290764595': 20.00,
        'gid://shopify/ProductVariant/51777290797363': 30.00,
        'gid://shopify/ProductVariant/51504906535219': 40.00,
        'gid://shopify/ProductVariant/51504906567987': 50.00,
        'gid://shopify/ProductVariant/51504906600755': 60.00,
        'gid://shopify/ProductVariant/51504906633523': 70.00,
        'gid://shopify/ProductVariant/51504906666291': 80.00,
        'gid://shopify/ProductVariant/52391641219379': 90.00,
        'gid://shopify/ProductVariant/51786323165491': 100.00,
        'gid://shopify/ProductVariant/51568864887091': 120.00
    };

    // I9-SYSTEM (round 9): assembly is free on a System wheel set whose wheel has an Industry Nine alloy rim. The $0.00 variant of the Assembly Service product
    // ("Price" option value 0.00, price 0.00) was added in the store by Agent C. While this is empty the rule is off and every wheel is priced as before.
    // ON again (round 10): the store's SYSTEM10 automatic discount (minimum 6 counted items, $0.00 lines are not counted) covers a System set with free assembly.
    const FREE_ASSEMBLY_VARIANT_GID = 'gid://shopify/ProductVariant/67810649014579';
    if (FREE_ASSEMBLY_VARIANT_GID) { ASSEMBLY_SERVICE_VARIANT_IDS_MAP['0.00'] = FREE_ASSEMBLY_VARIANT_GID; ASSEMBLY_SERVICE_PRICES_BY_GID[FREE_ASSEMBLY_VARIANT_GID] = 0.00; }
    const DEFAULT_ASSEMBLY_SERVICE_VARIANT_GID = ASSEMBLY_SERVICE_VARIANT_IDS_MAP['60.00'];
    const SINGLE_WHEEL_ASSEMBLY_GID = ASSEMBLY_SERVICE_VARIANT_IDS_MAP['100.00']; // --- NEW: Constant for the single wheel build charge


    const HUB_VENDOR_TO_ASSEMBLY_VARIANT_GID_MAP = {
    // Use lowercase hub vendor names from product data
    'chris king': ASSEMBLY_SERVICE_VARIANT_IDS_MAP['80.00'],
    'erase components': ASSEMBLY_SERVICE_VARIANT_IDS_MAP['80.00'],
    'hope': ASSEMBLY_SERVICE_VARIANT_IDS_MAP['70.00'],
    'industry nine': ASSEMBLY_SERVICE_VARIANT_IDS_MAP['40.00'],
    'oneup': ASSEMBLY_SERVICE_VARIANT_IDS_MAP['80.00'],
    'onyx racing': ASSEMBLY_SERVICE_VARIANT_IDS_MAP['80.00'],
    'spank': ASSEMBLY_SERVICE_VARIANT_IDS_MAP['70.00'],
    'tairin': ASSEMBLY_SERVICE_VARIANT_IDS_MAP['70.00'],
    'tune': ASSEMBLY_SERVICE_VARIANT_IDS_MAP['80.00'],
    'your own component': ASSEMBLY_SERVICE_VARIANT_IDS_MAP['120.00']
}; 

// --- Add this entire block for Rim Vendor specific assembly costs ---
const RIM_VENDOR_TO_ASSEMBLY_VARIANT_GID_MAP = {
    // Use lowercase rim vendor names from product data
    'nobl': ASSEMBLY_SERVICE_VARIANT_IDS_MAP['80.00'],
    'reserve': ASSEMBLY_SERVICE_VARIANT_IDS_MAP['50.00'],
    'we are one': ASSEMBLY_SERVICE_VARIANT_IDS_MAP['40.00'],
    'your own component': ASSEMBLY_SERVICE_VARIANT_IDS_MAP['120.00'],
    // Add other specific rim vendors here in the future
};
  
    const REQUIRED_ADDONS_CONFIG = {
        'Berd Hub Inserts': {
            condition: (selectedHub, selectedSpokeVendor) => {
                return selectedSpokeVendor === 'Berd' && selectedHub && selectedHub.tags && !selectedHub.tags.includes('Berd_insert_not_required') && !selectedHub.tags.includes('hub_type:hook_flange');
            },
            variantGid: `gid://shopify/ProductVariant/${BERD_HUB_INSERTS_PRODUCT_VARIANT_ID}`, // Use GID format
            price: BERD_HUB_INSERTS_PRICE, // Price in dollars
            name: 'Berd Hub Inserts'
        }
    };
    // --- END: CART INTEGRATION & ASSEMBLY SERVICE CONFIGURATION ---

    // --- START: CONSTANTS FOR SAVE/LOAD FUNCTIONALITY ---
    const SAVED_BUILDS_INDEX_KEY = 'loamlabs_saved_builds_index';
    const SAVED_BUILD_PREFIX = 'loamlabs_saved_build_';
    const LAST_ACTIVE_BUILD_KEY = 'loamlabs_active_build_progress';
    // --- END: CONSTANTS ---
  
    // --- DOM Element Variables (Declare ONCE) ---
    let builderContainer, step1NextButton, step2NextButton, step3AddToCartButton, summaryContainer, subtotalValueElement, summaryContentElement;
    let frontRimFilters, frontRimLoading, frontRimError, frontRimOptionsContainer, frontRimImageContainer;
    let rearRimFilters, rearRimLoading, rearRimError, rearRimOptionsContainer, rearRimImageContainer;
    let frontHubOptionsContainer, frontHubFilters, frontHubLoading, frontHubError, frontHubImageContainer;
    let rearHubOptionsContainer, rearHubFilters, rearHubLoading, rearHubError, rearHubImageContainer;
    let frontSpokesOptionsContainer, frontSpokesFilters, frontSpokesLoading, frontSpokesError, frontSpokesImageContainer;
    let rearSpokesOptionsContainer, rearSpokesFilters, rearSpokesLoading, rearSpokesError, rearSpokesImageContainer;
    let frontNipplesOptionsContainer, frontNipplesFilters, frontNipplesLoading, frontNipplesError, frontNipplesImageContainer;
    let rearNipplesOptionsContainer, rearNipplesFilters, rearNipplesLoading, rearNipplesError, rearNipplesImageContainer;
    let frontValveStemOptionsContainer, frontValveStemFilters, frontValveStemLoading, frontValveStemError, frontValveStemImageContainer, removeFrontValveStemButton;
    let rearValveStemOptionsContainer, rearValveStemFilters, rearValveStemLoading, rearValveStemError, rearValveStemImageContainer, removeRearValveStemButton;
    let addonsModal, addonsModalTitle, addonsModalBody, addonsModalCloseBtn, addonsModalDoneBtn;
    let quickSpecAdjustersContainer, step3RefreshOverlay;
    let specChangeModal, specChangeModalTitle, specChangeModalBody, specChangeModalCloseBtn, specChangeModalCancelBtn, specChangeModalConfirmBtn;
    let _tempActionAfterSpecChange = null;
    let stickyFooter, stickySubtotal, stickyWeight, stickyDetailsBtn, stickyDrawer, stickyDrawerOverlay, stickyDrawerCloseBtn, stickyDrawerBody, stickyAddToCartBtn;

    // console.log('variant-builder.js: Initial buildState defined:', JSON.parse(JSON.stringify(buildState)));

/**
 * Gathers all unique masterVariantGids from rim rules and fetches their prices in a single API call.
 */
async function cachePreconfiguredPrices() {
   if (allRimProductsCache.length === 0) {
        console.log("cachePreconfiguredPrices: Rim cache is empty, cannot fetch prices.");
        return;
    }

    const uniqueVariantGids = new Set();
    allRimProductsCache.forEach(rim => {
        if (rim.preconfiguredRules && rim.preconfiguredRules.length > 0) {
            rim.preconfiguredRules.forEach(rule => {
                if (rule.masterVariantGid) {
                    uniqueVariantGids.add(rule.masterVariantGid);
                }
            });
        }
    });

    const gidsToFetch = Array.from(uniqueVariantGids);
    if (gidsToFetch.length === 0) {
        return;
    }

    console.log(gidsToFetch);

    const query = `
      query getVariantPrices($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on ProductVariant {
            id
            price { amount }
            availableForSale
          }
        }
      }
    `;

    try {
        const data = await storefrontApiQuery(query, { ids: gidsToFetch });
        if (data && data.nodes) {
            data.nodes.forEach(variantNode => {
                if (variantNode && variantNode.price) {
                    // PRECONFIGURED-RULES: a master that is not available for sale gets no price, so its rule is skipped (normal parts pricing)
                    const cents = window.PreconfiguredRules ? window.PreconfiguredRules.priceFromNode(variantNode) : parseFloat(variantNode.price.amount) * 100;
                    if (typeof cents === 'number') preconfiguredPriceCache[variantNode.id] = cents; else delete preconfiguredPriceCache[variantNode.id];
                }
            });
        }
        console.log(preconfiguredPriceCache);
    } catch (error) {
    }
}

// --- START: ALL FUNCTION DEFINITIONS ---

    // --- START: WHEEL WEIGHT CALCULATION ENGINE ---

/**
 * Performs the geometric spoke length calculation. Ported from spoke-calculator.js.
 * This version is for weight estimation and does not account for stretch.
 * @param {object} params - Object containing all geometric parameters.
 * @returns {number} The calculated geometric spoke length in mm.
 */
function calculateGeometricSpokeLength(params) {
    // Destructure all required variables from the params object
    const { hubType, crossPattern, spokeCount, erd, hubFlangeDiameter, flangeOffset, spOffset = 0, hubSpokeHoleDiameter = 2.6 } = params;

    // Ensure all critical numbers are valid before proceeding
    if ([crossPattern, spokeCount, erd, hubFlangeDiameter, flangeOffset].some(val => typeof val !== 'number' || isNaN(val))) {
        console.warn("calculateGeometricSpokeLength: Missing critical geometric data.", params);
        return 0;
    }

    let effectiveCrossPattern = crossPattern;
    // Straight pull hubs effectively add a half-cross to the geometric pattern
    if (hubType === 'Straight Pull' && crossPattern > 0) {
        effectiveCrossPattern += 0.5;
    }

    const angle = (2 * Math.PI * effectiveCrossPattern) / (spokeCount / 2);
    const term1 = Math.pow(flangeOffset, 2);
    const term2 = Math.pow(hubFlangeDiameter / 2, 2);
    const term3 = Math.pow(erd / 2, 2);
    const term4 = 2 * (hubFlangeDiameter / 2) * (erd / 2) * Math.cos(angle);

    const geometricLength = Math.sqrt(term1 + term2 + term3 - term4);

    let finalLength;
    if (hubType === 'Classic Flange' || hubType === 'Hook Flange') {
        finalLength = geometricLength - (hubSpokeHoleDiameter / 2);
    } else { // Straight Pull
        finalLength = geometricLength + spOffset;
    }
    return finalLength > 0 ? finalLength : 0;
}

/**
 * Extrapolates the weight of a single spoke based on its calculated length.
 * @param {number} baseWeightG - The manufacturer's weight for a reference spoke (in grams).
 * @param {number} calculatedLengthMm - The actual length needed for the wheel.
 * @param {number} [baseLengthMm=260] - The length of the reference spoke (e.g., 260mm).
 * @returns {number} The extrapolated weight for one spoke of the calculated length.
 */
function extrapolateSpokeWeight(baseWeightG, calculatedLengthMm, baseLengthMm = 260) {
    if (!baseWeightG || !calculatedLengthMm || baseLengthMm === 0) {
        return 0;
    }
    // Simple ratio calculation: (actual length / base length) * base weight
    return (calculatedLengthMm / baseLengthMm) * baseWeightG;
}

function isLacingPossible(spokeCount, crossPattern) {
    if (crossPattern === 0) return true;
    if (!spokeCount || spokeCount < 4) return false;
    const angleBetweenHoles = 360 / (spokeCount / 2);
    const lacingAngle = crossPattern * angleBetweenHoles;
    return lacingAngle < 90;
}

/**
 * Determines the cross pattern for weight estimation.
 * Defaults to Radial (0) for Front Rim Brake wheels.
 */
function getEstimatedCrossPattern(hubProduct, hubVariantData, spokeCount, position, brakeStyle) {
    if (!hubProduct || !spokeCount) return 3; // Fallback

    const lacingPolicy = hubProduct.hub_lacing_policy?.value;

    // PRIORITY 1: Manual Override Field (Respects your specific hub settings first)
    if (lacingPolicy === 'Use Manual Override Field') {
        const manualCross = hubVariantData?.hub_manual_cross_value?.value;
        if (manualCross) return parseFloat(manualCross);
    }

    // PRIORITY 2: Specific Lacing Policies
    if (lacingPolicy === 'Force 2-Cross for 28h Only' && spokeCount === 28) return 2;
    if (lacingPolicy === 'Force 3-Cross for 28h Only' && spokeCount === 28) return 3;
    if (lacingPolicy === 'Force All as 2-Cross') return 2;

    // PRIORITY 3: Front Rim Brake Default (RADIAL - ONLY for low spoke counts)
    // We only assume Radial if it's a front wheel, rim brake, and 24 holes or less.
    const numericSpokeCount = parseInt(spokeCount);
    if (position === 'Front' && brakeStyle === 'Rim Brake' && numericSpokeCount <= 24) {
        return 0; 
    }

    // PRIORITY 4: Standard / No Policy -> Calculate Max Possible
    const possibleCrosses = [4, 3, 2, 1, 0];
    for (const cross of possibleCrosses) {
        if (isLacingPossible(spokeCount, cross)) {
            return cross;
        }
    }

    return 3; // Final fallback
}
// --- END: WHEEL WEIGHT CALCULATION ENGINE ---

/**
 * Calculates total weight including Valves, Tape, and dynamic Spoke calculations.
 * Also updates the Spoke UI text with the calculated values.
 */
function calculateTotalEstimatedWeight() {
    const TAPE_WEIGHT_G = 10;
    const weights = { front: 0, rear: 0, total: 0 };
    const { components, buildType, specs } = buildState;
    
    // Debug Groups help keep console clean
    // console.groupCollapsed("⚖️ Weight Calc Detail"); 

    const positionsToCalculate = [];
    if (buildType === 'Front' || buildType === 'Wheel Set') positionsToCalculate.push('Front');
    if (buildType === 'Rear' || buildType === 'Wheel Set') positionsToCalculate.push('Rear');

    for (const position of positionsToCalculate) {
        const posLower = position.toLowerCase();
        let positionWeight = 0;

        const rim = components[`${posLower}Rim`];
        const hub = components[`${posLower}Hub`];
        const nipples = components[`${posLower}Nipples`];
        const valves = components[`${posLower}ValveStem`];
        const spokeCount = specs[`${posLower}SpokeCount`] ? parseInt(specs[`${posLower}SpokeCount`], 10) : 0;

        // 1. Add Component Weights
        positionWeight += rim?.weight_g || 0;
        positionWeight += hub?.weight_g || 0;
        positionWeight += valves?.weight_g || 0; // Valve Weight

        if (rim && buildState.tubelessTapeInstalled) {
            positionWeight += TAPE_WEIGHT_G;
        }

        if (nipples?.weight_g && spokeCount > 0) {
            positionWeight += nipples.weight_g * spokeCount;
        }
        if (position === 'Rear' && components.rearComponentFreehub) {
            positionWeight += components.rearComponentFreehub.weight_g || 0;
        }

        // 2. Calculate Spokes
        const spokes = components[`${posLower}Spokes`];
        let displaySpokeText = null;

        if (spokes?.weight_g && rim && hub && spokeCount > 0) {
            const hubProduct = allHubProductsCache.find(p => p.id === hub.productId);
            // Use Variant ERD if available, else Product ERD
            const erd = rim.rim_erd ? parseFloat(rim.rim_erd) : NaN;
            
            const pcdL = hubProduct?.hub_flange_diameter_left ? parseFloat(hubProduct.hub_flange_diameter_left) : NaN;
            const pcdR = hubProduct?.hub_flange_diameter_right ? parseFloat(hubProduct.hub_flange_diameter_right) : NaN;
            const flangeL = hubProduct?.hub_flange_offset_left ? parseFloat(hubProduct.hub_flange_offset_left) : NaN;
            const flangeR = hubProduct?.hub_flange_offset_right ? parseFloat(hubProduct.hub_flange_offset_right) : NaN;
            
            const hasAllGeoData = !isNaN(erd) && !isNaN(pcdL) && !isNaN(pcdR) && !isNaN(flangeL) && !isNaN(flangeR);

            // I9-SYSTEM: LENGTH-CALC HOOK. System spoke lengths are not calculated yet (waiting on Industry Nine); for System builds the
            // geometric estimate below is skipped and the label is per-spoke weight x spoke count. Plug the System length calculation in here later.
            if (hubProduct && hasAllGeoData && !window.I9System?.isSystem()) {
                const hubVariantData = hubProduct.variants.find(v => v.id === hub.variantId);
                const hubTags = hubProduct.tags || [];
                const hubType = hubTags.includes('hub_type:straight_pull') ? 'Straight Pull' : (hubTags.includes('hub_type:hook_flange') ? 'Hook Flange' : 'Classic Flange');
                const crossPatternToUse = getEstimatedCrossPattern(hubProduct, hubVariantData, spokeCount, position, specs.brakeStyle);
                
                const spOffsetL = hubVariantData?.hub_sp_offset_spoke_hole_left ? parseFloat(hubVariantData.hub_sp_offset_spoke_hole_left) : 0;
                const spOffsetR = hubVariantData?.hub_sp_offset_spoke_hole_right ? parseFloat(hubVariantData.hub_sp_offset_spoke_hole_right) : 0;
                const avgPCD = (pcdL + pcdR) / 2;
                const avgFlangeOffset = (flangeL + flangeR) / 2;
                const avgSpOffset = (spOffsetL + spOffsetR) / 2;
                
                const estimatedLength = calculateGeometricSpokeLength({
                    hubType: hubType, crossPattern: crossPatternToUse,
                    spokeCount: spokeCount, erd: erd, hubFlangeDiameter: avgPCD, 
                    flangeOffset: avgFlangeOffset, spOffset: avgSpOffset,
                    hubSpokeHoleDiameter: parseFloat(hubProduct.hub_spoke_hole_diameter) || 2.6
                });

                if (estimatedLength > 0) {
                    const singleSpokeWeight = extrapolateSpokeWeight(spokes.weight_g, estimatedLength);
                    const totalSpokeWeight = singleSpokeWeight * spokeCount;
                    positionWeight += totalSpokeWeight;
                    
                    // --- CHANGED: Only showing Weight, NO LENGTH ---
                    displaySpokeText = `Wt: ${Math.round(totalSpokeWeight)}g`;
                } else {
                     // Fallback
                     displaySpokeText = `Wt: ${(spokes.weight_g * spokeCount).toFixed(0)}g`;
                }
            } else {
                // Fallback
                displaySpokeText = `Wt: ${(spokes.weight_g * spokeCount).toFixed(0)}g`;
            }
        }

        // 3. Update Spoke UI directly
        if (displaySpokeText && /NaN|Infinity/.test(displaySpokeText)) displaySpokeText = null; // never show "Wt: NaNg"
        const spokeContainer = document.getElementById(`${posLower}-spokes-image-container`);
        if (spokeContainer && displaySpokeText) {
            const weightDiv = spokeContainer.querySelector('.selected-component-weight-display');
            if (weightDiv) {
                weightDiv.innerHTML = displaySpokeText;
                weightDiv.style.display = '';
            }
        }

        weights[posLower] = positionWeight;
    }

    // console.groupEnd();
    weights.total = weights.front + weights.rear;
    return weights;
}

    // --- Error Display ---
    function displayInitializationError(message) { const targetElement=document.getElementById('step-0')||builderContainer||document.body; const messageElement=targetElement.querySelector?.('.error-message'); if(messageElement){messageElement.textContent=message; targetElement.style.display='flex'; targetElement.style.flexDirection='column'; targetElement.style.alignItems='center'; document.querySelectorAll('.builder-step[data-step="1"], .builder-step[data-step="2"], .builder-step[data-step="3"]').forEach(s=>s.style.display='none'); if(summaryContainer)summaryContainer.style.display='none';}else{(builderContainer||document.body).innerHTML=`<div style="color: red; border: 1px solid red; padding: 15px; text-align: center;">${message}</div>`;} console.error("BUILDER INIT ERROR:", message); }

    // --- Function to save buildState (local storage for anonymous, customer metafields for logged in) ---
async function saveBuildState(buildId, fullStateObject) {
    if (!buildId || !fullStateObject) {
        console.error("saveBuildState: Missing buildId or fullStateObject.");
        return;
    }
  
    const stateJson = JSON.stringify(fullStateObject);
    const MAX_LOCAL_STORAGE_SIZE = 5 * 1024 * 1024; // 5MB approx
    const MAX_METAFIELD_SIZE_BYTES = 5000; // Shopify's limit for a single string metafield value is around 5KB

    if (window.customerLoggedIn && Shopify.customer.id) {
        // For logged-in users, attempt to save to a customer metafield.
        // This requires a custom metafield definition in Shopify Admin:
        // Namespace: `custom`
        // Key: `saved_builds`
        // Type: `JSON string` (or `text line` if saving multiple as a larger JSON array of objects)
        // (If individual builds are large, you might need an app or a series of metafields)

        // Simplistic approach: Just save the latest build to a single metafield.
        // More complex: Fetch existing saved_builds, add/update current, save back.
        // This example assumes saving the *most recent* build to a specific metafield for simplicity.

        // Fetch current customer metafields
        // (You'd need a backend endpoint or a Shopify App to write customer metafields securely from the frontend)
        // As writing customer metafields directly from frontend JS is not straightforward/secure in Dawn theme.
        // For now, we will save to localStorage for *all* users, and you can implement metafield saving
        // with a server-side component later if cross-device persistence for logged-in users is critical.
        
        localStorage.setItem(`loamlabs_build_${buildId}`, stateJson);

    } else {
        // For anonymous users (and as a fallback for logged-in users for now), use localStorage
        try {
            if (stateJson.length * 2 > MAX_LOCAL_STORAGE_SIZE) { // Rough size estimate for UTF-16
                console.error(`Build state for ${buildId} is too large for localStorage.`);
                alert("Your custom build is very large and could not be saved to your browser for later editing. Please contact support.");
                return;
            }
            localStorage.setItem(`loamlabs_build_${buildId}`, stateJson);
        } catch (e) {
            console.error(`[SAVE_BUILD_STATE] Error saving build "${buildId}" to localStorage:`, e);
            alert("An error occurred while trying to save your build. Please contact support.");
        }
    }
}

// --- Function to retrieve buildState (from local storage primarily) ---
function retrieveBuildState(buildId) {
    if (!buildId) { // Check if buildId is empty or null
        return null;
    }

    // Try localStorage first (for anonymous users or as primary storage for all now)
    const localStorageKey = `loamlabs_build_${buildId}`;
    const storedState = localStorage.getItem(`loamlabs_build_${buildId}`);
    
    if (storedState) {
        try {
            const parsedState = JSON.parse(storedState);
            return parsedState;
        } catch (e) {
            console.error(`[RETRIEVE_BUILD_STATE] Error PARSING stored state for buildId: "${buildId}" from localStorage. Error:`, e);
            localStorage.removeItem(localStorageKey); // Clear invalid data
            return null;
        }
    }

    // If you implement customer metafields, you'd add fetch logic here:
    // if (window.customerLoggedIn && Shopify.customer.id) {
    //     // Add logic to fetch customer metafield here, requires backend or app.
    //     // Example: Fetch from /apps/your-app/api/customer-metafield?customer_id=...
    //     // For now, this branch is effectively skipped.
    // }

    return null;
}
  
    // --- START: SAVE/LOAD FUNCTIONS ---

function getCleanBuildStateForSaving() {
    // Creates a deep copy suitable for saving.
    const stateToSave = {
        step: buildState.step,
        buildType: buildState.buildType,
        ridingStyle: buildState.ridingStyle,
        ridingStyleDisplay: buildState.ridingStyleDisplay,
        spokeInterface: buildState.spokeInterface || null, // I9-SYSTEM: null only while Step 1 has no choice yet (an in-progress save); every build past Step 1 has one
        system: buildState.system ? (window.I9System?.snapshot() || JSON.parse(JSON.stringify(buildState.system))) : null, // I9-SYSTEM: Studio colors travel with Save / Resume / Share / _build (a System build also carries the wheel geometry and color hexes the cart page draws from)
        ...(window.StandardStudio?.snapshot() ? { standardStudio: window.StandardStudio.snapshot() } : {}), // STANDARD-STUDIO: the _build.standardStudio contract; the key is left out when no wheel has a Standard spoke product
        customerSupplied: { ...buildState.customerSupplied }, // <<< ADD THIS LINE
        specs: { ...buildState.specs },
        components: { ...buildState.components },
        selectedOptionalAddons: { ...buildState.selectedOptionalAddons },
        buildId: buildState.buildId,
        _ui: {
            activeVendor: buildState._ui.activeVendor,
            valveStemExplicitlyRemoved: buildState._ui.valveStemExplicitlyRemoved,
            step2AutoSelected: buildState._ui.step2AutoSelected || {}
        }
    };
    return stateToSave;
}

/**
 * Creates a minimal, lightweight version of the build state for analytics reporting.
 * This reduces the payload size to work reliably with navigator.sendBeacon.
 */
function getMinimalBuildStateForReporting() {
    // --- qbMaterial, qbGoal, and quickBuildGenerated extraction ---
    const { buildId, buildType, ridingStyleDisplay, subtotal, components, quickBuildGenerated } = buildState;
    const minimalState = {
        buildId, buildType, ridingStyleDisplay, subtotal,
        components: {
            front: [],
            rear: []
        },
        visitor: buildState.visitor || null,
        // --- Pass the tracking flag and the selected specs ---
        quickBuildGenerated: quickBuildGenerated || false,
        quickBuildGoal: quickBuildGenerated ? (buildState._ui.qbGoal || 'Best Value') : null,
        quickBuildMaterial: quickBuildGenerated ? (buildState._ui.qbMaterial || 'Aluminum') : null
    };

    const componentOrder = ['Rim', 'Hub', 'Spokes', 'Nipples', 'ValveStem'];
    const positions = [];
    if (buildType === 'Front' || buildType === 'Wheel Set') positions.push('front');
    if (buildType === 'Rear' || buildType === 'Wheel Set') positions.push('rear');

    positions.forEach(pos => {
        componentOrder.forEach(type => {
            const componentData = components[`${pos}${type}`];

            if (componentData && componentData.title) {
                let displayName = componentData.title; // Start with the product title

                // Use a switch statement for clarity and robustness
                switch (type) {
                    case 'Spokes':
                        // Spokes have a special 'selectedColor' property for a clean display
                        if (componentData.selectedColor) {
                            displayName += ` (${componentData.selectedColor})`;
                        }
                        break;
                    
                    // All other components can use a more generic approach based on their variant title or selected options
                    case 'Rim':
                    case 'Hub':
                    case 'Nipples':
                    case 'ValveStem':
                        // We prefer using selectedOptions for a cleaner, more reliable output
                        if (componentData.selectedOptions && componentData.selectedOptions.length > 0) {
                            const optionsString = componentData.selectedOptions
                                .map(opt => opt.value)
                                .filter(val => val && val.toLowerCase() !== 'default title' && val !== '-')
                                .join(' / ');
                            
                            if (optionsString) {
                                displayName += ` (${optionsString})`;
                            }
                        } 
                        // Fallback to the raw variantTitle if selectedOptions isn't available
                        else if (componentData.variantTitle) {
                            const variantParts = componentData.variantTitle.split(' / ').filter(part => part && part.toLowerCase() !== 'default title' && part !== '-');
                            if (variantParts.length > 0) {
                                displayName += ` (${variantParts.join(' / ')})`;
                            }
                        }
                        break;
                }
                
                minimalState.components[pos].push({
                    type: getDisplayName(type.toLowerCase()),
                    name: displayName
                });
            }
        });
    });

    return minimalState;
}

async function saveCurrentBuild() {
    console.log("saveCurrentBuild: Initiated.");
    if (buildState.step < 3 && !Object.values(buildState.components).some(c => c !== null)) {
        alert("Please select some components before saving your build.");
        return;
    }

    let buildName = prompt("Enter a name for your wheel build:", `My Build - ${new Date().toLocaleDateString()}`);
    if (buildName === null) { // User pressed cancel
        console.log("Save cancelled by user.");
        return;
    }
    buildName = buildName.trim() || `Saved Build - ${Date.now()}`;

    const newBuildId = `${Math.floor(100000 + Math.random() * 900000)}`;
    const stateToSave = getCleanBuildStateForSaving();
    
    // Assign the new ID to the state object we are saving AND the main buildState
    stateToSave.buildId = newBuildId;
    buildState.buildId = newBuildId; 
    
    // Use this new ID for all subsequent operations in this function
    const currentBuildId = newBuildId;

    try {
        // Save the full build state object
        saveBuildState(currentBuildId, stateToSave); // This uses your existing function

        // Update the index
        let savedBuildsIndex = [];
        const indexJson = localStorage.getItem(SAVED_BUILDS_INDEX_KEY);
        if (indexJson) {
            try {
                savedBuildsIndex = JSON.parse(indexJson);
                if (!Array.isArray(savedBuildsIndex)) savedBuildsIndex = [];
            } catch (e) {
                console.error("Error parsing saved builds index, resetting.", e);
                savedBuildsIndex = [];
            }
        }

        const existingEntryIndex = savedBuildsIndex.findIndex(b => b.id === currentBuildId);
        if (existingEntryIndex > -1) {
            savedBuildsIndex[existingEntryIndex].name = buildName;
            savedBuildsIndex[existingEntryIndex].timestamp = Date.now();
        } else {
            savedBuildsIndex.push({
                id: currentBuildId,
                name: buildName,
                timestamp: Date.now()
            });
        }

        // Sort by timestamp, newest first
        savedBuildsIndex.sort((a, b) => b.timestamp - a.timestamp);
        localStorage.setItem(SAVED_BUILDS_INDEX_KEY, JSON.stringify(savedBuildsIndex));

        // alert(`Build "${buildName}" saved!`);
        // console.log(`Build "${buildName}" (ID: ${currentBuildId}) saved successfully.`);

    } catch (error) {
        console.error("Error saving build:", error);
        alert("Could not save build. Check console for errors.");
    }
}

function renderSavedBuildsList() {
    if (!savedBuildsModalBody) return;
    savedBuildsModalBody.innerHTML = ''; // Clear previous list

    let savedBuildsIndex = [];
    const indexJson = localStorage.getItem(SAVED_BUILDS_INDEX_KEY);
    if (indexJson) {
        try {
            savedBuildsIndex = JSON.parse(indexJson);
            if (!Array.isArray(savedBuildsIndex)) savedBuildsIndex = [];
        } catch (e) { savedBuildsIndex = []; }
    }

    if (savedBuildsIndex.length === 0) {
        savedBuildsModalBody.innerHTML = '<p>No saved builds found.</p>';
        return;
    }

    const ul = document.createElement('ul');
    ul.className = 'saved-builds-list';
    savedBuildsIndex.forEach(buildEntry => {
        const li = document.createElement('li');
        li.className = 'saved-build-item';
        const dateString = new Date(buildEntry.timestamp).toLocaleString();
        li.innerHTML = `
            <div class="saved-build-info">
                <span class="saved-build-name">${buildEntry.name}</span>
                <span class="saved-build-date">Saved: ${dateString} (ID: ${buildEntry.id})</span>
            </div>
            <div class="saved-build-actions">
                <button type="button" class="button builder-button saved-build-load-btn" data-build-id="${buildEntry.id}">Load</button>
                <button type="button" class="button builder-button button--danger saved-build-delete-btn" data-build-id="${buildEntry.id}">Delete</button>
            </div>
        `;
        ul.appendChild(li);
    });
    savedBuildsModalBody.appendChild(ul);
}

async function loadBuildFromStorage(buildIdToLoad, isLastActiveResume = false) {
    const storageKey = isLastActiveResume ? LAST_ACTIVE_BUILD_KEY : `loamlabs_build_${buildIdToLoad}`;
    const retrievedStateString = localStorage.getItem(storageKey);

    if (!retrievedStateString) {
        alert("Could not find the saved build data.");
        if (isLastActiveResume) localStorage.removeItem(LAST_ACTIVE_BUILD_KEY);
        return false;
    }

    let loadedState;
    try {
        loadedState = JSON.parse(retrievedStateString);
    } catch (e) {
        alert("Error loading build: The saved data is corrupted.");
        if (isLastActiveResume) localStorage.removeItem(LAST_ACTIVE_BUILD_KEY);
        return false;
    }

    const loadingOverlay = document.getElementById('builder-edit-loading-overlay');
    if (loadingOverlay) loadingOverlay.style.display = 'flex';

    // Reset and merge state
    resetBuildStateToDefaults();
    
    // Deep copy the loaded state to safeguard nested properties
    const stateCopy = JSON.parse(JSON.stringify(loadedState));
    
    if (stateCopy._ui) {
        // Safe migration for legacy single-depth properties
        if (stateCopy._ui.qbDepthMin !== undefined && stateCopy._ui.qbFrontDepthMin === undefined) {
            stateCopy._ui.qbFrontDepthMin = stateCopy._ui.qbDepthMin;
            stateCopy._ui.qbFrontDepthMax = stateCopy._ui.qbDepthMax;
            stateCopy._ui.qbRearDepthMin = stateCopy._ui.qbDepthMin;
            stateCopy._ui.qbRearDepthMax = stateCopy._ui.qbDepthMax;
        }
    }

    Object.assign(buildState, stateCopy);
    buildState.spokeInterface = interfaceForLoadedBuild(stateCopy); // I9-SYSTEM

    // Safe-merge the UI state to preserve newly added properties
    if (stateCopy._ui) {
        buildState._ui = { ...buildState._ui, ...stateCopy._ui };
    }

    if(loadedState.specs) buildState.specs = { ...buildState.specs, ...loadedState.specs };
    if(loadedState.components) buildState.components = { ...buildState.components, ...loadedState.components };
    if(loadedState.selectedOptionalAddons) buildState.selectedOptionalAddons = { ...buildState.selectedOptionalAddons, ...loadedState.selectedOptionalAddons };
    if(loadedState._ui) buildState._ui = { ...buildState._ui, ...loadedState._ui };
    
    if(loadedState.customerSupplied) buildState.customerSupplied = { ...buildState.customerSupplied, ...loadedState.customerSupplied };

    // Ensure all promises are reset to allow re-fetching
    componentFetchPromises = { rims: null, hubs: null, spokes: null, nipples: null, valves: null, freehubs: null };

    // Update Step 1 and 2 UI immediately
    updateStep1VisualFeedback();
    validateStep1();
    renderStep2();
    updateStep2OptionsVisibility();
    updateStep2VisualFeedback();
    validateStep2();

    // Re-trigger all necessary data fetches in the background.
    triggerEarlyComponentFetches();

    // --- KEY CHANGE: REMOVED THE BLOCKING PROMISE.ALL() CALL ---
    // By calling showStep immediately, the UI for Step 3 will be rendered
    // and each component section will display its own "Loading..." message
    // while it awaits the data it needs. This eliminates the blank screen.
    await showStep(buildState.step);

    // --- Manually trigger lead time calculation after a build is loaded ---
    handleComponentChangeForLeadTime();

    // Final updates and cleanup are now handled within the showStep function
    if (isLastActiveResume) localStorage.removeItem(LAST_ACTIVE_BUILD_KEY);
    if (savedBuildsModal?.style.display !== 'none') savedBuildsModal.style.display = 'none';
    if (lastActiveBuildPromptModal?.style.display !== 'none') lastActiveBuildPromptModal.style.display = 'none';
    if (loadingOverlay) loadingOverlay.style.display = 'none';

    return true;
}

function deleteSavedBuild(buildIdToDelete) {
    if (!buildIdToDelete) return;
        if (!confirm(`Are you sure you want to delete build "${getBuildNameFromIndex(buildIdToDelete) || buildIdToDelete}"? This cannot be undone.`)) { // Improved prompt
            return;
        }

    localStorage.removeItem(`loamlabs_build_${buildIdToDelete}`); 
    let savedBuildsIndex = [];
    const indexJson = localStorage.getItem(SAVED_BUILDS_INDEX_KEY);
    if (indexJson) {
        try {
            savedBuildsIndex = JSON.parse(indexJson);
            if (!Array.isArray(savedBuildsIndex)) savedBuildsIndex = [];
        } catch (e) { savedBuildsIndex = []; }
    }

    const updatedIndex = savedBuildsIndex.filter(b => b.id !== buildIdToDelete);
    localStorage.setItem(SAVED_BUILDS_INDEX_KEY, JSON.stringify(updatedIndex));

    renderSavedBuildsList(); // Re-render the list in the modal
        alert(`Build "${getBuildNameFromIndex(buildIdToDelete) || buildIdToDelete}" deleted.`);
    }

    // Helper function to get build name for delete prompt (optional but nice)
    function getBuildNameFromIndex(buildId) {
        const indexJson = localStorage.getItem(SAVED_BUILDS_INDEX_KEY);
        if (indexJson) {
            try {
                const savedBuildsIndex = JSON.parse(indexJson);
                const entry = savedBuildsIndex.find(b => b.id === buildId);
                return entry ? entry.name : null;
            } catch (e) { return null; }
        }
        return null;
    }

const saveLastActiveBuild = debounce(() => {
    if (buildState.step === 1 && !buildState.buildType && !buildState.ridingStyle) {
        // Don't save an empty step 1 state
        return;
    }
    const stateToSave = getCleanBuildStateForSaving();
    // Add a display name for the "resume" prompt
    stateToSave._ui.buildNameForDisplay = `In-progress build from ${new Date().toLocaleTimeString()}`;
    
    try {
        localStorage.setItem(LAST_ACTIVE_BUILD_KEY, JSON.stringify(stateToSave));
        // console.log("Last active build progress saved.");
    } catch (e) {
        console.error("Error auto-saving last active build:", e);
    }
}, 1500); // Debounce for 1.5 seconds

async function checkForLastActiveBuildAndShowPrompt() { // Renamed and made async
        const lastActiveStateJson = localStorage.getItem(LAST_ACTIVE_BUILD_KEY);
        if (lastActiveStateJson) {
            try {
                const lastActiveState = JSON.parse(lastActiveStateJson);
                if (lastActiveState && lastActiveState.buildId && lastActiveState.step) {
                    if (lastActiveBuildPromptModal) {
                        lastActiveBuildPromptModal.style.display = 'flex';
                        return true; // Indicate prompt was shown
                    } else {
                    }
                } else {
                    localStorage.removeItem(LAST_ACTIVE_BUILD_KEY); 
                }
            } catch (e) {
                localStorage.removeItem(LAST_ACTIVE_BUILD_KEY);
            }
        }
        return false; // Indicate prompt was NOT shown
    }

// --- END: SAVE/LOAD FUNCTIONS ---
  
// --- Function to load build state from URL parameters (for "Edit" functionality) ---
function loadBuildFromUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    let buildIdFromUrl = urlParams.get('buildid') || urlParams.get('buildId');

    if (buildIdFromUrl && buildIdFromUrl !== "null") {
        try {
            const loadedState = retrieveBuildState(buildIdFromUrl);
            if (!loadedState) {
                console.warn(`[LOAD_FROM_URL] Build data not found for buildId: "${buildIdFromUrl}". Starting new build.`);
                return false;
            }

            // --- START: MERGE LOADED STATE and DISCOUNT STATE ---
            buildState.step = 3; // Force to step 3 for editing
            buildState.buildType = loadedState.buildType;
            
            // Restore all the saved properties
            buildState.ridingStyle = loadedState.ridingStyle;
            buildState.ridingStyleDisplay = loadedState.ridingStyleDisplay;
            buildState.spokeInterface = interfaceForLoadedBuild(loadedState); // I9-SYSTEM (a build that reached the cart always has its choice; a pre-System cart build has no key and reads as Standard)
            buildState.system = loadedState.system ? JSON.parse(JSON.stringify(loadedState.system)) : null; // I9-SYSTEM
            window.StandardStudio?.restore(loadedState.standardStudio); // STANDARD-STUDIO: Studio painting travels with Save / Resume / Share / edit from cart
            buildState.specs = { ...buildState.specs, ...loadedState.specs };
            buildState.buildId = loadedState.buildId;
            buildState.selectedOptionalAddons = { ...loadedState.selectedOptionalAddons };

            // Restore UI state

            // Restore UI state
            buildState._ui.activeVendor = loadedState._ui?.activeVendor || buildState._ui.activeVendor;
            buildState._ui.valveStemExplicitlyRemoved = loadedState._ui?.valveStemExplicitlyRemoved || buildState._ui.valveStemExplicitlyRemoved;
            buildState._ui.inEditMode = true; // Set edit mode flag
            buildState._ui.hasChanges = false;
            buildState._ui.step2AutoSelected = {};
            // --- END: MERGE LOADED STATE ---

            // Prune components based on the wheel type being edited
            const tempLoadedComponents = { ...loadedState.components };
            if (buildState.buildType === 'Front') {
                buildState.components = {
                    frontRim: tempLoadedComponents.frontRim, frontHub: tempLoadedComponents.frontHub,
                    frontSpokes: tempLoadedComponents.frontSpokes, frontNipples: tempLoadedComponents.frontNipples,
                    frontValveStem: tempLoadedComponents.frontValveStem,
                    rearRim: null, rearHub: null, rearSpokes: null, rearNipples: null, rearValveStem: null
                };
            } else if (buildState.buildType === 'Rear') {
                 buildState.components = {
                    rearRim: tempLoadedComponents.rearRim, rearHub: tempLoadedComponents.rearHub,
                    rearSpokes: tempLoadedComponents.rearSpokes, rearNipples: tempLoadedComponents.rearNipples,
                    rearValveStem: tempLoadedComponents.rearValveStem,
                    frontRim: null, frontHub: null, frontSpokes: null, frontNipples: null, frontValveStem: null
                };
            } else { // Wheel Set
                buildState.components = tempLoadedComponents;
            }

            // Update Step 1 visuals to reflect loaded state
            updateStep1VisualFeedback();
            validateStep1();

            // Prepare for Step 3
            buildState._ui.hasProgressedPastStep1 = true;
            triggerEarlyComponentFetches();
            handleComponentChangeForLeadTime();
            return true; // Indicate success

        } catch (e) {
            console.error('[LOAD_FROM_URL] Error processing build from URL:', e);
            return false;
        }
    }
    return false; // No buildId in URL
}

// --- Customer Supplied Modal Logic ---
let currentModalConfirmation = { component: null, position: null };

function showConsolidatedConfirmationModal() {
  const modal = document.getElementById('customer-supplied-modal');
  const title = document.getElementById('customer-supplied-modal-title');
  const body = document.getElementById('customer-supplied-modal-body');
  const confirmBtn = document.getElementById('customer-supplied-modal-confirm-btn');
  const checkbox = document.getElementById('customer-supplied-modal-checkbox');
  const checkboxLabel = document.getElementById('customer-supplied-modal-checkbox-label');

  let modalBodyHtml = '';
  const providingRim = buildState.customerSupplied.front.rim || buildState.customerSupplied.rear.rim;
  const providingHub = buildState.customerSupplied.front.hub || buildState.customerSupplied.rear.hub;

  if (providingRim) {
    modalBodyHtml += `
      <div class="modal-section">
        <h4>Regarding Your Rim(s):</h4>
        <p>Please ensure your rim is new or in excellent, undamaged condition. The build lead time begins after your rim is received and inspected by LoamLabs.</p>
      </div>`;
  }

  if (providingHub) {
    modalBodyHtml += `
      <div class="modal-section">
        <h4>Regarding Your Hub(s):</h4>
        <p>To ensure a successful build, <strong>you must include the correct end caps and the complete freehub body</strong> when you send us your hub. The build lead time begins after all parts are received and inspected.</p>
      </div>`;
  }
  
  title.textContent = "Please Confirm";
  body.innerHTML = modalBodyHtml;
  checkboxLabel.textContent = "I understand and will include all necessary parts.";
  
  checkbox.checked = false;
  confirmBtn.disabled = true;
  modal.style.display = 'flex';
}

function hideConfirmationModal() {
  const modal = document.getElementById('customer-supplied-modal');
  if (modal) modal.style.display = 'none';
}

// --- START: Dynamic Wheel Size Discovery ---
function generateDynamicWheelSizeButtons(position) {
    const container = document.getElementById(`${position}-wheel-size-container`);
    if (!container) return;
    if (window.I9System?.isSystem()) { window.I9System.generateStep2Buttons(position, 'size', container); return; } // I9-SYSTEM

    const posPascal = position.charAt(0).toUpperCase() + position.slice(1);
    const sizeMap = new Map(); // Maps a size (e.g., '29"') to a Set of supported riding styles
    const ridingStyle = buildState.ridingStyle;

    // Strict category definitions to prevent crossover (e.g., 700c showing up in MTB mode)
    const sizeStandardsMap = {
        gravelroad: ["700c", "650b"],
        mtb: ["29\"", "27.5\"", "32\"", "26\"", "24\"", "20\""]
    };

    // --- PHASE 1: Essential Standards (Instant Render) ---
    if (ridingStyle === 'mtb' || ridingStyle === 'hybrid') {
        sizeMap.set('29"', new Set(['mtb']));
        sizeMap.set('27.5"', new Set(['mtb']));
    }
    if (ridingStyle === 'gravelroad' || ridingStyle === 'hybrid') {
        sizeMap.set('700c', new Set(['gravelroad']));
        sizeMap.set('650b', new Set(['gravelroad']));
    }

    // --- PHASE 2: Dynamic Discovery (Add niche sizes like 32" from cache) ---
    if (allRimProductsCache.length > 0) {
        allRimProductsCache.forEach(product => {
            if (product.vendor === 'Your Own Component') return;
            
            // ISOLATION: Hide System components from the standard builder discovery
            if (product.tags && product.tags.includes('i9_system')) return;

            const styles = new Set();
            if (product.tags.includes('style:mtb')) styles.add('mtb');
            if (product.tags.includes('style:gravelroad')) styles.add('gravelroad');
            if (product.tags.includes('style:both') || styles.size === 0) {
                styles.add('mtb');
                styles.add('gravelroad');
            }

            product.variants.forEach(variant => {
                const positionMatch = (variant.spec_position === posPascal || variant.spec_position === "Front/Rear");
                if (positionMatch && variant.availableForSale) {
                    const sizeVal = variant.spec_rim_size?.parsedValue;
                    if (!sizeVal) return;
                    
                    const sizes = Array.isArray(sizeVal) ? sizeVal : [sizeVal];
                    sizes.forEach(s => {
                        // --- STRICT CATEGORY FILTERING ---
                        const otherStyle = ridingStyle === 'mtb' ? 'gravelroad' : 'mtb';
                        const isWrongStyle = ridingStyle !== 'hybrid' && 
                                             sizeStandardsMap[otherStyle]?.includes(s) && 
                                             !sizeStandardsMap[ridingStyle]?.includes(s);
                        
                        if (!isWrongStyle) {
                            if (!sizeMap.has(s)) sizeMap.set(s, new Set());
                            styles.forEach(style => sizeMap.get(s).add(style));
                        }
                    });
                }
            });
        });
    }

    // --- PHASE 3: Render ---
    const sortOrder = ['20"', '24"', '26"', '650b', '27.5"', '700c', '29"', '32"'];
    
    const discoveredSizes = Array.from(sizeMap.keys()).sort((a, b) => {
        let indexA = sortOrder.indexOf(a);
        let indexB = sortOrder.indexOf(b);
        if (indexA === -1) indexA = 999;
        if (indexB === -1) indexB = 999;
        if (indexA !== indexB) return indexA - indexB;
        return a.localeCompare(b); // Alphabetical fallback
    });

    container.innerHTML = discoveredSizes.map(size => {
        const stylesArray = Array.from(sizeMap.get(size));
        const stylesString = stylesArray.join('|');
        const isActive = buildState.specs[`${position}WheelSize`] === size;
        
        return `
            <button type="button" class="spec-option-button builder-button ${isActive ? 'active' : ''}" 
                    data-spec-group="${position}WheelSize" data-value='${size}' data-riding-style="${stylesString}">
                ${size}
                <span class="spec-count-bubble is-rim is-loading" title="Matching components available"></span>
            </button>`;
    }).join('');
}
// --- END: FUNCTION ---
  
    // --- Utility Functions ---
    // --- START: HELPER FUNCTION ---
/**
 * V5.5: Co-dependent Spoke Discovery.
 * Only generates a button if AT LEAST ONE Rim and ONE Hub exist with that count.
 */
function generateDynamicSpokeButtons(position) {
    const container = document.getElementById(`${position}-spoke-count-container`);
    if (!container) return;
    if (window.I9System?.isSystem()) { window.I9System.generateStep2Buttons(position, 'count', container); return; } // I9-SYSTEM

    const rimCounts = new Set();
    const hubCounts = new Set();
    const posPascal = position.charAt(0).toUpperCase() + position.slice(1);

    // --- SAFETY CHECK: The "Forever" Counts ---
    const forcedCounts = ['24', '28', '32'];
    forcedCounts.forEach(c => { rimCounts.add(c); hubCounts.add(c); });

    const cleanVal = (val) => {
        if (!val) return null;
        const numeric = val.toString().replace(/\D/g, '');
        return numeric || null;
    };

    // 1. Scan Rims (Filtered by position only - removed sizeMatch so they don't disappear)
    allRimProductsCache.forEach(product => {
        if (product.vendor === 'Your Own Component') return;
        if (product.tags && product.tags.includes('i9_system')) return;
        
        product.variants.forEach(variant => {
            const positionMatch = (variant.spec_position === posPascal || variant.spec_position === "Front/Rear");
            if (positionMatch && variant.availableForSale) {
                const c = cleanVal(variant.spec_spoke_count);
                if (c) rimCounts.add(c);
            }
        });
    });

    // 2. Scan Hubs (Filtered by position only)
    allHubProductsCache.forEach(product => {
        if (product.vendor === 'Your Own Component') return;
        if (product.tags && product.tags.includes('i9_system')) return;
        
        product.variants.forEach(variant => {
            const positionMatch = (variant.spec_position === posPascal || variant.spec_position === "Front/Rear");
            if (positionMatch && variant.availableForSale) {
                const c = cleanVal(variant.spec_spoke_count);
                if (c) hubCounts.add(c);
            }
        });
    });

    // 3. THE CO-DEPENDENCY FILTER: Only keep counts found in BOTH sets
    const discoveredCounts = Array.from(rimCounts).filter(count => hubCounts.has(count));
    
    // Sort smallest to highest (a - b)
    const sortedCounts = discoveredCounts.sort((a, b) => parseInt(a) - parseInt(b));

    // 4. Fallback (Safety only, ascending)
    const finalCounts = sortedCounts.length > 0 ? sortedCounts : ['20', '24', '28', '32', '36'];

    // 5. Build Buttons (Added the bubble span)
    container.innerHTML = finalCounts.map(count => {
        const valueWithH = `${count}h`;
        const isActive = buildState.specs[`${position}SpokeCount`] === valueWithH;
        return `
            <button type="button" class="spec-option-button builder-button ${isActive ? 'active' : ''}" 
                    data-spec-group="${position}SpokeCount" data-value="${valueWithH}" data-riding-style="both">
                ${valueWithH}
                <span class="spec-count-bubble is-rim is-loading" title="Calculating compatible options..."></span>
            </button>`;
    }).join('');
}

function generateDynamicHubSpacingButtons(position) {
    const container = document.getElementById(`${position}-hub-spacing-container`);
    if (!container) return;
    if (window.I9System?.isSystem()) { window.I9System.generateStep2Buttons(position, 'spacing', container); return; } // I9-SYSTEM

    const posPascal = position.charAt(0).toUpperCase() + position.slice(1); // "Front" or "Rear"
    const ridingStyle = buildState.ridingStyle;
    const discovered = new Set();

    // --- PHASE 1: Mapped Standards (Strictly separated by style) ---
    const standardsMap = {
        front: {
            gravelroad: ["12x100mm", "9x100mm QR"],
            mtb: ["15x110mm", "15x100mm", "20x110mm (Boost)", "20x110mm (Non-Boost)"]
        },
        rear: {
            gravelroad: ["12x142mm", "10x130mm QR"],
            mtb: ["12x148mm (Boost)", "12x142mm", "12x150mm", "12x157mm (SuperBoost)", "12x157mm (DH)"]
        }
    };

    // Add ONLY the core essentials immediately to prevent blank space without showing "ghost" buttons
const essentialStandards = {
    front: { 
        gravelroad: ["12x100mm", "9x100mm QR"], 
        mtb: ["15x110mm", "20x110mm (Boost)"] 
    },
    rear: { 
        gravelroad: ["12x142mm", "10x130mm QR"], 
        mtb: ["12x148mm (Boost)", "12x150mm", "12x157mm (SuperBoost)"] 
    }
};

if (ridingStyle === 'hybrid') {
    essentialStandards[position].gravelroad.forEach(s => discovered.add(s));
    essentialStandards[position].mtb.forEach(s => discovered.add(s));
} else if (essentialStandards[position][ridingStyle]) {
    essentialStandards[position][ridingStyle].forEach(s => discovered.add(s));
}

    // --- PHASE 2: Dynamic Discovery (Add niche ones ONLY if found in cache) ---
    if (allHubProductsCache.length > 0) {
        allHubProductsCache.forEach(product => {
            // Hide placeholder products from discovery
            if (product.vendor === 'Your Own Component') return;
            
            // ISOLATION: Hide System components from discovery
            if (product.tags && product.tags.includes('i9_system')) return;
            const styleMatch = ridingStyle === 'hybrid' || product.tags.some(tag => tag.includes(ridingStyle)) || product.tags.includes('style:both');
            product.variants.forEach(variant => {
                // Position Guard
if (variant.spec_position !== posPascal && variant.spec_position !== "Front/Rear") return;

const otherStyle = ridingStyle === 'mtb' ? 'gravelroad' : 'mtb';
const oppPos = position === 'front' ? 'rear' : 'front';

// 1. Block if discovery finds a spacing that actually belongs to the opposite wheel (e.g., 20x110 in Rear)
const isWrongPos = standardsMap[oppPos].mtb.includes(variant.spec_hub_spacing) || 
                   standardsMap[oppPos].gravelroad.includes(variant.spec_hub_spacing);

// 2. Block if discovery finds a spacing strictly for the other discipline (e.g., 15x110 in Gravel)
const isWrongStyle = ridingStyle !== 'hybrid' && 
                     standardsMap[position][otherStyle]?.includes(variant.spec_hub_spacing) && 
                     !standardsMap[position][ridingStyle]?.includes(variant.spec_hub_spacing);

if (styleMatch && variant.spec_hub_spacing && !isWrongPos && !isWrongStyle) {
    discovered.add(variant.spec_hub_spacing);
}
            });
        });
    }

    // --- PHASE 3: Render ---
    const sortedSpacings = Array.from(discovered).sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
    container.innerHTML = sortedSpacings.map(spacing => {
        const isActive = buildState.specs[`${position}HubSpacing`] === spacing;
        return `
            <button type="button" class="spec-option-button builder-button ${isActive ? 'active' : ''}" 
                    data-spec-group="${position}HubSpacing" data-value="${spacing}" data-riding-style="both">
                ${spacing}
                <span class="spec-count-bubble is-hub is-loading" title="Matching components available"></span>
            </button>`;
    }).join('');
}

/**
 * Gets a list of products for a given component type that are compatible with the current Step 2 spec selections.
 * @param {string} position 'Front' or 'Rear'.
 * @param {string} typePascal The component type in PascalCase (e.g., 'Rim', 'Hub', 'Spokes').
 * @returns {Array} A filtered array of compatible product objects.
 */
function getCurrentlyCompatibleProducts(position, typePascal) {
    const posLower = position.toLowerCase();
    const specs = buildState.specs;
    let cacheToSearch;
    let filterFn;

    // Determine which cache and filter logic to use based on the component type
    switch (typePascal) {
        case 'Rim':
            cacheToSearch = allRimProductsCache;
            if (!specs[`${posLower}WheelSize`]) return [];
            
            filterFn = p => {
                if (p.vendor === 'Your Own Component') return true;
                return p.variants.some(v => {
                    const sizeValue = v.spec_rim_size?.parsedValue;
                    const sizeMatch = (sizeValue === specs[`${posLower}WheelSize`] || (Array.isArray(sizeValue) && sizeValue.includes(specs[`${posLower}WheelSize`])));
                    const positionMatch = (v.spec_position === position || v.spec_position === "Front/Rear");
                    const spokeMatch = (!specs[`${posLower}SpokeCount`] || (String(v.spec_spoke_count) === String(specs[`${posLower}SpokeCount`])));
                    
                    // --- THE BRAKE FILTER ENGINE ---
                    const vBrakes = v.spec_brake_interface || [];
                    let brakeMatch = false;
                    if (specs.brakeStyle === 'Rim Brake') {
                        brakeMatch = vBrakes.includes('Rim Brake');
                    } else {
                        const isDiscRim = !vBrakes.includes('Rim Brake');
                        const isRimBrakeRim = vBrakes.includes('Rim Brake');
                        brakeMatch = isDiscRim || (isRimBrakeRim && buildState._ui.showRimBrakeRims);
                    }
                    return sizeMatch && positionMatch && v.availableForSale && spokeMatch && brakeMatch;
                });
            };
            break;

        case 'Hub':
            cacheToSearch = allHubProductsCache;
            if (!specs.brakeStyle || !specs[`${posLower}HubSpacing`] || !specs[`${posLower}SpokeCount`] || (position === 'Rear' && !specs.freehubType)) return [];
            filterFn = p => {
                if (p.vendor === 'Your Own Component') return true;
                // For rear hubs, first perform a product-level check on available freehubs
                if (position === 'Rear' && (!p.availableFreehubs || !isFreehubCompatible(specs.freehubType, p.availableFreehubs))) {
                    return false;
                }
                // Then check if any variant matches the rest of the specs
                return p.variants.some(v =>
        (v.spec_position === position || v.spec_position === "Front/Rear") &&
        (v.spec_brake_interface || []).includes(specs.brakeStyle) && // This now handles "Rim Brake" correctly
        normalizeSpacing(v.spec_hub_spacing) === normalizeSpacing(specs[`${posLower}HubSpacing`]) &&
        String(v.spec_spoke_count) === String(specs[`${posLower}SpokeCount`]) &&
        v.availableForSale
    );
};
            break;

        case 'Spokes':
        case 'Nipples':
            // Spokes and Nipples generally don't have spec dependencies, so we return the whole cache.
            // Compatibility (e.g., with hook flange hubs) is handled visually in the UI, not by removing them from the list.
            cacheToSearch = (typePascal === 'Spokes') ? allSpokeProductsCache : allNippleProductsCache;
            filterFn = p => p.variants.some(v => v.availableForSale);
            break;
            
        case 'ValveStem':
            cacheToSearch = allValveStemProductsCache;
            const selectedRim = buildState.components[`${posLower}Rim`];
            // If no rim is selected, the section is disabled, but for completeness, we return an empty array.
            if (!selectedRim) return [];
            
            const rimDepth = selectedRim.rimDepth;
            // If the rim has no depth specified, all valves are considered compatible.
            if (rimDepth === null || typeof rimDepth === 'undefined') {
                filterFn = p => p.variants.some(v => v.availableForSale);
            } else {
                // Filter by rim depth compatibility.
                filterFn = p => p.variants.some(v => v.availableForSale && ((v.valve_min_depth === null || v.valve_max_depth === null) || (rimDepth >= v.valve_min_depth && rimDepth <= v.valve_max_depth)));
            }
            break;

        default:
            // Return an empty array for unknown types
            return [];
    }

    if (!cacheToSearch) return [];
    // Apply the determined filter function to the correct cache
    return cacheToSearch.filter(filterFn);
}
// --- END: HELPER FUNCTION ---

// --- START: UTILITY FUNCTION FOR SCROLLING ---
/**
 * Smoothly scrolls the viewport to the component subsection that was just interacted with.
 * This prevents the page from "jumping" when the selection options collapse.
 * @param {string} position 'Front' or 'Rear'.
 * @param {string} typePascal The component type in PascalCase (e.g., 'Rim', 'Hub', 'Spokes').
 */
function scrollToComponentSection(position, typePascal) {
    const posLower = position.toLowerCase();
    const typeForId = typePascal.toLowerCase();
    
    const subsectionId = `${posLower}-${typeForId}-subsection`;
    const element = document.getElementById(subsectionId);

    if (element) {
        // Use a small timeout to allow the DOM to reflow after the options list collapses.
        // This makes the scroll feel smoother and more intentional.
        setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 150);
    } else {
        console.warn(`scrollToComponentSection: Could not find element #${subsectionId}`);
    }
}
// --- END: UTILITY FUNCTION FOR SCROLLING ---
  
    function formatPrice(valueInCents) { const n = Number(valueInCents); return isNaN(n) ? "$0.00" : `$${(n / 100).toFixed(2)}`; }
    function debounce(func, wait) { let timeout; return function executedFunction(...args) { const later = () => { clearTimeout(timeout); func(...args); }; clearTimeout(timeout); timeout = setTimeout(later, wait); }; }
    function updateGlobalVendorLogoMap(productsArray) {
    if (!Array.isArray(productsArray)) return;
    productsArray.forEach(p => {
        const v = p.vendor;
        const l = p.vendorLogoUrl;
        if (v && (!vendorLogoMap[v] || (l && !vendorLogoMap[v].logoUrl))) {
            vendorLogoMap[v] = { name: v, logoUrl: l || null };
        }
    });
    // ADD THIS LINE: Expose the map after it's updated
    window.loamlabs = window.loamlabs || {};
    window.loamlabs.vendorLogoMap = vendorLogoMap;
}

/**
 * Initializes technical tooltips for spec labels.
 * Handles both hover (desktop) and click (mobile) states.
 */
function initializeInfoTooltips() {
    // Clean up any existing tooltips if re-initializing
    document.querySelectorAll('.info-tooltip-popup').forEach(el => el.remove());

    const triggers = document.querySelectorAll('.info-tooltip-trigger');

    triggers.forEach(trigger => {
        const text = trigger.dataset.tooltipText;
        if (!text) return;

        // Create the popup element
        const popup = document.createElement('div');
        popup.className = 'info-tooltip-popup';
        popup.textContent = text;
        document.body.appendChild(popup);

        const positionPopup = () => {
            const rect = trigger.getBoundingClientRect();
            popup.style.left = `${rect.left + (rect.width / 2)}px`;
            popup.style.top = `${rect.top - 10}px`;
        };

        // Desktop: Hover
        trigger.addEventListener('mouseenter', () => {
            positionPopup();
            popup.classList.add('is-visible');
        });
        trigger.addEventListener('mouseleave', () => {
            popup.classList.remove('is-visible');
        });

        // Mobile: Toggle on Click
        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            const wasVisible = popup.classList.contains('is-visible');
            
            // Hide all others
            document.querySelectorAll('.info-tooltip-popup').forEach(p => p.classList.remove('is-visible'));
            
            if (!wasVisible) {
                positionPopup();
                popup.classList.add('is-visible');
            }
        });
    });

    // Close tooltips when clicking anywhere else
    document.addEventListener('click', () => {
        document.querySelectorAll('.info-tooltip-popup').forEach(p => p.classList.remove('is-visible'));
    });
}

    function capitalizeFirstLetter(string) { if (!string) return ''; return string.charAt(0).toUpperCase() + string.slice(1); }
    function getDisplayName(typeLower) {
        if (typeLower === 'valvestem') return "Valve Stem";
        if (typeLower === 'nipples') return "Nipples";
        if (typeLower === 'spokes') return "Spokes";
        return capitalizeFirstLetter(typeLower);
    }
    function getNumericIdFromShopifyGid(gid) {
    if (typeof gid !== 'string') return null;
    const match = gid.match(/ProductVariant\/(\d+)/);
    return match ? parseInt(match[1]) : null;
}

// I9-SYSTEM: the Spoke Interface of a build that is loaded (Resume, Saved Builds, share link, edit from cart). A saved choice is kept. A build saved before
// the System launch has no such key and was always Standard. Only an in-progress save still on Step 1 with the choice saved as null stays unselected.
function interfaceForLoadedBuild(loaded) {
    const saved = loaded ? loaded.spokeInterface : undefined;
    if (saved === 'standard' || saved === 'system') return saved;
    return (loaded && saved === null && Number(loaded.step) <= 1) ? null : 'standard';
}

function resetBuildStateToDefaults() {
    const newBuildId = `${Math.floor(100000 + Math.random() * 900000)}`;
    const defaults = {
        step: 1, buildType: null, ridingStyle: null, ridingStyleDisplay: null,
        spokeInterface: null, system: null, // I9-SYSTEM: no interface until the customer chooses one in Step 1
        standardStudio: null, // STANDARD-STUDIO
        customerSupplied: { front: { rim: false, hub: false }, rear: { rim: false, hub: false } },
        tubelessTapeInstalled: true,
        estimatedLeadTime: 0,
        specs: { frontWheelSize: null, rearWheelSize: null, frontSpokeCount: null, rearSpokeCount: null, brakeStyle: null, frontHubSpacing: null, rearHubSpacing: null, freehubType: null, systemHub: null /* I9-SYSTEM */ },
        components: { frontRim: null, rearRim: null, frontHub: null, rearHub: null, frontSpokes: null, rearSpokes: null, frontNipples: null, rearNipples: null, frontValveStem: null, rearValveStem: null, rearComponentFreehub: null },
        selectedOptionalAddons: {},
        subtotal: 0,
        buildId: newBuildId,
        _ui: {
            step2AutoSelected: {}, hasProgressedPastStep1: false,
            activeVendor: { frontRim: null, rearRim: null, frontHub: null, rearHub: null, frontSpokes: null, rearSpokes: null, frontNipples: null, rearNipples: null, frontValveStem: null, rearValveStem: null },
            isChangingComponent: null,
            valveStemExplicitlyRemoved: { front: false, rear: false },
            hasChanges: false, originalCartItemKeys: null, inEditMode: false,
            qbMaterial: 'Aluminum',
            qbGoal: 'Best Value',
            qbFrontDepthMin: 0,
            qbFrontDepthMax: 35,
            qbRearDepthMin: 0,
            qbRearDepthMax: 35
        }
    };

    // This is the key: Reset properties of the EXISTING object.
    Object.keys(buildState).forEach(key => delete buildState[key]);
    Object.assign(buildState, defaults);
}

async function handleAdminShareBuildClick() {
  const shareButton = document.getElementById('admin-share-build-button');
  if (!shareButton) return;

  if (!buildState || Object.keys(buildState).length === 0) {
    alert('Please configure a build before sharing.');
    return;
  }

  const originalButtonText = shareButton.textContent;
  
  try {
    // 1. Show loading state (saving to database takes ~0.5 seconds)
    shareButton.textContent = 'Generating Link...';
    shareButton.disabled = true;

    // 2. Clean the state for saving
    const stateToSave = getCleanBuildStateForSaving();

    // 3. Send to Vercel Database
    const response = await fetch('https://loamlabs-data-audit.vercel.app/api/save-shared-build', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(stateToSave)
    });

    if (!response.ok) throw new Error("Failed to save build to database");

    const data = await response.json();
    const shareId = data.shareId;

    // 4. Construct the clean, unbreakable URL
    const shareableURL = `${window.location.origin}${window.location.pathname}?share=${shareId}`;
    console.log("Database Share URL created:", shareableURL);

    // 5. Copy to Clipboard
    await navigator.clipboard.writeText(shareableURL);

    // 6. Give user feedback
    shareButton.textContent = 'Copied to Clipboard!';
    setTimeout(() => {
        shareButton.textContent = originalButtonText;
        shareButton.disabled = false;
        validateStep3(); // Re-validate to set correct disabled state
    }, 2500);

  } catch (error) {
    console.error('Error during link creation and copy:', error);
    alert('An error occurred while creating the share link. Ensure you are connected to the internet.');
    shareButton.textContent = originalButtonText;
    shareButton.disabled = false;
  }
}

// --- NEW: Database Share Loading Logic ---
async function loadSharedBuildFromDatabase(shareId) {
    console.log(`[Share Link] Attempting to load build ID: ${shareId} from database...`);
    const loadingOverlay = document.getElementById('builder-edit-loading-overlay');
    if (loadingOverlay) loadingOverlay.style.display = 'flex';

    try {
        const response = await fetch(`https://loamlabs-data-audit.vercel.app/api/get-shared-build?id=${shareId}`);
        
        if (!response.ok) {
            throw new Error(`Database returned ${response.status}: Link may be expired or invalid.`);
        }

        const loadedState = await response.json();

        await hydrateStateAndRenderBuilder(loadedState, loadingOverlay);

    } catch (error) {
        console.error('[SHARE LINK] CRITICAL ERROR:', error);
        alert('This shared link appears to be invalid or has expired (links expire after 60 days). Starting a new build.');
        resetBuildStateToDefaults();
        if (loadingOverlay) loadingOverlay.style.display = 'none';
        await showStep(1);
    }
}

// --- LEGACY: Fallback for old LZString links ---
async function loadBuildFromLegacyHash(compressedBuildData) {
    console.log("[Legacy Share Link] Attempting to decompress old hash format...");
    const loadingOverlay = document.getElementById('builder-edit-loading-overlay');
    if (loadingOverlay) loadingOverlay.style.display = 'flex';

    try {
        const decodedBuildJSON = LZString.decompressFromBase64(compressedBuildData);
        if (!decodedBuildJSON) throw new Error("Decompressed data from Base64 is null or empty.");
        
        const loadedState = JSON.parse(decodedBuildJSON);
        await hydrateStateAndRenderBuilder(loadedState, loadingOverlay);

    } catch (error) {
        console.error('[LEGACY SHARE LINK] CRITICAL ERROR:', error);
        alert('This legacy build link appears to be broken (likely truncated by an email/SMS app). Starting a new build.');
        resetBuildStateToDefaults();
        if (loadingOverlay) loadingOverlay.style.display = 'none';
        await showStep(1);
    }
}

// --- HELPER: Handles the actual merging of data into the UI ---
async function hydrateStateAndRenderBuilder(loadedState, loadingOverlay) {
    resetBuildStateToDefaults();
    Object.assign(buildState, loadedState);
    buildState.spokeInterface = interfaceForLoadedBuild(loadedState); // I9-SYSTEM
    if(loadedState.specs) buildState.specs = { ...buildState.specs, ...loadedState.specs };
    if(loadedState.components) buildState.components = { ...buildState.components, ...loadedState.components };
    if(loadedState.selectedOptionalAddons) buildState.selectedOptionalAddons = { ...buildState.selectedOptionalAddons, ...loadedState.selectedOptionalAddons };
    if(loadedState._ui) buildState._ui = { ...buildState._ui, ...loadedState._ui };
    if(loadedState.customerSupplied) buildState.customerSupplied = { ...buildState.customerSupplied, ...loadedState.customerSupplied };
    
    componentFetchPromises = { rims: null, hubs: null, spokes: null, nipples: null, valves: null, freehubs: null };

    updateStep1VisualFeedback();
    validateStep1();
    renderStep2();
    updateStep2OptionsVisibility();
    updateStep2VisualFeedback();
    validateStep2();
    triggerEarlyComponentFetches();

    await showStep(3);
    
    handleComponentChangeForLeadTime();

    // Clean up the URL so if the user refreshes, they don't accidentally reload the shared state over their new edits
    const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
    window.history.pushState({ path: newUrl }, '', newUrl);

    if (loadingOverlay) loadingOverlay.style.display = 'none';
}
  
function getSortableName(name) {
    if (typeof name !== 'string') return '';
    // Converts to lowercase and removes all non-letter/non-number characters
    return name.toLowerCase().replace(/[^a-z0-9]/g, '');
}
  
async function fetchAddonProductDetailsByGids(gidsArray) {
    if (!gidsArray || gidsArray.length === 0) {
        return [];
    }
    // console.log(`fetchAddonProductDetailsByGids: Fetching details for GIDs:`, gidsArray);

    const query = `
      query getAddonDetails($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on Product {
            __typename
            id
            title
            handle
            vendor
            pairingKey: metafield(namespace: "custom", key: "pairing_key") { value }
            options(first: 5) { name values }
            variants(first: 50) {
              edges {
                node {
                  id
                  title
                  sku
                  availableForSale
                  price { amount currencyCode }
                  image { url(transform:{maxWidth:100, maxHeight:100}) altText }
                  selectedOptions { name value }
                }
              }
            }
          }
        }
      }
    `;
    try {
        const data = await storefrontApiQuery(query, { ids: gidsArray });
        if (data && data.nodes) {
            return data.nodes.filter(node => node && node.__typename === 'Product').map(p => {
                // Process variants minimally here, or do it where consumed
                const variants = p.variants.edges.map(edge => ({
                    ...edge.node,
                    price: { amount: parseFloat(edge.node.price.amount) * 100, code: edge.node.price.currencyCode }
                }));
                return {
                    id: p.id,
                    title: p.title,
                    handle: p.handle,
                    vendor: p.vendor,
                    pairingKeyValue: p.pairingKey?.value || null,
                    options: p.options,
                    variants: variants // Store processed variants
                };
            });
        }
        return [];
    } catch (error) {
        console.error("Error in fetchAddonProductDetailsByGids:", error, "for GIDs:", gidsArray);
        return [];
    }
}

async function applyCustomerSuppliedSelections() {
    console.log("Applying customer-supplied selections...");

    // This waits for the product data to be fetched and cached, which is correct.
    await Promise.all([
        componentFetchPromises.rims,
        componentFetchPromises.hubs
    ]);

    const positions = ['front', 'rear'];
    const componentsToProcess = [
        { type: 'Rim', cache: allRimProductsCache },
        { type: 'Hub', cache: allHubProductsCache }
    ];

    for (const position of positions) {
        for (const comp of componentsToProcess) {
            // Check if the user intended to supply this component
            if (buildState.customerSupplied[position][comp.type.toLowerCase()]) {
                const stateKey = `${position}${comp.type}`;
                const positionPascal = position.charAt(0).toUpperCase() + position.slice(1);

                // Only apply if the slot is currently empty
                if (buildState.components[stateKey]) {
                    console.log(`Skipping auto-selection for ${stateKey}, as it's already filled.`);
                    continue;
                }

                const productCache = comp.cache;
                if (productCache && productCache.length > 0) {
                    const suppliedProduct = productCache.find(p => p.vendor === 'Your Own Component');

                    if (suppliedProduct && suppliedProduct.variants.length > 0) {
                        
                        let variantToSelect = null;
                        const requiredSpokeCount = String(buildState.specs[`${position}SpokeCount`]);

                        // Logic is now different for Rims vs. Hubs
                        if (comp.type === 'Rim') {
                            const requiredWheelSize = buildState.specs[`${position}WheelSize`];
                            console.log(`[Customer Supplied Rim] Searching for variant with: Size=${requiredWheelSize}, Spokes=${requiredSpokeCount}`);
                            
                            variantToSelect = suppliedProduct.variants.find(variant => {
                                // Check for spoke count match
                                const spokeMatch = String(variant.spec_spoke_count) === requiredSpokeCount;

                                // Check for wheel size match (handles both single string and array of strings)
                                const sizeValue = variant.spec_rim_size?.parsedValue;
                                const sizeMatch = Array.isArray(sizeValue)
                                    ? sizeValue.includes(requiredWheelSize)
                                    : sizeValue === requiredWheelSize;
                                
                                return sizeMatch && spokeMatch;
                            });

                        } else if (comp.type === 'Hub') {
                             console.log(`[Customer Supplied Hub] Searching for variant with: Spokes=${requiredSpokeCount}`);
                             variantToSelect = suppliedProduct.variants.find(variant =>
                                String(variant.spec_spoke_count) === requiredSpokeCount
                            );
                        }

                        // If no exact match is found, default to the first variant as a safe fallback.
                        if (!variantToSelect) {
                            console.warn(`Could not find a precise match for 'Your Own ${comp.type}' with the required specs. Defaulting to the first available variant.`);
                            variantToSelect = suppliedProduct.variants[0];
                        }

                        const componentData = {
                            variantId: variantToSelect.id,
                            productId: suppliedProduct.id,
                            productHandle: suppliedProduct.handle,
                            title: suppliedProduct.title,
                            variantTitle: variantToSelect.title,
                            sku: variantToSelect.sku,
                            price: variantToSelect.price.amount,
                            vendor: suppliedProduct.vendor,
                            image: variantToSelect.image,
                            pairingKey: suppliedProduct.pairingKey,
                            tags: suppliedProduct.tags || [],
                            selectedOptions: variantToSelect.selectedOptions,
                            optionalAddonProductGids: suppliedProduct.optionalAddonProductGidsFromProduct || [],
                            // Add the specific spec data to the component object for consistency
                            spec_spoke_count: variantToSelect.spec_spoke_count,
                            wheelSize: (comp.type === 'Rim') ? buildState.specs[`${position}WheelSize`] : null,
                            wheelModel: suppliedProduct.wheelModel
                        };

                        buildState.components[stateKey] = componentData;
                        console.log(`Pre-selected 'Your Own ${comp.type}' for ${position} with variant ${variantToSelect.title}.`);
                        
                        updateComponentUI(positionPascal, comp.type, componentData);
                        calculateWheelCosts(positionPascal);

                        // If we just auto-selected a Rim, we need to manually trigger the valve stem evaluation.
                        if (comp.type === 'Rim') {
                            evaluateValveStemForRimChange(positionPascal);
                        }
                    }
                }
            }
        }
    }
    // Update summary and validation after all potential changes
    updateSubtotal();
    updateBuildSummary();
    validateStep3();
}

function updateMismatchHints() {
    if (buildState.buildType !== 'Wheel Set') {
        document.querySelectorAll('.mismatch-hint, .match-pair-button--from-hint').forEach(hint => hint.remove());
        return;
    }

    const componentTypes = ['Rim', 'Hub', 'Spokes', 'Nipples', 'ValveStem'];

    const processHintForComponent = (position, type) => {
        const oppositePosition = position === 'Front' ? 'Rear' : 'Front';
        const posLower = position.toLowerCase();

        const currentComponent = buildState.components[`${posLower}${type}`];
        const oppositeComponent = buildState.components[`${oppositePosition.toLowerCase()}${type}`];
        
        const imageContainer = document.getElementById(`${posLower}-${type.toLowerCase().replace('valvestem', 'valvestem')}-image-container`);
        const optionsContainer = document.getElementById(`${posLower}-${type.toLowerCase().replace('valvestem', 'valvestem')}-options-container`);

        imageContainer?.querySelector('.mismatch-hint')?.remove();
        optionsContainer?.querySelector('.match-pair-button--from-hint')?.remove();

        const isMatchPossible = (sourceComponent) => {
            if (!sourceComponent || !sourceComponent.pairingKey) return false;
            
            if (type === 'ValveStem') {
                const destRim = buildState.components[`${posLower}Rim`];
                return !!destRim; // Only return true if the destination rim exists
            }
            if (['Spokes', 'Nipples'].includes(type)) {
                return true;
            }

            const destSpecs = {
                wheelSize: buildState.specs[`${posLower}WheelSize`],
                spokeCount: buildState.specs[`${posLower}SpokeCount`],
                brakeStyle: buildState.specs.brakeStyle,
                hubSpacing: buildState.specs[`${posLower}HubSpacing`],
            };

            let cacheToSearch = type === 'Rim' ? allRimProductsCache : allHubProductsCache;
            if (type === 'Rim') {
                const sourceColor = (sourceComponent.variantTitle || '').split('/').pop().trim().toLowerCase();
                return cacheToSearch.some(p => p.pairingKey === sourceComponent.pairingKey && p.variants.some(v => {
                    const variantTitle = v.title || '';
                    return v.availableForSale &&
                        variantTitle.split('/').pop().trim().toLowerCase() === sourceColor &&
                        (v.spec_position === position || v.spec_position === "Front/Rear") &&
                        String(v.spec_spoke_count) === String(destSpecs.spokeCount) &&
                        (Array.isArray(v.spec_rim_size?.parsedValue) ? v.spec_rim_size.parsedValue.includes(destSpecs.wheelSize) : v.spec_rim_size?.parsedValue === destSpecs.wheelSize);
                }));
            } else if (type === 'Hub') {
                const sourceHubColor = sourceComponent.selectedOptions?.find(o => o.name.toLowerCase() === 'color')?.value;
                return cacheToSearch.some(p => p.pairingKey === sourceComponent.pairingKey && p.variants.some(v => 
                    v.availableForSale &&
                    v.selectedOptions?.find(o => o.name.toLowerCase() === 'color')?.value === sourceHubColor &&
                    (v.spec_brake_interface || []).includes(destSpecs.brakeStyle) &&
                    v.spec_hub_spacing === destSpecs.hubSpacing &&
                    String(v.spec_spoke_count) === String(destSpecs.spokeCount)
                ));
            }
            return false;
        };

        const createHintElement = (isForOptionsContainer) => {
            const hintElement = document.createElement('button');
            hintElement.className = 'builder-button match-pair-button match-pair-button--from-hint';
            hintElement.dataset.action = 'match-from-hint'; 
            hintElement.dataset.position = position;
            hintElement.dataset.type = type;
            hintElement.textContent = `Match to ${oppositePosition} ${getDisplayName(type.toLowerCase())}`;
            
            if (isForOptionsContainer) {
                hintElement.style.marginBottom = '15px';
                hintElement.style.width = '100%';
            }
            return hintElement;
        };

        if (currentComponent && oppositeComponent) {
            let isMismatched = false;
            if (type === 'Rim') isMismatched = !areRimsPaired(currentComponent, oppositeComponent);
            else if (type === 'Hub') isMismatched = !areHubsPaired(currentComponent, oppositeComponent);
            else if (type === 'Spokes') isMismatched = !areSpokesPaired(currentComponent, oppositeComponent);
            else if (type === 'Nipples') isMismatched = !areNipplesPaired(currentComponent, oppositeComponent);
            else if (type === 'ValveStem') isMismatched = !areValveStemsPaired(currentComponent, oppositeComponent);

            if (isMismatched && isMatchPossible(oppositeComponent)) {
                const hintElement = document.createElement('div');
                hintElement.className = 'mismatch-hint';
                hintElement.dataset.action = 'match-from-hint'; 
                hintElement.dataset.position = position;
                hintElement.dataset.type = type;
                hintElement.innerHTML = `<span>Click to Match to ${oppositePosition}</span>`;
                hintElement.style.animation = 'subtleFadeIn 0.5s ease-out forwards';
                imageContainer?.appendChild(hintElement);
            }
        } else if (!currentComponent && oppositeComponent) {
            if (optionsContainer && isMatchPossible(oppositeComponent)) {
                const hint = createHintElement(true);
                optionsContainer.prepend(hint);
            }
        }
    };

    componentTypes.forEach(type => {
        processHintForComponent('Front', type);
        processHintForComponent('Rear', type);
    });
}

  
function manageStickyAddonsForChangedBaseVariant(position, baseTypePascal, oldBaseVariantId, newBaseVariantId, newBaseProductOptionalAddonGids) {
    const addonKeysToProcess = Object.keys(buildState.selectedOptionalAddons);
    let addonsWereReassignedOrCleared = false;

    // console.log(`   New base product supports addon GIDs:`, newBaseProductOptionalAddonGids);

    for (const currentAddonKey of addonKeysToProcess) {
        const selectedAddon = buildState.selectedOptionalAddons[currentAddonKey];

        if (selectedAddon.baseComponentPosition === position &&
            selectedAddon.baseComponentType === baseTypePascal &&
            selectedAddon.baseComponentVariantId === oldBaseVariantId) {

            // Check if the new base variant's *product* still supports this *addon product type*
            const newBaseSupportsThisAddonProductType = newBaseProductOptionalAddonGids &&
                                                      newBaseProductOptionalAddonGids.includes(selectedAddon.addonProductId);

            if (newBaseSupportsThisAddonProductType) {
                // Addon product type IS still supported. Re-key the addon to the new base variant.
                const newAddonKey = `${position}_${baseTypePascal}_${newBaseVariantId}_${selectedAddon.addonProductId}`;
                
                // Only re-assign if the key is actually changing (it should be)
                // and to avoid issues if for some reason old and new variant ID were the same.
                if (currentAddonKey !== newAddonKey) {
                    console.log(`     from base variant ${oldBaseVariantId} to ${newBaseVariantId}.`);
                    console.log(`     Old key: ${currentAddonKey}, New key: ${newAddonKey}`);

                    // Create the new entry
                    buildState.selectedOptionalAddons[newAddonKey] = {
                        ...selectedAddon, // Copy all existing addon details
                        baseComponentVariantId: newBaseVariantId // Update the base variant ID
                    };
                    // Delete the old entry
                    delete buildState.selectedOptionalAddons[currentAddonKey];
                    addonsWereReassignedOrCleared = true;
                    saveLastActiveBuild();
                } else {
                }

                // Phase 1: We keep the same addon *variant*.
                // Future Phase 2 of sticky could involve re-evaluating if a *different variant* of the same addon product
                // would be more appropriate for the newBaseVariantId.

            } else {
                // Addon product type is NO LONGER supported by the new base variant's product. Clear it.
                addonsWereReassignedOrCleared = true;
                saveLastActiveBuild();
            }
        }
    }
    return addonsWereReassignedOrCleared;
}

async function attemptRevalidateComponent(position, typePascal, currentComponentData) {
    // --- Skip revalidation for Virtual Components (Integrated Wheels) ---
    if (currentComponentData && currentComponentData.isVirtual) {
        console.log(`Revalidation: Skipping Virtual Component for ${position} ${typePascal}`);
        return { ...currentComponentData, _reval_action: 'kept' };
    }
    const { productId, variantId, selectedOptions } = currentComponentData;
    const posLower = position.toLowerCase();

    console.log(`Attempting revalidation for ${position} ${typePascal}... Current VariantID: ${variantId}`);

    let cacheToSearch;
    let checkCompatibilityFn;
    let newSpecs = { position: position };

    switch (typePascal) {
        case 'Rim':
            cacheToSearch = allRimProductsCache;
            checkCompatibilityFn = (productNode, variantNode, specs) => {
                if (!variantNode) return false;
                
                // --- INTEGRATED WHEEL LOGIC ---
                const isIntegrated = productNode.tags && productNode.tags.includes('type:integrated_wheel');
                
                // Common Checks
                const sizeValue = variantNode.spec_rim_size?.parsedValue;
                const sizeMatch = Array.isArray(sizeValue) ? sizeValue.includes(specs.size) : sizeValue === specs.size;
                const positionMatch = variantNode.spec_position === specs.position || variantNode.spec_position === "Front/Rear";
                const availabilityMatch = productNode.vendor === 'Your Own Component' ? true : variantNode.availableForSale;

                if (isIntegrated) {
                    // For Integrated, bypass spoke check, but check Hub Specs
                    const posLower = specs.position.toLowerCase();
                    const hubSpacing = buildState.specs[`${posLower}HubSpacing`];
                    const brakeStyle = buildState.specs.brakeStyle;
                    
                    const spacingMatch = normalizeSpacing(variantNode.spec_hub_spacing) === normalizeSpacing(hubSpacing);
                    const brakeMatch = (variantNode.spec_brake_interface || []).includes(brakeStyle);
                    
                    // Also check Freehub if Rear
                    let freehubMatch = true;
                    if (posLower === 'rear') {
                         const targetFreehub = buildState.specs.freehubType;
                         if (productNode.availableFreehubs && !productNode.availableFreehubs.includes(targetFreehub)) {
                             freehubMatch = false;
                         }
                    }

                    return availabilityMatch && sizeMatch && positionMatch && spacingMatch && brakeMatch && freehubMatch;
                } else {
                    // Standard Logic
                    const spokeMatch = !specs.spokeCount || (String(variantNode.spec_spoke_count) === String(specs.spokeCount));
                    return availabilityMatch && sizeMatch && positionMatch && spokeMatch;
                }
            };
            newSpecs.size = buildState.specs[`${posLower}WheelSize`];
            newSpecs.spokeCount = buildState.specs[`${posLower}SpokeCount`];

            if (!newSpecs.size || !newSpecs.spokeCount) {
                console.warn(`Revalidation (${position} Rim): Wheel Size or Spoke Count is missing. Cannot validate.`);
                return null;
            }

            const originalProductInCacheRim = cacheToSearch.find(p => p.id === productId);
            if (!originalProductInCacheRim) {
                console.warn(`Revalidation: Original Product ID ${productId} not found in rim cache. Clearing selection.`);
                return null;
            }

            const currentVariantNode = originalProductInCacheRim.variants.find(v => v.id === variantId);
            if (currentVariantNode && checkCompatibilityFn(originalProductInCacheRim, currentVariantNode, newSpecs)) {
                 console.log(`Revalidation: Current ${position} Rim variant IS STILL COMPATIBLE.`);
                 return { ...currentComponentData, _reval_action: 'kept', wheelSize: newSpecs.size, spokeCount: newSpecs.spokeCount };
            }

            console.log(`Revalidation: Current ${position} Rim variant IS NO LONGER COMPATIBLE. Searching for replacement within the same product model.`);
            let replacementVariantRim = null;
            for (const variant of originalProductInCacheRim.variants) {
                if (checkCompatibilityFn(originalProductInCacheRim, variant, newSpecs)) {
                    replacementVariantRim = variant;
                    break;
                }
            }

            if (replacementVariantRim) {
                console.log(`Revalidation: Auto-replacing ${position} Rim with variant ${replacementVariantRim.title}`);
                let newComponentStateData = {
                    variantId: replacementVariantRim.id, productId: originalProductInCacheRim.id, productHandle: originalProductInCacheRim.handle,
                    title: originalProductInCacheRim.title, variantTitle: replacementVariantRim.title, sku: replacementVariantRim.sku,
                    price: replacementVariantRim.price.amount, vendor: originalProductInCacheRim.vendor, image: replacementVariantRim.image,
                    pairingKey: originalProductInCacheRim.pairingKey, selectedOptions: replacementVariantRim.selectedOptions,
                    optionalAddonProductGids: originalProductInCacheRim.optionalAddonProductGidsFromProduct || [], _reval_action: 'replaced',
                    tags: originalProductInCacheRim.tags || [],
                    wheelSize: newSpecs.size, spokeCount: newSpecs.spokeCount,
                    wheelModel: originalProductInCacheRim.wheelModel,
                    rimDepth: originalProductInCacheRim.rimDepth,
                    rim_erd: replacementVariantRim.rim_erd ?? originalProductInCacheRim.rim_erd ?? null,
                    weight_g: replacementVariantRim.weight_g ?? originalProductInCacheRim.weight_g ?? null
                };
                return newComponentStateData;
            }

            console.warn(`Revalidation: No compatible replacement Rim variant found within product "${originalProductInCacheRim.title}". Clearing selection.`);
            return null;

        case 'Hub':
            cacheToSearch = allHubProductsCache;
            checkCompatibilityFn = (productNode, variantNode, specs) => {
                if (!variantNode || !productNode) return false;
                if (specs.position === 'Rear' && productNode.vendor !== 'Your Own Component') {
                    if (!productNode.availableFreehubs || !isFreehubCompatible(specs.freehubType, productNode.availableFreehubs)) {
                        return false;
                    }
                }
                const positionMatch = variantNode.spec_position === specs.position || variantNode.spec_position === "Front/Rear";
                const variantBrakeInterfaces = variantNode.spec_brake_interface || [];
                const brakeMatch = productNode.vendor === 'Your Own Component' ? true : variantBrakeInterfaces.includes(specs.brakeStyle);
                const spacingMatch = productNode.vendor === 'Your Own Component' ? true : normalizeSpacing(variantNode.spec_hub_spacing) === normalizeSpacing(specs.hubSpacing);
                const spokeMatch = String(variantNode.spec_spoke_count) === String(specs.spokeCount);
                const availabilityMatch = productNode.vendor === 'Your Own Component' ? true : variantNode.availableForSale;
                const i9Match = window.I9System?.hubVariantAllowed(variantNode, specs.position, productNode) ?? true; // I9-SYSTEM: per-variant freehub
                return availabilityMatch && positionMatch && brakeMatch && spacingMatch && spokeMatch && i9Match;
            };
            newSpecs.brakeStyle = buildState.specs.brakeStyle;
            newSpecs.hubSpacing = buildState.specs[`${posLower}HubSpacing`];
            newSpecs.freehubType = (posLower === 'rear') ? buildState.specs.freehubType : null;
            newSpecs.spokeCount = buildState.specs[`${posLower}SpokeCount`];

            if (!newSpecs.brakeStyle || !newSpecs.hubSpacing || (posLower === 'rear' && !newSpecs.freehubType) || !newSpecs.spokeCount) {
                console.warn(`Revalidation (${position} Hub): One or more critical hub specs missing. Cannot validate. Clearing.`);
                return null;
            }

            const originalProductInCache = cacheToSearch.find(p => p.id === productId);
            if (!originalProductInCache) {
                console.warn(`Revalidation: Original Product ID ${productId} not found in hub cache. Clearing selection.`);
                return null;
            }
            const originalWheelModel = originalProductInCache.wheelModel;
            const currentVariantNodeOriginalProduct = originalProductInCache.variants.find(v => v.id === variantId);

            if (currentVariantNodeOriginalProduct && checkCompatibilityFn(originalProductInCache, currentVariantNodeOriginalProduct, newSpecs)) {
                console.log(`Revalidation: Current ${position} Hub variant ${currentVariantNodeOriginalProduct.title} IS STILL COMPATIBLE.`);
                let updatedComponentData = { ...currentComponentData, _reval_action: 'kept' };
                if (newSpecs.position === 'Rear') {
                    updatedComponentData.spec_freehub = newSpecs.freehubType;
                }
                return updatedComponentData;
            }

            console.log(`Revalidation: Current ${position} Hub variant IS NO LONGER COMPATIBLE. Searching for replacement.`);

            // For "Your Own Component", we only search within the same product.
            const productsToSearch = (originalProductInCache.vendor === 'Your Own Component')
                ? [originalProductInCache]
                : cacheToSearch.filter(p => p.wheelModel === originalWheelModel);

            if (productsToSearch.length === 0) {
                 console.warn(`Revalidation: Original Hub has no wheelModel or no products in group. Cannot search for alternatives. Clearing.`);
                 return null;
            }

            let replacementVariant = null;
            let replacementProduct = null;
            const targetColor = selectedOptions?.find(o => o.name.toLowerCase() === 'color')?.value;
            let potentialReplacements = [];

            for (const candidateProduct of productsToSearch) {
                for (const variant of candidateProduct.variants) {
                    if (checkCompatibilityFn(candidateProduct, variant, newSpecs)) {
                        potentialReplacements.push({ variant, product: candidateProduct });
                    }
                }
            }

            if (potentialReplacements.length > 0) {
                let preferredReplacement = potentialReplacements.find(pr => pr.product.id === productId);
                if (targetColor) {
                    let colorMatchedInOriginalProduct = null;
                    if (preferredReplacement) {
                        colorMatchedInOriginalProduct = potentialReplacements.find(pr => pr.product.id === productId && pr.variant.selectedOptions?.find(o => o.name.toLowerCase() === 'color')?.value === targetColor);
                    }
                    if (colorMatchedInOriginalProduct) {
                        preferredReplacement = colorMatchedInOriginalProduct;
                    }
                    const colorMatchedOverall = potentialReplacements.find(pr => pr.variant.selectedOptions?.find(o => o.name.toLowerCase() === 'color')?.value === targetColor);
                    if (colorMatchedOverall) {
                        replacementVariant = colorMatchedOverall.variant;
                        replacementProduct = colorMatchedOverall.product;
                    }
                }
                if (!replacementVariant) {
                    if (preferredReplacement) {
                        replacementVariant = preferredReplacement.variant;
                        replacementProduct = preferredReplacement.product;
                    } else {
                        replacementVariant = potentialReplacements[0].variant;
                        replacementProduct = potentialReplacements[0].product;
                    }
                }
            }

            if (replacementVariant && replacementProduct) {
                console.log(`Revalidation: Auto-replacing ${position} Hub with variant ${replacementVariant.title}`);
                let productOptionalAddonGids = replacementProduct.optionalAddonProductGidsFromProduct || [];
                let newComponentStateData = {
                    variantId: replacementVariant.id, productId: replacementProduct.id, productHandle: replacementProduct.handle,
                    title: replacementProduct.title, variantTitle: replacementVariant.title, sku: replacementVariant.sku,
                    price: replacementVariant.price.amount, vendor: replacementProduct.vendor, image: replacementVariant.image,
                    pairingKey: replacementProduct.pairingKey, selectedOptions: replacementVariant.selectedOptions,
                    optionalAddonProductGids: productOptionalAddonGids, _reval_action: 'replaced',
                    tags: replacementProduct.tags || [], spec_spoke_count: String(replacementVariant.spec_spoke_count),
                    spec_brake_interface: replacementVariant.spec_brake_interface, spec_hub_spacing: replacementVariant.spec_hub_spacing,
                    wheelModel: replacementProduct.wheelModel,
                    spec_freehub: (newSpecs.position === 'Rear') ? newSpecs.freehubType : null,
                    weight_g: replacementVariant.weight_g ?? replacementProduct.weight_g ?? null
                };
                return newComponentStateData;
            }

            console.warn(`Revalidation: No compatible replacement Hub found for ${position}. Clearing selection.`);
            return null;

        default:
            console.warn(`attemptRevalidateComponent: Revalidation not configured for type ${typePascal}`);
            return {...currentComponentData, _reval_action: 'kept_no_logic'};
    }
}

async function revalidateAllStep3Selections() {
    if (buildState.step !== 3) return;
    let somethingChangedInState = false;

    const positions = [];
    if (buildState.buildType === 'Front' || buildState.buildType === 'Wheel Set') positions.push('Front');
    if (buildState.buildType === 'Rear' || buildState.buildType === 'Wheel Set') positions.push('Rear');

    for (const position of positions) {
        // --- Revalidate Rims ---
        const rimKey = `${position.toLowerCase()}Rim`;
        const currentRim = buildState.components[rimKey];
        if (currentRim) {
            const newRimData = await attemptRevalidateComponent(position, 'Rim', currentRim);
            if (newRimData === null) {
                if(clearComponentAndItsAddons(position, 'Rim')) somethingChangedInState = true;
                if(buildState.components[`${position.toLowerCase()}ValveStem`]) {
                    if(clearComponentAndItsAddons(position, 'ValveStem')) somethingChangedInState = true;
                }
                await loadAndFilterRimsForPosition(position, true);
            } else if (newRimData._reval_action === 'replaced') {
                manageStickyAddonsForChangedBaseVariant(
                    position,
                    'Rim',
                    currentRim.variantId,
                    newRimData.variantId,
                    newRimData.optionalAddonProductGids
                );
                buildState.components[rimKey] = newRimData;
                updateComponentUI(position, 'Rim', newRimData);
                calculateWheelCosts(position);
                evaluateValveStemForRimChange(position);
                buildState._ui.hasChanges = true;
                updateStep3ButtonText();
                somethingChangedInState = true;
            } else if (newRimData._reval_action === 'kept') {
                buildState.components[rimKey] = newRimData;
                updateComponentUI(position, 'Rim', newRimData);
                evaluateValveStemForRimChange(position);
            }
        }

        // --- Revalidate Hubs ---
        const hubKey = `${position.toLowerCase()}Hub`;
        const currentHub = buildState.components[hubKey];
        if (currentHub) {
            const newHubData = await attemptRevalidateComponent(position, 'Hub', currentHub);

            if (newHubData === null) {
                if(clearComponentAndItsAddons(position, 'Hub')) somethingChangedInState = true;
                if(buildState.components[`${position.toLowerCase()}Spokes`]) {
                    if(clearComponentAndItsAddons(position, 'Spokes')) somethingChangedInState = true;
                }
                if(buildState.components[`${position.toLowerCase()}Nipples`]) {
                    if(clearComponentAndItsAddons(position, 'Nipples')) somethingChangedInState = true;
                }
                await loadAndFilterHubsForPosition(position, true);
            } else if (newHubData._reval_action === 'replaced') {
                manageStickyAddonsForChangedBaseVariant(
                    position, 'Hub', currentHub.variantId, newHubData.variantId,
                    newHubData.optionalAddonProductGids
                );
                buildState.components[hubKey] = newHubData;

                if (position === 'Rear') {
                    const fullProductData = allHubProductsCache.find(p => p.id === newHubData.productId);
                    if (fullProductData) {
                        setComponentFreehubForHub({ ...newHubData, freehubVariantMap: fullProductData.freehubVariantMap });
                    }
                }

                updateComponentUI(position, 'Hub', newHubData);
                calculateWheelCosts(position);
                buildState._ui.hasChanges = true;
                updateStep3ButtonText();
                somethingChangedInState = true;
            } else if (newHubData._reval_action === 'kept') {
                const oldFreehub = currentHub.spec_freehub;
                const newFreehub = newHubData.spec_freehub;
                buildState.components[hubKey] = newHubData;

                if (position === 'Rear') {
                    const fullProductData = allHubProductsCache.find(p => p.id === newHubData.productId);
                    if (fullProductData) {
                        setComponentFreehubForHub({ ...newHubData, freehubVariantMap: fullProductData.freehubVariantMap });
                    }
                }

                updateComponentUI(position, 'Hub', newHubData);
                if (oldFreehub !== newFreehub) {
                    somethingChangedInState = true;
                }
            }
        }
    }

    if (somethingChangedInState) {
        updateSubtotal();
        updateBuildSummary();
        updateHubSpokeCompatibilityUI();
        validateStep3();
        saveLastActiveBuild();
    }
}
  
// I9-SYSTEM: assets/i9-system.js calls this (through the bridge) when the Spoke Interface or the System hub model changes,
// because the product fetch filter in fetchBuilderComponentProducts depends on them. Classic code never calls it.
// Each reset starts a new fetch generation: a fetch that was still in flight for the previous context (Standard vs System,
// Hydra2 vs Solix) must not overwrite the caches when it finishes after the new one. Classic builds never bump the generation.
let i9FetchGeneration = 0;
function i9ResetProductCaches() {
    i9FetchGeneration++;
    allRimProductsCache = []; allHubProductsCache = []; allSpokeProductsCache = [];
    componentFetchPromises.rims = null; componentFetchPromises.hubs = null; componentFetchPromises.spokes = null;
}
// I9-SYSTEM: assets/i9-system.js fills the caches from its prefetched System products (already filtered for the chosen hub model),
// so Step 2 does not wait on the network once the prefetch is in. Resolved promises keep the loaders from refetching; the generation
// bump discards any on-demand fetch still in flight. Classic code never calls it.
function i9SetProductCaches(data) {
    i9FetchGeneration++;
    allRimProductsCache = data.rims || []; allHubProductsCache = data.hubs || []; allSpokeProductsCache = data.spokes || [];
    componentFetchPromises.rims = Promise.resolve(allRimProductsCache);
    componentFetchPromises.hubs = Promise.resolve(allHubProductsCache);
    componentFetchPromises.spokes = Promise.resolve(allSpokeProductsCache);
    updateGlobalVendorLogoMap(allRimProductsCache); updateGlobalVendorLogoMap(allHubProductsCache); updateGlobalVendorLogoMap(allSpokeProductsCache);
}

function triggerEarlyComponentFetches() {
    const currentRidingStyle = buildState.ridingStyle;
    if (!currentRidingStyle) return; // Wait until we know the style

    // 1. RIMS (Only fetch if not already in progress)
    if (!componentFetchPromises.rims) {
        console.log(`[Predictive] Starting Rim fetch for: ${currentRidingStyle}`);
        componentFetchPromises.rims = fetchRimProducts(currentRidingStyle).catch(err => {
            console.error("Early rim fetch failed:", err);
            componentFetchPromises.rims = null; // Allow retry
        });
    }

    // 2. HUBS (Discipline agnostic, fetch immediately)
    if (!componentFetchPromises.hubs) {
        console.log(`[Predictive] Starting Hub fetch...`);
        componentFetchPromises.hubs = fetchHubProducts().catch(err => {
            console.error("Early hub fetch failed:", err);
            componentFetchPromises.hubs = null; // Allow retry
        });
    }

    // 3. Other components (Spokes, Nipples, etc.)
    if (!componentFetchPromises.spokes) componentFetchPromises.spokes = fetchSpokeProducts();
    if (!componentFetchPromises.nipples) componentFetchPromises.nipples = fetchNippleProducts();
    if (!componentFetchPromises.valves) componentFetchPromises.valves = fetchValveStemProducts();
    if (!componentFetchPromises.freehubs) componentFetchPromises.freehubs = fetchFreehubComponentProducts();
}
  
function clearComponentAndItsAddons(position, typePascal) {
    const posLower = position.toLowerCase();
    const stateKeyBase = `${posLower}${typePascal}`; // e.g., "frontSpokes"

    const clearedBaseComponent = buildState.components[stateKeyBase];
    if (!clearedBaseComponent) {
        // console.log(`clearComponentAndItsAddons: No ${position} ${typePascal} to clear.`);
        return false; // Nothing was cleared
    }

    const baseVariantIdToClearAddonsFor = clearedBaseComponent.variantId;

    // 1. Clear base component from buildState
    buildState.components[stateKeyBase] = null;

    // 2. Clear associated optional addons for the specific cleared base component variant
    let addonsWereCleared = false;
    const addonKeysToPotentiallyRemove = Object.keys(buildState.selectedOptionalAddons);
    for (const addonKey of addonKeysToPotentiallyRemove) {
        const selectedAddon = buildState.selectedOptionalAddons[addonKey];
        if (selectedAddon.baseComponentPosition === position &&
            selectedAddon.baseComponentType === typePascal && // Ensure type matches (e.g., 'Spokes')
            selectedAddon.baseComponentVariantId === baseVariantIdToClearAddonsFor) {
            
            delete buildState.selectedOptionalAddons[addonKey];
            addonsWereCleared = true;
            saveLastActiveBuild();
        }
    }

    // 3. Update UI for the cleared base component
    // This will also trigger updateSelectedAddonsDisplayOnCard for the (now null) base component.
    updateComponentUI(position, typePascal, null);

    // 4. Recalculate costs, update summary, and re-validate Step 3
    // For hub/spoke incompatibility, calculateWheelCosts for the *specific wheel* might be important
    // if a hub (which determines assembly cost) was cleared.
    if (typePascal === 'Hub') { // If a hub was cleared, assembly cost might change
         calculateWheelCosts(position);
    }
    updateSubtotal();
    updateBuildSummary();
    validateStep3();
    saveLastActiveBuild();
    updateMismatchHints();
  
    return true; // Indicates that the base component (and potentially addons) were cleared
}
  
// --- BLOCK FOR ALL ADDON MODAL HELPER FUNCTIONS ---

async function fetchAndDisplayAddonDetailsInModal(addonProductGidsString) {
    if (!addonsModalBody) {
        console.error("fetchAndDisplayAddonDetailsInModal: Modal body element not found.");
        addonsModalBody.innerHTML = '<p>Error: Modal body not available.</p>';
        return;
    }

    const productGids = addonProductGidsString.split(',').filter(gid => gid.trim() !== '');
    if (productGids.length === 0) {
        addonsModalBody.innerHTML = '<p>No add-on GIDs provided.</p>';
        return;
    }

    addonsModalBody.innerHTML = '<p>Loading add-on details...</p>';

    const query = `
      query getAddonProductsDetails($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on Product {
            __typename
            id
            title
            handle
            vendor
            pairingKey: metafield(namespace: "custom", key: "pairing_key") { value } # <<< --- ADD THIS LINE ---
            options(first: 5) {
              id
              name
              values
            }
            variants(first: 50) {
              edges {
                node {
                  id
                  title
                  sku
                  availableForSale
                  price { amount currencyCode }
                  image { url(transform:{maxWidth:100, maxHeight:100}) altText }
                  selectedOptions { name value }
                }
              }
            }
            # If your addon products themselves can have 'optional_addon_gids' (unlikely for now, but if so, keep this part)
            # optionalAddonProductGids: metafield(namespace: "custom", key: "optional_addon_gids") {
            #     value
            # }
          }
        }
      }
    `;

    try {
        const data = await storefrontApiQuery(query, { ids: productGids });

        if (!data || !data.nodes || data.nodes.length === 0) {
            addonsModalBody.innerHTML = '<p>Could not fetch details for the add-ons.</p>';
            console.warn("fetchAndDisplayAddonDetailsInModal: No nodes returned for addon GIDs", productGids, data);
            return;
        }

        // Process the fetched products to include the pairingKey value directly
        const addonProducts = data.nodes
            .filter(node => node && node.__typename === 'Product')
            .map(productNode => {
                return {
                    ...productNode, // Spread all existing product data
                    pairingKeyValue: productNode.pairingKey?.value || null // Add pairingKeyValue for easier access
                };
            });


        if (addonProducts.length === 0) {
            addonsModalBody.innerHTML = '<p>No valid add-on products found.</p>';
            return;
        }

        if (addonsModal) {
            // Store the processed products (which now include pairingKeyValue)
            addonsModal.dataset.currentAddonProducts = JSON.stringify(addonProducts);
        }
        renderAddonProductsInModal(addonProducts);

    } catch (error) {
        console.error("Error fetching addon product details:", error);
        addonsModalBody.innerHTML = `<p>Error loading add-on details: ${error.message}</p>`;
    }
}

// --- START: DELEGATING HANDLER FOR MODAL ACTION BUTTONS --- // <<< This would start on line 208
function handleModalActionButtonsClick(event) {
    const addBuildButton = event.target.closest('.add-addon-to-build-btn');
    const matchButton = event.target.closest('.match-addon-btn'); // Generic class for both match buttons

    if (addBuildButton) {
        handleAddonBuildButtonClick(event); 
    } else if (matchButton) {
        handleGenericMatchButtonClick(event, matchButton);
    }
}
// --- END: DELEGATING HANDLER FOR MODAL ACTION BUTTONS ---
  
function renderAddonProductsInModal(addonProducts) {
    if (!addonsModalBody) return;
    addonsModalBody.innerHTML = ''; 

    const basePosFromModal = addonsModal.dataset.basePosition;
    const baseTypeFromModal = addonsModal.dataset.baseType;
    const currentBaseComponentVariantId = addonsModal.dataset.baseVariantId;

    addonProducts.forEach(product => { 
        if (!product.variants || !product.variants.edges || product.variants.edges.length === 0) {
            console.warn(`Addon product ${product.title} has no variants or variants data is missing. Skipping.`);
            return;
        }

        const productCard = document.createElement('div');
        productCard.className = 'addon-item-card';
        productCard.dataset.addonProductId = product.id;

        let cardHTML = `
            <div class="addon-item-image">
                ${product.variants.edges[0].node.image ? `<img src="${product.variants.edges[0].node.image.url}" alt="${product.title}">` : '<div class="selected-addon-thumbnail-placeholder"></div>'}
            </div>
            <div class="addon-item-details">
                <h4>${product.title}</h4>
                <div class="addon-variant-selector" data-product-id="${product.id}"></div>
                <p class="addon-variant-price" data-product-id="${product.id}"></p>
            </div>
            <div class="addon-item-actions">
                <button type="button" class="builder-button add-addon-to-build-btn" data-product-id="${product.id}" disabled>Add to Build</button>
            </div>
        `;
        productCard.innerHTML = cardHTML;
        addonsModalBody.appendChild(productCard);

        const variantSelectorContainer = productCard.querySelector(`.addon-variant-selector[data-product-id="${product.id}"]`);
        
        let actualSelectedAddonVariantGidForThisInstance = null;
        if (basePosFromModal && baseTypeFromModal && currentBaseComponentVariantId) {
            const fullAddonKeyForLookup = `${basePosFromModal}_${baseTypeFromModal}_${currentBaseComponentVariantId}_${product.id}`;
            const selectedAddonInstanceDetails = buildState.selectedOptionalAddons[fullAddonKeyForLookup];
            
            if (selectedAddonInstanceDetails) {
                actualSelectedAddonVariantGidForThisInstance = selectedAddonInstanceDetails.addonVariantId;
            }
        }

        populateAddonVariantSelector(product, variantSelectorContainer, actualSelectedAddonVariantGidForThisInstance);
        updateAddonPriceAndButtonState(product, productCard); 
    });
    
    if (basePosFromModal && baseTypeFromModal && currentBaseComponentVariantId) {
        updateAddonButtonsStateInModal(basePosFromModal, baseTypeFromModal, currentBaseComponentVariantId);
    }
    
    addonsModalBody.removeEventListener('change', handleAddonVariantChangeInModal); 
    addonsModalBody.addEventListener('change', handleAddonVariantChangeInModal);

    addonsModalBody.removeEventListener('click', handleModalActionButtonsClick); // Remove if already exists
    addonsModalBody.addEventListener('click', handleModalActionButtonsClick);
}

function populateAddonVariantSelector(product, container, currentlySelectedAddonVariantGid) {
    container.innerHTML = ''; 

    let selectedVariantNodeDetails = null;

    // Priority 1: Use the "sticky" variant already selected in the build
    if (currentlySelectedAddonVariantGid) {
        const foundEdge = product.variants.edges.find(edge => edge.node.id === currentlySelectedAddonVariantGid);
        if (foundEdge) {
            selectedVariantNodeDetails = foundEdge.node;
        }
    }

    // Priority 2: If no sticky variant (or it was removed), find the first one that is IN STOCK
    if (!selectedVariantNodeDetails) {
        const firstAvailableEdge = product.variants.edges.find(edge => edge.node.availableForSale);
        if (firstAvailableEdge) {
            selectedVariantNodeDetails = firstAvailableEdge.node;
        }
    }

    product.options.forEach(option => { 
        if (option.values.length > 0) { 
            const optionDiv = document.createElement('div');
            optionDiv.className = 'addon-option-group';
            
            const label = document.createElement('label');
            label.htmlFor = `addon-${product.id}-option-${option.name.replace(/\s+/g, '-')}`;
            label.textContent = `${option.name}:`;
            optionDiv.appendChild(label);
            
            const select = document.createElement('select');
            select.id = `addon-${product.id}-option-${option.name.replace(/\s+/g, '-')}`;
            select.dataset.optionName = option.name;
            select.dataset.productId = product.id;

            let valueToPreselect = null;
            if (selectedVariantNodeDetails && selectedVariantNodeDetails.selectedOptions) {
                const matchingSelectedOptionFromVariant = selectedVariantNodeDetails.selectedOptions.find(selOpt => selOpt.name === option.name);
                if (matchingSelectedOptionFromVariant) {
                    valueToPreselect = matchingSelectedOptionFromVariant.value;
                }
            }

            option.values.forEach(value => { 
                const opt = document.createElement('option');
                opt.value = value;
                
                // Check if THIS specific option value is available in ANY in-stock variant
                // (This provides a hint to the user in the dropdown)
                const isPossibleInStock = product.variants.edges.some(edge => 
                    edge.node.availableForSale && 
                    edge.node.selectedOptions.some(so => so.name === option.name && so.value === value)
                );
                
                opt.textContent = isPossibleInStock ? value : `${value} (Out of Stock)`;
                if (valueToPreselect && value === valueToPreselect) {
                    opt.selected = true; 
                }
                select.appendChild(opt);
            });
            optionDiv.appendChild(select);
            container.appendChild(optionDiv);
        }
    });
}

function handleAddonVariantChangeInModal(event) {
    if (event.target.tagName === 'SELECT' && event.target.closest('.addon-variant-selector')) {
        const selectElement = event.target;
        const productId = selectElement.dataset.productId;
        const productCard = addonsModalBody.querySelector(`.addon-item-card[data-addon-product-id="${productId}"]`);
        
        const allAddonProductsData = JSON.parse(addonsModal.dataset.currentAddonProducts || '[]');
        const productData = allAddonProductsData.find(p => p.id === productId);

        if (productData && productCard) {
            updateAddonPriceAndButtonState(productData, productCard); 
            
            const basePosFromModal = addonsModal.dataset.basePosition;
            const baseTypeFromModal = addonsModal.dataset.baseType;
            const baseVarIdFromModal = addonsModal.dataset.baseVariantId;
            if (basePosFromModal && baseTypeFromModal && baseVarIdFromModal) { 
                updateAddonButtonsStateInModal(basePosFromModal, baseTypeFromModal, baseVarIdFromModal);
            }
        }
    }
}

function updateAddonPriceAndButtonState(product, productCard) {
    const selectedOptionsFromForm = [];
    const selects = productCard.querySelectorAll('.addon-variant-selector select');
    
    if (selects.length > 0) {
        selects.forEach(select => {
            selectedOptionsFromForm.push({
                name: select.dataset.optionName,
                value: select.value
            });
        });
    } else { 
        product.options.forEach(opt => {
            if (opt.values.length === 1) {
                selectedOptionsFromForm.push({ name: opt.name, value: opt.values[0] });
            }
        });
    }

    const matchingVariantEdge = product.variants.edges.find(edge => {
        const variant = edge.node;
        if (selectedOptionsFromForm.length === 0 && variant.selectedOptions.length === 0) return true;
        if (selectedOptionsFromForm.length !== variant.selectedOptions.length) return false;
        return selectedOptionsFromForm.every(selOpt => 
            variant.selectedOptions.some(vOpt => vOpt.name === selOpt.name && vOpt.value === selOpt.value)
        );
    });

    const priceElement = productCard.querySelector('.addon-variant-price');
    const addButton = productCard.querySelector('.add-addon-to-build-btn');
    const imageElement = productCard.querySelector('.addon-item-image img'); 
    const imagePlaceholder = productCard.querySelector('.addon-item-image .selected-addon-thumbnail-placeholder'); 

    if (matchingVariantEdge && matchingVariantEdge.node.availableForSale) {
        const variantNode = matchingVariantEdge.node;
        priceElement.textContent = `Price: ${formatPrice(parseFloat(variantNode.price.amount) * 100)}`;
        priceElement.classList.remove('is-unavailable-text'); // Remove red color if present
        
        // ENABLE the button
        addButton.disabled = false;
        addButton.style.opacity = "1";
        addButton.style.cursor = "pointer";

        addButton.dataset.selectedVariantId = variantNode.id; 
        addButton.dataset.selectedVariantPrice = parseFloat(variantNode.price.amount) * 100;
        
        let addonVariantDisplayTitle = product.title;
        const optionsString = variantNode.selectedOptions.map(o => o.value).join(' / ');
        if (optionsString && optionsString !== 'Default Title') {
             addonVariantDisplayTitle += ` (${optionsString})`;
        }
        addButton.dataset.selectedVariantFullTitle = addonVariantDisplayTitle;
        
        if (variantNode.image && variantNode.image.url) {
            if (imageElement) {
                imageElement.src = variantNode.image.url;
                imageElement.style.display = 'block';
                if (imagePlaceholder) imagePlaceholder.style.display = 'none';
            }
            addButton.dataset.selectedVariantImage = variantNode.image.url;
        }
    } else {
        // DISABLE the button if out of stock or variant doesn't exist
        priceElement.textContent = "Option currently unavailable";
        priceElement.classList.add('is-unavailable-text'); // Add a red styling class
        
        addButton.disabled = true;
        addButton.textContent = "Unavailable";
        addButton.style.opacity = "0.5";
        addButton.style.cursor = "not-allowed";
        
        delete addButton.dataset.selectedVariantId;
    }
}

// --- START: FUNCTION - Build Validation Summary ---
function updateValidationSummary() {
    const validationSummaryEl = document.getElementById('build-validation-summary');
    if (!validationSummaryEl) {
        return; // Do nothing if the element doesn't exist
    }

    const { buildType, components } = buildState;
    const missingFront = [];
    const missingRear = [];

    // This array defines the correct display order
    const mandatoryComponentTypes = [
        { key: 'Rim', display: 'Rim' },
        { key: 'Hub', display: 'Hub' },
        { key: 'Spokes', display: 'Spokes' },
        { key: 'Nipples', display: 'Nipples' }
    ].filter(t => t.key !== 'Nipples' || !window.I9System?.isSystem()); // I9-SYSTEM

    // Check for missing FRONT components
    if (buildType === 'Front' || buildType === 'Wheel Set') {
        mandatoryComponentTypes.forEach(type => {
            if (!components[`front${type.key}`]) {
                missingFront.push({
                    name: type.display,
                    targetId: `front-${type.key.toLowerCase()}-subsection`
                });
            }
        });
    }

    // Check for missing REAR components
    if (buildType === 'Rear' || buildType === 'Wheel Set') {
        mandatoryComponentTypes.forEach(type => {
            if (!components[`rear${type.key}`]) {
                missingRear.push({
                    name: type.display,
                    targetId: `rear-${type.key.toLowerCase()}-subsection`
                });
            }
        });
    }

    // Only display the box if there's at least one missing component
    if (missingFront.length > 0 || missingRear.length > 0) {
        let html = '<h4>Build Not Complete</h4><p>Please select the following required components to proceed:</p>';
        html += '<div class="validation-columns-container">'; // Flex container for columns

        // --- Front Column ---
        if (missingFront.length > 0) {
            html += '<div class="validation-column">';
            html += '<h5>Front Wheel</h5><ul>';
            missingFront.forEach(item => {
                html += `<li><a href="#" class="validation-summary-link" data-target-id="${item.targetId}">${item.name}</a></li>`;
            });
            html += '</ul></div>';
        }

        // --- Rear Column ---
        if (missingRear.length > 0) {
            html += '<div class="validation-column">';
            html += '<h5>Rear Wheel</h5><ul>';
            missingRear.forEach(item => {
                html += `<li><a href="#" class="validation-summary-link" data-target-id="${item.targetId}">${item.name}</a></li>`;
            });
            html += '</ul></div>';
        }

        html += '</div>'; 

        validationSummaryEl.innerHTML = html;
        validationSummaryEl.style.display = 'block';
    } else {
        validationSummaryEl.innerHTML = '';
        validationSummaryEl.style.display = 'none';
    }
}
// --- END: Build Validation Summary ---
  
async function handleAddonBuildButtonClick(event) {
    const clickedButton = event.target.closest('.add-addon-to-build-btn');
    if (!clickedButton) return;
     // ... (rest of the initial variable setup: addonProductId, selectedAddonVariantId, etc.)
    event.preventDefault();
    if (clickedButton.disabled) return;
    
    const addonProductId = clickedButton.dataset.productId; // GID of the addon product being actioned
    const selectedAddonVariantId = clickedButton.dataset.selectedVariantId; // GID of its variant
    const selectedAddonPriceCents = parseInt(clickedButton.dataset.selectedVariantPrice);
    const selectedAddonFullTitle = clickedButton.dataset.selectedVariantFullTitle;
    const selectedAddonImage = clickedButton.dataset.selectedVariantImage || null;

    if (!selectedAddonVariantId || isNaN(selectedAddonPriceCents) || !selectedAddonFullTitle) {
        console.error("handleAddonBuildButtonClick: Essential data missing from button dataset.", clickedButton.dataset);
        alert("Could not add this option, data is missing.");
        return;
    }

    const basePosition = addonsModal.dataset.basePosition; 
    const baseType = addonsModal.dataset.baseType; 
    const baseComponentVariantId = addonsModal.dataset.baseVariantId;

    if (!basePosition || !baseType || !baseComponentVariantId) {
        console.error("handleAddonBuildButtonClick: Base component context missing from modal dataset.");
        alert("Error: Cannot associate this addon with a base component.");
        return;
    }

    const currentAddonKey = `${basePosition}_${baseType}_${baseComponentVariantId}_${addonProductId}`;
    const isCurrentlySelectedExactVariant = buildState.selectedOptionalAddons[currentAddonKey]?.addonVariantId === selectedAddonVariantId;
    
    let parentAddonProductData = null;
    try {
        const allFetchedAddonProducts = JSON.parse(addonsModal.dataset.currentAddonProducts || '[]').map(p => ({
            ...p, 
            pairingKeyValue: p.pairingKey?.value || p.pairingKeyValue || null // Ensure pairingKeyValue is used if already processed
        }));
        parentAddonProductData = allFetchedAddonProducts.find(p => p.id === addonProductId);
    } catch (e) { console.error("handleAddonBuildButtonClick: Error parsing currentAddonProducts for handle/pairingKey:", e); }
    
    const currentAddonProductPairingKey = parentAddonProductData ? parentAddonProductData.pairingKeyValue : null;

    if (isCurrentlySelectedExactVariant) { // User is REMOVING the addon
        // --- ADVANCED DE-PAIRING (this part seemed mostly okay, ensure it covers both cases) ---
        const canHavePairedAddon = ['Rim', 'Hub', 'Spokes', 'Nipples', 'ValveStem'].includes(baseType);
        if (canHavePairedAddon && buildState.buildType === 'Wheel Set' && currentAddonProductPairingKey) {
            const oppositePosition = basePosition === 'Front' ? 'Rear' : 'Front';
            const oppositeComponentStateKey = `${oppositePosition.toLowerCase()}${baseType}`;
            const oppositeBaseComponent = buildState.components[oppositeComponentStateKey];

            if (oppositeBaseComponent && oppositeBaseComponent.variantId) {
                let oppositePairedAddonKeyToRemove = null;
                let oppositePairedAddonDetails = null;

                for (const key in buildState.selectedOptionalAddons) {
                    const addonEntry = buildState.selectedOptionalAddons[key];
                    if (addonEntry.baseComponentPosition === oppositePosition &&
                        addonEntry.baseComponentType === baseType &&
                        addonEntry.baseComponentVariantId === oppositeBaseComponent.variantId &&
                        addonEntry.addonProductPairingKey === currentAddonProductPairingKey) {
                        
                        // Check if it's an identical item pair OR a different product pair
                        if (addonEntry.addonProductId === addonProductId) { // Identical item (e.g. valve caps)
                            if (addonEntry.addonVariantId === selectedAddonVariantId) { // Ensure variant matches too
                                oppositePairedAddonKeyToRemove = key;
                                oppositePairedAddonDetails = addonEntry;
                                break;
                            }
                        } else { // Different product with same pairing key (e.g. bearings)
                            oppositePairedAddonKeyToRemove = key;
                            oppositePairedAddonDetails = addonEntry;
                            break;
                        }
                    }
                }

                if (oppositePairedAddonKeyToRemove && oppositePairedAddonDetails) {
                    const oppositeDisplayName = `${oppositePosition} ${getDisplayName(baseType.toLowerCase())}`;
                    const removePairMsg = `The ${oppositeDisplayName} also has ${oppositePairedAddonDetails.addonName} selected (paired). Remove it as well?`;
                    if (confirm(removePairMsg)) {
                        delete buildState.selectedOptionalAddons[oppositePairedAddonKeyToRemove];
                        updateSelectedAddonsDisplayOnCard(oppositePosition, baseType, oppositeBaseComponent.variantId);
                        saveLastActiveBuild();
                    }
                }
            }
        }
        delete buildState.selectedOptionalAddons[currentAddonKey];
        updateSubtotal();
        buildState._ui.hasChanges = true;
        updateStep3ButtonText();
        saveLastActiveBuild();

    } else { // User is ADDING/CHANGING the addon
        buildState.selectedOptionalAddons[currentAddonKey] = {
            baseComponentPosition: basePosition, baseComponentType: baseType,
            baseComponentVariantId: baseComponentVariantId, addonProductId: addonProductId,
            addonVariantId: selectedAddonVariantId, addonName: selectedAddonFullTitle,
            addonPriceCents: selectedAddonPriceCents, addonImage: selectedAddonImage,
            addonProductHandle: parentAddonProductData ? parentAddonProductData.handle : null,
            addonProductPairingKey: currentAddonProductPairingKey // Store the pairing key
        };
      updateSubtotal();
    }
        updateSelectedAddonsDisplayOnCard(basePosition, baseType, baseComponentVariantId);
    await updateAddonButtonsStateInModal(basePosition, baseType, baseComponentVariantId); 
    
    const canPairForModalUpdate = ['Rim', 'Hub', 'Spokes', 'Nipples', 'ValveStem'].includes(baseType);
    if (canPairForModalUpdate && buildState.buildType === 'Wheel Set') {
        const oppositePositionForModalCheck = basePosition === 'Front' ? 'Rear' : 'Front';
        const oppositeComponentForModalCheckKey = `${oppositePositionForModalCheck.toLowerCase()}${baseType}`;
        const oppositeBaseComponentForModalCheck = buildState.components[oppositeComponentForModalCheckKey];
        if (oppositeBaseComponentForModalCheck && oppositeBaseComponentForModalCheck.variantId) {
            if (addonsModal.style.display !== 'none' &&
                addonsModal.dataset.basePosition === oppositePositionForModalCheck &&
                addonsModal.dataset.baseType === baseType && 
                addonsModal.dataset.baseVariantId === oppositeBaseComponentForModalCheck.variantId) {
                await updateAddonButtonsStateInModal(oppositePositionForModalCheck, baseType, oppositeBaseComponentForModalCheck.variantId);
            }
        }
    }
    
// Update the subtotal and summary to reflect the change immediately.
updateSubtotal();
updateBuildSummary();

// Validate Step 3 to enable/disable the "Add to Cart" button.
validateStep3();

// Save the progress.
saveLastActiveBuild();
}

function handleRemoveSelectedAddonFromCard(event) {
    const button = event.currentTarget;
    const basePos = button.dataset.basePosition;
    const baseType = button.dataset.baseType;
    const baseVarId = button.dataset.baseVariantId;
    const addonProdId = button.dataset.addonProductId;

    if (!basePos || !baseType || !baseVarId || !addonProdId) {
        console.error("Cannot remove addon from card, essential data missing from button.");
        return;
    }

    const addonKeyToRemove = `${basePos}_${baseType}_${baseVarId}_${addonProdId}`;
    if (buildState.selectedOptionalAddons[addonKeyToRemove]) {
        console.log(`Removing addon via card 'x': Key ${addonKeyToRemove}`);
        delete buildState.selectedOptionalAddons[addonKeyToRemove];
        buildState._ui.hasChanges = true;
        updateStep3ButtonText();

        updateSubtotal();
        updateBuildSummary();
        updateSelectedAddonsDisplayOnCard(basePos, baseType, baseVarId);
        saveLastActiveBuild();
        
        if (addonsModal.style.display !== 'none' &&
            addonsModal.dataset.basePosition === basePos &&
            addonsModal.dataset.baseType === baseType &&
            addonsModal.dataset.baseVariantId === baseVarId) {
            updateAddonButtonsStateInModal(basePos, baseType, baseVarId);
        }
        saveLastActiveBuild();
    }
}

function updateSelectedAddonsDisplayOnCard(basePosition, baseTypePascal, baseComponentVariantId) {
    const posLower = basePosition.toLowerCase();
    let typeLowerForDOM = baseTypePascal.toLowerCase();
    if (baseTypePascal === "ValveStem") typeLowerForDOM = "valvestem";
    else if (baseTypePascal === "Spokes") typeLowerForDOM = "spokes";
    else if (baseTypePascal === "Nipples") typeLowerForDOM = "nipples";

    const selectionContainer = document.getElementById(`${posLower}-${typeLowerForDOM}-selection`);

    // **CHANGE 1: Find button from the parent subsection, not the summary span container**
    const subsectionContainer = document.getElementById(`${posLower}-${typeLowerForDOM}-subsection`);
    if (!subsectionContainer) {
        console.warn(`updateSelectedAddonsDisplayOnCard: Subsection container not found for ${posLower}-${typeLowerForDOM}-subsection`);
        return;
    }
    const addonsButtonElement = subsectionContainer.querySelector('.optional-addons-btn');
    // **END CHANGE 1**

    let listContainerElement = document.getElementById(`${posLower}-${typeLowerForDOM}-selected-addons-list`);

    if (!listContainerElement || !addonsButtonElement) {
        if (addonsButtonElement) { 
             // **CHANGE 2: Simplified button text**
            addonsButtonElement.textContent = "Add Ons";
        }
        if (listContainerElement && !baseComponentVariantId) {
            listContainerElement.innerHTML = '';
            listContainerElement.style.display = 'none';
        }
        return;
    }

    listContainerElement.innerHTML = ''; 

    if (!baseComponentVariantId) { 
        addonsButtonElement.textContent = "Add Ons";
        listContainerElement.style.display = 'none';
        return;
    }
    
    // **CHANGE 3: Simplified button text logic**
    const matchingSelectedAddons = [];
    for (const key in buildState.selectedOptionalAddons) {
        const addon = buildState.selectedOptionalAddons[key];
        if (addon.baseComponentPosition === basePosition &&
            addon.baseComponentType === baseTypePascal &&
            addon.baseComponentVariantId === baseComponentVariantId) {
            matchingSelectedAddons.push(addon);
        }
    }

    if (matchingSelectedAddons.length > 0) {
        addonsButtonElement.textContent = `Add Ons (${matchingSelectedAddons.length} selected)`;
    } else {
        addonsButtonElement.textContent = "Add Ons";
    }
    // **END CHANGE 3**

    if (matchingSelectedAddons.length > 0) {
        listContainerElement.style.display = 'block'; 
        const ul = document.createElement('ul');
        matchingSelectedAddons.forEach(addon => {
            const li = document.createElement('li');
            
            let addonImageHtml = '';
            if (addon.addonImage) {
                addonImageHtml = `<img src="${addon.addonImage}" alt="${addon.addonName}" class="selected-addon-thumbnail">`;
            } else {
                addonImageHtml = `<div class="selected-addon-thumbnail-placeholder"></div>`;
            }

            let addonNameText = `+ ${addon.addonName}`; 
            let addonNameHtml = `<span class="selected-addon-name-text">${addonNameText}</span>`; 
            if (addon.addonProductHandle) {
                const productUrl = `/products/${addon.addonProductHandle}`;
                addonNameHtml = `<span class="selected-addon-name-text"><a href="${productUrl}" target="_blank" title="View ${addon.addonName} product page">${addonNameText}</a></span>`;
            }
            
            const removeXButtonHtml = `<button type="button" class="remove-selected-addon-btn" 
                                         data-base-position="${addon.baseComponentPosition}"
                                         data-base-type="${addon.baseComponentType}"
                                         data-base-variant-id="${addon.baseComponentVariantId}"
                                         data-addon-product-id="${addon.addonProductId}"
                                         aria-label="Remove ${addon.addonName}">×</button>`;
            
            li.innerHTML = `${addonImageHtml} ${addonNameHtml} ${removeXButtonHtml}`;
            ul.appendChild(li);
        });
        listContainerElement.appendChild(ul);

        listContainerElement.querySelectorAll('.remove-selected-addon-btn').forEach(button => {
            button.removeEventListener('click', handleRemoveSelectedAddonFromCard); 
            button.addEventListener('click', handleRemoveSelectedAddonFromCard);
        });

    } else {
        listContainerElement.style.display = 'none'; 
    }
}


// --- START: ADDONS MODAL FUNCTIONS --- (openAddonsModal, closeAddonsModal)
    function openAddonsModal(baseComponentPosition, baseComponentType, baseComponentProductId, baseComponentVariantId, optionalAddonProductGidsString) {
        if (!addonsModal || !addonsModalTitle || !addonsModalBody) {
            console.error("Addons modal elements not found.");
            return;
        }

        addonsModal.dataset.basePosition = baseComponentPosition;
        addonsModal.dataset.baseType = baseComponentType;
        addonsModal.dataset.baseProductId = baseComponentProductId;
        addonsModal.dataset.baseVariantId = baseComponentVariantId;

        const cleanTypePascal = baseComponentType.replace(/([A-Z])/g, ' $1').trim();
        let titleBase = (baseComponentType === "ValveStem") ? `${baseComponentPosition} Valve Stem` : `${baseComponentPosition} ${cleanTypePascal}`;
        addonsModalTitle.textContent = `${titleBase} Options & Upgrades`;
        
        addonsModalBody.innerHTML = '<p>Loading add-on options...</p>'; 
        addonsModal.style.display = 'flex'; 

        console.log("Opening addons modal for:", {
            position: baseComponentPosition, type: baseComponentType,
            baseProductId: baseComponentProductId, baseVariantId: baseComponentVariantId,
            addonProductGids: optionalAddonProductGidsString
        });
        
        addonsModal.dataset.currentAddonProducts = '[]'; 
        fetchAndDisplayAddonDetailsInModal(optionalAddonProductGidsString); 
    }

// --- END: ADDONS MODAL FUNCTIONS ---

// --- START: HANDLE "MATCH ADDON TO OPPOSITE" CLICKS ---
async function handleGenericMatchButtonClick(event, clickedMatchButton) {
    event.preventDefault();

    const action = clickedMatchButton.dataset.action; 
    
    let positionToApplyMatch, baseTypeToApplyMatch, addonProductToApplyId,
        sourceAddonVariantToMatchId, sourceAddonProductIdToMatch;

    if (action === "match-to") { 
        positionToApplyMatch = clickedMatchButton.dataset.targetPosition; 
        baseTypeToApplyMatch = clickedMatchButton.dataset.sourceBaseType; 
        addonProductToApplyId = clickedMatchButton.dataset.targetAddonProductId; 
        sourceAddonVariantToMatchId = clickedMatchButton.dataset.sourceAddonVariantId; 
        sourceAddonProductIdToMatch = clickedMatchButton.dataset.sourceAddonProductId; 
    } else if (action === "match-from") { 
        positionToApplyMatch = clickedMatchButton.dataset.targetPosition; 
        baseTypeToApplyMatch = clickedMatchButton.dataset.targetBaseType; 
        addonProductToApplyId = clickedMatchButton.dataset.targetAddonProductId; 
        sourceAddonVariantToMatchId = clickedMatchButton.dataset.sourceAddonVariantId; 
        sourceAddonProductIdToMatch = clickedMatchButton.dataset.sourceAddonProductId; 
    } else {
        console.error("Unknown match button action:", action);
        return;
    }

    const baseComponentToApplyOn = buildState.components[`${positionToApplyMatch.toLowerCase()}${baseTypeToApplyMatch}`];
    if (!baseComponentToApplyOn || !baseComponentToApplyOn.variantId) {
        alert(`Error: The ${positionToApplyMatch} ${getDisplayName(baseTypeToApplyMatch.toLowerCase())} is not selected.`);
        return;
    }

    const productToApplyDetailsArray = await fetchAddonProductDetailsByGids([addonProductToApplyId]);
    if (!productToApplyDetailsArray || productToApplyDetailsArray.length === 0) {
        alert("Error: Could not load details for the item to match.");
        return;
    }
    const productToApplyInfo = productToApplyDetailsArray[0];

    let variantToApply = null;
    if (productToApplyInfo.variants && productToApplyInfo.variants.length > 0) {
        if (addonProductToApplyId === sourceAddonProductIdToMatch) { 
            variantToApply = productToApplyInfo.variants.find(v => v.id === sourceAddonVariantToMatchId && v.availableForSale);
        }
        if (!variantToApply) {
            const sourceAddonFromState = Object.values(buildState.selectedOptionalAddons).find(
                sa => sa.addonVariantId === sourceAddonVariantToMatchId && sa.addonProductId === sourceAddonProductIdToMatch
            );
            const sourceNameLower = sourceAddonFromState?.addonName.toLowerCase() || "";
            if (sourceNameLower.includes("ceramic") && addonProductToApplyId !== sourceAddonProductIdToMatch) { 
                 variantToApply = productToApplyInfo.variants.find(v => v.availableForSale && (v.title.toLowerCase().includes("ceramic") || v.selectedOptions.some(so => so.value.toLowerCase().includes("ceramic"))));
            }
            if (!variantToApply) {
                variantToApply = productToApplyInfo.variants.find(v => v.availableForSale); 
            }
        }
    }

    if (!variantToApply) {
        alert(`Could not find an available option for ${productToApplyInfo.title} for the ${positionToApplyMatch} ${getDisplayName(baseTypeToApplyMatch.toLowerCase())}.`);
        return;
    }
    
    const addonKeyForBuildState = `${positionToApplyMatch}_${baseTypeToApplyMatch}_${baseComponentToApplyOn.variantId}_${addonProductToApplyId}`;
    
    let finalAddonName = productToApplyInfo.title;
    const optionsStr = variantToApply.selectedOptions.map(o => o.value).join(' / ');
    if (variantToApply.title && variantToApply.title.toLowerCase() !== 'default title') {
        if (optionsStr && variantToApply.title !== optionsStr) finalAddonName += ` (${optionsStr})`;
        else finalAddonName += ` (${variantToApply.title})`;
    } else if (optionsStr) {
        finalAddonName += ` (${optionsStr})`;
    }

    buildState.selectedOptionalAddons[addonKeyForBuildState] = {
        baseComponentPosition: positionToApplyMatch,
        baseComponentType: baseTypeToApplyMatch,
        baseComponentVariantId: baseComponentToApplyOn.variantId,
        addonProductId: addonProductToApplyId,
        addonVariantId: variantToApply.id,
        addonName: finalAddonName,
        addonPriceCents: variantToApply.price.amount,
        addonImage: variantToApply.image ? variantToApply.image.url : null,
        addonProductHandle: productToApplyInfo.handle,
        addonProductPairingKey: productToApplyInfo.pairingKeyValue
    };

    updateSubtotal();
    updateBuildSummary();
    updateSelectedAddonsDisplayOnCard(positionToApplyMatch, baseTypeToApplyMatch, baseComponentToApplyOn.variantId);
    saveLastActiveBuild();

    // --- START: UPDATE MODAL'S DROPDOWNS ---
    // Get modal context variables ONCE here, no re-declaration
    const modalBasePos = addonsModal.dataset.basePosition;
    const modalBaseType = addonsModal.dataset.baseType;
    const modalBaseVarId = addonsModal.dataset.baseVariantId;

    if (modalBasePos === positionToApplyMatch && 
        modalBaseType === baseTypeToApplyMatch && 
        modalBaseVarId === baseComponentToApplyOn.variantId) {

        const productCardInModal = addonsModalBody.querySelector(`.addon-item-card[data-addon-product-id="${addonProductToApplyId}"]`);
        if (productCardInModal) {
            const variantSelectorContainerInModal = productCardInModal.querySelector('.addon-variant-selector');
            const allAddonProductsData = JSON.parse(addonsModal.dataset.currentAddonProducts || '[]').map(p => ({
                 ...p, // Spread existing product data from modal dataset
                 pairingKeyValue: p.pairingKey?.value || p.pairingKeyValue || null 
            }));
            const productDataForCard = allAddonProductsData.find(p => p.id === addonProductToApplyId);

            if (variantSelectorContainerInModal && productDataForCard) {
                populateAddonVariantSelector(productDataForCard, variantSelectorContainerInModal, variantToApply.id);
                updateAddonPriceAndButtonState(productDataForCard, productCardInModal);
            }
        }
    }
    // --- END: UPDATE MODAL'S DROPDOWNS ---

        // Re-evaluate all buttons in the current modal (this will now see the updated dropdowns)
    // Use the modalBasePos, etc. variables that were ALREADY DEFINED above.
    if (modalBasePos && modalBaseType && modalBaseVarId) { // These are already defined, no need for const/let
        await updateAddonButtonsStateInModal(modalBasePos, modalBaseType, modalBaseVarId);
        saveLastActiveBuild(); // MOVED INSIDE AND ON NEW LINE
    }
}
// --- END: HANDLE "MATCH ADDON TO OPPOSITE" CLICKS ---
  
// --- START: UPDATE STATE OF BUTTONS IN ADDON MODAL ---
async function updateAddonButtonsStateInModal(currentBasePositionInModal, currentBaseTypeInModal, currentBaseComponentVariantIdInModal) {
    if (!addonsModalBody) return;

    const allProductCardsInModal = addonsModalBody.querySelectorAll('.addon-item-card');

    // --- Helper function to get a concise variant descriptor ---
    const getConciseVariantName = (addonDetails) => {
        if (!addonDetails) return "Item";
        // Try to extract from selectedOptions first if available
        // Ensure selectedOptions is available on addonDetails (it should be if populated correctly in buildState)
        if (addonDetails.selectedOptions && addonDetails.selectedOptions.length > 0) {
            const colorOpt = addonDetails.selectedOptions.find(opt => opt.name.toLowerCase() === 'color');
            if (colorOpt) return colorOpt.value;
            const materialOpt = addonDetails.selectedOptions.find(opt => opt.name.toLowerCase() === 'material');
            if (materialOpt) return materialOpt.value;
            // You might want to add more prioritized options here (e.g., 'Length', 'Size')
            return addonDetails.selectedOptions[0].value; // Fallback to first option's value
        }
        // Fallback: Try to parse from addonName like "Product (Variant)"
        const nameParts = addonDetails.addonName.match(/\(([^)]+)\)/);
        if (nameParts && nameParts[1]) {
            // Take the first part if multiple options are in parentheses like "(Option1 / Option2)"
            return nameParts[1].split(' / ')[0];
        }
        // Further fallback: first word of the addon's product title
        // This requires fetching the product title if addonDetails only has addonName
        // For simplicity, if addonName is "Product Title (Variant)", this will try to get "Product"
        const productTitleFromName = addonDetails.addonName.split('(')[0].trim();
        return productTitleFromName.split(' ')[0] || "Item"; // Fallback to "Item"
    };
    // --- End Helper ---

    await Promise.all(Array.from(allProductCardsInModal).map(async (productCard) => {
        const addonProductIdOnCard = productCard.dataset.addonProductId;
        const addButton = productCard.querySelector('.add-addon-to-build-btn');

        if (!addButton) return;

        const displayedAddonVariantIdOnCard = addButton.dataset.selectedVariantId;
        const fullAddonKeyForThisModalInstance = `${currentBasePositionInModal}_${currentBaseTypeInModal}_${currentBaseComponentVariantIdInModal}_${addonProductIdOnCard}`;
        const activeSelectedAddonInBuildState = buildState.selectedOptionalAddons[fullAddonKeyForThisModalInstance];

        productCard.querySelectorAll('.match-addon-btn').forEach(btn => btn.remove());
        addButton.classList.remove('builder-button--cta');

        if (activeSelectedAddonInBuildState) {
            if (activeSelectedAddonInBuildState.addonVariantId === displayedAddonVariantIdOnCard) {
                let shortAddonName = getConciseVariantName(activeSelectedAddonInBuildState); // Use helper for consistency
                addButton.textContent = `Remove ${shortAddonName}`;
                addButton.classList.add('addon-added', 'remove-mode');

                const canHavePairedAddon = ['Rim', 'Hub', 'Spokes', 'Nipples', 'ValveStem'].includes(currentBaseTypeInModal);
                if (buildState.buildType === 'Wheel Set' && canHavePairedAddon && activeSelectedAddonInBuildState.addonProductPairingKey) {
                    const oppositePosition = currentBasePositionInModal === 'Front' ? 'Rear' : 'Front';
                    const oppositeBaseComponent = buildState.components[`${oppositePosition.toLowerCase()}${currentBaseTypeInModal}`];

                    if (oppositeBaseComponent && oppositeBaseComponent.variantId && oppositeBaseComponent.optionalAddonProductGids) {
                        let productCandidateForOppositeSide_SamePairingKey = null;
                        
                        // Get details of the product for the current addon in the modal to compare names if needed
                        let currentModalAddonProductDetails = null;
                        const allProdsInModal = JSON.parse(addonsModal.dataset.currentAddonProducts || '[]');
                        currentModalAddonProductDetails = allProdsInModal.find(p => p.id === activeSelectedAddonInBuildState.addonProductId);


                        const oppositeAddonCandidatesDetails = await fetchAddonProductDetailsByGids(oppositeBaseComponent.optionalAddonProductGids);
                        for (const candidate of oppositeAddonCandidatesDetails) {
                            if (candidate.pairingKeyValue === activeSelectedAddonInBuildState.addonProductPairingKey) {
                                productCandidateForOppositeSide_SamePairingKey = candidate;
                                break;
                            }
                        }

                        if (productCandidateForOppositeSide_SamePairingKey) {
                            const keyForPairedAddonOnOpposite = `${oppositePosition}_${currentBaseTypeInModal}_${oppositeBaseComponent.variantId}_${productCandidateForOppositeSide_SamePairingKey.id}`;
                            const pairedAddonSelectedOnOpposite = buildState.selectedOptionalAddons[keyForPairedAddonOnOpposite];
                            let showMatchToButton = true;
                            if (pairedAddonSelectedOnOpposite) {
                                if (productCandidateForOppositeSide_SamePairingKey.id === activeSelectedAddonInBuildState.addonProductId) {
                                    if (pairedAddonSelectedOnOpposite.addonVariantId === activeSelectedAddonInBuildState.addonVariantId) {
                                        showMatchToButton = false;
                                    }
                                } else {
                                    showMatchToButton = false;
                                }
                            }

                            if (showMatchToButton) {
                                const matchToButton = document.createElement('button');
                                matchToButton.className = 'builder-button builder-button--secondary match-addon-btn match-addon-to-opposite-btn builder-button--cta';
                                
                                const conciseSourceName = getConciseVariantName(activeSelectedAddonInBuildState);
                                let buttonText = `Make ${oppositePosition} Match (${conciseSourceName})`;
                                // If product GIDs are different, means it's a specific pair like bearings.
                                // Use the target product's name for clarity.
                                if (productCandidateForOppositeSide_SamePairingKey.id !== activeSelectedAddonInBuildState.addonProductId) {
                                    buttonText = `Make ${oppositePosition} use ${productCandidateForOppositeSide_SamePairingKey.title.split(' ')[0]} (${conciseSourceName})`;
                                }
                                matchToButton.textContent = buttonText;
                                matchToButton.dataset.action = "match-to";
                                matchToButton.dataset.sourcePosition = currentBasePositionInModal;
                                matchToButton.dataset.sourceBaseType = currentBaseTypeInModal;
                                matchToButton.dataset.sourceAddonProductId = activeSelectedAddonInBuildState.addonProductId;
                                matchToButton.dataset.sourceAddonVariantId = activeSelectedAddonInBuildState.addonVariantId;
                                matchToButton.dataset.targetPosition = oppositePosition;
                                matchToButton.dataset.targetAddonProductId = productCandidateForOppositeSide_SamePairingKey.id;
                                productCard.querySelector('.addon-item-actions')?.appendChild(matchToButton);
                            }
                        }

                        // --- Button 2: "Adopt addon FROM Opposite side" ---
                        const addonProductOnThisCard = allProdsInModal.find(p => p.id === addonProductIdOnCard);
                        if (addonProductOnThisCard?.pairingKeyValue) {
                            let selectedAddonOnOpposite_ThatPairsWithThisCardProduct = null;
                            for (const key in buildState.selectedOptionalAddons) {
                                const addon = buildState.selectedOptionalAddons[key];
                                if (addon.baseComponentPosition === oppositePosition &&
                                    addon.baseComponentType === currentBaseTypeInModal &&
                                    addon.baseComponentVariantId === oppositeBaseComponent.variantId &&
                                    addon.addonProductPairingKey === addonProductOnThisCard.pairingKeyValue) {
                                    // Now, ensure that the item selected on opposite is either the same product as this card
                                    // OR this card's product is the correct partner for what's on opposite.
                                    if (addon.addonProductId === addonProductOnThisCard.id || // Opposite has same product selected as current card
                                        (currentModalAddonProductDetails && addon.addonProductId === currentModalAddonProductDetails.id && addonProductOnThisCard.id !== currentModalAddonProductDetails.id ) // handles bearing case
                                        ) {
                                         // Check if this card's item is different from what's active on this side
                                        if (!activeSelectedAddonInBuildState || // Nothing active on this side for this card's product type OR
                                            (activeSelectedAddonInBuildState.addonProductId === addon.addonProductId && activeSelectedAddonInBuildState.addonVariantId !== addon.addonVariantId) || // Same product, different variant
                                            (activeSelectedAddonInBuildState.addonProductId !== addon.addonProductId) // Different products (like bearings, current is front, opposite is rear)
                                           ) {
                                                selectedAddonOnOpposite_ThatPairsWithThisCardProduct = addon;
                                                break;
                                           }
                                    }
                                }
                            }

                            if (selectedAddonOnOpposite_ThatPairsWithThisCardProduct) {
                                const adoptFromButton = document.createElement('button');
                                adoptFromButton.className = 'builder-button builder-button--secondary match-addon-btn match-addon-from-opposite-btn builder-button--cta';
                                const conciseOppositeName = getConciseVariantName(selectedAddonOnOpposite_ThatPairsWithThisCardProduct);
                                let buttonText = `Adopt from ${oppositePosition} (${conciseOppositeName})`;
                                if (selectedAddonOnOpposite_ThatPairsWithThisCardProduct.addonProductId !== addonProductIdOnCard) {
                                   buttonText = `Adopt ${selectedAddonOnOpposite_ThatPairsWithThisCardProduct.addonName.split(" (")[0].substring(0,15)}... (${conciseOppositeName}) from ${oppositePosition}`;
                                }
                                adoptFromButton.textContent = buttonText;
                                adoptFromButton.dataset.action = "match-from";
                                adoptFromButton.dataset.targetPosition = currentBasePositionInModal;
                                adoptFromButton.dataset.targetBaseType = currentBaseTypeInModal;
                                adoptFromButton.dataset.targetAddonProductId = addonProductIdOnCard; // Product of the current card
                                adoptFromButton.dataset.sourcePosition = oppositePosition;
                                adoptFromButton.dataset.sourceAddonProductId = selectedAddonOnOpposite_ThatPairsWithThisCardProduct.addonProductId;
                                adoptFromButton.dataset.sourceAddonVariantId = selectedAddonOnOpposite_ThatPairsWithThisCardProduct.addonVariantId;
                                productCard.querySelector('.addon-item-actions')?.appendChild(adoptFromButton);
                            }
                        }
                    }
                }
            } else { // Dropdowns DO NOT MATCH activeSelectedAddonInBuildState
                addButton.textContent = 'Update Selection';
                addButton.classList.remove('addon-added', 'remove-mode');
                addButton.classList.add('builder-button--cta');
            }
        } else { // No addon for this product type IS actively selected in buildState
            addButton.textContent = 'Add to Build';
            addButton.classList.remove('addon-added', 'remove-mode');
            addButton.classList.add('builder-button--cta');

            const canHavePairedAddon = ['Rim', 'Hub', 'Spokes', 'Nipples', 'ValveStem'].includes(currentBaseTypeInModal);
            const currentAddonProductOnCardDetails = JSON.parse(addonsModal.dataset.currentAddonProducts || '[]').find(p => p.id === addonProductIdOnCard);

            if (buildState.buildType === 'Wheel Set' && canHavePairedAddon && currentAddonProductOnCardDetails?.pairingKeyValue) {
                const oppositePosition = currentBasePositionInModal === 'Front' ? 'Rear' : 'Front';
                const oppositeBaseComponent = buildState.components[`${oppositePosition.toLowerCase()}${currentBaseTypeInModal}`];

                if (oppositeBaseComponent && oppositeBaseComponent.variantId) {
                    let selectedPairedAddonOnOppositeSide = null;
                    for (const key in buildState.selectedOptionalAddons) {
                        const addon = buildState.selectedOptionalAddons[key];
                        if (addon.baseComponentPosition === oppositePosition &&
                            addon.baseComponentType === currentBaseTypeInModal &&
                            addon.baseComponentVariantId === oppositeBaseComponent.variantId &&
                            addon.addonProductPairingKey === currentAddonProductOnCardDetails.pairingKeyValue) {
                            selectedPairedAddonOnOppositeSide = addon;
                            break;
                        }
                    }

                    if (selectedPairedAddonOnOppositeSide) {
                        // Check if the current card product IS the correct partner for what's on opposite
                        let isCorrectPartnerForAdopt = false;
                        if (currentAddonProductOnCardDetails.id === selectedPairedAddonOnOppositeSide.addonProductId) { // Same product type
                            isCorrectPartnerForAdopt = true;
                        } else if (currentAddonProductOnCardDetails.pairingKeyValue === selectedPairedAddonOnOppositeSide.addonProductPairingKey) {
                            // Different product types but same pairing key (e.g., bearings)
                            isCorrectPartnerForAdopt = true;
                        }


                        if (isCorrectPartnerForAdopt) {
                            const matchFromButton = document.createElement('button');
                            matchFromButton.className = 'builder-button builder-button--secondary match-addon-btn match-addon-from-opposite-btn builder-button--cta';
                            const conciseOppositeName = getConciseVariantName(selectedPairedAddonOnOppositeSide);
                            let buttonText = `Adopt from ${oppositePosition} (${conciseOppositeName})`;
                             if (selectedPairedAddonOnOppositeSide.addonProductId !== addonProductIdOnCard) { // If different product types
                                buttonText = `Adopt ${selectedPairedAddonOnOppositeSide.addonName.split(" (")[0].substring(0,15)}... (${conciseOppositeName}) from ${oppositePosition}`;
                            }
                            matchFromButton.textContent = buttonText;
                            matchFromButton.dataset.action = "match-from";
                            matchFromButton.dataset.targetPosition = currentBasePositionInModal;
                            matchFromButton.dataset.targetBaseType = currentBaseTypeInModal;
                            matchFromButton.dataset.targetAddonProductId = addonProductIdOnCard;
                            matchFromButton.dataset.sourcePosition = oppositePosition;
                            matchFromButton.dataset.sourceAddonProductId = selectedPairedAddonOnOppositeSide.addonProductId;
                            matchFromButton.dataset.sourceAddonVariantId = selectedPairedAddonOnOppositeSide.addonVariantId;
                            productCard.querySelector('.addon-item-actions')?.appendChild(matchFromButton);
                        }
                    }
                }
            }
        }
    }));
}
// --- END: UPDATE STATE OF BUTTONS IN ADDON MODAL ---

// --- START: updateSelectedAddonsDisplayOnCard (RESTORES ADDON LIST) ---
function updateSelectedAddonsDisplayOnCard(basePosition, baseTypePascal, baseComponentVariantId) {
    const posLower = basePosition.toLowerCase();
    let typeLowerForDOM = baseTypePascal.toLowerCase();
    if (baseTypePascal === "ValveStem") typeLowerForDOM = "valvestem";
    else if (baseTypePascal === "Spokes") typeLowerForDOM = "spokes";
    else if (baseTypePascal === "Nipples") typeLowerForDOM = "nipples";

    // This is the container for the text "Selected Front Rim: ..."
    const selectionContainer = document.getElementById(`${posLower}-${typeLowerForDOM}-selection`);

    const subsectionContainer = document.getElementById(`${posLower}-${typeLowerForDOM}-subsection`);
    if (!subsectionContainer || !selectionContainer) {
        console.warn(`updateSelectedAddonsDisplayOnCard: Critical containers not found for ${posLower}-${typeLowerForDOM}`);
        return;
    }
    const addonsButtonElement = subsectionContainer.querySelector('.optional-addons-btn');

    // Find the list container. We will create it if it's missing.
    let listContainerElement = document.getElementById(`${posLower}-${typeLowerForDOM}-selected-addons-list`);
    const defaultButtonText = "Add Ons";

    if (!baseComponentVariantId) {
        if (addonsButtonElement) addonsButtonElement.textContent = defaultButtonText;
        if (listContainerElement) {
            listContainerElement.innerHTML = '';
            listContainerElement.style.display = 'none';
        }
        return;
    }

    const matchingSelectedAddons = [];
    for (const key in buildState.selectedOptionalAddons) {
        const addon = buildState.selectedOptionalAddons[key];
        if (addon.baseComponentPosition === basePosition &&
            addon.baseComponentType === baseTypePascal &&
            addon.baseComponentVariantId === baseComponentVariantId) {
            matchingSelectedAddons.push(addon);
        }
    }

// --- START: SORTING LOGIC ---
    // Get the base component from the state to find its master list of addon GIDs for sorting.
    const stateKeyForBaseComponent = `${posLower}${baseTypePascal}`;
    const baseComponent = buildState.components[stateKeyForBaseComponent];
    const masterAddonOrder = baseComponent?.optionalAddonProductGids || [];
    
    // Sort the collected addons to match the order defined in the base component's metafield.
    matchingSelectedAddons.sort((a, b) => {
        const indexA = masterAddonOrder.indexOf(a.addonProductId);
        const indexB = masterAddonOrder.indexOf(b.addonProductId);
        // If an addon isn't found in the master list, push it to the end.
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
    });
    // --- END: SORTING LOGIC ---
  
    if (addonsButtonElement) {
        if (matchingSelectedAddons.length > 0) {
            addonsButtonElement.textContent = `${defaultButtonText} (${matchingSelectedAddons.length} selected)`;
        } else {
            addonsButtonElement.textContent = defaultButtonText;
        }
    }

    if (matchingSelectedAddons.length > 0) {
        // If the list container doesn't exist, create it and append it to the right place.
        if (!listContainerElement) {
            listContainerElement = document.createElement('div');
            listContainerElement.className = 'selected-addons-list';
            listContainerElement.id = `${posLower}-${typeLowerForDOM}-selected-addons-list`;
            // Append it to the text summary container
            selectionContainer.appendChild(listContainerElement);
        }

        listContainerElement.innerHTML = ''; // Clear previous content before re-populating
        listContainerElement.style.display = 'block';

        const ul = document.createElement('ul');
        matchingSelectedAddons.forEach(addon => {
            const li = document.createElement('li');
            
            let addonImageHtml = addon.addonImage ? `<img src="${addon.addonImage}" alt="${addon.addonName}" class="selected-addon-thumbnail">` : `<div class="selected-addon-thumbnail-placeholder"></div>`;
            let addonNameText = `+ ${addon.addonName}`; 
            let addonNameHtml = `<span class="selected-addon-name-text">${addonNameText}</span>`; 
            if (addon.addonProductHandle) {
                const productUrl = `/products/${addon.addonProductHandle}`;
                addonNameHtml = `<span class="selected-addon-name-text"><a href="${productUrl}" target="_blank" title="View ${addon.addonName} product page">${addonNameText}</a></span>`;
            }
            const removeXButtonHtml = `<button type="button" class="remove-selected-addon-btn" 
                                         data-base-position="${addon.baseComponentPosition}"
                                         data-base-type="${addon.baseComponentType}"
                                         data-base-variant-id="${addon.baseComponentVariantId}"
                                         data-addon-product-id="${addon.addonProductId}"
                                         aria-label="Remove ${addon.addonName}">×</button>`;
            
            li.innerHTML = `${addonImageHtml} ${addonNameHtml} ${removeXButtonHtml}`;
            ul.appendChild(li);
        });
        listContainerElement.appendChild(ul);

        listContainerElement.querySelectorAll('.remove-selected-addon-btn').forEach(button => {
            button.removeEventListener('click', handleRemoveSelectedAddonFromCard); 
            button.addEventListener('click', handleRemoveSelectedAddonFromCard);
        });

    } else {
        if (listContainerElement) {
            listContainerElement.innerHTML = '';
            listContainerElement.style.display = 'none'; 
        }
    }
}
// --- END: updateSelectedAddonsDisplayOnCard ---
  
// --- START: ADDONS MODAL FUNCTIONS ---
    function openAddonsModal(baseComponentPosition, baseComponentType, baseComponentProductId, baseComponentVariantId, optionalAddonProductGidsString) {
        if (!addonsModal || !addonsModalTitle || !addonsModalBody) {
            console.error("Addons modal elements not found.");
            return;
        }

        // Store context for when an addon is selected
        addonsModal.dataset.basePosition = baseComponentPosition;
        addonsModal.dataset.baseType = baseComponentType;
        addonsModal.dataset.baseProductId = baseComponentProductId;
        addonsModal.dataset.baseVariantId = baseComponentVariantId;

        const cleanTypePascal = baseComponentType.replace(/([A-Z])/g, ' $1').trim();
        let titleBase = (baseComponentType === "ValveStem") ? `${baseComponentPosition} Valve Stem` : `${baseComponentPosition} ${cleanTypePascal}`;
        addonsModalTitle.textContent = `${titleBase} Options & Upgrades`;
        
        addonsModalBody.innerHTML = '<p>Loading add-on options...</p>'; // Placeholder
        addonsModal.style.display = 'flex'; // Use flex for centering

        /* console.log("Opening addons modal for:", {
            position: baseComponentPosition,
            type: baseComponentType,
            baseProductId: baseComponentProductId,
            baseVariantId: baseComponentVariantId,
            addonProductGids: optionalAddonProductGidsString
        });
        */
        // Store the raw addon products data once fetched, so variant change handler can access it
    // This is a temporary way to make it available; a more robust state might be better long-term
    addonsModal.dataset.currentAddonProducts = '[]'; // Initialize

    fetchAndDisplayAddonDetailsInModal(optionalAddonProductGidsString); 
    }

    function closeAddonsModal() {
        if (!addonsModal) return;
        addonsModal.style.display = 'none';
        addonsModalBody.innerHTML = ''; 
        delete addonsModal.dataset.basePosition;
        delete addonsModal.dataset.baseType;
        delete addonsModal.dataset.baseProductId;
        delete addonsModal.dataset.baseVariantId;
    }
    // --- END: ADDONS MODAL FUNCTIONS ---
  
// --- START: updateVendorButtonHighlight (with Toggle UI Update) ---
function updateVendorButtonHighlight(componentKey, activeVendorName) {
    if (!componentKey) {
        console.warn("updateVendorButtonHighlight: componentKey is missing.");
        return;
    }
    let positionLc;
    let typeLcForDomId;

    if (componentKey.startsWith('front')) {
        positionLc = 'front';
        typeLcForDomId = componentKey.substring(5).toLowerCase();
    } else if (componentKey.startsWith('rear')) {
        positionLc = 'rear';
        typeLcForDomId = componentKey.substring(4).toLowerCase();
    } else {
        return;
    }

    if (componentKey.toLowerCase().endsWith("valvestem")) typeLcForDomId = "valvestem";
    if (componentKey.toLowerCase().endsWith("nipples")) typeLcForDomId = "nipples";


    const filterContainerId = `${positionLc}-${typeLcForDomId}-filters`;
    const filterContainer = document.getElementById(filterContainerId);

    if (!filterContainer) return;

    const vendorArea = filterContainer.querySelector('.vendor-filter-area');
    const dropdown = vendorArea?.querySelector('.vendor-filter-dropdown');
    if (!dropdown) {
        return;
    }
    const toggle = dropdown.querySelector('.dropdown-toggle');
    const menuButtons = dropdown.querySelectorAll('.vendor-filter-btn');

    if (toggle) {
        let newToggleContent = '';
        if (activeVendorName === null) {
            newToggleContent = '<span class="vendor-prompt"><b>Click to select a vendor</b></span>';
        } else if (activeVendorName === 'all') {
            newToggleContent = '<span class="toggle-all-vendors-button">All Vendors</span>';
        } else {
            const vendorInfo = vendorLogoMap[activeVendorName];
            const logoUrl = vendorInfo?.logoUrl;
            newToggleContent = `<span>
                                    ${logoUrl ? `<img src="${logoUrl}" alt="${activeVendorName}" class="toggle-vendor-logo">` : `<span>${activeVendorName}</span>`}
                               </span>`;
        }
        toggle.innerHTML = newToggleContent;
    }

    menuButtons.forEach(btn => {
        btn.classList.toggle('active', btn.dataset.vendor === activeVendorName);
    });
    
    // Set the state last to ensure consistency
    buildState._ui.activeVendor[componentKey] = activeVendorName;
}
// --- END: updateVendorButtonHighlight ---

// Valve stem color shown in the Spoke Color Studio pictures, per wheel. The color comes from the chosen valve stem (its Color option), so nothing extra is saved:
// resume, edit from cart, share links, saved builds and presets all get it from the components they restore. Sent to the Studio hosts (I9 System and Standard)
// as the 'loam:valve-color' event only when it changed; no valve stem on a wheel = the default dark stem.
let lastValveColors = null;
function syncValveColors() {
    try {
        if (!window.LoamStudio || typeof window.LoamStudio.valveColorsOf !== 'function' || !buildState) return;
        const next = window.LoamStudio.valveColorsOf(buildState.components);
        if (lastValveColors && lastValveColors.front === next.front && lastValveColors.rear === next.rear) return;
        lastValveColors = next;
        window.dispatchEvent(new CustomEvent('loam:valve-color', { detail: { front: next.front, rear: next.rear } }));
    } catch (e) { console.warn('syncValveColors failed:', e); }
}
function updateComponentUI(position, type, componentData) {
    const pL = position.toLowerCase();
    Promise.resolve().then(syncValveColors); // after the caller finished setting buildState.components

    let typePascal = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
    if (type.toLowerCase() === "valvestem") typePascal = "ValveStem";
    else if (type.toLowerCase() === "spokes") typePascal = "Spokes";
    else if (type.toLowerCase() === "nipples") typePascal = "Nipples";

    const componentKey = `${pL}${typePascal}`;
    const tL_for_dom_id = typePascal.toLowerCase(); 

    const sub = document.getElementById(`${pL}-${tL_for_dom_id}-subsection`);
    const selSpanCont = document.getElementById(`${pL}-${tL_for_dom_id}-selection`); 
    const imgCont = document.getElementById(`${pL}-${tL_for_dom_id}-image-container`);
    const optsCont = sub ? sub.querySelector('.component-options') : null;
    const actionButtonsContainer = document.getElementById(`${pL}-${tL_for_dom_id}-action-buttons`);
    const removeButton = document.getElementById(`remove-${pL}-${tL_for_dom_id}-button`);

    if (!sub || !selSpanCont || !imgCont || !optsCont || !actionButtonsContainer) {
        console.error(`updateComponentUI ABORT: Missing one or more critical UI elements for ${position} ${typePascal}.`);
        return;
    }
    const displayName = `${position} ${getDisplayName(typePascal.toLowerCase())}`;

    selSpanCont.classList.remove('no-addon-ui-present'); 

    // Clear any leftover addon UI elements before deciding to re-add them
    const existingAddonBtn = sub.querySelector('.optional-addons-btn'); 
    if (existingAddonBtn) {
        existingAddonBtn.remove();
    }
    const existingAddonList = selSpanCont.querySelector('.selected-addons-list');
    if (existingAddonList) {
        existingAddonList.remove(); 
    }

    if (componentData) { 
        const spanEl = selSpanCont.querySelector('span'); 
        const pH = componentData.productHandle;
        const url = pH ? `/products/${pH}` : '#';
        const lT = pH ? `View ${componentData.title} product page` : 'Product page link unavailable';
        const priceD = componentData.price ? ` - ${formatPrice(componentData.price)}` : '';
        let displayTitle;
        if (typePascal === 'Spokes') {
            // For spokes, construct the clean title from our new state properties
            const color = componentData.selectedColor || '';
            displayTitle = `${componentData.title} (${color})`;
        } else {
            // Original logic for all other components
            displayTitle = componentData.title;
            if (componentData.selectedOptions && Array.isArray(componentData.selectedOptions) && componentData.selectedOptions.length > 0) {
                const usefulOptions = componentData.selectedOptions.filter(opt => opt.value.toLowerCase() !== 'default title');
                if (usefulOptions.length > 0) {
                    const variantDetails = usefulOptions.map(opt => opt.value).join(', ');
                    displayTitle += ` (${variantDetails})`;
                }
            }
        }
      
        if (spanEl) {
            // Check if the component is a placeholder from "Your Own Component"
            if (componentData.vendor === 'Your Own Component') {
                // If it is, render the text without a hyperlink
                spanEl.innerHTML = `Selected ${displayName}: <strong>${displayTitle}</strong>${priceD}`;
            } else {
                // Otherwise, use the original logic to render the hyperlink
                spanEl.innerHTML = `Selected ${displayName}: <a href="${url}" target="_blank" title="${lT}"><strong>${displayTitle}</strong></a>${priceD}`;
                // This safety check remains for non-placeholder products that might be missing a handle
                if (!pH) { const lE = spanEl.querySelector('a'); if (lE) { lE.style.pointerEvents = 'none'; lE.style.textDecoration = 'none'; lE.style.color = 'inherit'; } }
            }
        }

        imgCont.innerHTML = ''; // Clear previous content

// 1. Create a dedicated wrapper for the image and its weight text
const imageWrapper = document.createElement('div');
imageWrapper.className = 'selected-image-wrapper'; // New class for positioning context

// 2. Add the image to the wrapper
if (componentData.image?.url) {
    const img = document.createElement('img');
    img.src = componentData.image.url;
    img.alt = componentData.title || `${displayName} Image`;
    img.loading = 'lazy';
    img.onerror = () => { imageWrapper.innerHTML = '<p>(Image Error)</p>'; };
    imageWrapper.appendChild(img);
} else {
    imageWrapper.innerHTML = '<div class="selected-image-placeholder">No Image</div>';
}

// 3. Add the weight display to the wrapper
const weight = componentData.weight_g;

// DIAGNOSTIC LOG: Check if valves are passing weight
if (typePascal === 'ValveStem') {
    console.log(`[UI Render] Valve Stem: ${componentData.variantTitle}, Weight Data:`, weight);
}

// A weight is shown only when it is a real number above zero (a missing, empty or non-numeric weight shows nothing, never "Wt: NaNg").
const weightNumber = (weight === null || weight === undefined || weight === '') ? NaN : Number(weight);
if (isFinite(weightNumber) && weightNumber > 0) {
    const weightDisplay = document.createElement('div');
    weightDisplay.className = 'selected-component-weight-display';

    if (typePascal === 'Spokes') {
        // Initial render for spokes (will be updated by calc function later)
        // Just show generic weight initially to prevent layout shift
        const countDigits = parseInt(String(buildState.specs[`${pL}SpokeCount`] || '').replace(/\D/g, ''), 10); // the spoke count is text like "32h": use its digits
        const count = countDigits > 0 ? countDigits : 32;
        const spokesWeight = Math.round(weightNumber * count);
        if (isFinite(spokesWeight)) weightDisplay.innerHTML = `Wt: ${spokesWeight}g`;
        else weightDisplay.style.display = 'none'; // kept (empty, hidden) so the weight calculation can fill it in once the wheel is complete
        imageWrapper.appendChild(weightDisplay);
    } else {
        weightDisplay.textContent = `Wt: ${weight}g`;
        imageWrapper.appendChild(weightDisplay);
    }
}

// 4. Add the entire wrapper to the main image container
imgCont.appendChild(imageWrapper);
imgCont.style.display = 'flex';

        if (componentData.optionalAddonProductGids && componentData.optionalAddonProductGids.length > 0) {
            const addonsButton = document.createElement('button');
            addonsButton.type = 'button';
            addonsButton.className = 'optional-addons-btn builder-button--secondary';
            addonsButton.textContent = "Add Ons";
            addonsButton.dataset.position = position; 
            addonsButton.dataset.type = typePascal;
            addonsButton.dataset.baseComponentProductId = componentData.productId; 
            addonsButton.dataset.baseComponentVariantId = componentData.variantId;
            addonsButton.dataset.optionalAddonProductGids = componentData.optionalAddonProductGids.join(',');
            
            imgCont.appendChild(addonsButton);

            addonsButton.addEventListener('click', () => {
                openAddonsModal(
                    addonsButton.dataset.position,
                    addonsButton.dataset.type,
                    addonsButton.dataset.baseComponentProductId,
                    addonsButton.dataset.baseComponentVariantId,
                    addonsButton.dataset.optionalAddonProductGids
                );
            });
            updateSelectedAddonsDisplayOnCard(position, typePascal, componentData.variantId);
        } else {
            selSpanCont.classList.add('no-addon-ui-present');
        }

        if (typePascal === "ValveStem" && imgCont && imgCont.style.display !== 'none') {
            const originalDisplay = imgCont.style.display;
            imgCont.style.display = 'none';
            imgCont.offsetHeight; 
            imgCont.style.display = originalDisplay;
        }

        optsCont.style.display = 'none';
        optsCont.innerHTML = '';

        actionButtonsContainer.style.display = 'none';
        actionButtonsContainer.innerHTML = '';

        sub.classList.add('selection-made');
        sub.classList.remove('change-in-progress');
        updateVendorButtonHighlight(componentKey, componentData.vendor);

        let filtersContainerElement = document.getElementById(`${pL}-${tL_for_dom_id}-filters`);

        if (filtersContainerElement) {
            // Get the correctly filtered list of products using the new helper function.
            const compatibleProductsForFilter = getCurrentlyCompatibleProducts(position, typePascal);
            // Pass this filtered list to the function that builds the vendor UI.
            displayComponentVendorFilters(componentKey, compatibleProductsForFilter, filtersContainerElement, position);
        } else {
            console.warn(`updateComponentUI: Could not find filtersContainerElement for ${componentKey}.`);
        }
        
        const existingIcon = imgCont.querySelector('.remove-component-icon');
        if (existingIcon) {
            existingIcon.remove();
        }

        if (componentData && typePascal === "ValveStem") {
            const removeIcon = document.createElement('button');
            removeIcon.type = 'button';
            removeIcon.className = 'remove-component-icon';
            removeIcon.innerHTML = '×';
            removeIcon.title = `Remove ${position} Valve Stem`;
            removeIcon.dataset.action = 'remove-component';
            removeIcon.dataset.position = position;
            removeIcon.dataset.type = 'ValveStem';
            imgCont.appendChild(removeIcon);
            removeIcon.style.display = 'block';
        }
        window.I9System?.decorateComponentUI(position, typePascal, componentData); // I9-SYSTEM: System spokes (stage card, "each", fee line) and the hub line in hub-list form "Title (variant title)"

    } else { // No componentData (slot is empty)
        const spanEl = selSpanCont.querySelector('span');
        if (spanEl) {
            spanEl.innerHTML = `Selected ${displayName}: None`;
        }
        selSpanCont.classList.add('no-addon-ui-present');

        imgCont.innerHTML = '';
        imgCont.style.display = 'none';

        optsCont.style.display = 'flex'; 

        actionButtonsContainer.style.display = 'none';
        actionButtonsContainer.innerHTML = '';

        sub.classList.remove('selection-made', 'change-in-progress');
        updateVendorButtonHighlight(componentKey, null);

        if (removeButton) {
            removeButton.style.display = 'none';
        }
        updateSelectedAddonsDisplayOnCard(position, typePascal, null);
        window.I9System?.decorateComponentUI(position, typePascal, null); // I9-SYSTEM: a cleared rim or hub takes that wheel's Studio card away
    }

    if (typePascal === "Rim") {
        ['Front', 'Rear'].forEach(valvePos => {
            const valveStateKey = `${valvePos.toLowerCase()}ValveStem`;
            if (buildState.components[valveStateKey]) {
                const valveImgContToReflow = document.getElementById(`${valvePos.toLowerCase()}-valvestem-image-container`);
                if (valveImgContToReflow && valveImgContToReflow.style.display !== 'none') {
                    const originalDisplay = valveImgContToReflow.style.display;
                    valveImgContToReflow.style.display = 'none';
                    valveImgContToReflow.offsetHeight;
                    valveImgContToReflow.style.display = originalDisplay;
                }
            }
        });
    }
  window.StandardStudio?.decorateComponentUI(position, typePascal, componentData); // STANDARD-STUDIO: "Color each spoke individually" card and the custom-color wording (also removes the card for an empty slot)
  updateMismatchHints();
}

    function updateComponentHeaderSpecs() {

  // --- Rims ---
  const frontRimSpecEl = document.getElementById('front-rim-spec-context');
  const rearRimSpecEl = document.getElementById('rear-rim-spec-context');

  if (buildState.buildType === 'Wheel Set' || buildState.buildType === 'Front') { // Corrected: buildState.buildType directly
    if (frontRimSpecEl && buildState.specs.frontWheelSize && buildState.specs.frontSpokeCount) {
      frontRimSpecEl.textContent = `- ${buildState.specs.frontWheelSize} | ${buildState.specs.frontSpokeCount}`;
    } else if (frontRimSpecEl) {
      frontRimSpecEl.textContent = ''; // Clear if specs not available
    }
  } else if (frontRimSpecEl) {
    frontRimSpecEl.textContent = ''; // Clear if not applicable
  }

  if (buildState.buildType === 'Wheel Set' || buildState.buildType === 'Rear') { // Corrected: buildState.buildType directly
    if (rearRimSpecEl && buildState.specs.rearWheelSize && buildState.specs.rearSpokeCount) {
      rearRimSpecEl.textContent = `- ${buildState.specs.rearWheelSize} | ${buildState.specs.rearSpokeCount}`;
    } else if (rearRimSpecEl) {
      rearRimSpecEl.textContent = ''; // Clear if specs not available
    }
  } else if (rearRimSpecEl) {
    rearRimSpecEl.textContent = ''; // Clear if not applicable
  }

  // --- Hubs ---
  const frontHubSpecEl = document.getElementById('front-hub-spec-context');
  const rearHubSpecEl = document.getElementById('rear-hub-spec-context');
  const brakeStyle = buildState.specs.brakeStyle || ''; // Handle if brakeStyle is null/undefined

  if (buildState.buildType === 'Wheel Set' || buildState.buildType === 'Front') { // Corrected: buildState.buildType directly
    if (frontHubSpecEl && buildState.specs.frontHubSpacing && buildState.specs.frontSpokeCount) {
      frontHubSpecEl.textContent = `- ${buildState.specs.frontHubSpacing} | ${buildState.specs.frontSpokeCount} | ${brakeStyle}`;
    } else if (frontHubSpecEl) {
      frontHubSpecEl.textContent = ''; // Clear if specs not available
    }
  } else if (frontHubSpecEl) {
    frontHubSpecEl.textContent = ''; // Clear if not applicable
  }

  if (buildState.buildType === 'Wheel Set' || buildState.buildType === 'Rear') { // Corrected: buildState.buildType directly
    if (rearHubSpecEl && buildState.specs.rearHubSpacing && buildState.specs.rearSpokeCount && buildState.specs.freehubType) {
      rearHubSpecEl.textContent = `- ${buildState.specs.rearHubSpacing} | ${buildState.specs.rearSpokeCount} | ${brakeStyle} | ${buildState.specs.freehubType}`;
    } else if (rearHubSpecEl) {
      rearHubSpecEl.textContent = ''; // Clear if specs not available
    }
  } else if (rearHubSpecEl) {
    rearHubSpecEl.textContent = ''; // Clear if not applicable
  }
}
    // END OF NEW updateComponentHeaderSpecs FUNCTION

    // --- START: HUB-SPOKE COMPATIBILITY HELPERS ---
function applyIncompatibleStyling(element, isCompatible, reason = '') {
    if (!element) return;
    
    if (isCompatible) {
        element.classList.remove('conditionally-incompatible');
        element.dataset.isConditionallyDisabled = 'false';
        element.removeAttribute('title'); // Remove the tooltip text when it's compatible
    } else {
        element.classList.add('conditionally-incompatible');
        element.dataset.isConditionallyDisabled = 'true';
        element.setAttribute('title', reason); // Set the native browser tooltip
    }
}
// --- END: HUB-SPOKE COMPATIBILITY HELPERS ---
  
// --- START: NEW FUNCTION - Enforce Spoke Compatibility After Programmatic Hub Selection ---
function enforceSpokeCompatibilityForHub(position, selectedHubData) {
    if (!selectedHubData) return;

    const isHookFlange = selectedHubData.tags?.includes('hub_type:hook_flange');
    if (!isHookFlange) {
        return; // Not a hook flange hub, no action needed.
    }

    const posLower = position.toLowerCase();
    const spokeStateKey = `${posLower}Spokes`;
    const currentSpoke = buildState.components[spokeStateKey];
    const isNonBerdSpokeSelected = currentSpoke && currentSpoke.vendor?.toLowerCase() !== 'berd';

    // If a hook flange hub was just selected AND a non-Berd spoke is present, fix it.
    if (isNonBerdSpokeSelected) {
        console.log(`[Auto-Compat] Enforcing spoke compatibility for ${position} due to hook flange hub selection.`);
        
        // Clear the incompatible spokes.
        clearComponentAndItsAddons(position, 'Spokes');
        
        // Set the active vendor to 'Berd'.
        buildState._ui.activeVendor[spokeStateKey] = 'Berd';
        
        // Reload the spoke options UI to reflect the new filter.
        loadAndFilterSpokesForPosition(position, false);
    }
}
// --- END: NEW FUNCTION ---
  
function updateHubSpokeCompatibilityUI() {
    // --- Part 1: Hub Styling based on Spoke Selection ---
    ['front', 'rear'].forEach(pos => {
        const hubOptionsContainer = document.getElementById(`${pos}-hub-options-container`);
        if (!hubOptionsContainer) return;

        const spokeData = buildState.components[`${pos}Spokes`];
        let selectedSpokeInterface = null;
        if (spokeData) {
            const spokeProduct = allSpokeProductsCache.find(p => p.id === spokeData.productId);
            selectedSpokeInterface = spokeProduct?.spokeHubInterface; // "J-Bend", "Straight Pull", "Hook Flange", or null/blank
        }

        hubOptionsContainer.querySelectorAll('.hub-model-card').forEach(hubCard => {
            const modelName = hubCard.querySelector('h5')?.textContent;
            if (!modelName) return;
            const productInCache = allHubProductsCache.find(p => p.wheelModel === modelName);
            const hubTags = productInCache?.tags || [];

            let isCompatible = true;
            let reason = '';

            if (selectedSpokeInterface) { // Only apply rules if a spoke is selected
                // RULE: If Spoke is explicitly "Hook Flange", Hub MUST be Hook Flange
                if (selectedSpokeInterface === 'Hook Flange' && !hubTags.includes('hub_type:hook_flange')) {
                    isCompatible = false;
                    reason = 'Selected spokes require a Hook Flange hub.';
                }
                // RULE: If Spoke is J-Bend, Hub cannot be Straight Pull
                else if (selectedSpokeInterface === 'J-Bend' && hubTags.includes('hub_type:straight_pull')) {
                    isCompatible = false;
                    reason = 'Requires Straight Pull spokes.';
                } 
                // RULE: If Spoke is Straight Pull, Hub cannot be J-Bend
                else if (selectedSpokeInterface === 'Straight Pull' && hubTags.includes('hub_type:j_bend')) {
                    isCompatible = false;
                    reason = 'Requires J-Bend spokes.';
                }
            }
            applyIncompatibleStyling(hubCard, isCompatible, reason);
        });
    });

    // --- Part 2: Spoke Styling based on Hub Selection ---
    ['front', 'rear'].forEach(pos => {
        const spokeOptionsContainer = document.getElementById(`${pos}-spokes-options-container`);
        if (!spokeOptionsContainer) return;

        const hubData = buildState.components[`${pos}Hub`];
        const selectedHubTags = hubData?.tags || [];

        spokeOptionsContainer.querySelectorAll('.spoke-model-card, .spoke-variant-button').forEach(spokeElement => {
            const spokeInterface = spokeElement.dataset.spokeHubInterface; // "Hook Flange", etc.

            let isCompatible = true;
            let reason = '';
            
            if (selectedHubTags.length > 0) { // Only apply rules if a hub is selected
                // RULE: If Hub is Hook Flange, allow ONLY "Hook Flange" OR "Universal/Blank" (Standard Berd)
                // This means we block J-Bend and Straight Pull steel spokes
                if (selectedHubTags.includes('hub_type:hook_flange')) {
                    if (spokeInterface === 'J-Bend' || spokeInterface === 'Straight Pull') {
                        isCompatible = false;
                        reason = 'Hook Flange hubs require Berd spokes.';
                    }
                }
                // RULE: If Hub is J-Bend/SP, block "Hook Flange" spokes (PolyLightX)
                else if (spokeInterface === 'Hook Flange') {
                    isCompatible = false;
                    reason = 'These spokes require a Hook Flange hub.';
                }
                // Standard Steel Spoke Logic
                else if (selectedHubTags.includes('hub_type:j_bend') && spokeInterface === 'Straight Pull') {
                    isCompatible = false;
                    reason = 'Not compatible with selected J-Bend hub.';
                } else if (selectedHubTags.includes('hub_type:straight_pull') && spokeInterface === 'J-Bend') {
                    isCompatible = false;
                    reason = 'Not compatible with selected Straight Pull hub.';
                }
            }
            applyIncompatibleStyling(spokeElement, isCompatible, reason);
        });
    });
}

function applyIntegratedWheelLogic(position, variantData) {
    const posLower = position.toLowerCase();
    
    console.group(`[Integrated Logic] Applying for ${position}`);

    // 1. Create a "Virtual" Hub
    const hubName = variantData.integrated_hub_name || "Integrated Hub";
    const virtualHub = {
        title: hubName,
        variantTitle: "Built-in (Included)",
        price: 0, 
        vendor: variantData.vendor, 
        variantId: `VIRTUAL-HUB-${position}-${Date.now()}`,
        isVirtual: true, 
        image: null,
        freehubVariantMap: variantData.freehubVariantMap,
        availableFreehubs: variantData.availableFreehubs
    };
    buildState.components[`${posLower}Hub`] = virtualHub;
    
    // Handle Freehub Swap for Rear
    if (posLower === 'rear') {
        buildState.components.rearComponentFreehub = null;
        if (virtualHub.freehubVariantMap) {
            setComponentFreehubForHub(virtualHub);
        }
    }

    updateComponentUI(position, 'Hub', virtualHub);

    // 2. Create "Virtual" Spokes & Nipples
    const virtualSpoke = { title: "Integrated Spokes", variantTitle: "N/A", price: 0, variantId: `VIRTUAL-SPOKE-${position}`, isVirtual: true, vendor: "Reserve" };
    const virtualNipple = { title: "Integrated Nipples", variantTitle: "N/A", price: 0, variantId: `VIRTUAL-NIPPLE-${position}`, isVirtual: true, vendor: "Reserve" };
    
    buildState.components[`${posLower}Spokes`] = virtualSpoke;
    buildState.components[`${posLower}Nipples`] = virtualNipple;
    updateComponentUI(position, 'Spokes', virtualSpoke);
    updateComponentUI(position, 'Nipples', virtualNipple);

    // 3. Lock the UI Sections
    ['Hub', 'Spokes', 'Nipples', 'ValveStem'].forEach(type => {
        const container = document.getElementById(`${posLower}-${type.toLowerCase()}-subsection`);
        if (container) {
            container.classList.add('is-locked-integrated');
            container.style.pointerEvents = 'none'; 
            container.style.opacity = '0.6';
            const removeBtn = document.getElementById(`remove-${posLower}-${type.toLowerCase()}-button`);
            if (removeBtn) removeBtn.style.display = 'none';
        }
    });

    // 4. Auto-Select Valve (NOW AS A PAID ITEM)
    if (variantData.included_valve_variant_id) {
        const targetId = variantData.included_valve_variant_id;
        let valveVariant = null;
        let valveProduct = null;

        for (const p of allValveStemProductsCache) {
            const foundV = p.variants.find(v => v.id === targetId || v.id.endsWith(targetId.split('/').pop()));
            if (foundV) {
                valveVariant = foundV;
                valveProduct = p;
                break;
            }
        }

        if (valveVariant && valveProduct) {
            const valveComponent = {
                variantId: valveVariant.id,
                productId: valveProduct.id,
                title: valveProduct.title,
                // --- Use Real Price ---
                price: valveVariant.price.amount, 
                // ---------------------------
                variantTitle: valveVariant.title, 
                // --- Remove 'isIncluded' so it adds to cart ---
                // isIncluded: true, <--- REMOVED
                // --------------------------------------------------
                image: valveVariant.image,
                vendor: valveProduct.vendor
            };
            buildState.components[`${posLower}ValveStem`] = valveComponent;
            updateComponentUI(position, 'ValveStem', valveComponent);
        }
    }
    console.groupEnd();
}

function resetIntegratedWheelLogic(position) {
    const posLower = position.toLowerCase();
    
    // Unlock the UI Sections (Added ValveStem)
    ['Hub', 'Spokes', 'Nipples', 'ValveStem'].forEach(type => {
        const container = document.getElementById(`${posLower}-${type.toLowerCase()}-subsection`);
        if (container) {
            container.classList.remove('is-locked-integrated');
            container.style.pointerEvents = '';
            container.style.opacity = '';
        }
    });

    // Clear Virtual Items
    if (buildState.components[`${posLower}Hub`]?.isVirtual) {
        buildState.components[`${posLower}Hub`] = null;
        updateComponentUI(position, 'Hub', null);
    }
    if (buildState.components[`${posLower}Spokes`]?.isVirtual) {
        buildState.components[`${posLower}Spokes`] = null;
        updateComponentUI(position, 'Spokes', null);
    }
    if (buildState.components[`${posLower}Nipples`]?.isVirtual) {
        buildState.components[`${posLower}Nipples`] = null;
        updateComponentUI(position, 'Nipples', null);
    }
    // Clear Included Valve
    if (buildState.components[`${posLower}ValveStem`]?.isIncluded) {
        buildState.components[`${posLower}ValveStem`] = null;
        updateComponentUI(position, 'ValveStem', null);
    }
}
   
    // --- START: calculateWheelCosts FUNCTION ---
function calculateWheelCosts(wheelPosition) {
    const posLower = wheelPosition.toLowerCase();
    
    // SAFETY GUARD: Ensure the array exists
    buildState.components[`${posLower}RequiredAddons`] = [];
    window.I9System?.applyColorFee(wheelPosition); // I9-SYSTEM: $25 "Custom Spoke Color Configuration" per wheel using more than one color (rides in RequiredAddons)
    window.StandardStudio?.applyColorFee(wheelPosition); // STANDARD-STUDIO: Mixed colors / Berd painted color / Berd multi-color fee, one line per wheel (rides in RequiredAddons)

    const selectedRim = buildState.components[`${posLower}Rim`];
    // SAFETY GUARD: If no rim is selected yet, stop here to prevent errors
    if (!selectedRim) return; 

    const isIntegrated = selectedRim.tags && selectedRim.tags.includes('type:integrated_wheel');

    if (isIntegrated) {
        // --- Add $20 Assembly Fee for Integrated Wheels ---
        buildState.components[`${posLower}AssemblyService`] = {
            variantGid: 'gid://shopify/ProductVariant/51777290764595', // The $20.00 Variant ID
            name: 'Assembly Service',
            price: 2000, // $20.00 in cents
            costInCents: 2000
        };
        // -------------------------------------------------------

        buildState.components[`${posLower}TubelessTape`] = null;
        // The array is already empty from the initialization above, so we don't need to null it here, 
        // but we leave it alone or empty it just to be safe.
        buildState.components[`${posLower}RequiredAddons`] = []; 
        return; 
    }

    const selectedHub = buildState.components[`${posLower}Hub`];
    const selectedSpokes = buildState.components[`${posLower}Spokes`];
    const isWheelBeingBuilt = selectedRim || selectedHub || selectedSpokes;

    if (isWheelBeingBuilt) {
        let finalAssemblyGid = null;

        // First, check the build type.
        if (buildState.buildType === 'Front' || buildState.buildType === 'Rear') {
            // Rule: If it's a single wheel build, use the flat $100 charge and ignore all other rules.
            finalAssemblyGid = SINGLE_WHEEL_ASSEMBLY_GID;

        } else {
            // Rule: If it's a Wheel Set, use the original competitive pricing logic.
            const hubVendorKey = selectedHub ? selectedHub.vendor.toLowerCase() : null;
            const hubSpecificGid = HUB_VENDOR_TO_ASSEMBLY_VARIANT_GID_MAP[hubVendorKey] || null;
            const hubPrice = hubSpecificGid ? (ASSEMBLY_SERVICE_PRICES_BY_GID[hubSpecificGid] || 0) : 0;

            const rimVendorKey = selectedRim ? selectedRim.vendor.toLowerCase() : null;
            const rimSpecificGid = RIM_VENDOR_TO_ASSEMBLY_VARIANT_GID_MAP[rimVendorKey] || null;
            const rimPrice = rimSpecificGid ? (ASSEMBLY_SERVICE_PRICES_BY_GID[rimSpecificGid] || 0) : 0;

            const freeAlloy = !!FREE_ASSEMBLY_VARIANT_GID && !!window.I9System?.isSystem() && !!window.I9System.isAlloyRim(selectedRim); // I9-SYSTEM: this wheel of a System set has an Industry Nine alloy rim
            if (freeAlloy) {
                finalAssemblyGid = FREE_ASSEMBLY_VARIANT_GID;
            } else if (hubSpecificGid && rimSpecificGid) {
                // Both vendors have special pricing, so pick the HIGHEST of the two.
                finalAssemblyGid = (rimPrice > hubPrice) ? rimSpecificGid : hubSpecificGid;
            } else if (hubSpecificGid) {
                // Only the hub has special pricing. Use it.
                finalAssemblyGid = hubSpecificGid;
            } else if (rimSpecificGid) {
                // Only the rim has special pricing. Use it.
                finalAssemblyGid = rimSpecificGid;
            } else {
                // No vendor-specific pricing was found. Use the default for wheelsets.
                finalAssemblyGid = DEFAULT_ASSEMBLY_SERVICE_VARIANT_GID;
            }
        }

        // Get the final price based on the chosen GID.
        const finalPrice = ASSEMBLY_SERVICE_PRICES_BY_GID[finalAssemblyGid] || 0;

        // Assign the final service and cost to the build state.
        buildState.components[`${posLower}AssemblyService`] = {
            variantGid: finalAssemblyGid,
            name: "Assembly Service",
            price: finalPrice,
            costInCents: Math.round(finalPrice * 100)
        };
    }

    if (selectedRim && buildState.tubelessTapeInstalled) {
        buildState.components[`${posLower}TubelessTape`] = {
            variantGid: 'gid://shopify/ProductVariant/51561220669747',
            name: 'Tubeless Tape (Installed)',
            price: 0,
            costInCents: 0
        };
    }

    const spokeVendor = selectedSpokes ? selectedSpokes.vendor : null;
    for (const addonKey in REQUIRED_ADDONS_CONFIG) {
        const addonConfig = REQUIRED_ADDONS_CONFIG[addonKey];
        if (addonConfig.condition(selectedHub, spokeVendor)) {
            // This .push() was causing the crash because the array wasn't defined above
            buildState.components[`${posLower}RequiredAddons`].push({
                name: addonConfig.name,
                price: addonConfig.price,
                variantGid: addonConfig.variantGid,
                costInCents: Math.round(addonConfig.price * 100)
            });
        }
    }
}
// --- END: calculateWheelCosts FUNCTION ---

    // --- API Call Functions ---
    async function storefrontApiQuery(query, variables = {}) { if(!config.storefrontApiToken)throw new Error("API Token missing."); const url=`/api/2024-04/graphql.json`; try { const r=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':config.storefrontApiToken},body:JSON.stringify({query,variables})}); const j=await r.json(); if(j.errors||!r.ok){const e=j.errors?j.errors.map(e=>e.message).join(','):`HTTP ${r.status}`; throw new Error(`GraphQL failed: ${e}`);} if(!j.data && !j.errors) { console.warn("GraphQL query successful but no data field."); return null;} return j.data;} catch(e){console.error("API Error:",e); throw e;} }

    // --- COMPONENT LOGIC FUNCTIONS (fetchers, displayers - existing code) ---
    // ... (Keep all your existing component fetching, filtering, and display functions for Rims, Hubs, Spokes, Nipples, ValveStems here, like fetchComponentProducts, loadAndFilterRims, displayRimProductCards, etc.)
    // ... NO CHANGES TO THESE FUNCTIONS THEMSELVES, JUST THEIR CALLERS IF NEEDED
    // --- Ensure all your component selection functions correctly set:
    // --- buildState.components[key].variantId (Shopify GID string)
    // --- buildState.components[key].price (price in CENTS as a number)
    // --- buildState.components[key].vendor, etc.

async function fetchBuilderComponentProducts(tag) {
    let allProductNodes = [];
    let cursor = null;
    let hasNextPage = true;

    while (hasNextPage) {
        const query = `
            query getComponentProducts($tagQuery: String!, $first: Int = 50, $variantsFirst: Int = 250, $cursor: String) {
                products(first: $first, query: $tagQuery, after: $cursor) {
                    pageInfo { hasNextPage endCursor }
                    edges {
                        node {
                            id title handle tags vendor availableForSale productType
                            vendorLogo: metafield(namespace: "custom", key: "vendor_logo") { reference { ... on MediaImage { image { url(transform:{maxWidth:100}) } } } value }
                            wheelModel: metafield(namespace: "custom", key: "wheel_spec_model") { value }
                            pairingKey: metafield(namespace: "custom", key: "pairing_key") { value }
                            spokeHubInterface: metafield(namespace: "custom", key: "spoke_hub_interface") { value }
                            rimDepth: metafield(namespace: "custom", key: "rim_depth_mm") { value }
                            leadTimeDays: metafield(namespace: "custom", key: "lead_time_days") { value }
                            optionalAddonProductGids: metafield(namespace: "custom", key: "optional_addon_gids") { value }
                            availableFreehubs: metafield(namespace: "custom", key: "freehub") { value }
                            freehubVariantMap: metafield(namespace: "custom", key: "freehub_variant_map") { value }
                            weight_g: metafield(namespace: "custom", key: "weight_g") { value }
                            pre_configured_wheel_rules: metafield(namespace: "custom", key: "pre_configured_wheel_rules") { value }
                            
                            rim_erd: metafield(namespace: "custom", key: "rim_erd") { value }
                            hub_flange_diameter_left: metafield(namespace: "custom", key: "hub_flange_diameter_left") { value }
                            hub_flange_diameter_right: metafield(namespace: "custom", key: "hub_flange_diameter_right") { value }
                            hub_flange_offset_left: metafield(namespace: "custom", key: "hub_flange_offset_left") { value }
                            hub_flange_offset_right: metafield(namespace: "custom", key: "hub_flange_offset_right") { value }
                            hub_spoke_hole_diameter: metafield(namespace: "custom", key: "hub_sp_offset_spoke_hole_diameter") { value }
                            hub_lacing_policy: metafield(namespace: "custom", key: "hub_lacing_policy") { value }
                            hub_lacing_ratio: metafield(namespace: "custom", key: "hub_lacing_ratio") { value } # I9-SYSTEM: "2:1" or blank (product-level fallback)
                            rim_wall: metafield(namespace: "custom", key: "rim_wall") { value } # I9-SYSTEM: "single" or "double" (product level); a single-wall rim is never offered in System
                            # --- ADD THIS LINE FOR THE QUICK BUILD ENGINE ---
                            spoke_cross_section_area_mm2: metafield(namespace: "custom", key: "spoke_cross_section_area_mm2") { value }
                            # --- ADDED THESE LINES FOR INTEGRATED WHEELS ---
                            integrated_hub_name: metafield(namespace: "custom", key: "integrated_hub_name") { value }
                            included_valve_variant_id: metafield(namespace: "custom", key: "included_valve_variant_id") { value }

                            variants(first: $variantsFirst) {
                                edges {
                                    node {
                                        id sku title availableForSale quantityAvailable
                                        price { amount currencyCode }
                                        image { url(transform:{maxWidth:500}) altText }
                                        selectedOptions { name value }
                                        spec_position: metafield(namespace:"custom",key:"wheel_spec_position"){ value }
                                        spec_brake_interface: metafield(namespace:"custom",key:"wheel_spec_brake_interface"){ value }
                                        spec_hub_spacing: metafield(namespace:"custom",key:"wheel_spec_hub_spacing"){ value }
                                        spec_freehub: metafield(namespace:"custom",key:"wheel_spec_freehub"){ value }
                                        spec_spoke_count: metafield(namespace:"custom",key:"wheel_spec_spoke_count"){ value }
                                        spec_rim_size: metafield(namespace:"custom",key:"wheel_spec_rim_size"){ value }
                                        valve_min_depth: metafield(namespace:"custom", key:"valve_min_rim_depth_mm") { value }
                                        valve_max_depth: metafield(namespace:"custom", key:"valve_max_rim_depth_mm") { value }
                                        internal_width_mm: metafield(namespace:"custom", key:"wheel_spec_internal_width_mm"){ value }
                                        weight_g: metafield(namespace: "custom", key: "weight_g") { value }
                                        rim_erd: metafield(namespace: "custom", key: "rim_erd") { value }
                                        hub_sp_offset_spoke_hole_left: metafield(namespace: "custom", key: "hub_sp_offset_spoke_hole_left") { value }
                                        hub_sp_offset_spoke_hole_right: metafield(namespace: "custom", key: "hub_sp_offset_spoke_hole_right") { value }
                                        hub_manual_cross_value: metafield(namespace: "custom", key: "hub_manual_cross_value") { value }
                                        hub_lacing_ratio: metafield(namespace: "custom", key: "hub_lacing_ratio") { value } # I9-SYSTEM: per-variant lacing ratio
                                        i9_system_allowed: metafield(namespace: "custom", key: "i9_system_allowed") { value } # I9-SYSTEM: rim variant may appear in System (only read when CFG.requireRimAllowedFlag)
                                        variant_freehub: metafield(namespace: "custom", key: "freehub") { value } # I9-SYSTEM: System hubs keep freehubs per variant (spacing is a variant option)
                                        variant_freehub_variant_map: metafield(namespace: "custom", key: "freehub_variant_map") { value } # I9-SYSTEM
                                        paint_fee_color: metafield(namespace: "custom", key: "paint_fee_color") { value } # STANDARD-STUDIO: "Yes" = this spoke color is painted (spoke variants)
                                    }
                                }
                            }
                        }
                    }
                }
            }`;

        try {
            const data = await storefrontApiQuery(query, { tagQuery: `tag:'${tag}'`, cursor: cursor });
            if (!data?.products?.edges) { hasNextPage = false; continue; }
            const pageProducts = data.products.edges.map(edge => edge.node);
            allProductNodes.push(...pageProducts);
            hasNextPage = data.products.pageInfo.hasNextPage;
            cursor = data.products.pageInfo.endCursor;
        } catch (error) {
            console.error(`fetchBuilderComponentProducts Error for tag '${tag}': ${error.message}`);
            hasNextPage = false;
        }
    }
    
    // Helper to safely parse floats
    const safeFloat = (metafield) => {
        if (!metafield || !metafield.value || metafield.value.trim() === '') return null;
        const num = parseFloat(metafield.value);
        return isNaN(num) ? null : num;
    };

    // Helper to safely get string values
    const safeString = (metafield) => {
        if (!metafield || !metafield.value || metafield.value.trim() === '') return null;
        return metafield.value;
    };

    const mappedProducts = allProductNodes.map(node => { // I9-SYSTEM: was `return allProductNodes.map(...)`; the result is filtered below
        let productOptionalAddonGids = [];
        if (node.optionalAddonProductGids && typeof node.optionalAddonProductGids.value === 'string') {
            try { productOptionalAddonGids = JSON.parse(node.optionalAddonProductGids.value); } catch (e) { productOptionalAddonGids = node.optionalAddonProductGids.value.split(',').map(gid => gid.trim()); }
            if (!Array.isArray(productOptionalAddonGids)) productOptionalAddonGids = [];
        }

        const variants = node.variants.edges.map(vEdge => {
            const vNode = vEdge.node;
            
            let processedVariant = {
                ...vNode,
                price: { amount: parseFloat(vNode.price.amount) * 100, code: vNode.price.currencyCode },
                spec_position: vNode.spec_position?.value,
                spec_brake_interface: (() => { const rawValue = vNode.spec_brake_interface?.value; if (!rawValue) return []; try { return JSON.parse(rawValue); } catch (e) { return [String(rawValue).trim()]; } })(),
                spec_hub_spacing: vNode.spec_hub_spacing?.value,
                spec_freehub: vNode.spec_freehub?.value,
                spec_spoke_count: (() => { const spokeOption = vNode.selectedOptions?.find(opt => opt.name.toLowerCase() === 'spoke count'); return spokeOption?.value || vNode.spec_spoke_count?.value || null; })(),
                spec_rim_size: vNode.spec_rim_size,
                valve_min_depth: vNode.valve_min_depth?.value ? parseInt(vNode.valve_min_depth.value) : null,
                valve_max_depth: vNode.valve_max_depth?.value ? parseInt(vNode.valve_max_depth.value) : null,
                internal_width_mm: vNode.internal_width_mm?.value ? parseInt(vNode.internal_width_mm.value) : null,
                weight_g: safeFloat(vNode.weight_g) !== null ? safeFloat(vNode.weight_g) : safeFloat(node.weight_g),
                rim_erd: safeString(vNode.rim_erd) !== null ? safeString(vNode.rim_erd) : safeString(node.rim_erd),
                hub_sp_offset_spoke_hole_left: vNode.hub_sp_offset_spoke_hole_left?.value,
                hub_sp_offset_spoke_hole_right: vNode.hub_sp_offset_spoke_hole_right?.value,
                hub_manual_cross_value: vNode.hub_manual_cross_value?.value,
                hub_lacing_ratio: safeString(vNode.hub_lacing_ratio) !== null ? safeString(vNode.hub_lacing_ratio) : safeString(node.hub_lacing_ratio), // I9-SYSTEM: variant first, product fallback
                i9_system_allowed: safeString(vNode.i9_system_allowed), // I9-SYSTEM: "true" / "false" / null (variant only, no product fallback)
                paintFeeColor: safeString(vNode.paint_fee_color), // STANDARD-STUDIO: "Yes" or null
                // I9-SYSTEM: variant-level freehub list and freehub -> component variant map (same shapes as the product-level fields). Empty when not set.
                variantFreehubs: (() => { const raw = vNode.variant_freehub?.value; if (!raw) return []; try { const a = JSON.parse(raw); return Array.isArray(a) ? a : [String(a)]; } catch (e) { return String(raw).split(',').map(x => x.trim()).filter(Boolean); } })(),
                variantFreehubMap: (() => { const raw = vNode.variant_freehub_variant_map?.value; if (!raw) return {}; try { const m = JSON.parse(raw); return m && typeof m === 'object' ? m : {}; } catch (e) { return {}; } })()
            };
            
            if (vNode.spec_rim_size?.value) {
                try { processedVariant.spec_rim_size.parsedValue = JSON.parse(vNode.spec_rim_size.value); } catch (e) { processedVariant.spec_rim_size.parsedValue = String(vNode.spec_rim_size.value).trim(); }
            } else { processedVariant.spec_rim_size = { value: null, parsedValue: null }; }
            return processedVariant;
        });

        return {
            ...node,
            variants: variants,
            vendorLogoUrl: node.vendorLogo?.reference?.image?.url || node.vendorLogo?.value || null,
            wheelModel: node.wheelModel?.value || null,
            pairingKey: node.pairingKey?.value || null,
            spokeHubInterface: node.spokeHubInterface?.value || null,
            rimDepth: node.rimDepth?.value ? parseInt(node.rimDepth.value) : null,
            leadTimeDays: node.leadTimeDays?.value ? parseInt(node.leadTimeDays.value, 10) : 0,
            weight_g: safeFloat(node.weight_g),
            availableFreehubs: (() => { const rawValue = node.availableFreehubs?.value; if (!rawValue) return []; try { return JSON.parse(rawValue); } catch(e) { return []; } })(),
            freehubVariantMap: (() => { const rawValue = node.freehubVariantMap?.value; if (!rawValue) return {}; try { return JSON.parse(rawValue); } catch(e) { return {}; } })(),
            optionalAddonProductGidsFromProduct: productOptionalAddonGids,
            rim_erd: safeString(node.rim_erd),
            spoke_cross_section_area_mm2: safeFloat(node.spoke_cross_section_area_mm2),
            preconfiguredRules: (() => { 
                const rawValue = node.pre_configured_wheel_rules?.value; 
                if (!rawValue) return []; 
                try { 
                    const rules = JSON.parse(rawValue);
                    return Array.isArray(rules) ? rules.filter(r => r && r.masterVariantGid) : [];
                } catch(e) { return []; } 
            })(),
            hub_flange_diameter_left: node.hub_flange_diameter_left?.value,
            hub_flange_diameter_right: node.hub_flange_diameter_right?.value,
            hub_flange_offset_left: node.hub_flange_offset_left?.value,
            hub_flange_offset_right: node.hub_flange_offset_right?.value,
            hub_spoke_hole_diameter: node.hub_spoke_hole_diameter?.value,
            // --- ADD THIS LINE FOR THE QUICK BUILD ENGINE ---
            spoke_cross_section_area_mm2: safeFloat(node.spoke_cross_section_area_mm2),
            // --- ADDED MAPPING FOR INTEGRATED WHEELS ---
            integrated_hub_name: node.integrated_hub_name?.value,
            included_valve_variant_id: node.included_valve_variant_id?.value,
            hub_lacing_ratio: safeString(node.hub_lacing_ratio), // I9-SYSTEM
            rim_wall: safeString(node.rim_wall) // I9-SYSTEM: "single" / "double" / null
        };
    });
    // I9-SYSTEM: single choke point for product eligibility. Classic builds: drop i9_system hubs/spokes and every rim variant
    // whose lacing ratio starts with "2:1" (and rim products left with no variants). System builds: keep only System products
    // and the rims/variants that match the chosen hub model. Without the module the list passes through untouched.
    return window.I9System ? window.I9System.filterEligible(tag, mappedProducts) : mappedProducts;
}

    async function loadAndFilterRims() {
    console.log("--- loadAndFilterRims (Combined F/R) ---");
    const buildType = buildState.buildType;
    const positionsToLoad = [];
    if (buildType === 'Front' || buildType === 'Wheel Set') positionsToLoad.push('Front');
    if (buildType === 'Rear' || buildType === 'Wheel Set') positionsToLoad.push('Rear');
    if (positionsToLoad.length === 0) return;

    if (allRimProductsCache.length === 0) {
        console.log("Rim cache empty in loadAndFilterRims.");
        if (componentFetchPromises.rims) {
            console.log("Waiting for early rim fetch promise to complete...");
            try {
                await componentFetchPromises.rims;
                console.log("Early rim fetch completed. Cache should now be populated.");
            } catch (error) {
                console.error("Error awaiting early rim fetch in loadAndFilterRims:", error);
            }
        } else {
            console.log("No early rim fetch promise found or it failed. Fetching Rims directly now...");
            const ridingStyleForDirectFetch = buildState.ridingStyle;
            if (!ridingStyleForDirectFetch) {
                console.warn("loadAndFilterRims (direct fetch): Riding style not set. Cannot fetch rims.");
                // Handle UI feedback if necessary (e.g., show error in rim sections)
                positionsToLoad.forEach(p => {
                    const loader = document.getElementById(`${p.toLowerCase()}-rim-loading`);
                    if(loader) loader.style.display = 'none';
                    const errorEl = document.getElementById(`${p.toLowerCase()}-rim-error`);
                    if(errorEl) errorEl.textContent = `Error: Riding style not selected.`;
                     const optionsEl = document.getElementById(`${p.toLowerCase()}-rim-options-container`);
                    if(optionsEl) optionsEl.innerHTML = '<p>Please select a riding style in Step 1.</p>';
                });
                return;
            }
            try {
                // This call to fetchRimProducts will populate allRimProductsCache
                await fetchRimProducts(ridingStyleForDirectFetch);
            } catch (error) {
                console.error("Error fetching rim products directly in loadAndFilterRims:", error);
            }
        }
    } else {
        console.log("Using already populated/cached rim data for loadAndFilterRims.");
    }

    if (allRimProductsCache.length === 0 && buildState.ridingStyle) { // Only show critical error if style was set but fetch failed
        console.error("Rim cache is STILL empty after attempting to load/wait for fetch. Rim data loading failed.");
        positionsToLoad.forEach(p => {
            const loader = document.getElementById(`${p.toLowerCase()}-rim-loading`);
            if(loader) loader.style.display = 'none';
            const errorEl = document.getElementById(`${p.toLowerCase()}-rim-error`);
            if(errorEl) errorEl.textContent = `Error: Rim data failed to load.`;
             const optionsEl = document.getElementById(`${p.toLowerCase()}-rim-options-container`);
            if(optionsEl) optionsEl.innerHTML = '<p>Rim data failed to load.</p>';
        });
        return;
    }

    // The rest of loadAndFilterRims (looping through positionsToLoad, calling loadAndFilterRimsForPosition) remains the same.
    for (const position of positionsToLoad) {
        await loadAndFilterRimsForPosition(position);
    }
    console.log("--- loadAndFilterRims (Combined F/R) finished ---");
}

async function loadAndFilterRimsForPosition(position, isChange = false) {
    console.log(`--- loadAndFilterRimsForPosition: ${position} ${isChange ? '(Change Mode)' : ''} ---`);
    const posLower = position.toLowerCase();
    const refs = {
        filters: document.getElementById(`${posLower}-rim-filters`),
        loading: document.getElementById(`${posLower}-rim-loading`),
        error: document.getElementById(`${posLower}-rim-error`),
        optionsContainer: document.getElementById(`${posLower}-rim-options-container`),
        selectionSpan: document.querySelector(`#${posLower}-rim-selection span`),
        imageContainer: document.getElementById(`${posLower}-rim-image-container`),
        actionButtonsContainer: document.getElementById(`${posLower}-rim-action-buttons`)
    };

    if (!refs.optionsContainer) return;

    refs.loading.style.display = 'block';
    refs.error.style.display = 'none';
    const subsectionElement = document.getElementById(`${posLower}-rim-subsection`);
    const stateKey = `${posLower}Rim`;
    const isSelected = buildState.components[stateKey];

    // --- Restore Integrated Logic on Load ---
    if (isSelected && isSelected.tags && isSelected.tags.includes('type:integrated_wheel') && !isChange) {
        console.log(`Restoring Integrated Wheel Logic for ${position}`);
        applyIntegratedWheelLogic(position, isSelected);
        updateComponentUI(position, 'Rim', isSelected);
        refs.loading.style.display = 'none';
        return;
    }
    // ---------------------------------------------

    if (isSelected && !isChange) {
        updateComponentUI(position, 'Rim', isSelected);
        refs.loading.style.display = 'none';
        return;
    }
    
    if (!isSelected) buildState._ui.activeVendor[stateKey] = window.I9System?.defaultVendor(stateKey) ?? null; // I9-SYSTEM: System rims: no vendor preselected when several brands fit (as in Standard); hubs and spokes preselect Industry Nine

    refs.imageContainer.innerHTML = '';
    refs.imageContainer.style.display = 'none';
    refs.optionsContainer.style.display = 'flex';
    refs.optionsContainer.innerHTML = '<p>Loading options...</p>';
    if (isChange && refs.actionButtonsContainer) refs.actionButtonsContainer.style.display = 'flex';
    else if (refs.actionButtonsContainer) refs.actionButtonsContainer.innerHTML = '';
    if (subsectionElement && !isChange) subsectionElement.classList.remove('selection-made');

    try {
        const size = buildState.specs[`${posLower}WheelSize`];
        const spokeCountSpec = buildState.specs[`${posLower}SpokeCount`];

        if (!size || !spokeCountSpec) { 
            refs.optionsContainer.innerHTML = '<p>Please select Wheel Size and Spoke Count in Step 2.</p>';
            refs.loading.style.display = 'none';
            displayComponentVendorFilters(stateKey, [], refs.filters, position);
            return;
        }

        if (allRimProductsCache.length === 0) {
            await loadAndFilterRims();
            if (allRimProductsCache.length === 0) {
                refs.optionsContainer.innerHTML = '<p>Rim data failed.</p>';
                refs.loading.style.display = 'none';
                return;
            }
        }
        
        // --- HELPER FOR STRICT CHECKS ---
        const checkProduct = (p, v) => {
            const isIntegrated = p.tags && p.tags.includes('type:integrated_wheel');
            const sizeValue = v.spec_rim_size?.parsedValue;
            const sizeMatch = (sizeValue === size || (Array.isArray(sizeValue) && sizeValue.includes(size)));
            const positionMatch = (v.spec_position === position || v.spec_position === "Front/Rear");
            const availMatch = v.availableForSale;

            // START: NEW TOGGLE-AWARE BRAKE MATCH
            let brakeMatch = false;
            const variantBrakeInterfaces = v.spec_brake_interface || [];
            const isRimBrakeRim = variantBrakeInterfaces.includes('Rim Brake');
            const toggleActive = buildState._ui.showRimBrakeRims;

            if (buildState.specs.brakeStyle === 'Rim Brake') {
                brakeMatch = isRimBrakeRim;
            } else {
                // If it's a Disc build: Show Disc Rims OR (Show Rim Brake Rims ONLY if toggle is on)
                brakeMatch = !isRimBrakeRim || (isRimBrakeRim && toggleActive);
            }
            // END: NEW TOGGLE-AWARE BRAKE MATCH

            if (isIntegrated) {
                const hubSpacing = buildState.specs[`${posLower}HubSpacing`];
                const brakeStyle = buildState.specs.brakeStyle;
                const spacingMatch = normalizeSpacing(v.spec_hub_spacing) === normalizeSpacing(hubSpacing);
                const integratedBrakeMatch = (v.spec_brake_interface || []).includes(brakeStyle);
                
                // Rear Integrated Check
                if (posLower === 'rear') {
                    const targetFreehub = buildState.specs.freehubType;
                    if (!p.availableFreehubs || !p.availableFreehubs.includes(targetFreehub)) return false;
                }
                
                return sizeMatch && positionMatch && availMatch && spacingMatch && integratedBrakeMatch;
            } else {
                const spokeMatch = (String(v.spec_spoke_count) === String(spokeCountSpec));
                // Ensure brakeMatch is added to the end of this return line:
                return sizeMatch && positionMatch && availMatch && spokeMatch && brakeMatch;
            }
        };

        // Filter 1: STRICTLY filtered list for the vendor dropdown.
        const strictlyCompatibleProducts = allRimProductsCache.filter(p => {
            if (p.vendor === 'Your Own Component') return true;
            return p.variants.some(v => checkProduct(p, v));
        });

        // Filter 2: LOOSELY filtered list for displaying product cards.
        const productsForDisplay = allRimProductsCache.filter(p => {
            if (p.vendor === 'Your Own Component') return true;
            return p.variants.some(v => checkProduct(p, v));
        });

        if (productsForDisplay.length === 0) {
            refs.optionsContainer.innerHTML = `<p>No ${posLower} rims available for size: ${size}.</p>`;
        }

        displayComponentVendorFilters(stateKey, strictlyCompatibleProducts, refs.filters, position);
        
        if (isChange) showCancelChangeButtonIfNeeded(position, 'Rim', refs.actionButtonsContainer);
        
        displayRimProductCards(position, productsForDisplay, refs.optionsContainer);

    } catch (error) {
        refs.error.textContent = `Error: ${error.message}.`;
        refs.error.style.display = 'block';
        console.error(`Error in loadAndFilterRimsForPosition(${position}):`, error);
        refs.optionsContainer.innerHTML = '<p>Error.</p>';
    } finally {
        refs.loading.style.display = 'none';
    }
}

function generateMismatchHint(vendor, componentKey, position) {
    const { specs } = buildState;
    const posLower = position.toLowerCase();
    
    let cacheToSearch;
    if (componentKey.endsWith('Rim')) cacheToSearch = allRimProductsCache;
    else if (componentKey.endsWith('Hub')) cacheToSearch = allHubProductsCache;
    else return `No products match your current specs`;

    const vendorProducts = cacheToSearch.filter(p => p.vendor === vendor);
    if (vendorProducts.length === 0) return `No products match your current specs`;

    // --- LOGIC FOR HUBS (with tiered hint priority) ---
    if (componentKey.endsWith('Hub')) {
        const currentBrakeStyle = specs.brakeStyle;
        const currentSpokeCount = specs[`${posLower}SpokeCount`];
        const currentHubSpacing = specs[`${posLower}HubSpacing`];

        // --- Priority 1: Check for a "one-step fix" by changing ONLY Brake Style ---
        const possibleBrakeHints = new Set();
        for (const p of vendorProducts) {
            for (const v of p.variants) {
                if (String(v.spec_spoke_count) === String(currentSpokeCount) && v.spec_hub_spacing === currentHubSpacing) {
                    (v.spec_brake_interface || []).forEach(style => {
                        if (style !== currentBrakeStyle) possibleBrakeHints.add(style);
                    });
                }
            }
        }
        if (possibleBrakeHints.size > 0) {
            return `Requires Brake Style: ${Array.from(possibleBrakeHints).join(' or ')}`;
        }

        // --- Priority 2: Check for a "one-step fix" by changing ONLY Spoke Count ---
        const possibleSpokeHints = new Set();
        for (const p of vendorProducts) {
            for (const v of p.variants) {
                if ((v.spec_brake_interface || []).includes(currentBrakeStyle) && v.spec_hub_spacing === currentHubSpacing) {
                    if (String(v.spec_spoke_count) !== String(currentSpokeCount)) {
                        possibleSpokeHints.add(v.spec_spoke_count);
                    }
                }
            }
        }
        if (possibleSpokeHints.size > 0) {
            const sortedCounts = Array.from(possibleSpokeHints).sort((a, b) => parseInt(a) - parseInt(b));
            return `Requires Spoke Count: ${sortedCounts.join(' or ')}`;
        }

        // --- Priority 3 (Fallback): Multiple specs are wrong. Show all available options. ---
        const allAvailableBrakeStyles = new Set();
        const allAvailableSpokeCounts = new Set();
        vendorProducts.forEach(p => {
            p.variants.forEach(v => {
                if (v.spec_hub_spacing === currentHubSpacing) { // Still respect the "hard" spec of spacing
                    (v.spec_brake_interface || []).forEach(style => allAvailableBrakeStyles.add(style));
                    if (v.spec_spoke_count) allAvailableSpokeCounts.add(v.spec_spoke_count);
                }
            });
        });

        let hints = [];
        if (allAvailableBrakeStyles.size > 0 && !allAvailableBrakeStyles.has(currentBrakeStyle)) {
            hints.push(`Brake Style: ${Array.from(allAvailableBrakeStyles).join('/')}`);
        }
        if (allAvailableSpokeCounts.size > 0 && !allAvailableSpokeCounts.has(currentSpokeCount)) {
            const sortedCounts = Array.from(allAvailableSpokeCounts).sort((a, b) => parseInt(a) - parseInt(b));
            hints.push(`Spoke Count: ${sortedCounts.join('/')}`);
        }
        if (hints.length > 0) {
            return `Requires ${hints.join(' & ')}`;
        }
    }

    // --- LOGIC FOR RIMS (Simpler, as it only has one quick-change spec) ---
    if (componentKey.endsWith('Rim')) {
        const currentSpokeCount = specs[`${posLower}SpokeCount`];
        const currentWheelSize = specs[`${posLower}WheelSize`];

        // I9-SYSTEM: the sold-out reason wins: this brand has rims in the chosen size and hole count, and every one of them is unavailable
        const matchSizeHoles = v => { const sv = v.spec_rim_size?.parsedValue; return (Array.isArray(sv) ? sv.includes(currentWheelSize) : sv === currentWheelSize) && String(v.spec_spoke_count) === String(currentSpokeCount); };
        const matching = vendorProducts.flatMap(p => p.variants.filter(matchSizeHoles));
        if (currentWheelSize && matching.length > 0 && matching.every(v => !v.availableForSale)) {
            return `${vendor} ${String(currentWheelSize).replace(/"/g, '&quot;')} ${currentSpokeCount} rims are sold out right now`;
        }

        const otherSpokeCounts = new Set();
        for (const p of vendorProducts) {
            for (const v of p.variants) {
                const sizeValue = v.spec_rim_size?.parsedValue;
                const sizeMatch = Array.isArray(sizeValue) ? sizeValue.includes(currentWheelSize) : sizeValue === currentWheelSize;
                
                if (String(v.spec_spoke_count) !== String(currentSpokeCount) && sizeMatch) {
                    otherSpokeCounts.add(v.spec_spoke_count);
                }
            }
        }
        if (otherSpokeCounts.size > 0) {
            const sortedCounts = Array.from(otherSpokeCounts).sort((a, b) => parseInt(a) - parseInt(b));
            return `Requires Spoke Count: ${sortedCounts.join(' or ')}`;
        }
        // I9-SYSTEM: say why a brand is gray when the spoke count is not the reason: no approved rim of this brand in the chosen size, or sold out
        const sizeOf = v => { const sv = v.spec_rim_size?.parsedValue; return Array.isArray(sv) ? sv.includes(currentWheelSize) : sv === currentWheelSize; };
        const inSize = vendorProducts.some(p => p.variants.some(sizeOf));
        const sizeLabel = String(currentWheelSize || '').replace(/"/g, '&quot;'); // the hint goes into a title="" attribute
        if (currentWheelSize && !inSize) return `${vendor} has no rim for this build in ${sizeLabel}`;
        if (currentWheelSize && vendorProducts.some(p => p.variants.some(v => sizeOf(v) && String(v.spec_spoke_count) === String(currentSpokeCount) && !v.availableForSale))) return `${vendor} ${sizeLabel} ${currentSpokeCount} rims are sold out right now`;
    }

    return `No products match your current specs`; // Final fallback
}

function displayComponentVendorFilters(componentKey, products, filterContainer, position) {
    if (!filterContainer) return;
    const vendorArea = filterContainer.querySelector('.vendor-filter-area');
    if (!vendorArea) {
        console.error("Missing .vendor-filter-area in", filterContainer);
        return;
    }

    let globalCacheForComponentType;
    if (componentKey.endsWith('Rim')) globalCacheForComponentType = allRimProductsCache;
    else if (componentKey.endsWith('Hub')) globalCacheForComponentType = allHubProductsCache;
    else if (componentKey.endsWith('Spokes')) globalCacheForComponentType = allSpokeProductsCache;
    else if (componentKey.endsWith('Nipples')) globalCacheForComponentType = allNippleProductsCache;
    else if (componentKey.endsWith('ValveStem')) globalCacheForComponentType = allValveStemProductsCache;
    else globalCacheForComponentType = products;

    const allPossibleVendors = [...new Set(globalCacheForComponentType.map(p => p.vendor))].sort((a, b) => {
        return getSortableName(a).localeCompare(getSortableName(b));
    });
    
    // --- Use the products list passed from the loader ---
    // The 'products' argument already contains the correctly filtered list (including Reserve Infinity).
    // We just need to check if a vendor exists in that list.
    const availableVendors = new Set(products.map(p => p.vendor));

    const currentActiveVendor = buildState._ui.activeVendor[componentKey];
    let toggleContentHTML = '';

    if (currentActiveVendor === null) {
        toggleContentHTML = '<span class="vendor-prompt"><b>Click to select a vendor</b></span>';
    } else if (currentActiveVendor === 'all') {
        toggleContentHTML = '<span class="toggle-all-vendors-button">All Vendors</span>';
    } else {
        const vendorInfo = vendorLogoMap[currentActiveVendor];
        const logoUrl = vendorInfo?.logoUrl;
        toggleContentHTML = `<span>
                                ${logoUrl ? `<img src="${logoUrl}" alt="${currentActiveVendor}" class="toggle-vendor-logo">` : `<span>${currentActiveVendor}</span>`}
                             </span>`;
    }

    const hasAnyCompatibleProducts = availableVendors.size > 0;
    const allVendorsDisabledAttr = hasAnyCompatibleProducts ? '' : 'disabled';
    const allVendorsTooltip = hasAnyCompatibleProducts ? 'All Vendors' : 'No products match your current specs';

    let dropdownHTML = `
        <h4>Vendor:</h4>
        <div class="vendor-filter-dropdown" data-component-key="${componentKey}">
            <button type="button" class="dropdown-toggle">
                ${toggleContentHTML}
            </button>
            <div class="dropdown-menu">
                <div class="vendor-filter-options">
                    <button type="button" class="vendor-filter-btn ${currentActiveVendor === 'all' ? 'active' : ''}" data-vendor="all" data-position="${position}" data-component-key="${componentKey}" title="${allVendorsTooltip}" ${allVendorsDisabledAttr}>
                        <span>All</span>
                    </button>`;

    allPossibleVendors.forEach(vendor => {
        // This check now respects the "Integrated" logic because 'availableVendors' is built from the pre-filtered 'products' list
        const hasCompatibleProducts = availableVendors.has(vendor);

        // If unavailable, use hint engine
        const tooltipTitle = hasCompatibleProducts 
            ? vendor 
            : generateMismatchHint(vendor, componentKey, position);

        const vendorInfo = vendorLogoMap[vendor];
        const logoUrl = vendorInfo?.logoUrl;
        const vendorName = vendorInfo?.name || vendor;
        const activeClass = currentActiveVendor === vendorName ? 'active' : '';
        const unavailableClass = hasCompatibleProducts ? '' : 'is-unavailable';
        const disabledAttr = hasCompatibleProducts ? '' : 'disabled';

        dropdownHTML += `<button type="button" class="vendor-filter-btn ${activeClass} ${unavailableClass}" data-vendor="${vendorName.replace(/"/g, '\\"')}" data-position="${position}" data-component-key="${componentKey}" title="${tooltipTitle}" ${disabledAttr}>
                            ${logoUrl ? `<img src="${logoUrl}" alt="${vendorName}" class="vendor-logo">` : `<span>${vendorName}</span>`}
                         </button>`;
    });

    if (componentKey.endsWith('Rim')) {
        const isChecked = buildState._ui.showRimBrakeRims ? 'checked' : '';
        dropdownHTML += `
            <div class="vendor-msw-toggle-wrapper">
                <input type="checkbox" class="msw-global-checkbox" id="msw-${position}" ${isChecked}>
                <label for="msw-${position}">Include Rim Brake Options</label>
            </div>`;
    }

    dropdownHTML += `
                </div>
            </div>
        </div>
    `;

    vendorArea.innerHTML = dropdownHTML;
}
  
    function checkIfModelGroupHasVariants(position, productsInGroup) { const posLower = position.toLowerCase(); const size = buildState.specs[`${posLower}WheelSize`]; const spokeCountSpec = buildState.specs[`${posLower}SpokeCount`]; if (!size) return false; for (const p of productsInGroup) { for (const v of p.variants) { const sizeMatch = v.spec_rim_size?.parsedValue === size || (Array.isArray(v.spec_rim_size?.parsedValue) && v.spec_rim_size.parsedValue.includes(size)); const positionMatch = v.spec_position === position || v.spec_position === "Front/Rear"; const spokeMatch = !spokeCountSpec || (v.spec_spoke_count && String(v.spec_spoke_count) === String(spokeCountSpec)); if (v.availableForSale && positionMatch && sizeMatch && spokeMatch) return true; } } return false; }

function displayRimVariantButtonsByProduct(position, productsInGroup, variantContainer) {
    if (!variantContainer) return;
    variantContainer.innerHTML = ''; 

    const posLower = position.toLowerCase();
    const size = buildState.specs[`${posLower}WheelSize`];
    const spokeCountSpec = buildState.specs[`${posLower}SpokeCount`];
    const stateKey = `${posLower}Rim`;
    const selectedComponent = buildState.components[stateKey];

    const getRimColor = (variantTitle) => {
        if (!variantTitle) return null;
        const parts = variantTitle.split('/').map(p => p.trim());
        const lastPart = parts[parts.length - 1];
        return isNaN(lastPart) ? lastPart.toLowerCase() : null;
    };

    let compatibleVariants = [];
    
    productsInGroup.forEach(p => {
        const productDetails = {
            productId: p.id, productTitle: p.title, productHandle: p.handle, vendor: p.vendor, pairingKey: p.pairingKey, rimDepth: p.rimDepth, optionalAddonProductGidsFromProduct: p.optionalAddonProductGidsFromProduct, leadTimeDays: p.leadTimeDays || 0, wheelModel: p.wheelModel || null, product_weight_g: p.weight_g, product_rim_erd: p.rim_erd,
            tags: p.tags, integrated_hub_name: p.integrated_hub_name, included_valve_variant_id: p.included_valve_variant_id,
            freehubVariantMap: p.freehubVariantMap, 
            availableFreehubs: p.availableFreehubs
        };

        const isIntegrated = p.tags && p.tags.includes('type:integrated_wheel');

        p.variants.forEach(v => {
            const sizeValue = v.spec_rim_size?.parsedValue;
            const sizeMatch = sizeValue === size || (Array.isArray(sizeValue) && sizeValue.includes(size));
            const positionMatch = (v.spec_position === position || v.spec_position === "Front/Rear");
            
            // START: TOGGLE-AWARE BRAKE MATCH
            let brakeMatch = false;
            const variantBrakeInterfaces = v.spec_brake_interface || [];
            const isRimBrakeRim = variantBrakeInterfaces.includes('Rim Brake');
            const toggleActive = buildState._ui.showRimBrakeRims;

            if (buildState.specs.brakeStyle === 'Rim Brake') {
                brakeMatch = isRimBrakeRim;
            } else {
                // Assume Disc build: Show everything except Rim Brake rims, UNLESS toggle is on.
                brakeMatch = !isRimBrakeRim || (isRimBrakeRim && toggleActive);
            }
            // END: NEW TOGGLE-AWARE BRAKE MATCH

    let spokeMatch = false;
            if (isIntegrated) {
                // Define the variables needed for the Integrated Wheel check
                const hubSpacing = buildState.specs[`${posLower}HubSpacing`];
                const brakeStyle = buildState.specs.brakeStyle;
                
                const spacingMatch = normalizeSpacing(v.spec_hub_spacing) === normalizeSpacing(hubSpacing);
                const integratedBrakeMatch = (v.spec_brake_interface || []).includes(brakeStyle);
                
                let freehubMatch = true;
                if (posLower === 'rear') {
                    const targetFreehub = buildState.specs.freehubType;
                    if (p.availableFreehubs && Array.isArray(p.availableFreehubs)) {
                         if (!p.availableFreehubs.includes(targetFreehub)) {
                            freehubMatch = false;
                         }
                    } else if (targetFreehub) {
                        freehubMatch = false;
                    }
                }

                spokeMatch = spacingMatch && integratedBrakeMatch && freehubMatch;
            } else {
                // Standard Rim Logic
                spokeMatch = !spokeCountSpec || (String(v.spec_spoke_count) === String(spokeCountSpec));
            }

    if (v.availableForSale && positionMatch && sizeMatch && spokeMatch && brakeMatch) {
                compatibleVariants.push({ ...v, ...productDetails });
            }
});
    });

    if (compatibleVariants.length === 0) {
        variantContainer.innerHTML = `<p>No options match Size: ${size}${spokeCountSpec ? ` & Spokes: ${spokeCountSpec}` : ''}.</p>`;
        return;
    }

    const uniqueVariants = Array.from(new Map(compatibleVariants.map(v => [v.id, v])).values())
                                .sort((a, b) => (a.productTitle || '').localeCompare(b.productTitle || ''));

    uniqueVariants.forEach(v_rim => {
        const btn = document.createElement('button');
        btn.className = 'component-variant-button rim-variant-button';
        btn.dataset.variantId = v_rim.id;
        btn.dataset.productId = v_rim.productId;
        btn.type = 'button';
        if (selectedComponent?.variantId === v_rim.id) btn.classList.add('selected');

        const weight = v_rim.weight_g ?? v_rim.product_weight_g ?? null;
        let displayTitle = v_rim.productTitle;
        const potentialColor = getRimColor(v_rim.title);
        if (potentialColor) { displayTitle += ` (${potentialColor.charAt(0).toUpperCase() + potentialColor.slice(1)})`; }

        btn.innerHTML = `
            <div class="variant-button-image-container">
                ${v_rim.image?.url ? `<img src="${v_rim.image.url}" alt="${displayTitle}" loading="lazy" class="variant-button-image">` : '<div class="variant-button-image-placeholder"></div>'}
            </div>
            <div class="variant-button-details">
                <span class="variant-details">${displayTitle}</span>
                ${v_rim.price?.amount ? `<span class="variant-price">${formatPrice(v_rim.price.amount)}</span>` : ''}
            </div>
            <div class="variant-button-stats">
                ${weight ? `<span class="stat-item">Weight: <strong>${weight}g</strong></span>` : ''}
            </div>`;

        btn.addEventListener('click', async () => {
            const isIntegratedClick = v_rim.tags && v_rim.tags.includes('type:integrated_wheel');
            if (isIntegratedClick) {
                applyIntegratedWheelLogic(position, v_rim);
            } else {
                resetIntegratedWheelLogic(position);
            }

            const selectedRimComponentData = v_rim;
            const previouslySelectedComponent = buildState.components[stateKey];
            const newSelectedVariantId = selectedRimComponentData.id;
            if (previouslySelectedComponent && previouslySelectedComponent.productId !== selectedRimComponentData.productId) {
                const addonKeysToRemove = Object.keys(buildState.selectedOptionalAddons).filter(key => {
                    const addon = buildState.selectedOptionalAddons[key];
                    return addon.baseComponentPosition === position && addon.baseComponentType === 'Rim' && addon.baseComponentVariantId === previouslySelectedComponent.variantId;
                });
                addonKeysToRemove.forEach(key => { delete buildState.selectedOptionalAddons[key]; });
                if (addonKeysToRemove.length > 0) saveLastActiveBuild();
            } else if (previouslySelectedComponent && previouslySelectedComponent.variantId !== newSelectedVariantId) {
                 manageStickyAddonsForChangedBaseVariant(position, 'Rim', previouslySelectedComponent.variantId, newSelectedVariantId, selectedRimComponentData.optionalAddonProductGidsFromProduct || []);
            }
            
            const selectedRimComponent = {
                variantId: selectedRimComponentData.id, title: selectedRimComponentData.productTitle, variantTitle: selectedRimComponentData.title, sku: selectedRimComponentData.sku,
                price: selectedRimComponentData.price.amount, vendor: selectedRimComponentData.vendor, spokeCount: String(selectedRimComponentData.spec_spoke_count),
                wheelSize: size, image: selectedRimComponentData.image, pairingKey: selectedRimComponentData.pairingKey, selectedOptions: selectedRimComponentData.selectedOptions,
                rimDepth: selectedRimComponentData.rimDepth, productId: selectedRimComponentData.productId, productHandle: selectedRimComponentData.productHandle,
                optionalAddonProductGids: selectedRimComponentData.optionalAddonProductGidsFromProduct,
                internal_width_mm: selectedRimComponentData.internal_width_mm,
                quantityAvailable: selectedRimComponentData.quantityAvailable, 
                leadTimeDays: selectedRimComponentData.leadTimeDays, 
                wheelModel: selectedRimComponentData.wheelModel, 
                weight_g: selectedRimComponentData.weight_g ?? selectedRimComponentData.product_weight_g ?? null,
                rim_erd: selectedRimComponentData.rim_erd ?? selectedRimComponentData.product_rim_erd ?? null,
                tags: selectedRimComponentData.tags,
                integrated_hub_name: selectedRimComponentData.integrated_hub_name,
                included_valve_variant_id: selectedRimComponentData.included_valve_variant_id,
                freehubVariantMap: selectedRimComponentData.freehubVariantMap, 
                availableFreehubs: selectedRimComponentData.availableFreehubs  
            };
            buildState.components[stateKey] = selectedRimComponent;
            buildState._ui.hasChanges = true;
            updateStep3ButtonText();
            calculateWheelCosts(position);
            updateComponentUI(position, 'Rim', selectedRimComponent);
            evaluateValveStemForRimChange(position);
            await handleAutoPairing('Rim', position, selectedRimComponent, false);
            updateSubtotal();
            updateBuildSummary();
            validateStep3();
            saveLastActiveBuild();
            if (buildState._ui.isChangingComponent?.position === position && buildState._ui.isChangingComponent?.type === 'Rim') { cancelComponentChange(); }
            handleComponentChangeForLeadTime();
            scrollToComponentSection(position, 'Rim');
        });
        variantContainer.appendChild(btn);
    });
}
// --- END: displayRimVariantButtonsByProduct ---

// --- START: fetchRimProducts (V4.3 - With Specific Tag Query & Race Guard) ---
async function fetchRimProducts(ridingStyle) {
    if (!ridingStyle) {
        console.warn("fetchRimProducts: Riding style not provided. Cannot fetch rims.");
        allRimProductsCache = []; // Ensure cache is empty if style is missing
        return;
    }
    
    let tagQuery;
    
    if (ridingStyle === 'hybrid') {
        tagQuery = "component:rim"; 
    } else {
        tagQuery = ridingStyle === 'mtb'
            ? "style:mtb' AND tag:'component:rim"
            : (ridingStyle === 'gravelroad' ? "style:gravelroad' AND tag:'component:rim" : null);
    }

    if (!tagQuery) {
        console.warn(`fetchRimProducts: Unknown ridingStyle '${ridingStyle}', cannot construct tag query for rims.`);
        allRimProductsCache = [];
        return;
    }
    
    console.log(`fetchRimProducts: Constructing query with tags: ${tagQuery}`);

    try {
        const i9Gen = i9FetchGeneration; // I9-SYSTEM: context at the start of this fetch
        const fetchedProducts = await fetchBuilderComponentProducts(tagQuery);

        // --- NEW: RACE CONDITION GUARD ---
        // If the user clicked a different riding style while this was downloading, discard this old data.
        if (buildState.ridingStyle !== ridingStyle) {
            console.log(`[Fetch Guard] Discarding ${ridingStyle} rim data; active style is now ${buildState.ridingStyle}`);
            return;
        }
        if (i9Gen !== i9FetchGeneration) return; // I9-SYSTEM: the caches were reset for another context while this was downloading; the newer fetch owns them
        // ---------------------------------

        allRimProductsCache = fetchedProducts;
        updateGlobalVendorLogoMap(allRimProductsCache);
        if (buildState.step === 2) renderStep2(); 
        console.log(`fetchRimProducts: Found and cached ${allRimProductsCache.length} rim products using query: "${tagQuery}".`);
    } catch (error) {
        console.error(`fetchRimProducts Error for query "${tagQuery}":`, error);
        allRimProductsCache = []; // Clear cache on error
        throw error; // Re-throw to be caught by caller
    }
}
// --- END: fetchRimProducts ---
  
// [START] fetchHubProducts
async function fetchHubProducts() {
    console.log("Fetching ALL hub products using tag: component:hub");
    const hubTag = "component:hub";
    try {
        const i9Gen = i9FetchGeneration; // I9-SYSTEM: context at the start of this fetch
        const fetchedHubs = await fetchBuilderComponentProducts(hubTag);
        if (i9Gen !== i9FetchGeneration) return allHubProductsCache; // I9-SYSTEM: caches were reset for another context meanwhile; the newer fetch owns them
        allHubProductsCache = fetchedHubs;
        updateGlobalVendorLogoMap(allHubProductsCache);
        if (buildState.step === 2) renderStep2();
        console.log(`fetchHubProducts: Found and cached ${allHubProductsCache.length} products.`);
    } catch (error) {
        console.error("fetchHubProducts Error:", error);
        allHubProductsCache = [];
        throw error;
    }
    return allHubProductsCache;
}
// [END] fetchHubProducts
  
    async function loadAndFilterHubs() { console.log("--- loadAndFilterHubs (Combined F/R) ---"); const buildType = buildState.buildType; const positionsToLoad = []; if (buildType === 'Front' || buildType === 'Wheel Set') positionsToLoad.push('Front'); if (buildType === 'Rear' || buildType === 'Wheel Set') positionsToLoad.push('Rear'); if (positionsToLoad.length === 0) return; positionsToLoad.forEach(p => { const l=document.getElementById(`${p.toLowerCase()}-hub-loading`); if(l)l.style.display='block'; const o=document.getElementById(`${p.toLowerCase()}-hub-options-container`); if(o)o.innerHTML='<p>Loading hub options...</p>';}); 

        // --- START: MODIFIED CACHE/PROMISE HANDLING FOR HUBS ---
 if (allHubProductsCache.length === 0) {
     console.log("Hub cache empty in loadAndFilterHubs.");
     if (componentFetchPromises.hubs) {
         // console.log("Waiting for early hub fetch promise to complete...");
         try {
             await componentFetchPromises.hubs; // Wait for the early fetch
             // console.log("Early hub fetch completed. Cache should now be populated.");
         } catch (error) {
             console.error("Error awaiting early hub fetch in loadAndFilterHubs:", error);
             // The fetchHubProducts call itself handles setting allHubProductsCache to [] on error.
             // So, the check below will handle the error display.
         }
     } else {
         // This case means early fetch was not triggered or it failed and promise was reset.
         // console.log("No early hub fetch promise found or it failed. Fetching Hubs directly now...");
         try {
             // Crucial: Pass buildState.ridingStyle for direct fetches
             await fetchHubProducts(buildState.ridingStyle);
         } catch (error) {
             console.error("Error fetching hub products directly in loadAndFilterHubs:", error);
             // Error display will be handled by the check below if cache is still empty.
         }
     }
 } else {
     console.log("Using already populated/cached hub data for loadAndFilterHubs.");
 }

 // Check cache status *after* attempting to await promise or fetch directly
 if (allHubProductsCache.length === 0) {
     console.error("Hub cache is STILL empty after attempting to load/wait for fetch. Hub data loading failed.");
     positionsToLoad.forEach(p => {
         const loader = document.getElementById(`${p.toLowerCase()}-hub-loading`);
         if(loader) loader.style.display = 'none';
         const errorEl = document.getElementById(`${p.toLowerCase()}-hub-error`);
         if(errorEl) errorEl.textContent = `Error: Hub data failed to load. Please try refreshing.`;
         const optionsEl = document.getElementById(`${p.toLowerCase()}-hub-options-container`);
         if(optionsEl) optionsEl.innerHTML = '<p>Hub data failed to load.</p>';
     });
     return; // Stop further processing for hubs if data isn't available
 }
 // --- END: MODIFIED CACHE/PROMISE HANDLING FOR HUBS ---
                                         
      for (const position of positionsToLoad) { await loadAndFilterHubsForPosition(position); } console.log("--- loadAndFilterHubs (Combined F/R) finished ---"); }
    
async function loadAndFilterHubsForPosition(position, isChange = false) {
    console.log(`--- loadAndFilterHubsForPosition: ${position} ${isChange ? '(Change Mode)' : ''} ---`);
    const posLower = position.toLowerCase();
    const refs = {
        filters: document.getElementById(`${posLower}-hub-filters`),
        loading: document.getElementById(`${posLower}-hub-loading`),
        error: document.getElementById(`${posLower}-hub-error`),
        optionsContainer: document.getElementById(`${posLower}-hub-options-container`),
        selectionSpan: document.querySelector(`#${posLower}-hub-selection span`),
        imageContainer: document.getElementById(`${posLower}-hub-image-container`),
        actionButtonsContainer: document.getElementById(`${posLower}-hub-action-buttons`)
    };

    if (!refs.optionsContainer || !refs.filters || !refs.loading || !refs.error) {
        console.error(`Hub DOM elements missing for ${position}!`);
        return;
    }

    refs.loading.style.display = 'block';
    refs.error.style.display = 'none';
    const subsectionElement = document.getElementById(`${posLower}-hub-subsection`);
    const stateKey = `${posLower}Hub`;
    const isSelected = buildState.components[stateKey];

// --- Handle Virtual (Integrated) Components ---
    if (isSelected && isSelected.isVirtual) {
        console.log(`Keeping Virtual Hub for ${position}`);
        updateComponentUI(position, 'Hub', isSelected);
        if (refs.loading) refs.loading.style.display = 'none';
        
        // Ensure UI is locked visually
        const container = document.getElementById(`${posLower}-hub-subsection`);
        if (container) {
            container.classList.add('is-locked-integrated');
            container.style.pointerEvents = 'none';
            container.style.opacity = '0.6';
        }
        return; // STOP HERE
    }

    if (isSelected && !isChange) {
        updateComponentUI(position, 'Hub', isSelected);
        refs.loading.style.display = 'none';
        return;
    }
    
    if (!isSelected) {
        buildState._ui.activeVendor[stateKey] = window.I9System?.defaultVendor() ?? null; // I9-SYSTEM: System builds preselect Industry Nine
    }

    refs.imageContainer.innerHTML = '';
    refs.imageContainer.style.display = 'none';
    refs.optionsContainer.style.display = 'flex';
    refs.optionsContainer.innerHTML = '<p>Loading hub options...</p>';
    if (isChange) {
        if (refs.actionButtonsContainer) refs.actionButtonsContainer.style.display = 'flex';
    } else {
        if (refs.actionButtonsContainer) refs.actionButtonsContainer.innerHTML = '';
    }
    if (subsectionElement && !isChange) subsectionElement.classList.remove('selection-made');

    try {
        const brakeStyle = buildState.specs.brakeStyle;
        const hubSpacing = buildState.specs[`${posLower}HubSpacing`];
        const freehubType = (posLower === 'rear') ? buildState.specs.freehubType : null;
        const spokeCount = buildState.specs[`${posLower}SpokeCount`]; // Get current spoke count

        let missingPrerequisites = [];
        if (!brakeStyle) missingPrerequisites.push("Brake Style");
        if (!hubSpacing) missingPrerequisites.push(`${position} Hub Spacing`);
        if (posLower === 'rear' && !freehubType) missingPrerequisites.push("Freehub Type");
        if (!spokeCount) missingPrerequisites.push(`${position} Spoke Count`); // Add spoke count to prerequisites

        if (missingPrerequisites.length > 0) {
            refs.optionsContainer.innerHTML = `<p class="selection-prompt">Please select required Step 2 specs: ${missingPrerequisites.join(', ')}.</p>`;
            refs.loading.style.display = 'none';
            displayComponentVendorFilters(stateKey, [], refs.filters, position);
            return;
        }

        if (allHubProductsCache.length === 0) {
            await fetchHubProducts();
        }

        // Filter 1: STRICTLY filtered list for the vendor dropdown.
        const strictlyCompatibleProducts = allHubProductsCache.filter(product => {
            if (product.vendor === 'Your Own Component') return true;
            if (position === 'Rear' && (!product.availableFreehubs || !isFreehubCompatible(freehubType, product.availableFreehubs))) return false;
            return product.variants.some(variant => 
                (variant.spec_position === position || variant.spec_position === "Front/Rear") &&
                (variant.spec_brake_interface || []).includes(brakeStyle) &&
                normalizeSpacing(variant.spec_hub_spacing) === normalizeSpacing(hubSpacing) &&
                String(variant.spec_spoke_count) === String(spokeCount) && // Strict spoke count check
                variant.availableForSale
            );
        });

        // Filter 2: LOOSELY filtered list for displaying product cards (ignores spoke count).
        const productsForDisplay = allHubProductsCache.filter(product => {
            if (product.vendor === 'Your Own Component') return true;
            if (position === 'Rear' && (!product.availableFreehubs || !isFreehubCompatible(freehubType, product.availableFreehubs))) return false;
            return product.variants.some(variant => 
                (variant.spec_position === position || variant.spec_position === "Front/Rear") &&
                (variant.spec_brake_interface || []).includes(brakeStyle) &&
                normalizeSpacing(variant.spec_hub_spacing) === normalizeSpacing(hubSpacing) &&
                variant.availableForSale
            );
        });

        if (productsForDisplay.length === 0) {
            refs.optionsContainer.innerHTML = `<p>No hubs match all selected specs. Please adjust your selections in Step 2.</p>`;
        }
        
        // Use the STRICT list for the vendor filter
        displayComponentVendorFilters(stateKey, strictlyCompatibleProducts, refs.filters, position);
        
        if (isChange) {
            showCancelChangeButtonIfNeeded(position, 'Hub', refs.actionButtonsContainer);
        }
        
        // Use the LOOSE list for the card display
        displayHubProductCards(position, productsForDisplay, refs.optionsContainer);

    } catch (error) {
        refs.error.textContent = `Error: ${error.message}.`;
        refs.error.style.display = 'block';
        console.error(`Error in loadAndFilterHubsForPosition(${position}):`, error);
    } finally {
        refs.loading.style.display = 'none';
    }
}

function displayHubProductCards(position, allCompatibleProducts, optionsContainer, allowedModels = null) {
    if (!optionsContainer) return;
    const componentKeyForState = `${position.toLowerCase()}Hub`;
    const selectedVendor = buildState._ui.activeVendor[componentKeyForState];

    if (selectedVendor === null) {
        optionsContainer.innerHTML = '';
        updateHubSpokeCompatibilityUI();
        return;
    }

    optionsContainer.innerHTML = '';

    const productsFilteredByVendor = selectedVendor === 'all' ? allCompatibleProducts : allCompatibleProducts.filter(p => p.vendor === selectedVendor);

    if (productsFilteredByVendor.length === 0) {
        optionsContainer.innerHTML = `<p>No hubs from vendor "${selectedVendor}" match your selections.</p>`;
        return;
    }

    const groupedByModel = {};
    productsFilteredByVendor.forEach(p => {
        const modelKey = p.wheelModel || 'Other';
        if (!groupedByModel[modelKey]) groupedByModel[modelKey] = [];
        groupedByModel[modelKey].push(p);
    });

    let displayedModelCount = 0;

    const selectedSpokes = buildState.components[`${position.toLowerCase()}Spokes`];
    let requiredHubTag = null;
    if (selectedSpokes) {
        const spokeProduct = allSpokeProductsCache.find(p => p.id === selectedSpokes.productId);
        const spokeInterface = spokeProduct?.spokeHubInterface;
        if (spokeInterface === 'J-Bend') requiredHubTag = 'hub_type:j_bend';
        if (spokeInterface === 'Straight Pull') requiredHubTag = 'hub_type:straight_pull';
    }

    const modelsToSort = allowedModels ? Object.keys(groupedByModel).filter(modelName => allowedModels.includes(modelName)) : Object.keys(groupedByModel);

    const modelsToDisplay = modelsToSort.sort((a, b) => {
        const modelAProducts = groupedByModel[a];
        const modelBProducts = groupedByModel[b];
        const tagsA = modelAProducts[0]?.tags || [];
        const tagsB = modelBProducts[0]?.tags || [];
        if (requiredHubTag) {
            const isACompatible = tagsA.includes(requiredHubTag);
            const isBCompatible = tagsB.includes(requiredHubTag);
            if (isACompatible && !isBCompatible) return -1;
            if (isBCompatible && !isACompatible) return 1;
        }
        return getSortableName(a).localeCompare(getSortableName(b));
    });

    const currentSpokeCount = buildState.specs[`${position.toLowerCase()}SpokeCount`];

    modelsToDisplay.forEach(modelName => {
        const productsInThisModelGroup = groupedByModel[modelName];
        
        const availableSpokeCounts = [...new Set(
            productsInThisModelGroup.flatMap(p => p.variants
                .filter(v => v.availableForSale && (v.spec_position === position || v.spec_position === "Front/Rear"))
                .map(v => v.spec_spoke_count)
            ).filter(Boolean)
        )].sort((a, b) => a - b);
        
        if (availableSpokeCounts.length === 0) return;

        displayedModelCount++;
        const card = document.createElement('div');
        card.className = 'component-product-card hub-model-card';
        card.dataset.modelName = modelName; // Add model name for later reference

        const isCompatibleNow = availableSpokeCounts.includes(String(currentSpokeCount));
        if (!isCompatibleNow) {
            card.classList.add('is-spec-incompatible');
            card.dataset.targetSpec = availableSpokeCounts[0];
            card.title = `Requires ${availableSpokeCounts.join('h or ')}h spoke count. Click to change.`;
        }

        card.innerHTML = `<div class="product-card-header"><h5>${modelName}</h5></div><div class="product-card-body"><p>Click to view options...</p><div class="component-variant-options" style="display:none;"></div></div>`;

        card.addEventListener('click', (e) => {
            if (e.target.closest('.component-variant-options button')) return;

            const vc = card.querySelector('.component-variant-options');
            if (!vc) return;
            
            const isTrigger = e.target.closest('.product-card-header') || e.target.closest('.product-card-body p');
            if (!isTrigger) return;
            
            const isVisible = vc.style.display !== 'none';
            
            optionsContainer.querySelectorAll('.component-product-card.expanded').forEach(c => {
                if (c !== card) {
                    c.classList.remove('expanded');
                    const otherVc = c.querySelector('.component-variant-options');
                    if (otherVc) otherVc.style.display = 'none';
                }
            });
            
            vc.style.display = isVisible ? 'none' : 'block';
            card.classList.toggle('expanded', !isVisible);
            
            if (!isVisible) {
                displayHubVariantButtonsByProduct(position, productsInThisModelGroup, vc);
            }
        });
        optionsContainer.appendChild(card);
    });

    if (displayedModelCount === 0) {
        optionsContainer.innerHTML = `<p>No hub models found for the selected vendor and specifications.</p>`;
    }
    updateHubSpokeCompatibilityUI();
}

function displayHubVariantButtonsByProduct(position, productsInGroup, variantContainer) {
    if (!variantContainer) return;
    variantContainer.innerHTML = 'Loading options...';

    const posLower = position.toLowerCase();
    const brakeStyle = buildState.specs.brakeStyle;
    const hubSpacing = buildState.specs[`${posLower}HubSpacing`];
    const freehubType = (posLower === 'rear') ? buildState.specs.freehubType : null;
    const spokeCount = buildState.specs[`${posLower}SpokeCount`];
    const stateKey = `${posLower}Hub`;
    const selectedComponent = buildState.components[stateKey];

    let variantsForDisplay = [];
    productsInGroup.forEach(product => {
        const matchingVariants = product.variants.filter(v => {
            const isYOC = product.vendor === 'Your Own Component';
            const positionMatch = v.spec_position === position || v.spec_position === "Front/Rear";
            const brakeMatch = isYOC ? true : (v.spec_brake_interface || []).includes(brakeStyle);
            const spacingMatch = isYOC ? true : normalizeSpacing(v.spec_hub_spacing) === normalizeSpacing(hubSpacing);
            const spokeMatch = String(v.spec_spoke_count) === String(spokeCount);
            const availabilityMatch = isYOC ? true : v.availableForSale;
            const i9Match = window.I9System?.hubVariantAllowed(v, position, product) ?? true; // I9-SYSTEM: System hubs also match the chosen freehub per variant
            return availabilityMatch && positionMatch && brakeMatch && spacingMatch && spokeMatch && i9Match;
        });
        matchingVariants.forEach(variant => {
            variantsForDisplay.push({ ...variant, productId: product.id, productTitle: product.title, productHandle: product.handle, vendor: product.vendor, pairingKey: product.pairingKey, tags: product.tags || [], optionalAddonProductGidsFromProduct: product.optionalAddonProductGidsFromProduct || [], leadTimeDays: product.leadTimeDays || 0, wheelModel: product.wheelModel || null, availableFreehubs: product.availableFreehubs || [], freehubVariantMap: product.freehubVariantMap || {}, product_weight_g: product.weight_g });
        });
    });

    if (variantsForDisplay.length === 0) {
        variantContainer.innerHTML = `<p>No specific hub options in this model match all your Step 2 selections.</p>`;
        return;
    }

    variantsForDisplay.sort((a, b) => (a.title || '').localeCompare(b.title || ''));
    variantContainer.innerHTML = '';
    
    variantsForDisplay.forEach(v_hub => {
        const btn = document.createElement('button');
        btn.className = 'component-variant-button hub-variant-button';
        btn.dataset.variantId = v_hub.id;
        btn.dataset.productId = v_hub.productId;
        btn.type = 'button';
        btn.dataset.vendor = v_hub.vendor || '';

        if (selectedComponent?.variantId === v_hub.id) {
            btn.classList.add('selected');
        }

        // --- UPDATED COMPATIBILITY CHECK AT RENDER TIME ---
        const currentSpokes = buildState.components[`${posLower}Spokes`];
        if (currentSpokes) {
            const spokeProduct = allSpokeProductsCache.find(p => p.id === currentSpokes.productId);
            const spokeInterface = spokeProduct?.spokeHubInterface; // "Hook Flange", "J-Bend", etc.
            
            const hubTags = v_hub.tags || [];
            const hubIsJbend = hubTags.includes('hub_type:j_bend');
            const hubIsStraightPull = hubTags.includes('hub_type:straight_pull');
            const hubIsHookFlange = hubTags.includes('hub_type:hook_flange');

            let isRenderIncompatible = false;

            // 1. Standard Steel Logic
            if (spokeInterface === 'J-Bend' && hubIsStraightPull) isRenderIncompatible = true;
            if (spokeInterface === 'Straight Pull' && hubIsJbend) isRenderIncompatible = true;

            // 2. PolyLightX (Hook Flange Spoke) Logic
            // If current spokes are Hook Flange, New Hub MUST be Hook Flange
            if (spokeInterface === 'Hook Flange' && !hubIsHookFlange) isRenderIncompatible = true;

            // 3. Hook Flange Hub Logic
            // If New Hub is Hook Flange, Current Spokes cannot be J-Bend or SP
            if (hubIsHookFlange && (spokeInterface === 'J-Bend' || spokeInterface === 'Straight Pull')) isRenderIncompatible = true;

            if (isRenderIncompatible) {
                btn.classList.add('conditionally-incompatible');
                btn.dataset.isConditionallyDisabled = 'true';
                btn.setAttribute('title', `Incompatible with selected ${spokeInterface || 'current'} spokes.`);
            }
        }
        // --- END UPDATED CHECK ---

        const weight = v_hub.weight_g ?? v_hub.product_weight_g ?? null;
        let displayTitle = (v_hub.vendor === 'Your Own Component')
            ? `${v_hub.productTitle} (${v_hub.title})`
            : `${v_hub.productTitle || ''} (${v_hub.title || ''})`;
    
        btn.innerHTML = `
            <div class="variant-button-image-container">
                ${v_hub.image?.url ? `<img src="${v_hub.image.url}" alt="${displayTitle}" loading="lazy" class="variant-button-image">` : '<div class="variant-button-image-placeholder"></div>'}
            </div>
            <div class="variant-button-details">
                <span class="variant-details">${displayTitle}</span>
                ${v_hub.price?.amount ? `<span class="variant-price">${formatPrice(v_hub.price.amount)}</span>` : ''}
            </div>
            <div class="variant-button-stats">
                ${weight ? `<span class="stat-item">Weight: <strong>${weight}g</strong></span>` : ''}
            </div>`;

        btn.addEventListener('click', async () => {
            if (btn.dataset.isConditionallyDisabled === 'true') {
                const hubTags = v_hub.tags || [];
                let requiredSpokeType = 'Compatible';
                
                // Determine the "type" for the error message
                if (hubTags.includes('hub_type:hook_flange')) requiredSpokeType = 'Berd (Hook Flange or Standard)';
                else if (hubTags.includes('hub_type:j_bend')) requiredSpokeType = 'J-Bend';
                else if (hubTags.includes('hub_type:straight_pull')) requiredSpokeType = 'Straight Pull';

                const confirmed = confirm(`Selecting this hub requires ${requiredSpokeType} spokes and will clear your current spoke selection for this wheel. Continue?`);
                
                if (confirmed) {
                    clearComponentAndItsAddons(position, 'Spokes');
                    
                    // Wheelset Logic: Check if opposite wheel also needs clearing
                    if (buildState.buildType === 'Wheel Set') {
                        const oppositePosition = position === 'Front' ? 'Rear' : 'Front';
                        const oppositeSpokes = buildState.components[`${oppositePosition.toLowerCase()}Spokes`];
                        if (oppositeSpokes) {
                            const oppositeSpokeProduct = allSpokeProductsCache.find(p => p.id === oppositeSpokes.productId);
                            const oppInterface = oppositeSpokeProduct?.spokeHubInterface;
                            
                            let oppIncompatible = false;
                            // Check Hook Flange logic on opposite side
                            if (hubTags.includes('hub_type:hook_flange') && (oppInterface === 'J-Bend' || oppInterface === 'Straight Pull')) oppIncompatible = true;
                            else if (!hubTags.includes('hub_type:hook_flange') && oppInterface === 'Hook Flange') oppIncompatible = true;
                            // Check J-Bend/SP logic on opposite side
                            else if (hubTags.includes('hub_type:j_bend') && oppInterface === 'Straight Pull') oppIncompatible = true;
                            else if (hubTags.includes('hub_type:straight_pull') && oppInterface === 'J-Bend') oppIncompatible = true;

                            if (oppIncompatible) {
                                console.log(`Also clearing incompatible ${oppositePosition} spokes.`);
                                clearComponentAndItsAddons(oppositePosition, 'Spokes');
                            }
                        }
                    }
                } else {
                    return;
                }
            }
            
            const previouslySelectedComponent = buildState.components[stateKey];
            const newSelectedVariantId = v_hub.id;
            if (previouslySelectedComponent && previouslySelectedComponent.productId !== v_hub.productId) {
                const addonKeysToRemove = Object.keys(buildState.selectedOptionalAddons).filter(key => key.startsWith(`${position}_Hub_${previouslySelectedComponent.variantId}`));
                addonKeysToRemove.forEach(key => { delete buildState.selectedOptionalAddons[key]; });
                if (addonKeysToRemove.length > 0) saveLastActiveBuild();
            } else if (previouslySelectedComponent && previouslySelectedComponent.variantId !== newSelectedVariantId) {
                manageStickyAddonsForChangedBaseVariant(position, 'Hub', previouslySelectedComponent.variantId, newSelectedVariantId, v_hub.optionalAddonProductGidsFromProduct || []);
            }
            if (position === 'Rear' && componentFetchPromises.freehubs) await componentFetchPromises.freehubs;
            const selectedHubComponent = {
                variantId: v_hub.id, productId: v_hub.productId, productHandle: v_hub.productHandle,
                title: v_hub.productTitle, variantTitle: v_hub.title, sku: v_hub.sku,
                price: v_hub.price.amount, vendor: v_hub.vendor, image: v_hub.image,
                pairingKey: v_hub.pairingKey, tags: v_hub.tags, spec_spoke_count: String(v_hub.spec_spoke_count),
                spec_brake_interface: v_hub.spec_brake_interface, spec_hub_spacing: v_hub.spec_hub_spacing,
                spec_freehub: (posLower === 'rear') ? freehubType : null, selectedOptions: v_hub.selectedOptions,
                optionalAddonProductGids: v_hub.optionalAddonProductGidsFromProduct, leadTimeDays: v_hub.leadTimeDays, wheelModel: v_hub.wheelModel,
                quantityAvailable: v_hub.quantityAvailable,
                leadTimeDays: v_hub.leadTimeDays,
                weight_g: v_hub.weight_g ?? v_hub.product_weight_g ?? null
            };
            buildState.components[stateKey] = selectedHubComponent;
            if (position === 'Rear') setComponentFreehubForHub(v_hub);
            buildState._ui.hasChanges = true;
            updateStep3ButtonText();
            calculateWheelCosts(position);
            updateComponentUI(position, 'Hub', selectedHubComponent);
            loadAndFilterSpokesForPosition(position, false);
            updateHubSpokeCompatibilityUI();
            updateSubtotal();
            updateBuildSummary();
            validateStep3();
            saveLastActiveBuild();
            if (buildState._ui.isChangingComponent?.position === position) cancelComponentChange();
            handleComponentChangeForLeadTime();
            await handleAutoPairing('Hub', position, selectedHubComponent, false);
            scrollToComponentSection(position, 'Hub');
        });
        
        variantContainer.appendChild(btn);
    });
}
  
function setComponentFreehubForHub(selectedHubData) {
    // I9-SYSTEM: System hubs carry custom.freehub_variant_map per variant; swap in that map (product map as fallback)
    if (selectedHubData && window.I9System?.isSystem()) selectedHubData = window.I9System.withFreehubMap(selectedHubData);
    // This function only applies to rear hubs that have a freehub type selected in Step 2.
    if (!selectedHubData || buildState.specs.freehubType === null) {
        buildState.components.rearComponentFreehub = null;
        return;
    }

    let freehubGid = selectedHubData.freehubVariantMap[buildState.specs.freehubType];
    
    // If exact match fails, use our translation dictionary to find the correct JSON key
    if (!freehubGid && selectedHubData.freehubVariantMap) {
        const validStrings = FREEHUB_EQUIVALENCE[buildState.specs.freehubType] || [];
        const mapKeys = Object.keys(selectedHubData.freehubVariantMap);
        const matchedKey = mapKeys.find(k => validStrings.includes(k));
        if (matchedKey) {
            freehubGid = selectedHubData.freehubVariantMap[matchedKey];
        }
    }

    if (freehubGid) {
        for (const freehubProduct of allFreehubComponentProductsCache) {
            const foundVariant = freehubProduct.variants.find(v => v.id === freehubGid);
            if (foundVariant) {
                buildState.components.rearComponentFreehub = {
                    variantId: foundVariant.id,
                    productId: freehubProduct.id,
                    title: freehubProduct.title,
                    variantTitle: foundVariant.title,
                    price: foundVariant.price.amount,
                    name: `${freehubProduct.title} - ${foundVariant.title}`,
                    weight_g: foundVariant.weight_g || freehubProduct.weight_g || null
                };
                return; // Exit after finding the match
            }
        }
    }
    
    console.error(`[V3 Set Freehub] FAILURE: Could not find Component Freehub Variant for GID: ${freehubGid}.`);
    buildState.components.rearComponentFreehub = null;
}

    async function fetchSpokeProducts() { console.log("Fetching spoke products using tag: component:spoke"); const spokeTag = "component:spoke"; try { const i9Gen = i9FetchGeneration; const fetchedSpokes = await fetchBuilderComponentProducts(spokeTag); if (i9Gen !== i9FetchGeneration) return allSpokeProductsCache; /* I9-SYSTEM: caches were reset for another context meanwhile */ allSpokeProductsCache = fetchedSpokes; updateGlobalVendorLogoMap(allSpokeProductsCache); console.log(`fetchSpokeProducts: Found and cached ${allSpokeProductsCache.length} products.`); } catch (error) { console.error("fetchSpokeProducts Error:", error); allSpokeProductsCache = []; throw error; } return allSpokeProductsCache; }
    async function loadAndFilterSpokes() { console.log("--- loadAndFilterSpokes (Combined F/R) ---"); const buildType = buildState.buildType; const positionsToLoad = []; if (buildType === 'Front' || buildType === 'Wheel Set') positionsToLoad.push('Front'); if (buildType === 'Rear' || buildType === 'Wheel Set') positionsToLoad.push('Rear'); if (positionsToLoad.length === 0) return; positionsToLoad.forEach(p => { const l = document.getElementById(`${p.toLowerCase()}-spokes-loading`); if (l) l.style.display = 'block'; const o = document.getElementById(`${p.toLowerCase()}-spokes-options-container`); if (o) o.innerHTML = '<p>Loading spoke options...</p>'; const e = document.getElementById(`${p.toLowerCase()}-spokes-error`); if (e) e.style.display = 'none'; }); 
         
                                           // --- START: MODIFIED CACHE/PROMISE HANDLING FOR SPOKES ---
 if (allSpokeProductsCache.length === 0) {
     // console.log("Spoke cache empty in loadAndFilterSpokes.");
     if (componentFetchPromises.spokes) {
         // console.log("Waiting for early spoke fetch promise to complete...");
         try {
             await componentFetchPromises.spokes;
             // console.log("Early spoke fetch completed.");
         } catch (error) {
             console.error("Error awaiting early spoke fetch in loadAndFilterSpokes:", error);
         }
     } else {
         // console.log("No early spoke fetch promise. Fetching Spokes directly now...");
         try {
             await fetchSpokeProducts();
         } catch (error) {
             console.error("Error fetching spoke products directly in loadAndFilterSpokes:", error);
         }
     }
 } else {
     // console.log("Using already populated/cached spoke data for loadAndFilterSpokes.");
 }

 if (allSpokeProductsCache.length === 0) {
     console.error("Spoke cache is STILL empty. Spoke data loading failed.");
     positionsToLoad.forEach(p => {
         const loader = document.getElementById(`${p.toLowerCase()}-spokes-loading`);
         if(loader) loader.style.display = 'none';
         const errorEl = document.getElementById(`${p.toLowerCase()}-spokes-error`);
         if(errorEl) errorEl.textContent = `Error: Spoke data failed to load.`;
         const optionsEl = document.getElementById(`${p.toLowerCase()}-spokes-options-container`);
         if(optionsEl) optionsEl.innerHTML = '<p>Spoke data failed to load.</p>';
     });
     return;
 }
 // --- END: MODIFIED CACHE/PROMISE HANDLING FOR SPOKES ---

        for (const position of positionsToLoad) { await loadAndFilterSpokesForPosition(position); } positionsToLoad.forEach(p => { const l = document.getElementById(`${p.toLowerCase()}-spokes-loading`); if (l) l.style.display = 'none'; }); console.log("--- loadAndFilterSpokes (Combined F/R) finished ---"); }

async function loadAndFilterSpokesForPosition(position, isChange = false) {
    console.log(`--- loadAndFilterSpokesForPosition: ${position} ${isChange ? '(Change Mode)' : ''} ---`);
    const posLower = position.toLowerCase();
    const refs = {
        filters: document.getElementById(`${posLower}-spokes-filters`),
        loading: document.getElementById(`${posLower}-spokes-loading`),
        error: document.getElementById(`${posLower}-spokes-error`),
        optionsContainer: document.getElementById(`${posLower}-spokes-options-container`),
        selectionSpan: document.querySelector(`#${posLower}-spokes-selection span`),
        imageContainer: document.getElementById(`${posLower}-spokes-image-container`),
        actionButtonsContainer: document.getElementById(`${posLower}-spokes-action-buttons`)
    };
    if (!refs.optionsContainer || !refs.filters || !refs.error || !refs.imageContainer || !refs.selectionSpan || !refs.actionButtonsContainer) {
        console.error(`Spoke DOM elements missing for ${position}! Check IDs:`, refs);
        if (refs.loading) refs.loading.style.display = 'none';
        return;
    }
    refs.error.style.display = 'none';
    refs.error.textContent = '';
    const subsectionElement = document.getElementById(`${posLower}-spokes-subsection`);
    const stateKey = `${posLower}Spokes`;
    const isSelected = buildState.components[stateKey];

    // I9-SYSTEM: System builds show one product (Industry Nine SYSTEM Spokes) as a color dropdown with a wheel preview; the module owns this UI
    if (window.I9System?.isSystem()) { await window.I9System.renderSpokes(position, isChange, refs); return; }

    // --- Handle Virtual (Integrated) Components ---
    if (isSelected && isSelected.isVirtual) {
        updateComponentUI(position, 'Spokes', isSelected);
        if (refs.loading) refs.loading.style.display = 'none';
        
        const container = document.getElementById(`${posLower}-spokes-subsection`);
        if (container) {
            container.classList.add('is-locked-integrated');
            container.style.pointerEvents = 'none';
            container.style.opacity = '0.6';
        }
        return;
    }

    if (isSelected && !isChange) {
        updateComponentUI(position, 'Spokes', isSelected);
        return;
    }
    
    if (!isSelected) {
        buildState._ui.activeVendor[stateKey] = null;
    }

    refs.imageContainer.innerHTML = '';
    refs.imageContainer.style.display = 'none';
    refs.optionsContainer.style.display = 'flex';
    refs.optionsContainer.innerHTML = '';
    if (isChange && refs.actionButtonsContainer) refs.actionButtonsContainer.style.display = 'flex';
    else if (refs.actionButtonsContainer) refs.actionButtonsContainer.innerHTML = '';
    if (subsectionElement && !isChange) {
        subsectionElement.classList.remove('selection-made');
    }

    // This section is reverted. We NO LONGER check for a hub.
    // We simply ensure the spoke cache is loaded.
    if (allSpokeProductsCache.length === 0) {
        try {
            await fetchSpokeProducts();
            if (allSpokeProductsCache.length === 0) throw new Error("Spoke data is empty after fetch.");
        } catch (error) {
            refs.optionsContainer.innerHTML = '<p>Error loading Spoke data.</p>';
            if (refs.error) { refs.error.textContent = `Error: ${error.message}`; refs.error.style.display = 'block'; }
            return;
        }
    }
    
    // This is the key change: We show ALL spokes and let the compatibility UI handle graying out.
    const productsToDisplay = allSpokeProductsCache;

    if (productsToDisplay.length === 0) {
        refs.optionsContainer.innerHTML = '<p>No spoke products found.</p>';
    }
    
    displayComponentVendorFilters(stateKey, productsToDisplay, refs.filters, position);
    if (isChange) {
        showCancelChangeButtonIfNeeded(position, 'Spokes', refs.actionButtonsContainer);
    }
    displaySpokeProductCards(position, productsToDisplay, refs.optionsContainer);
    
    console.log(`--- loadAndFilterSpokesForPosition: ${position} finished ---`);
}
    
function displaySpokeProductCards(position, allCompatibleSpokes, optionsContainer) {
    if (!optionsContainer) return;
    const componentKeyForState = `${position.toLowerCase()}Spokes`;
    const selectedVendor = buildState._ui.activeVendor[componentKeyForState];

    if (selectedVendor === null) {
        optionsContainer.innerHTML = '';
        updateHubSpokeCompatibilityUI();
        return;
    }

    optionsContainer.innerHTML = '';
    
    const filteredProducts = selectedVendor === 'all' ? allCompatibleSpokes : allCompatibleSpokes.filter(p => p.vendor === selectedVendor);
    if (filteredProducts.length === 0) {
        optionsContainer.innerHTML = `<p>No ${position.toLowerCase()} spokes found${selectedVendor !== 'all' ? ` for vendor: ${selectedVendor}` : ''}.</p>`;
        updateHubSpokeCompatibilityUI();
        return;
    }

    const groupedByModel = {};
    filteredProducts.forEach(p => {
        const model = p.wheelModel || 'Other';
        if (!groupedByModel[model]) groupedByModel[model] = [];
        groupedByModel[model].push(p);
    });
    
    // --- NEW SORTING LOGIC ---
    const selectedHub = buildState.components[`${position.toLowerCase()}Hub`];
    const hubTags = selectedHub?.tags || [];
    let requiredInterface = null;
    if (hubTags.includes('hub_type:j_bend')) requiredInterface = 'J-Bend';
    if (hubTags.includes('hub_type:straight_pull')) requiredInterface = 'Straight Pull';

    const sortedModelNames = Object.keys(groupedByModel).sort((a, b) => {
        const modelAProducts = groupedByModel[a];
        const modelBProducts = groupedByModel[b];
        const interfaceA = modelAProducts[0]?.spokeHubInterface;
        const interfaceB = modelBProducts[0]?.spokeHubInterface;
        const vendorA = modelAProducts[0]?.vendor;
        const vendorB = modelBProducts[0]?.vendor;

        // Prioritize Berd spokes to always be at the top
        if (vendorA === 'Berd' && vendorB !== 'Berd') return -1;
        if (vendorB === 'Berd' && vendorA !== 'Berd') return 1;

        // If a required interface is set, compatible models come first
        if (requiredInterface) {
            const isACompatible = (interfaceA === requiredInterface);
            const isBCompatible = (interfaceB === requiredInterface);
            if (isACompatible && !isBCompatible) return -1;
            if (isBCompatible && !isACompatible) return 1;
        }

        // Fallback to alphabetical sorting
        return getSortableName(a).localeCompare(getSortableName(b));
    });
    // --- END NEW SORTING LOGIC ---

    let displayedModelCount = 0;
    sortedModelNames.forEach(model => { // Use the new sorted array
        const productsInGroup = groupedByModel[model];
        if (!productsInGroup.some(p => p.variants.some(v => v.availableForSale))) {
            return;
        }
        displayedModelCount++;
        const card = document.createElement('div');
        card.className = 'component-product-card spoke-model-card';

        const firstProductInGroup = productsInGroup[0];
        if (firstProductInGroup) {
            card.dataset.vendor = firstProductInGroup.vendor || '';
            card.dataset.spokeHubInterface = firstProductInGroup.spokeHubInterface || '';
        }
        card.dataset.position = position;

        card.innerHTML = `<div class="product-card-header"><h5>${model}</h5></div><div class="product-card-body"><p>Click to view options...</p><div class="component-variant-options" style="display:none;"></div></div>`;

        card.addEventListener('click', (e) => {
            if (e.target.closest('.component-variant-options button')) return;
            const vc = card.querySelector('.component-variant-options');
            if (!vc) return;
            const isTrigger = e.target.closest('.product-card-header') || e.target.closest('.product-card-body p');
            if (!isTrigger) return;
            const isVisible = vc.style.display !== 'none';
            optionsContainer.querySelectorAll('.component-product-card.expanded').forEach(c => {
                if (c !== card) {
                    c.classList.remove('expanded');
                    const otherVc = c.querySelector('.component-variant-options');
                    if (otherVc) otherVc.style.display = 'none';
                }
            });
            vc.style.display = isVisible ? 'none' : 'block';
            card.classList.toggle('expanded', !isVisible);
            if (!isVisible) {
                displaySpokeVariantButtonsByProduct(position, productsInGroup, vc);
            }
        });
        optionsContainer.appendChild(card);
    });

    if (displayedModelCount === 0) {
        optionsContainer.innerHTML = `<p>No ${position.toLowerCase()} spoke models found${selectedVendor !== 'all' ? ` for vendor ${selectedVendor}` : ''} with available options.</p>`;
    }
    updateHubSpokeCompatibilityUI();
}

function displaySpokeVariantButtonsByProduct(position, productsInGroup, variantContainer) {
    if (!variantContainer) return;
    variantContainer.innerHTML = ''; // Clear any previous content

    const posLower = position.toLowerCase();
    const stateKey = `${posLower}Spokes`;
    const selectedComponent = buildState.components[stateKey];

    // 1. Find all "Builder Selection" variants from the product group.
    // This is the core of our new logic.
    const pricedBuilderVariants = [];
    productsInGroup.forEach(product => {
        product.variants.forEach(variant => {
            // Find the special variant where the Length option value is '-'
            const isBuilderVariant = variant.selectedOptions.some(opt => opt.name === 'Length' && opt.value === '-');
            
            if (isBuilderVariant && variant.availableForSale) {
                // Attach the parent product's info to the variant for easy access later
                pricedBuilderVariants.push({
                    ...variant, // Spread all variant properties
                    // Explicitly add parent product properties
                    productId: product.id,
                    productTitle: product.title,
                    productHandle: product.handle,
                    vendor: product.vendor,
                    pairingKey: product.pairingKey,
                    wheelModel: product.wheelModel,
                    leadTimeDays: product.leadTimeDays || 0,
                    optionalAddonProductGidsFromProduct: product.optionalAddonProductGidsFromProduct || [],
                    product_weight_g: product.weight_g
                });
            }
        });
    });

    if (pricedBuilderVariants.length === 0) {
        variantContainer.innerHTML = `<p>No purchaseable options found for this model. Please check product setup.</p>`;
        return;
    }

    // Sort the priced variants by their own title (which is usually the color)
    pricedBuilderVariants.sort((a, b) => (a.title || '').localeCompare(b.title || ''));

    // 2. Create a button for each "Builder Selection" variant
    pricedBuilderVariants.forEach(v_spoke => {
        const btn = document.createElement('button');
        btn.className = 'component-variant-button spoke-variant-button';
        btn.dataset.variantId = v_spoke.id;
        btn.dataset.productId = v_spoke.productId;
        btn.type = 'button';
        btn.dataset.vendor = v_spoke.vendor || '';
        btn.dataset.position = position;
        const spokeProduct = allSpokeProductsCache.find(p => p.id === v_spoke.productId);
        const thisSpokeInterface = spokeProduct?.spokeHubInterface || ''; // Store for logic
        btn.dataset.spokeHubInterface = thisSpokeInterface;

        if (selectedComponent?.variantId === v_spoke.id) {
            btn.classList.add('selected');
        }

        // --- UPDATED COMPATIBILITY CHECK AT RENDER TIME ---
        const currentHub = buildState.components[`${posLower}Hub`];
        if (currentHub) {
            const hubTags = currentHub.tags || [];
            let isRenderIncompatible = false;

            // 1. Standard Steel Logic
            if (hubTags.includes('hub_type:j_bend') && thisSpokeInterface === 'Straight Pull') isRenderIncompatible = true;
            if (hubTags.includes('hub_type:straight_pull') && thisSpokeInterface === 'J-Bend') isRenderIncompatible = true;

            // 2. Hook Flange Hub Logic
            // If Hub is Hook Flange, Spoke CANNOT be J-Bend or Straight Pull
            if (hubTags.includes('hub_type:hook_flange')) {
                if (thisSpokeInterface === 'J-Bend' || thisSpokeInterface === 'Straight Pull') isRenderIncompatible = true;
            }

            // 3. PolyLightX (Hook Flange Spoke) Logic
            // If Spoke is Hook Flange, Hub MUST be Hook Flange
            if (thisSpokeInterface === 'Hook Flange' && !hubTags.includes('hub_type:hook_flange')) isRenderIncompatible = true;

            if (isRenderIncompatible) {
                btn.classList.add('conditionally-incompatible');
                btn.dataset.isConditionallyDisabled = 'true';
                btn.setAttribute('title', `Incompatible with selected Hub.`);
            }
        }
        // --- END UPDATED CHECK ---

        const weight = v_spoke.weight_g ?? v_spoke.product_weight_g ?? null;
        const colorOption = v_spoke.selectedOptions.find(opt => opt.name === 'Color');
        const displayTitleText = `${v_spoke.productTitle} (${colorOption ? colorOption.value : v_spoke.title})`;
        const priceAmount = v_spoke.price?.amount;

        btn.innerHTML = `
            <div class="variant-button-image-container">
                ${v_spoke.image?.url ? `<img src="${v_spoke.image.url}" alt="${displayTitleText}" loading="lazy" class="variant-button-image">` : '<div class="variant-button-image-placeholder"></div>'}
            </div>
            <div class="variant-button-details">
                <span class="variant-details">${displayTitleText}</span>
                ${priceAmount ? `<span class="variant-price">${formatPrice(priceAmount)}</span>` : ''}
            </div>
            <div class="variant-button-stats">
                ${weight ? `<span class="stat-item">Weight: <strong>${weight}g</strong></span>` : ''}
            </div>`;

        // 3. Attach the full, preserved event listener logic.
        btn.addEventListener('click', async () => {
            // --- UPDATED BI-DIRECTIONAL ALERT FOR HOOK FLANGE ---
            if (btn.dataset.isConditionallyDisabled === 'true') {
                const hub = buildState.components[`${posLower}Hub`];
                let hubType = "selected";
                if (hub) {
                   if (hub.tags.includes('hub_type:j_bend')) hubType = 'J-Bend';
                   else if (hub.tags.includes('hub_type:straight_pull')) hubType = 'Straight Pull';
                   else if (hub.tags.includes('hub_type:hook_flange')) hubType = 'Hook Flange';
                }

                const selectedSpokeInterface = btn.dataset.spokeHubInterface; // "Hook Flange", "J-Bend", etc.
                let errorMsg = `These spokes are not compatible with the selected ${hubType} hub.`;
                
                if (selectedSpokeInterface === 'Hook Flange' && hubType !== 'Hook Flange') {
                    errorMsg = `PolyLightX (Hook Flange) spokes can ONLY be used with Hook Flange hubs.`;
                }

                const confirmed = confirm(`${errorMsg} Clicking OK will clear your hub selection for this wheel. Continue?`);
                
                if (confirmed) {
                    // Clear the hub for the current position first.
                    clearComponentAndItsAddons(position, 'Hub');

                    // If it's a wheelset, check and clear the opposite hub if it's also incompatible.
                    if (buildState.buildType === 'Wheel Set') {
                        const oppositePosition = position === 'Front' ? 'Rear' : 'Front';
                        const oppositeHub = buildState.components[`${oppositePosition.toLowerCase()}Hub`];

                        // Check if the opposite hub is incompatible with the spokes being selected.
                        if (oppositeHub) {
                            const oppositeHubTags = oppositeHub.tags || [];
                            let isOppositeIncompatible = false;

                            // Rule: Hook Flange spokes require Hook Flange hubs
                            if (selectedSpokeInterface === 'Hook Flange' && !oppositeHubTags.includes('hub_type:hook_flange')) {
                                isOppositeIncompatible = true;
                            }
                            // Rule: J-Bend/SP logic
                            else if (selectedSpokeInterface === 'J-Bend' && oppositeHubTags.includes('hub_type:straight_pull')) isOppositeIncompatible = true;
                            else if (selectedSpokeInterface === 'Straight Pull' && oppositeHubTags.includes('hub_type:j_bend')) isOppositeIncompatible = true;

                            if (isOppositeIncompatible) {
                                 console.log(`Also clearing incompatible ${oppositePosition} hub.`);
                                 clearComponentAndItsAddons(oppositePosition, 'Hub');
                            }
                        }
                    }
                } else {
                    return; // Abort if user cancels
                }
            }
            // This is the combined logic from your original function.
            const previouslySelectedSpokeComponent = buildState.components[stateKey];
            const newSelectedSpokeVariantId = v_spoke.id;

            // Handle "sticky" addons if the user is changing their selection.
            if (previouslySelectedSpokeComponent && previouslySelectedSpokeComponent.variantId !== newSelectedSpokeVariantId) {
                if (previouslySelectedSpokeComponent.productId === v_spoke.productId) {
                    manageStickyAddonsForChangedBaseVariant(
                        position, 'Spokes', previouslySelectedSpokeComponent.variantId,
                        newSelectedSpokeVariantId, v_spoke.optionalAddonProductGidsFromProduct
                    );
                } else {
                    // If the product itself is changing, clear the old addons.
                    const addonKeysToRemove = Object.keys(buildState.selectedOptionalAddons).filter(key => 
                        key.startsWith(`${position}_Spokes_${previouslySelectedSpokeComponent.variantId}`)
                    );
                    addonKeysToRemove.forEach(key => delete buildState.selectedOptionalAddons[key]);
                }
            }

            // Create the component object to save in the build state.
            const selectedSpokeComponent = {
                variantId: v_spoke.id,
                productId: v_spoke.productId,
                productHandle: v_spoke.productHandle,
                title: v_spoke.productTitle,
                variantTitle: v_spoke.title, // Will be "Black / -"
                sku: v_spoke.sku,
                price: v_spoke.price.amount,
                vendor: v_spoke.vendor,
                image: v_spoke.image,
                pairingKey: v_spoke.pairingKey,
                selectedOptions: v_spoke.selectedOptions,
                optionalAddonProductGids: v_spoke.optionalAddonProductGidsFromProduct,
                quantityAvailable: v_spoke.quantityAvailable,
                leadTimeDays: v_spoke.leadTimeDays,
                wheelModel: v_spoke.wheelModel,
                // Add the clean color for easy access by other functions.
                selectedColor: colorOption ? colorOption.value : null,
                weight_g: v_spoke.weight_g ?? v_spoke.product_weight_g ?? null
            };

            buildState.components[stateKey] = selectedSpokeComponent;
            window.StandardStudio?.onListPick(position); // STANDARD-STUDIO: a color picked in the list means "all spokes this color" (clears this wheel's custom painting)

            // Trigger all the necessary downstream updates.
            buildState._ui.hasChanges = true;
            updateStep3ButtonText();
            calculateWheelCosts(position);
            updateComponentUI(position, 'Spokes', selectedSpokeComponent);
            updateHubSpokeCompatibilityUI();
            
            // Trigger auto-pairing for the opposite wheel.
            await handleAutoPairing('Spokes', position, selectedSpokeComponent, false);

            updateSubtotal();
            updateBuildSummary();
            validateStep3();
            saveLastActiveBuild();

            if (buildState._ui.isChangingComponent?.position === position) {
                cancelComponentChange();
            }
            handleComponentChangeForLeadTime();
            scrollToComponentSection(position, 'Spokes');
        });

        variantContainer.appendChild(btn);
    });
    
    // Final UI check after rendering all buttons.
    updateHubSpokeCompatibilityUI();
}
  
    async function fetchNippleProducts() {
    console.log("Fetching nipple products using tag: component:nipple");
    const nippleTag = "component:nipple";
    try {
        allNippleProductsCache = await fetchBuilderComponentProducts(nippleTag);
        updateGlobalVendorLogoMap(allNippleProductsCache);
        console.log(`fetchNippleProducts: Found and cached ${allNippleProductsCache.length} products.`);
    } catch (error) {
        console.error("fetchNippleProducts Error:", error);
        allNippleProductsCache = [];
        throw error;
    }
    return allNippleProductsCache;
}
    async function loadAndFilterNipples() {
    console.log("--- loadAndFilterNipples (Combined F/R) ---");
    if (window.I9System?.isSystem()) { window.I9System.clearNipples(); return; } // I9-SYSTEM: System spokes thread straight into the hub, no nipples
    const buildType = buildState.buildType;
    const positionsToLoad = [];
    if (buildType === 'Front' || buildType === 'Wheel Set') positionsToLoad.push('Front');
    if (buildType === 'Rear' || buildType === 'Wheel Set') positionsToLoad.push('Rear');
    if (positionsToLoad.length === 0) return;

    positionsToLoad.forEach(p => {
        const l = document.getElementById(`${p.toLowerCase()}-nipples-loading`);
        if (l) l.style.display = 'block';
        const o = document.getElementById(`${p.toLowerCase()}-nipples-options-container`);
        if (o) o.innerHTML = '<p>Loading nipple options...</p>';
        const e = document.getElementById(`${p.toLowerCase()}-nipples-error`);
        if (e) e.style.display = 'none';
    });

    // --- START: MODIFIED CACHE/PROMISE HANDLING FOR NIPPLES ---
 if (allNippleProductsCache.length === 0) {
     console.log("Nipple cache empty in loadAndFilterNipples.");
     if (componentFetchPromises.nipples) {
         console.log("Waiting for early nipple fetch promise to complete...");
         try {
             await componentFetchPromises.nipples;
             console.log("Early nipple fetch completed.");
         } catch (error) {
             console.error("Error awaiting early nipple fetch in loadAndFilterNipples:", error);
         }
     } else {
         console.log("No early nipple fetch promise. Fetching Nipples directly now...");
         try {
             await fetchNippleProducts();
         } catch (error) {
             console.error("Error fetching nipple products directly in loadAndFilterNipples:", error);
         }
     }
 } else {
     console.log("Using already populated/cached nipple data for loadAndFilterNipples.");
 }

 if (allNippleProductsCache.length === 0) {
     console.error("Nipple cache is STILL empty. Nipple data loading failed.");
     positionsToLoad.forEach(p => {
         const loader = document.getElementById(`${p.toLowerCase()}-nipples-loading`);
         if(loader) loader.style.display = 'none';
         const errorEl = document.getElementById(`${p.toLowerCase()}-nipples-error`);
         if(errorEl) errorEl.textContent = `Error: Nipple data failed to load.`;
         const optionsEl = document.getElementById(`${p.toLowerCase()}-nipples-options-container`);
         if(optionsEl) optionsEl.innerHTML = '<p>Nipple data failed to load.</p>';
     });
     return;
 }
 // --- END: MODIFIED CACHE/PROMISE HANDLING FOR NIPPLES ---

    for (const position of positionsToLoad) {
        await loadAndFilterNipplesForPosition(position);
    }

    positionsToLoad.forEach(p => {
        const l = document.getElementById(`${p.toLowerCase()}-nipples-loading`);
        if (l) l.style.display = 'none';
    });
    console.log("--- loadAndFilterNipples (Combined F/R) finished ---");
}
    async function loadAndFilterNipplesForPosition(position, isChange = false) {
    console.log(`--- loadAndFilterNipplesForPosition: ${position} ${isChange ? '(Change Mode)' : ''} ---`);
    if (window.I9System?.isSystem()) return; // I9-SYSTEM
    const posLower = position.toLowerCase();
    const refs = {
        filters: document.getElementById(`${posLower}-nipples-filters`),
        loading: document.getElementById(`${posLower}-nipples-loading`),
        error: document.getElementById(`${posLower}-nipples-error`),
        optionsContainer: document.getElementById(`${posLower}-nipples-options-container`),
        selectionSpan: document.querySelector(`#${posLower}-nipples-selection span`),
        imageContainer: document.getElementById(`${posLower}-nipples-image-container`),
        actionButtonsContainer: document.getElementById(`${posLower}-nipples-action-buttons`)
    };

    if (!refs.optionsContainer || !refs.filters || !refs.error || !refs.imageContainer || !refs.selectionSpan || !refs.actionButtonsContainer) {
        console.error(`Nipple DOM elements missing for ${position}! Check IDs:`, refs);
        if(refs.loading) refs.loading.style.display = 'none';
        return;
    }

    refs.error.style.display = 'none';
    refs.error.textContent = '';

    const subsectionElement = document.getElementById(`${posLower}-nipples-subsection`);
    const stateKey = `${posLower}Nipples`;
    const isSelected = buildState.components[stateKey];

    // --- Handle Virtual (Integrated) Components ---
    if (isSelected && isSelected.isVirtual) {
        updateComponentUI(position, 'Nipples', isSelected);
        if (refs.loading) refs.loading.style.display = 'none';
        
        const container = document.getElementById(`${posLower}-nipples-subsection`);
        if (container) {
            container.classList.add('is-locked-integrated');
            container.style.pointerEvents = 'none';
            container.style.opacity = '0.6';
        }
        return;
    }

    if (isSelected && !isChange) {
        updateComponentUI(position, 'Nipples', isSelected);
        return;
    }

    refs.imageContainer.innerHTML = '';
    refs.imageContainer.style.display = 'none';
    refs.optionsContainer.style.display = 'flex';
    refs.optionsContainer.innerHTML = '';
    if (isChange && refs.actionButtonsContainer) refs.actionButtonsContainer.style.display = 'flex';
    else if (refs.actionButtonsContainer) refs.actionButtonsContainer.innerHTML = '';

    if (subsectionElement && !isChange) {
        subsectionElement.classList.remove('selection-made');
    }

    if (allNippleProductsCache.length === 0) {
        console.warn(`Nipple cache empty in loadAndFilterNipplesForPosition for ${position}. Parent should have fetched.`);
        refs.optionsContainer.innerHTML = '<p>Nipple data not available. Please try reloading or check console.</p>';
        return;
    }

    const compatibleProducts = allNippleProductsCache;

    if (compatibleProducts.length === 0) {
        refs.optionsContainer.innerHTML = '<p>No nipple products found.</p>';
        if (refs.selectionSpan) refs.selectionSpan.innerHTML = `Selected ${position} Nipples: None`;
        if (subsectionElement) subsectionElement.classList.remove('selection-made');
    } else {
        if (!isChange) {
            displayComponentVendorFilters(stateKey, compatibleProducts, refs.filters, position);
        } else {
            showCancelChangeButtonIfNeeded(position, 'Nipples', refs.actionButtonsContainer);
        }
        displayNippleProductCards(position, compatibleProducts, refs.optionsContainer);
    }
    console.log(`--- loadAndFilterNipplesForPosition: ${position} finished ---`);
}
   
function displayNippleProductCards(position, allCompatibleNipples, optionsContainer) {
    if (!optionsContainer) return;
    const componentKeyForState = `${position.toLowerCase()}Nipples`;
    const selectedVendor = buildState._ui.activeVendor[componentKeyForState];

    // If no vendor is selected, show nothing.
    if (selectedVendor === null) {
        optionsContainer.innerHTML = '';
        return;
    }

    optionsContainer.innerHTML = ''; // Clear previous content

    const filteredProducts = selectedVendor === 'all' ? allCompatibleNipples : allCompatibleNipples.filter(p => p.vendor === selectedVendor);

    if (filteredProducts.length === 0) {
        optionsContainer.innerHTML = `<p>No ${position.toLowerCase()} nipples found${selectedVendor !== 'all' ? ` for vendor: ${selectedVendor}` : ''}.</p>`;
        return;
    }

    const groupedByModel = {};
    filteredProducts.forEach(p => {
        const model = p.wheelModel || 'Other';
        if (!groupedByModel[model]) groupedByModel[model] = [];
        groupedByModel[model].push(p);
    });

    let displayedModelCount = 0;
    Object.keys(groupedByModel).sort((a, b) => getSortableName(a).localeCompare(getSortableName(b))).forEach(model => {
        const productsInGroup = groupedByModel[model];
        if (!productsInGroup.some(p => p.variants.some(v => v.availableForSale))) {
            return;
        }
        displayedModelCount++;
        const card = document.createElement('div');
        card.className = 'component-product-card nipple-model-card';
        card.innerHTML = `
            <div class="product-card-header"><h5>${model}</h5></div>
            <div class="product-card-body">
                <p>Click to view options...</p>
                <div class="component-variant-options" style="display:none;"></div>
            </div>`;
        card.addEventListener('click', (e) => {
            if (e.target.closest('.component-variant-options button')) return;
            const vc = card.querySelector('.component-variant-options');
            if (!vc) return;
            const isTrigger = e.target.closest('.product-card-header') || e.target.closest('.product-card-body p');
            if (!isTrigger) return;

            const isVisible = vc.style.display !== 'none';
            optionsContainer.querySelectorAll('.component-product-card.expanded').forEach(c => {
                if (c !== card) {
                    c.classList.remove('expanded');
                    const otherVc = c.querySelector('.component-variant-options');
                    if (otherVc) otherVc.style.display = 'none';
                }
            });
            vc.style.display = isVisible ? 'none' : 'block';
            card.classList.toggle('expanded', !isVisible);
            if (!isVisible) {
                displayNippleVariantButtonsByProduct(position, productsInGroup, vc);
            }
        });
        optionsContainer.appendChild(card);
    });

    if (displayedModelCount === 0) {
        optionsContainer.innerHTML = `<p>No ${position.toLowerCase()} nipple models found${selectedVendor !== 'all' ? ` for vendor ${selectedVendor}` : ''} with available options.</p>`;
    }
}
  
// --- START: displayNippleVariantButtonsByProduct (with lead time data) ---
function displayNippleVariantButtonsByProduct(position, productsInGroup, variantContainer) {
    if (!variantContainer) return;
    variantContainer.innerHTML = 'Loading options...';

    const posLower = position.toLowerCase();
    const stateKey = `${posLower}Nipples`;
    const selectedComponent = buildState.components[stateKey];

    let compatibleVariants = [];
    productsInGroup.forEach(p => {
        let p_optionalAddonProductGids = [];
        const rawGidValue = p.optionalAddonProductGids?.value;
        if (Array.isArray(rawGidValue)) {
            p_optionalAddonProductGids = rawGidValue.filter(gid => typeof gid === 'string' && gid.startsWith('gid://shopify/Product/'));
        } else if (typeof rawGidValue === 'string') {
            try {
                const parsedGids = JSON.parse(rawGidValue);
                if (Array.isArray(parsedGids)) {
                    p_optionalAddonProductGids = parsedGids.filter(gid => typeof gid === 'string' && gid.startsWith('gid://shopify/Product/'));
                }
            } catch (e) {
                 if (rawGidValue.startsWith('gid://shopify/Product/')) {
                       p_optionalAddonProductGids = [rawGidValue.trim()];
                 } else {
                    p_optionalAddonProductGids = rawGidValue.split(',')
                                       .map(gid => gid.trim())
                                       .filter(gid => gid.startsWith('gid://shopify/Product/'));
                 }
            }
        }

        const productDetails = {
            productId: p.id,
            productTitle: p.title,
            productHandle: p.handle,
            vendor: p.vendor,
            pairingKey: p.pairingKey,
            optionalAddonProductGidsFromProduct: p_optionalAddonProductGids,
            leadTimeDays: p.leadTimeDays || 0 // <<< ADD THIS
        };
        p.variants.forEach(v => {
            if (v.availableForSale) {
                compatibleVariants.push({ ...v, ...productDetails, product_weight_g: p.weight_g, price: v.price, product_weight_g: p.weight_g });
            }
        });
    });

    if (compatibleVariants.length === 0) {
        variantContainer.innerHTML = `<p>No available nipple options in this group.</p>`;
        return;
    }

    const uniqueVariantsMap = new Map();
    compatibleVariants.forEach(v => {
        if (!uniqueVariantsMap.has(v.id)) uniqueVariantsMap.set(v.id, v);
    });
    let uniqueVariants = Array.from(uniqueVariantsMap.values()).sort((a, b) => (a.title || '').localeCompare(b.title || ''));

    variantContainer.innerHTML = '';
    uniqueVariants.forEach(v_nipple => {
        const btn = document.createElement('button');
        btn.className = 'component-variant-button nipple-variant-button';
        btn.dataset.variantId = v_nipple.id;
        btn.dataset.productId = v_nipple.productId;
        btn.type = 'button';
        if (selectedComponent?.variantId === v_nipple.id) btn.classList.add('selected');

        const imageUrl = v_nipple.image?.url;
        const displayTitleText = `${v_nipple.productTitle || 'Nipple'} (${v_nipple.title || 'Default'})`;
        const priceAmount = v_nipple.price?.amount;

        btn.innerHTML = `
            ${imageUrl ? `<img src="${imageUrl}" alt="${displayTitleText}" loading="lazy" class="variant-button-image">` : '<div class="variant-button-image-placeholder"></div>'}
            <div class="variant-button-details">
                <span class="variant-details">${displayTitleText}</span>
                ${priceAmount ? `<span class="variant-price">${formatPrice(priceAmount)}</span>` : ''}
            </div>`;

        btn.addEventListener('click', () => {
            const newSelectedNippleVariantId = v_nipple.id;
            const newNippleProductOptionalAddonGids = v_nipple.optionalAddonProductGidsFromProduct || [];

            const previouslySelectedNippleComponent = buildState.components[stateKey];

            if (previouslySelectedNippleComponent && previouslySelectedNippleComponent.variantId !== newSelectedNippleVariantId) {
                if (previouslySelectedNippleComponent.productId === v_nipple.productId) {
                    manageStickyAddonsForChangedBaseVariant(
                        position,
                        'Nipples',
                        previouslySelectedNippleComponent.variantId, 
                        newSelectedNippleVariantId,                 
                        newNippleProductOptionalAddonGids
                    );
                } else {
                    const addonKeysToPotentiallyRemove = Object.keys(buildState.selectedOptionalAddons);
                    for (const addonKey of addonKeysToPotentiallyRemove) {
                        const selectedAddon = buildState.selectedOptionalAddons[addonKey];
                        if (selectedAddon.baseComponentPosition === position &&
                            selectedAddon.baseComponentType === 'Nipples' &&
                            selectedAddon.baseComponentVariantId === previouslySelectedNippleComponent.variantId) {
                            delete buildState.selectedOptionalAddons[addonKey];
                            saveLastActiveBuild();
                        }
                    }
                }
            }
            
            const selectedNippleComponent = {
                variantId: v_nipple.id,
                productId: v_nipple.productId,
                productHandle: v_nipple.productHandle,
                title: v_nipple.productTitle,
                variantTitle: v_nipple.title,
                sku: v_nipple.sku,
                price: v_nipple.price.amount,
                vendor: v_nipple.vendor,
                image: v_nipple.image,
                pairingKey: v_nipple.pairingKey,
                selectedOptions: v_nipple.selectedOptions,
                optionalAddonProductGids: newNippleProductOptionalAddonGids,
                quantityAvailable: v_nipple.quantityAvailable,
                leadTimeDays: v_nipple.leadTimeDays,
                weight_g: v_nipple.weight_g ?? v_nipple.product_weight_g ?? null
            };

            buildState.components[stateKey] = selectedNippleComponent;
            buildState._ui.hasChanges = true;
            updateStep3ButtonText();
            calculateWheelCosts(position);
            updateComponentUI(position, 'Nipples', selectedNippleComponent);

            if (buildState.buildType === 'Wheel Set') {
                const oppositePosition = position === 'Front' ? 'Rear' : 'Front';
                const oppositeStateKey = `${oppositePosition.toLowerCase()}Nipples`;

                if (!buildState.components[oppositeStateKey] && selectedNippleComponent.pairingKey) {
                    const selectedColorOption = selectedNippleComponent.selectedOptions.find(opt => opt.name.toLowerCase() === 'color');
                    const targetColor = selectedColorOption ? selectedColorOption.value : null;

                    const pairedProducts = allNippleProductsCache.filter(p => p.pairingKey === selectedNippleComponent.pairingKey);
                    let autoSelectedPairedVariant = null;
                    let firstTechnicallyCompatibleVariant = null;
                    
                    for (const p_pair of pairedProducts) {
                        if (!p_pair || !p_pair.variants) continue;
                        let p_pair_optionalAddonProductGids = [];
                        const rawGidValuePair = p_pair.optionalAddonProductGids?.value;
                        if (Array.isArray(rawGidValuePair)) {
                            p_pair_optionalAddonProductGids = rawGidValuePair.filter(gid => typeof gid === 'string' && gid.startsWith('gid://shopify/Product/'));
                        } else if (typeof rawGidValuePair === 'string') {
                             try {
                                const parsedGids = JSON.parse(rawGidValuePair);
                                if (Array.isArray(parsedGids)) p_pair_optionalAddonProductGids = parsedGids.filter(gid => typeof gid === 'string' && gid.startsWith('gid://shopify/Product/'));
                            } catch (e) { /* Fallback if needed */ }
                        }

                        for (const v_pair of p_pair.variants) {
                            if (!v_pair || !v_pair.price || typeof v_pair.price.amount === 'undefined' || !v_pair.availableForSale) continue;
                            const isTechnicallyCompatible = true; 
                            if (isTechnicallyCompatible) {
                                const currentPairedVariantCandidate = { 
                                    ...v_pair, productTitle: p_pair.title, productHandle: p_pair.handle, vendor: p_pair.vendor, 
                                    productId: p_pair.id, pairingKey: p_pair.pairingKey,
                                    optionalAddonProductGidsFromProduct: p_pair_optionalAddonProductGids,
                                    leadTimeDays: p_pair.leadTimeDays || 0,
                                    product_weight_g: p_pair.weight_g
                                };
                                if (!firstTechnicallyCompatibleVariant) {
                                    firstTechnicallyCompatibleVariant = currentPairedVariantCandidate;
                                }
                                const variantColorOption = v_pair.selectedOptions.find(opt => opt.name.toLowerCase() === 'color');
                                const variantColor = variantColorOption ? variantColorOption.value : null;
                                let colorMatch = (targetColor === variantColor);
                                if (targetColor === null) colorMatch = true;
                                if (colorMatch) {
                                    autoSelectedPairedVariant = currentPairedVariantCandidate;
                                    break;
                                }
                            }
                        }
                        if (autoSelectedPairedVariant) break;
                    }
                    const finalVariantToSelect = autoSelectedPairedVariant || firstTechnicallyCompatibleVariant;

                    if (finalVariantToSelect) {
                        const autoSelectedNippleComponent = {
                            variantId: finalVariantToSelect.id,
                            productId: finalVariantToSelect.productId,
                            productHandle: finalVariantToSelect.productHandle,
                            title: finalVariantToSelect.productTitle,
                            variantTitle: finalVariantToSelect.title,
                            sku: finalVariantToSelect.sku,
                            price: finalVariantToSelect.price.amount,
                            vendor: finalVariantToSelect.vendor,
                            image: finalVariantToSelect.image,
                            pairingKey: finalVariantToSelect.pairingKey,
                            selectedOptions: finalVariantToSelect.selectedOptions,
                            optionalAddonProductGids: finalVariantToSelect.optionalAddonProductGidsFromProduct,
                            quantityAvailable: finalVariantToSelect.quantityAvailable,
                            leadTimeDays: finalVariantToSelect.leadTimeDays, 
                            weight_g: finalVariantToSelect.weight_g ?? finalVariantToSelect.product_weight_g ?? null
                        };
                        buildState.components[oppositeStateKey] = autoSelectedNippleComponent;
                        calculateWheelCosts(oppositePosition);
                        updateComponentUI(oppositePosition, 'Nipples', autoSelectedNippleComponent);
                    } else {
                        if(buildState.components[oppositeStateKey]) calculateWheelCosts(oppositePosition);
                    }
                } else if (buildState.components[oppositeStateKey]) {
                     calculateWheelCosts(oppositePosition);
                }
            }

            updateSubtotal();
            updateBuildSummary();
            validateStep3();
            saveLastActiveBuild();

            if (buildState._ui.isChangingComponent?.position === position &&
                buildState._ui.isChangingComponent?.type === 'Nipples') {
                cancelComponentChange();
            }
            handleComponentChangeForLeadTime();
            scrollToComponentSection(position, 'Nipples');
        });
        variantContainer.appendChild(btn);
    });
}
// --- END: displayNippleVariantButtonsByProduct ---

// [START] NEW FUNCTION - fetchFreehubComponentProducts (V3)
async function fetchFreehubComponentProducts() {
    console.log("Fetching ALL freehub component products using tag: component:freehub");
    const freehubTag = "component:freehub";
    try {
        allFreehubComponentProductsCache = await fetchBuilderComponentProducts(freehubTag);
        console.log(`fetchFreehubComponentProducts: Found and cached ${allFreehubComponentProductsCache.length} freehub component products.`);
    } catch (error) {
        console.error("fetchFreehubComponentProducts Error:", error);
        allFreehubComponentProductsCache = [];
        throw error;
    }
    return allFreehubComponentProductsCache;
}
// [END] NEW FUNCTION - fetchFreehubComponentProducts (V3)
  
    async function fetchValveStemProducts() {
    console.log("Fetching valve stem products using tag: component:valvestem");
    const valveStemTag = "component:valvestem";
    try {
        allValveStemProductsCache = await fetchBuilderComponentProducts(valveStemTag);
        updateGlobalVendorLogoMap(allValveStemProductsCache);
        console.log(`fetchValveStemProducts: Found and cached ${allValveStemProductsCache.length} products.`);
    } catch (error) {
        console.error("fetchValveStemProducts Error:", error);
        allValveStemProductsCache = [];
        throw error;
    }
    return allValveStemProductsCache;
}

  
    async function loadAndFilterValveStems() {
    console.log("--- loadAndFilterValveStems (Combined F/R) ---");
    if (!buildState || typeof buildState.buildType === 'undefined') {
        console.error("loadAndFilterValveStems: buildState or buildState.buildType is not defined!");
        return;
    }
    const buildType = buildState.buildType;
    const positionsToLoad = [];
    if (buildType === 'Front' || buildType === 'Wheel Set') positionsToLoad.push('Front');
    if (buildType === 'Rear' || buildType === 'Wheel Set') positionsToLoad.push('Rear');
    if (positionsToLoad.length === 0) return;

    positionsToLoad.forEach(p => {
        const l = document.getElementById(`${p.toLowerCase()}-valvestem-loading`);
        if (l) l.style.display = 'block';
        const o = document.getElementById(`${p.toLowerCase()}-valvestem-options-container`);
        if (o) o.innerHTML = '<p>Loading valve stem options...</p>';
        const e = document.getElementById(`${p.toLowerCase()}-valvestem-error`);
        if (e) e.style.display = 'none';
    });

    // --- START: MODIFIED CACHE/PROMISE HANDLING FOR VALVESTEMS ---
 if (allValveStemProductsCache.length === 0) {
     console.log("ValveStem cache empty in loadAndFilterValveStems.");
     if (componentFetchPromises.valves) {
         console.log("Waiting for early valve stem fetch promise to complete...");
         try {
             await componentFetchPromises.valves;
             console.log("Early valve stem fetch completed.");
         } catch (error) {
             console.error("Error awaiting early valve stem fetch in loadAndFilterValveStems:", error);
         }
     } else {
         console.log("No early valve stem fetch promise. Fetching Valve Stems directly now...");
         try {
             await fetchValveStemProducts();
         } catch (error) {
             console.error("Error fetching valve stem products directly in loadAndFilterValveStems:", error);
         }
     }
 } else {
     console.log("Using already populated/cached valve stem data for loadAndFilterValveStems.");
 }

 if (allValveStemProductsCache.length === 0) {
     console.error("ValveStem cache is STILL empty. ValveStem data loading failed.");
     positionsToLoad.forEach(p => {
         const loader = document.getElementById(`${p.toLowerCase()}-valvestem-loading`);
         if(loader) loader.style.display = 'none';
         const errorEl = document.getElementById(`${p.toLowerCase()}-valvestem-error`);
         if(errorEl) errorEl.textContent = `Error: Valve Stem data failed to load.`;
         const optionsEl = document.getElementById(`${p.toLowerCase()}-valvestem-options-container`);
         if(optionsEl) optionsEl.innerHTML = '<p>Valve Stem data failed to load.</p>';
     });
     return;
 }
 // --- END: MODIFIED CACHE/PROMISE HANDLING FOR VALVESTEMS ---

    for (const position of positionsToLoad) {
        const stateKey = `${position.toLowerCase()}ValveStem`;
        const isAlreadySelected = !!buildState.components[stateKey];
        const isExplicitlyChangingThisOne = buildState._ui.isChangingComponent &&
                                           buildState._ui.isChangingComponent.position === position &&
                                           buildState._ui.isChangingComponent.type === 'ValveStem';

        const loadAsChangeMode = !isAlreadySelected || isExplicitlyChangingThisOne;
        await loadAndFilterValveStemsForPosition(position, loadAsChangeMode);
    }

    positionsToLoad.forEach(p => {
        const l = document.getElementById(`${p.toLowerCase()}-valvestem-loading`);
        if (l) l.style.display = 'none';
    });
    console.log("--- loadAndFilterValveStems (Combined F/R) finished ---");
}
        async function loadAndFilterValveStemsForPosition(position, isChange = false) {
        console.log(`--- loadAndFilterValveStemsForPosition: ${position} ${isChange ? '(Change Mode)' : ''} ---`);
        const posLower = position.toLowerCase();
        const refs = {
            filters: document.getElementById(`${posLower}-valvestem-filters`),
            loading: document.getElementById(`${posLower}-valvestem-loading`),
            error: document.getElementById(`${posLower}-valvestem-error`),
            optionsContainer: document.getElementById(`${posLower}-valvestem-options-container`),
            selectionSpan: document.querySelector(`#${posLower}-valvestem-selection span`),
            imageContainer: document.getElementById(`${posLower}-valvestem-image-container`),
            actionButtonsContainer: document.getElementById(`${posLower}-valvestem-action-buttons`),
            removeButton: document.getElementById(`remove-${posLower}-valvestem-button`)
        };

        let allRefsFound = true;
        for (const key in refs) { if (!refs[key]) { console.error(`Valve Stem DOM element missing for ${position}: ${key}`); allRefsFound = false; }}
        if (!allRefsFound) { if(refs.loading) refs.loading.style.display = 'none'; return; }

        refs.error.style.display = 'none'; refs.error.textContent = '';

        const subsectionElement = document.getElementById(`${posLower}-valvestem-subsection`);
        const stateKey = `${posLower}ValveStem`;
        const currentSelectedValve = buildState.components[stateKey];

        // If a valve is selected and we are NOT in explicit change mode, just update UI and return
        if (currentSelectedValve && !isChange) {
            console.log(`   ${position} ValveStem already selected and NOT in explicit change mode. Calling updateComponentUI.`);
            if (refs.loading) refs.loading.style.display = 'none';
            updateComponentUI(position, 'ValveStem', currentSelectedValve); // This handles remove button visibility
            
            // Ensure action buttons are hidden if a selection is displayed and not in change mode
            if (refs.actionButtonsContainer) {
                refs.actionButtonsContainer.innerHTML = '';
                refs.actionButtonsContainer.style.display = 'none';
            }
            return;
        }

        // If we reach here, it means we are showing the options area for one of these reasons:
        // 1. The slot is empty (currentSelectedValve is null), regardless of isChange.
        // 2. The slot has a selection, AND isChange is true (explicitly changing).

        // --- UI Setup for showing options ---
        if (refs.loading) refs.loading.style.display = 'block'; // Show loading as options will be processed/shown

        if (refs.optionsContainer) {
            refs.optionsContainer.innerHTML = '<p>Loading options...</p>'; // Placeholder
            refs.optionsContainer.style.display = 'flex';
        }
        if (refs.imageContainer) {
            refs.imageContainer.innerHTML = '';
            refs.imageContainer.style.display = 'none';
        }
        // Remove button should be hidden if no valve is selected OR if we are in change mode (it's handled by updateComponentUI otherwise)
        if (refs.removeButton && (!currentSelectedValve || isChange) ) {
             refs.removeButton.style.display = 'none';
        }
        
        if (subsectionElement) {
            if (isChange) { // Explicitly changing an existing selection
                subsectionElement.classList.add('change-in-progress');
                subsectionElement.classList.remove('selection-made');
            } else if (!currentSelectedValve) { // Slot is empty, and not an explicit change of a selected item
                subsectionElement.classList.remove('selection-made', 'change-in-progress');
            }
            // If currentSelectedValve exists but isChange is false, we would have returned earlier.
        }
        // --- End UI Setup for showing options ---

        // --- Manage Action Buttons (Match Pair / Cancel Change) ---
        // This should be called if options are being shown AND the prerequisite (rim) is met.
        const correspondingRimKey = `${posLower}Rim`;
        const selectedRim = buildState.components[correspondingRimKey];

        if (refs.actionButtonsContainer) {
            if (selectedRim) { // Only consider showing action buttons if rim is selected
                // showCancelChangeButtonIfNeeded will handle whether it's "Match Pair" and/or "Cancel Change"
                showCancelChangeButtonIfNeeded(position, 'ValveStem', refs.actionButtonsContainer);
            } else {
                // If no rim, no action buttons related to valve stem pairing/changing make sense
                refs.actionButtonsContainer.innerHTML = '';
                refs.actionButtonsContainer.style.display = 'none';
            }
        }
        // --- End Manage Action Buttons ---

        // Prerequisite: Rim must be selected to show valve stem options
        if (!selectedRim) {
            if (refs.optionsContainer) refs.optionsContainer.innerHTML = '<p class="selection-prompt centered-bold-prompt">Please select a Rim first to see compatible Valve Stems.</p>';
            if (refs.loading) refs.loading.style.display = 'none';
            // Action buttons are already handled above based on rim presence.
            return;
        }

        // If rim is selected, proceed to load and filter valve stems
        const selectedRimDepth = selectedRim.rimDepth;
        if (selectedRimDepth === null || typeof selectedRimDepth === 'undefined') {
             console.warn(`   Rim depth for ${selectedRim.title} is not defined. Valve stems will not be filtered by depth for ${position}.`);
        }

        if (allValveStemProductsCache.length === 0) {
            console.warn(`   Valve Stem cache empty for ${position}. Attempting fetch...`);
            try {
                await fetchValveStemProducts();
                 if (allValveStemProductsCache.length === 0) {
                    console.error(`   Valve Stem data could not be loaded after fetch.`);
                    if (refs.optionsContainer) refs.optionsContainer.innerHTML = '<p>Valve Stem data could not be loaded.</p>';
                    if (refs.loading) refs.loading.style.display = 'none';
                    return;
                }
            } catch (error) {
                console.error(`   Error fetching Valve Stem data for ${position}:`, error);
                if (refs.optionsContainer) refs.optionsContainer.innerHTML = '<p>Error loading Valve Stem data.</p>';
                if(refs.error) { refs.error.textContent = `Error: ${error.message}`; refs.error.style.display = 'block'; }
                if (refs.loading) refs.loading.style.display = 'none';
                return;
            }
        }

        const compatibleProducts = allValveStemProductsCache; // All products, filtering happens in displayValveStemProductCards

        if (compatibleProducts.length === 0) {
            if (refs.optionsContainer) refs.optionsContainer.innerHTML = '<p>No valve stem products found in cache.</p>';
        } else {
            // Vendor filters should be displayed if options are being shown
            // (isChange implies options are shown, !currentSelectedValve implies options are shown)
            if (isChange || !currentSelectedValve) {
                 displayComponentVendorFilters(stateKey, compatibleProducts, refs.filters, position);
            }
            displayValveStemProductCards(position, compatibleProducts, refs.optionsContainer, selectedRimDepth);
        }

        if (refs.loading) refs.loading.style.display = 'none';
        console.log(`--- loadAndFilterValveStemsForPosition: ${position} finished (isChange: ${isChange}, currentSelectedValve: ${!!currentSelectedValve}) ---`);
    }
  
function displayValveStemProductCards(position, allCompatibleValveStems, optionsContainer, selectedRimDepth) {
    if (!optionsContainer) {
        console.error(`   displayValveStemProductCards: optionsContainer is null for ${position}.`);
        return;
    }
    const componentKeyForState = `${position.toLowerCase()}ValveStem`;
    const selectedVendor = buildState._ui.activeVendor[componentKeyForState];

    // If no vendor is selected, show nothing.
    if (selectedVendor === null) {
        optionsContainer.innerHTML = '';
        return;
    }

    optionsContainer.innerHTML = ''; // Clear previous content
    
    const filteredProducts = selectedVendor === 'all' ? allCompatibleValveStems : allCompatibleValveStems.filter(p => p.vendor === selectedVendor);

    if (filteredProducts.length === 0) {
        optionsContainer.innerHTML = `<p>No ${position.toLowerCase()} valve stems found${selectedVendor !== 'all' ? ` for vendor: ${selectedVendor}` : ''}.</p>`;
        return;
    }

    const groupedByModel = {};
    filteredProducts.forEach(p => {
        const model = p.wheelModel || 'Other Valve Stems';
        if (!groupedByModel[model]) groupedByModel[model] = [];
        groupedByModel[model].push(p);
    });

    let displayedModelCount = 0;
    Object.keys(groupedByModel).sort((a, b) => getSortableName(a).localeCompare(getSortableName(b))).forEach(model => {
        const productsInGroup = groupedByModel[model];

        let groupHasCompatibleVariant = false;
        if (selectedRimDepth === null || typeof selectedRimDepth === 'undefined') {
            groupHasCompatibleVariant = productsInGroup.some(p => p.variants.some(v => v.availableForSale));
        } else {
            groupHasCompatibleVariant = productsInGroup.some(p =>
                p.variants.some(v =>
                    v.availableForSale &&
                    ( (v.valve_min_depth === null || v.valve_max_depth === null) ||
                      (selectedRimDepth >= v.valve_min_depth && selectedRimDepth <= v.valve_max_depth)
                    )
                )
            );
        }

        if (!groupHasCompatibleVariant) {
            return;
        }

        displayedModelCount++;
        const card = document.createElement('div');
        card.className = 'component-product-card valvestem-model-card';
        card.innerHTML = `
            <div class="product-card-header"><h5>${model}</h5></div>
            <div class="product-card-body">
                <p>Click to view options...</p>
                <div class="component-variant-options" style="display:none;"></div>
            </div>`;
        card.addEventListener('click', (e) => {
            if (e.target.closest('.component-variant-options button')) return;
            const vc = card.querySelector('.component-variant-options');
            if (!vc) {
                return;
            }
            const isTrigger = e.target.closest('.product-card-header') || e.target.closest('.product-card-body p');
            if (!isTrigger) return;

            const isVisible = vc.style.display !== 'none';
            optionsContainer.querySelectorAll('.component-product-card.expanded').forEach(c => {
                if (c !== card) {
                    c.classList.remove('expanded');
                    const otherVc = c.querySelector('.component-variant-options');
                    if (otherVc) otherVc.style.display = 'none';
                }
            });
            vc.style.display = isVisible ? 'none' : 'block';
            card.classList.toggle('expanded', !isVisible);
            if (!isVisible) {
                displayValveStemVariantButtonsByProduct(position, productsInGroup, vc, selectedRimDepth);
            }
        });
        optionsContainer.appendChild(card);
    });

    if (displayedModelCount === 0) {
        let message = `No ${position.toLowerCase()} valve stem models found`;
        if (selectedVendor !== 'all') message += ` for vendor ${selectedVendor}`;
        if (selectedRimDepth !== null && typeof selectedRimDepth !== 'undefined') message += ` compatible with ${selectedRimDepth}mm rim depth`;
        message += '.';
        optionsContainer.innerHTML = `<p>${message}</p>`;
    }
}
  
// --- START: displayValveStemVariantButtonsByProduct (with lead time data) ---
function displayValveStemVariantButtonsByProduct(position, productsInGroup, variantContainer, selectedRimDepth) {
    if (!variantContainer) return;
    variantContainer.innerHTML = 'Loading options...';

    const posLower = position.toLowerCase();
    const stateKey = `${posLower}ValveStem`;
    const selectedComponent = buildState.components[stateKey];

    let variantsToDisplay = [];
    productsInGroup.forEach(p => {
        let p_optionalAddonProductGids = [];
        const rawGidValue = p.optionalAddonProductGids?.value;
        if (Array.isArray(rawGidValue)) {
            p_optionalAddonProductGids = rawGidValue.filter(gid => typeof gid === 'string' && gid.startsWith('gid://shopify/Product/'));
        } else if (typeof rawGidValue === 'string') {
            try {
                const parsedGids = JSON.parse(rawGidValue);
                if (Array.isArray(parsedGids)) {
                    p_optionalAddonProductGids = parsedGids.filter(gid => typeof gid === 'string' && gid.startsWith('gid://shopify/Product/'));
                }
            } catch (e) {
                 if (rawGidValue.startsWith('gid://shopify/Product/')) {
                       p_optionalAddonProductGids = [rawGidValue.trim()];
                 } else {
                    p_optionalAddonProductGids = rawGidValue.split(',')
                                       .map(gid => gid.trim())
                                       .filter(gid => gid.startsWith('gid://shopify/Product/'));
                 }
            }
        }

        const productDetails = { 
            productId: p.id, productTitle: p.title, productHandle: p.handle, 
            vendor: p.vendor, pairingKey: p.pairingKey,
            optionalAddonProductGidsFromProduct: p_optionalAddonProductGids,
            leadTimeDays: p.leadTimeDays || 0 // <<< ADD THIS
        };
        p.variants.forEach(v => {
            if (v.availableForSale) {
                let isDepthCompatible = false;
                if (selectedRimDepth === null || typeof selectedRimDepth === 'undefined') {
                    isDepthCompatible = true;
                } else if (v.valve_min_depth === null || v.valve_max_depth === null) {
                    isDepthCompatible = true;
                } else {
                    isDepthCompatible = selectedRimDepth >= v.valve_min_depth && selectedRimDepth <= v.valve_max_depth;
                }

                if (isDepthCompatible) {
                    variantsToDisplay.push({ ...v, ...productDetails, price: v.price });
                }
            }
        });
    });

    if (variantsToDisplay.length === 0) {
        let msg = `<p>No available valve stem options in this group`;
        if (selectedRimDepth !== null && typeof selectedRimDepth !== 'undefined') {
            msg += ` compatible with ${selectedRimDepth}mm rim depth`;
        }
        msg += `.</p>`;
        variantContainer.innerHTML = msg;
        return;
    }

    const uniqueVariantsMap = new Map();
    variantsToDisplay.forEach(v => { if (!uniqueVariantsMap.has(v.id)) uniqueVariantsMap.set(v.id, v); });
    let uniqueVariants = Array.from(uniqueVariantsMap.values()).sort((a, b) => {
        const titleCompare = (a.productTitle || '').localeCompare(b.productTitle || ''); if (titleCompare !== 0) return titleCompare;
        const lengthAOpt = a.selectedOptions.find(opt => opt.name.toLowerCase() === 'length');
        const lengthBOpt = b.selectedOptions.find(opt => opt.name.toLowerCase() === 'length');
        const lengthA = lengthAOpt ? parseInt(lengthAOpt.value.replace(/\D/g, '')) : Infinity;
        const lengthB = lengthBOpt ? parseInt(lengthBOpt.value.replace(/\D/g, '')) : Infinity;
        return lengthA - lengthB;
    });

    variantContainer.innerHTML = '';
    uniqueVariants.forEach(v_valve => {
        const btn = document.createElement('button'); btn.className = 'component-variant-button valvestem-variant-button';
        btn.dataset.variantId = v_valve.id; btn.dataset.productId = v_valve.productId; btn.type = 'button';
        if (selectedComponent?.variantId === v_valve.id) btn.classList.add('selected');
        const imageUrl = v_valve.image?.url; let variantDisplayParts = [];
        v_valve.selectedOptions.forEach(opt => { variantDisplayParts.push(`${opt.value}`); });
        const displayTitleText = `${v_valve.productTitle || 'Valve Stem'} (${variantDisplayParts.join(', ') || v_valve.title || 'Default'})`;
        const priceAmount = v_valve.price?.amount;
        btn.innerHTML = `${imageUrl ? `<img src="${imageUrl}" alt="${displayTitleText}" loading="lazy" class="variant-button-image">` : '<div class="variant-button-image-placeholder"></div>'}<div class="variant-button-details"><span class="variant-details">${displayTitleText}</span>${priceAmount ? `<span class="variant-price">${formatPrice(priceAmount)}</span>` : ''}</div>`;

        btn.addEventListener('click', () => {
            const newSelectedValveVariantId = v_valve.id;
            const newValveProductOptionalAddonGids = v_valve.optionalAddonProductGidsFromProduct || [];

            const previouslySelectedValveComponent = buildState.components[stateKey];

            if (previouslySelectedValveComponent && previouslySelectedValveComponent.variantId !== newSelectedValveVariantId) {
                if (previouslySelectedValveComponent.productId === v_valve.productId) {
                    manageStickyAddonsForChangedBaseVariant(
                        position,
                        'ValveStem',
                        previouslySelectedValveComponent.variantId, 
                        newSelectedValveVariantId,                 
                        newValveProductOptionalAddonGids
                    );
                } else {
                    const addonKeysToPotentiallyRemove = Object.keys(buildState.selectedOptionalAddons);
                    for (const addonKey of addonKeysToPotentiallyRemove) {
                        const selectedAddon = buildState.selectedOptionalAddons[addonKey];
                        if (selectedAddon.baseComponentPosition === position &&
                            selectedAddon.baseComponentType === 'ValveStem' &&
                            selectedAddon.baseComponentVariantId === previouslySelectedValveComponent.variantId) {
                            delete buildState.selectedOptionalAddons[addonKey];
                            saveLastActiveBuild();
                        }
                    }
                }
            }

            const selectedValveComponent = {
                variantId: v_valve.id, productId: v_valve.productId, productHandle: v_valve.productHandle,
                title: v_valve.productTitle, variantTitle: v_valve.title,
                sku: v_valve.sku, price: v_valve.price.amount, vendor: v_valve.vendor,
                image: v_valve.image, pairingKey: v_valve.pairingKey,
                selectedOptions: v_valve.selectedOptions,
                selectedWithRimDepth: selectedRimDepth,
                valveMinDepth: v_valve.valve_min_depth,
                valveMaxDepth: v_valve.valve_max_depth,
                optionalAddonProductGids: newValveProductOptionalAddonGids,
                quantityAvailable: v_valve.quantityAvailable,
                leadTimeDays: v_valve.leadTimeDays,
                weight_g: v_valve.weight_g ?? v_valve.product_weight_g ?? null
            };
            buildState.components[stateKey] = selectedValveComponent;
            buildState._ui.hasChanges = true;
            updateStep3ButtonText();
            buildState._ui.valveStemExplicitlyRemoved[posLower] = false;
            updateComponentUI(position, 'ValveStem', selectedValveComponent);

            if (buildState.buildType === 'Wheel Set') {
                const oppositePosition = position === 'Front' ? 'Rear' : 'Front';
                const oppositePosLower = oppositePosition.toLowerCase();
                const oppositeStateKey = `${oppositePosLower}ValveStem`;

                if (buildState._ui.valveStemExplicitlyRemoved[oppositePosLower]) {
                    // Skip auto-pair if explicitly removed
                } else if (!buildState.components[oppositeStateKey] && selectedValveComponent.pairingKey) {
                    const selectedColorOption = selectedValveComponent.selectedOptions.find(opt => opt.name.toLowerCase() === 'color');
                    const targetColor = selectedColorOption ? selectedColorOption.value : null;

                    const oppositeRimKey = `${oppositePosLower}Rim`;
                    const oppositeSelectedRim = buildState.components[oppositeRimKey];
                    const oppositeRimDepth = oppositeSelectedRim ? oppositeSelectedRim.rimDepth : null;
                    
                    if (!oppositeSelectedRim) {
                        // Cannot auto-pair if opposite rim not selected
                    } else {
                        const pairedProducts = allValveStemProductsCache.filter(p => p.pairingKey === selectedValveComponent.pairingKey);
                        let potentialPairedValves = [];

                        for (const p_pair of pairedProducts) {
                            if (!p_pair || !p_pair.variants) continue;
                            let p_pair_optionalAddonProductGids = [];
                            const rawGidValuePair = p_pair.optionalAddonProductGids?.value;
                            if (Array.isArray(rawGidValuePair)) {
                                p_pair_optionalAddonProductGids = rawGidValuePair.filter(gid => typeof gid === 'string' && gid.startsWith('gid://shopify/Product/'));
                            } else if (typeof rawGidValuePair === 'string') {
                                try {
                                    const parsedGids = JSON.parse(rawGidValuePair);
                                    if (Array.isArray(parsedGids)) p_pair_optionalAddonProductGids = parsedGids.filter(gid => typeof gid === 'string' && gid.startsWith('gid://shopify/Product/'));
                                } catch (e) { /* Fallback if needed */ }
                            }

                            for (const v_pair of p_pair.variants) {
                                if (!v_pair.availableForSale) continue;
                                let isDepthCompatibleForPair = false;
                                if (oppositeRimDepth === null || typeof oppositeRimDepth === 'undefined') isDepthCompatibleForPair = true;
                                else if (v_pair.valve_min_depth === null || v_pair.valve_max_depth === null) isDepthCompatibleForPair = true;
                                else isDepthCompatibleForPair = oppositeRimDepth >= v_pair.valve_min_depth && oppositeRimDepth <= v_pair.valve_max_depth;
                                if (isDepthCompatibleForPair) {
                                    const variantColorOption = v_pair.selectedOptions.find(opt => opt.name.toLowerCase() === 'color');
                                    const variantColor = variantColorOption ? variantColorOption.value : null;
                                    let colorMatch = (targetColor === variantColor);
                                    if (targetColor === null) colorMatch = true;
                                    if (colorMatch) {
                                        potentialPairedValves.push({
                                            variant: v_pair, 
                                            product: p_pair, 
                                            optionalAddonProductGidsFromProduct: p_pair_optionalAddonProductGids,
                                            leadTimeDays: p_pair.leadTimeDays || 0 // <<< ADD THIS
                                        });
                                    }
                                }
                            }
                        }
                        let finalVariantToSelect = null;
                        if (potentialPairedValves.length > 0) {
                            potentialPairedValves.sort((a, b) => { /* ... existing sort ... */ });
                            finalVariantToSelect = potentialPairedValves[0]; 
                        }
                        if (finalVariantToSelect) {
                            const autoSelectedValveComponent = {
                                variantId: finalVariantToSelect.variant.id, productId: finalVariantToSelect.product.id, productHandle: finalVariantToSelect.product.handle,
                                title: finalVariantToSelect.product.title, variantTitle: finalVariantToSelect.variant.title, sku: finalVariantToSelect.variant.sku,
                                price: finalVariantToSelect.variant.price.amount, vendor: finalVariantToSelect.product.vendor, image: finalVariantToSelect.variant.image,
                                pairingKey: finalVariantToSelect.product.pairingKey, selectedOptions: finalVariantToSelect.variant.selectedOptions,
                                selectedWithRimDepth: oppositeRimDepth, valveMinDepth: finalVariantToSelect.variant.valve_min_depth, valveMaxDepth: finalVariantToSelect.variant.valve_max_depth,
                                optionalAddonProductGids: finalVariantToSelect.optionalAddonProductGidsFromProduct,
                                quantityAvailable: finalVariantToSelect.variant.quantityAvailable,
                                leadTimeDays: finalVariantToSelect.leadTimeDays,
                                weight_g: finalVariantToSelect.variant.weight_g ?? finalVariantToSelect.product.weight_g ?? null
                            };
                            buildState.components[oppositeStateKey] = autoSelectedValveComponent;
                            buildState._ui.valveStemExplicitlyRemoved[oppositePosLower] = false;
                            updateComponentUI(oppositePosition, 'ValveStem', autoSelectedValveComponent);
                        }
                    }
                }
            }

                        // After auto-pairing logic, explicitly re-evaluate the opposite side's action buttons.
            // This ensures the "Match Pair" button appears if auto-pairing did not happen.
            if (buildState.buildType === 'Wheel Set') {
                const oppositePosition = position === 'Front' ? 'Rear' : 'Front';
                const oppositePosLower = oppositePosition.toLowerCase();
                const oppositeActionButtonsContainer = document.getElementById(`${oppositePosLower}-valvestem-action-buttons`);
                
                // This is the key: We need to re-evaluate the opposite side's buttons
                // because a potential match (the one just selected) now exists.
                if (oppositeActionButtonsContainer) {
                    showCancelChangeButtonIfNeeded(oppositePosition, 'ValveStem', oppositeActionButtonsContainer);
                }
            }
          
            updateSubtotal(); updateBuildSummary(); validateStep3(); saveLastActiveBuild();
            if (buildState._ui.isChangingComponent?.position === position && buildState._ui.isChangingComponent?.type === 'ValveStem') cancelComponentChange();
            handleComponentChangeForLeadTime();
            scrollToComponentSection(position, 'ValveStem');
        });
        variantContainer.appendChild(btn);
    });
}
// --- END: displayValveStemVariantButtonsByProduct ---
  
    function evaluateValveStemForRimChange(rimPosition) {
        console.log(`evaluateValveStemForRimChange: Evaluating valve for ${rimPosition} Rim.`);
        const posLower = rimPosition.toLowerCase();
        const rimStateKey = `${posLower}Rim`;
        const valveStemStateKey = `${posLower}ValveStem`;

        const selectedRimComponent = buildState.components[rimStateKey];
        if (!selectedRimComponent) {
            console.log(`   evaluateValveStemForRimChange: No ${rimPosition} Rim selected. Cannot evaluate valve stem.`);
            if (buildState.components[valveStemStateKey]) {
                buildState.components[valveStemStateKey] = null;
                updateComponentUI(rimPosition, 'ValveStem', null);
            }
            loadAndFilterValveStemsForPosition(rimPosition, true);
            return;
        }

        const currentValveStem = buildState.components[valveStemStateKey];
        let valveStemWasCleared = false;
        let valveStemWasAutoReselected = false;
        const newRimDepth = selectedRimComponent.rimDepth;

        if (currentValveStem) {
            let isValveStillCompatible = false;
            if (newRimDepth === null || typeof newRimDepth === 'undefined') {
                isValveStillCompatible = true;
                console.log(`   evaluateValveStemForRimChange: ${rimPosition} Rim has no depth. Keeping selected Valve Stem: ${currentValveStem.variantTitle}.`);
            } else if (currentValveStem.valveMinDepth === null || currentValveStem.valveMaxDepth === null) {
                isValveStillCompatible = true;
                console.log(`   evaluateValveStemForRimChange: Selected ${rimPosition} Valve (${currentValveStem.variantTitle}) has no depth specs. Keeping selected Valve Stem.`);
            } else {
                isValveStillCompatible = newRimDepth >= currentValveStem.valveMinDepth && newRimDepth <= currentValveStem.valveMaxDepth;
            }

            if (!isValveStillCompatible) {
                console.warn(`   evaluateValveStemForRimChange: Previously selected ${rimPosition} Valve Stem (${currentValveStem.title} - ${currentValveStem.variantTitle}) NO LONGER compatible with new Rim depth (${newRimDepth}mm). Clearing.`);
                const clearedValveDetails = {
                    pairingKey: currentValveStem.pairingKey,
                    color: currentValveStem.selectedOptions?.find(opt => opt.name.toLowerCase() === 'color')?.value || null,
                    originalVariantId: currentValveStem.variantId
                };
                buildState.components[valveStemStateKey] = null;
                valveStemWasCleared = true;

                if (clearedValveDetails.pairingKey && newRimDepth !== null && typeof newRimDepth !== 'undefined' && allValveStemProductsCache.length > 0) {
                    console.log(`   evaluateValveStemForRimChange: Attempting auto-re-select ${rimPosition} Valve. Color: ${clearedValveDetails.color}, Key: ${clearedValveDetails.pairingKey}, Depth: ${newRimDepth}mm`);
                    let potentialNewValves = [];
                    for (const product of allValveStemProductsCache) {
                        if (product.pairingKey !== clearedValveDetails.pairingKey) continue;
                        for (const variant of product.variants) {
                            if (!variant.availableForSale || variant.id === clearedValveDetails.originalVariantId) continue;
                            let isDepthCompatibleReselect = (newRimDepth >= variant.valve_min_depth && newRimDepth <= variant.valve_max_depth);
                            if (variant.valve_min_depth === null || variant.valve_max_depth === null) isDepthCompatibleReselect = true;
                            const variantColorReselect = variant.selectedOptions?.find(opt => opt.name.toLowerCase() === 'color')?.value || null;
                            const isColorMatchReselect = (clearedValveDetails.color === variantColorReselect) || (clearedValveDetails.color === null);
                            if (isDepthCompatibleReselect && isColorMatchReselect) potentialNewValves.push({ variant, product });
                        }
                    }

                    if (potentialNewValves.length > 0) {
                        potentialNewValves.sort((a, b) => (parseInt(a.variant.selectedOptions.find(opt=>opt.name==='Length')?.value.replace(/\D/g,''))||Infinity) - (parseInt(b.variant.selectedOptions.find(opt=>opt.name==='Length')?.value.replace(/\D/g,''))||Infinity));
                        const newFoundValve = potentialNewValves[0];
                        const newValveComponent = {
                            variantId: newFoundValve.variant.id, productId: newFoundValve.product.id, productHandle: newFoundValve.product.handle,
                            title: newFoundValve.product.title, variantTitle: newFoundValve.variant.title, sku: newFoundValve.variant.sku,
                            price: newFoundValve.variant.price.amount, vendor: newFoundValve.product.vendor, image: newFoundValve.variant.image,
                            pairingKey: newFoundValve.product.pairingKey, selectedOptions: newFoundValve.variant.selectedOptions,
                            selectedWithRimDepth: newRimDepth, valveMinDepth: newFoundValve.variant.valve_min_depth, valveMaxDepth: newFoundValve.variant.valve_max_depth
                        };
                        console.log(`   evaluateValveStemForRimChange: Auto-re-selected ${rimPosition} Valve:`, newValveComponent);
                        buildState.components[valveStemStateKey] = newValveComponent;
                        buildState._ui.valveStemExplicitlyRemoved[posLower] = false;
                        valveStemWasCleared = false;
                        valveStemWasAutoReselected = true;
                    } else {
                         console.log(`   evaluateValveStemForRimChange: Could not find a valve to auto-re-select for ${rimPosition}. Slot remains cleared.`);
                    }
                }
            } else {
                buildState._ui.valveStemExplicitlyRemoved[posLower] = false;
                valveStemWasAutoReselected = false;
                if (newRimDepth !== null && typeof newRimDepth !== 'undefined' && allValveStemProductsCache.length > 0) {
                    console.log(`   evaluateValveStemForRimChange: ${rimPosition} Valve (${currentValveStem.variantTitle}) still compatible. Checking for shorter...`);
                    let potentialShorterValves = [];
                    for (const product of allValveStemProductsCache) {
                        if (product.pairingKey !== currentValveStem.pairingKey) continue;
                        for (const variant of product.variants) {
                            if (!variant.availableForSale) continue;
                            let isDepthCompatibleShorter = (newRimDepth >= variant.valve_min_depth && newRimDepth <= variant.valve_max_depth);
                            if (variant.valve_min_depth === null || variant.valve_max_depth === null) isDepthCompatibleShorter = true;
                            const variantColorShorter = variant.selectedOptions?.find(opt => opt.name.toLowerCase() === 'color')?.value || null;
                            const currentColorShorter = currentValveStem.selectedOptions?.find(opt => opt.name.toLowerCase() === 'color')?.value || null;
                            const isColorMatchShorter = (currentColorShorter === variantColorShorter);
                            if (isDepthCompatibleShorter && isColorMatchShorter) potentialShorterValves.push({variant, product});
                        }
                    }

                    if (potentialShorterValves.length > 0) {
                        potentialShorterValves.sort((a,b) => (parseInt(a.variant.selectedOptions.find(opt=>opt.name==='Length')?.value.replace(/\D/g,''))||Infinity) - (parseInt(b.variant.selectedOptions.find(opt=>opt.name==='Length')?.value.replace(/\D/g,''))||Infinity));
                        const shortestCompatible = potentialShorterValves[0];
                        const currentLength = parseInt(currentValveStem.selectedOptions.find(o=>o.name==='Length')?.value.replace(/\D/g,'')) || Infinity;
                        const shortestLength = parseInt(shortestCompatible.variant.selectedOptions.find(o=>o.name==='Length')?.value.replace(/\D/g,'')) || Infinity;

                        if (shortestCompatible.variant.id !== currentValveStem.variantId && shortestLength < currentLength) {
                            const shorterName = `${shortestCompatible.product.title || 'Valve'} (${shortestCompatible.variant.title || shortestCompatible.variant.selectedOptions.find(o=>o.name==='Length')?.value || 'Shorter'})`;
                            if (confirm(`A shorter valve stem (${shorterName}) is available for your ${rimPosition} rim. Would you like to switch to it?`)) {
                                const newValveComponent = {
                                    variantId: shortestCompatible.variant.id, productId: shortestCompatible.product.id, productHandle: shortestCompatible.product.handle,
                                    title: shortestCompatible.product.title, variantTitle: shortestCompatible.variant.title, sku: shortestCompatible.variant.sku,
                                    price: shortestCompatible.variant.price.amount, vendor: shortestCompatible.product.vendor, image: shortestCompatible.variant.image,
                                    pairingKey: shortestCompatible.product.pairingKey, selectedOptions: shortestCompatible.variant.selectedOptions,
                                    selectedWithRimDepth: newRimDepth, valveMinDepth: shortestCompatible.variant.valve_min_depth, valveMaxDepth: shortestCompatible.variant.valve_max_depth
                                };
                                buildState.components[valveStemStateKey] = newValveComponent;
                                valveStemWasAutoReselected = true;
                            } else {
                                console.log(`   User declined shorter ${rimPosition} valve. Keeping ${currentValveStem.variantTitle}`);
                            }
                        } else {
                            console.log(`   Current ${rimPosition} valve is already shortest or only option. Keeping ${currentValveStem.variantTitle}`);
                        }
                    } else {
                        console.log(`   No other valves found to compare for shorter option for ${rimPosition} valve.`);
                    }
                }
            }
        } else {
             console.log(`   evaluateValveStemForRimChange: No current valve for ${rimPosition}. Will show options if rim is present.`);
            valveStemWasCleared = true;
        }

        let isNowChangingThisValve = (valveStemWasCleared && !valveStemWasAutoReselected);

        console.log(`   evaluateValveStemForRimChange: Calling loadAndFilterValveStemsForPosition for ${rimPosition}. isChange (show options): ${isNowChangingThisValve}`);
        loadAndFilterValveStemsForPosition(rimPosition, isNowChangingThisValve);

    // --- Set hasChanges flag only if an actual change occurred to the valve stem ---
    if (valveStemWasCleared || valveStemWasAutoReselected) {
        buildState._ui.hasChanges = true;
        updateStep3ButtonText();
        saveLastActiveBuild();
    }
    // --- END ---

}
    // END OF EXISTING COMPONENT FUNCTIONS

// --- START: updateBuildSummary and updateSubtotal with Integrated Discount Logic (Plan E) ---

async function countChargeableItemsInBuild() { 
    let itemCount = 0;
    const { components, selectedOptionalAddons, buildType } = buildState;
    if (!buildType) return 0;

    const positionsToProcess = [];
    if (buildType === 'Front' || buildType === 'Wheel Set') positionsToProcess.push('front');
    if (buildType === 'Rear' || buildType === 'Wheel Set') positionsToProcess.push('rear');

    positionsToProcess.forEach(pos => {
        // Main components (Rims, Hubs, Spokes, Nipples, ValveStems)
        ['Rim', 'Hub', 'Spokes', 'Nipples', 'ValveStem'].forEach(type => {
            if (components[`${pos}${type}`]) {
                itemCount++;
            }
        });

        // Assembly Service
        if (components[`${pos}AssemblyService`]) {
            itemCount++;
        }

        // Required Addons (like Berd Inserts)
        if (components[`${pos}RequiredAddons`]) {
            itemCount += components[`${pos}RequiredAddons`].length;
        }
    });

    // Optional Add-ons
    if (selectedOptionalAddons) {
        itemCount += Object.keys(selectedOptionalAddons).length;
    }

    // --- START: LOGIC TO COUNT ACCESSORIES FROM CART IN EDIT MODE ---
if (buildState._ui.inEditMode === true && buildState.buildId) {
    try {
        const cartResponse = await fetch('/cart.json');
        const cartData = await cartResponse.json();
        const accessoryBundleId = `${buildState.buildId}-ACC`;
        
        cartData.items.forEach(item => {
            if (item.properties && item.properties._parent_build_id === accessoryBundleId) {
                itemCount += item.quantity;
            }
        });
    } catch (e) {
        console.error("Could not fetch cart to count accessories during edit:", e);
    }
}
// --- END: NEW LOGIC ---
  
    return itemCount;
}

/**
 * Calculates the total cost of all physical items for a pre-configured build.
 * Crucially, it ignores valve stems as they are considered an included part of the bundle.
 * @returns {number} The total cost in cents.
 */
function calculatePhysicalPreconfiguredTotal() {
    const { components, selectedOptionalAddons } = buildState;
    let total = 0;

    // IMPORTANT: Note that 'ValveStem' is excluded from this list.
    const mainComponentKeys = ['Rim', 'Hub', 'Spokes', 'Nipples'];
    const positions = ['front', 'rear'];

    positions.forEach(pos => {
        mainComponentKeys.forEach(typeKey => {
            const component = components[`${pos}${typeKey}`];
            if (component?.price) total += component.price;
        });
        (components[`${pos}RequiredAddons`] || []).forEach(addon => {
            total += addon.costInCents;
        });
    });

    if (components.rearComponentFreehub?.price) {
        total += components.rearComponentFreehub.price;
    }

    Object.values(selectedOptionalAddons).forEach(addon => {
        total += addon.addonPriceCents;
    });

    return total;
}


function updateSubtotal() {
    window.StandardStudio?.refresh(); // STANDARD-STUDIO: repair Studio painting and refresh each wheel's fee line before adding up
    let subtotalCents = 0;
    const { components, buildType, selectedOptionalAddons } = buildState;

    const mainComponentKeys = ['Rim', 'Hub', 'Spokes', 'Nipples', 'ValveStem'];
    const positionsToProcess = [];
    if (buildType === 'Front' || buildType === 'Wheel Set') positionsToProcess.push('front');
    if (buildType === 'Rear' || buildType === 'Wheel Set') positionsToProcess.push('rear');

    positionsToProcess.forEach(pos => {
        mainComponentKeys.forEach(typeKey => {
            const component = components[`${pos}${typeKey}`];
            if (component?.price && typeof component.price === 'number') {
                subtotalCents += component.price;
            }
        });

        const assemblyService = components[`${pos}AssemblyService`];
        if (assemblyService?.costInCents) {
            subtotalCents += assemblyService.costInCents;
        }

        const requiredAddons = components[`${pos}RequiredAddons`];
        if (requiredAddons) {
            requiredAddons.forEach(addon => {
                if (addon?.costInCents) subtotalCents += addon.costInCents;
            });
        }
    });

    if (selectedOptionalAddons) {
        Object.values(selectedOptionalAddons).forEach(addon => {
            if (addon?.addonPriceCents) subtotalCents += addon.addonPriceCents;
        });
    }

    if (components.rearComponentFreehub?.price && typeof components.rearComponentFreehub.price === 'number') {
        subtotalCents += components.rearComponentFreehub.price;
    }
    
    buildState.subtotal = subtotalCents;

    // This is now the ONLY place that calls updateBuildSummary, ensuring the flow is correct.
    updateBuildSummary();
}

// --- Inside variant-builder.js ---

/**
 * Checks if the current selection matches a pre-configured wheel rule.
 * @returns {object|null} The matching rule object (with finalPriceCents) or null if no match.
 */
function checkForPreconfiguredMatch() {

    if (buildState.buildType !== 'Wheel Set') {
        return null;
    }

    const { frontRim, rearRim, frontHub, rearHub, frontSpokes, rearSpokes } = buildState.components;

    if (!frontRim || !rearRim || !frontHub || !rearHub) {
        return null;
    }

    const frontRimProduct = allRimProductsCache.find(p => p.id === frontRim.productId);
    const rearRimProduct = allRimProductsCache.find(p => p.id === rearRim.productId);

    const rulesToCheck = [];
    // Add context to the rules so we know which product they "live" on
    if (frontRimProduct?.preconfiguredRules?.length > 0) {
        rulesToCheck.push(...frontRimProduct.preconfiguredRules.map(rule => ({ ...rule, hostProductId: frontRimProduct.id })));
    }
    if (rearRimProduct?.preconfiguredRules?.length > 0) {
        rulesToCheck.push(...rearRimProduct.preconfiguredRules.map(rule => ({ ...rule, hostProductId: rearRimProduct.id })));
    }

    if (rulesToCheck.length === 0) {
        return null;
    }

    for (const rule of rulesToCheck) {
        console.log("  - Rule requires:", {
            pairedRim: rule.pairedRimProductId,
            frontHub: rule.requiredFrontHubProductId,
            rearHub: rule.requiredRearHubProductId,
            spokes: rule.requiredSpokeProductId,
            masterVariant: rule.masterVariantGid
        });
        
        const ruleRimIds = new Set([rule.hostProductId, rule.pairedRimProductId]);
        const selectedRimIds = new Set([frontRim.productId, rearRim.productId]);
        const rimMatch = ruleRimIds.size === selectedRimIds.size && [...ruleRimIds].every(id => selectedRimIds.has(id));
        
        const hubMatch = frontHub.productId === rule.requiredFrontHubProductId && rearHub.productId === rule.requiredRearHubProductId;
        
        let spokeMatch = true;
        if (rule.requiredSpokeProductId) {
            spokeMatch = frontSpokes?.productId === rule.requiredSpokeProductId && rearSpokes?.productId === rule.requiredSpokeProductId;
        }

        console.log(`  - Match Results: rim=${rimMatch}, hub=${hubMatch}, spoke=${spokeMatch}`);

        // PRECONFIGURED-RULES: optional exact colour / variant conditions; a rule without them is unchanged
        const extrasOk = window.PreconfiguredRules ? window.PreconfiguredRules.extrasMatch(rule, buildState.components, window.StandardStudio?.feeCents?.() || 0, buildState.specs) : true;

        // RELEASE 11: opened from a master's link, the master price needs the master's own nipples (a nipple swap = separate parts at parts prices)
        const nipplesOk = window.PreconfiguredRules && window.PreconfiguredRules.nipplesMatchLink ? window.PreconfiguredRules.nipplesMatchLink(rule, buildState.fullBuild && buildState.fullBuild.data, buildState.components) : true;

        if (rimMatch && hubMatch && spokeMatch && extrasOk && nipplesOk) {
            const finalPriceCents = preconfiguredPriceCache[rule.masterVariantGid];
            if (typeof finalPriceCents === 'number') {
                return { ...rule, finalPriceCents };
            } else {
            }
        }
    }

    return null;
}

// --- START: DYNAMIC LEAD TIME FUNCTIONS ---

// Converts a number of days into a user-friendly week-based range.
function formatLeadTime(totalDays) {
    if (totalDays <= 5) return "Approx. 1 Week";
    if (totalDays <= 7) return "Approx. 1-2 Weeks";
    if (totalDays <= 12) return "Approx. 2-3 Weeks";
    if (totalDays <= 17) return "Approx. 3-4 Weeks";
    if (totalDays <= 22) return "Approx. 4-5 Weeks";
    // For anything longer, calculate weeks and add a buffer.
    const weeks = Math.ceil(totalDays / 5); // Using 5 for business days
    return `Approx. ${weeks}-${weeks + 1} Weeks`;
}

// --- START: updateLeadTime function ---
function updateLeadTime() {
    let maxLeadTime = 0;
    const { components } = buildState;

    // This new version directly inspects the selected components in the buildState,
    // which now contain all the necessary info (quantityAvailable and leadTimeDays).
    Object.entries(components).forEach(([componentKey, component]) => {
        // Check if the component is a physical item with lead time info
        if (component && typeof component.quantityAvailable !== 'undefined' && typeof component.leadTimeDays !== 'undefined') {

            let componentLeadTime = 0;
            const stockAvailable = window.StandardStudio?.lineQuantityAvailable(componentKey) ?? component.quantityAvailable; // STANDARD-STUDIO: a custom wheel's spoke line is its most-used color, so that variant's stock counts

            // If the component is out of stock, use its defined lead time.
            if (stockAvailable <= 0) {
                componentLeadTime = component.leadTimeDays;
            }
            
            // Check if this component's lead time is the new maximum.
            if (componentLeadTime > maxLeadTime) {
                maxLeadTime = componentLeadTime;
            }
        }
    });

    // Add your standard in-house build time to the longest part lead time
    buildState.estimatedLeadTime = maxLeadTime + LEAD_TIME_CONFIG.BUILD_TIME_DAYS;
    
    // The display is handled by updateBuildSummary.
}
// --- END: updateLeadTime function ---

// This function needs to be called every time a component is added/removed.
// The easiest way is to add it to the functions that already run on component change.
function handleComponentChangeForLeadTime() {
    updateLeadTime();
    updateBuildSummary(); // This will re-render the summary with the new lead time.
}
// --- END: DYNAMIC LEAD TIME FUNCTIONS ---
  
// [START] updateBuildSummary (V4.4)
async function updateBuildSummary() {
    if (!summaryContainer || !subtotalValueElement || !summaryContentElement || !buildState) {
        if (summaryContentElement) summaryContentElement.innerHTML = '<p>Select options.</p>';
        if (subtotalValueElement) subtotalValueElement.textContent = formatPrice(0);
        return;
    }

    if (!buildState.buildType) {
        summaryContentElement.innerHTML = '<p>Select options.</p>';
        subtotalValueElement.textContent = formatPrice(0);
        return;
    }

    window.StandardStudio?.refresh(); // STANDARD-STUDIO: same refresh as updateSubtotal (the summary can be redrawn on its own)
    let totalCents = 0;

    const { components, buildType, selectedOptionalAddons } = buildState;
    const mainComponentKeys = ['Rim', 'Hub', 'Spokes', 'Nipples', 'ValveStem'];
    const positionsToProcess = [];
    if (buildType === 'Front' || buildType === 'Wheel Set') positionsToProcess.push('front');
    if (buildType === 'Rear' || buildType === 'Wheel Set') positionsToProcess.push('rear');

    // 1. Calculate Totals (Include EVERYTHING in the discountable total)
    positionsToProcess.forEach(pos => {
        // Add up component costs (This includes Integrated Rims)
        mainComponentKeys.forEach(typeKey => {
            const component = components[`${pos}${typeKey}`];
            if (component?.price) {
                totalCents += component.price;
            }
        });

        const assemblyService = components[`${pos}AssemblyService`];
        if (assemblyService?.costInCents) {
            totalCents += assemblyService.costInCents;
        }

        const requiredAddons = components[`${pos}RequiredAddons`];
        if (requiredAddons) {
            requiredAddons.forEach(addon => {
                if (addon?.costInCents) totalCents += addon.costInCents;
            });
        }
    });

    if (components.rearComponentFreehub?.price) totalCents += components.rearComponentFreehub.price;
    
    Object.values(selectedOptionalAddons).forEach(addon => {
        if (addon?.addonPriceCents) totalCents += addon.addonPriceCents;
    });
    
    const grossTotal = totalCents;

    // 2. Determine Discount Eligibility
    const preconfiguredMatch = checkForPreconfiguredMatch();
    let discountInfoHtml = '';
    let finalTotal = grossTotal;

    if (preconfiguredMatch && preconfiguredMatch.masterVariantGid) {
        const ssFeeCents = window.StandardStudio?.feeCents() || 0; // STANDARD-STUDIO: the Studio fee lines ride next to the master variant, undiscounted
        // PRECONFIGURED-RULES: valves: "extra" = the master price leaves out the valve stems; kept valves are charged at their normal price with the builder's 10% per line
        const precfgCounted = window.PreconfiguredRules ? window.PreconfiguredRules.countedItems(components, Object.keys(selectedOptionalAddons || {}).length, 0, preconfiguredMatch) : 0; // the eligible lines that will really be in the cart (the master line is not eligible)
        const valveX = window.PreconfiguredRules && window.PreconfiguredRules.valvesExtra(preconfiguredMatch) ? window.PreconfiguredRules.valveTotals(components, DISCOUNT_CONFIG.DISCOUNT_PERCENTAGE, precfgCounted) : { grossCents: 0, netCents: 0 };
        // PRECONFIGURED-RULES: a freehub body is not in the master price (freehubLine rules): a priced body is charged on top; it gets the 10% only once the cart has 8 eligible items
        const fhX = window.PreconfiguredRules ? window.PreconfiguredRules.freehubSurcharge(components, preconfiguredMatch, precfgCounted) : { cents: 0, netCents: 0, name: null };
        const finalPrice = preconfiguredMatch.finalPriceCents + ssFeeCents + valveX.netCents + fhX.netCents;
        const physicalTotal = calculatePhysicalPreconfiguredTotal() + valveX.grossCents; // already includes the required add-ons, so the fee lines are in it
        finalTotal = finalPrice;
        subtotalValueElement.innerHTML = `<strike>${formatPrice(physicalTotal)}</strike> <strong>${formatPrice(finalTotal)}</strong>`;
        discountInfoHtml = `<div class="summary-discount-info">✓ LOAMLABS Discount Automatically Applied</div>`;
        if (fhX.cents > 0) discountInfoHtml += `<div class="summary-discount-info">${window.PreconfiguredRules.freehubText(preconfiguredMatch.finalPriceCents, fhX, precfgCounted, formatPrice)}</div>`;
    } else {
        // --- CUSTOM DISCOUNT LOGIC ---
        // Calculate item count to determine eligibility for single wheels
        let itemCount = 0;
        positionsToProcess.forEach(pos => {
            ['Rim', 'Hub', 'Spokes', 'Nipples', 'ValveStem'].forEach(type => {
                const comp = components[`${pos}${type}`];
                // Only count if it exists and is not virtual. 
                // Integrated Rims count. Real Valve Stems count. Virtual Hubs do not.
                if (comp && !comp.isVirtual) {
                    itemCount++;
                }
            });
            if (components[`${pos}AssemblyService`]) itemCount++;
            // The Spoke Color Configuration fee lines (Standard and System) are not in the store's discount collections, so Shopify does not count them toward the 10%; neither does this estimate.
            if (components[`${pos}RequiredAddons`]) itemCount += components[`${pos}RequiredAddons`].filter(a => !(window.StandardStudio?.isDiscountExempt(a) || window.I9System?.isDiscountExempt(a))).length;
        });
        if (selectedOptionalAddons) itemCount += Object.keys(selectedOptionalAddons).length;
        
        let isDiscountActive = false;
        
        // Rule: Automatically active for Wheel Sets, OR if item threshold is met
        if (buildState.buildType === 'Wheel Set' && buildState.step === 3) {
             isDiscountActive = true;
        } else if (itemCount >= DISCOUNT_CONFIG.ITEM_COUNT_GOAL) { 
            isDiscountActive = true; 
        }
        
        window.I9System?.syncRimPairNotice?.(); // I9-SYSTEM: small notice when the rear wheel has a different rim because the front rim is 28h-only
        // I9-SYSTEM: SYSTEM10 needs 6 counted items from its collections (rims tagged system-discount / weareone / i9_system / industrynine+aluminumrim, System hubs and spokes). A rim with none of those tags is not counted, the minimum is not reached and Shopify gives no 10% at all: the estimate must not show one.
        if (isDiscountActive && window.I9System?.isSystem() && window.I9System.systemDiscountApplies && !window.I9System.systemDiscountApplies()) {
            isDiscountActive = false;
            discountInfoHtml = `<div class="summary-discount-info">The 10% System discount does not apply with a rim from another brand.</div>`;
        }
        if (isDiscountActive && totalCents > 0) {
            const discountName = window.I9System?.isSystem() ? DISCOUNT_CONFIG.SYSTEM_DISCOUNT_CODE : DISCOUNT_CONFIG.DISCOUNT_CODE; // I9-SYSTEM: a System build is discounted by SYSTEM10
            discountInfoHtml = `<div class="summary-discount-info">✓ ${discountName} Discount Applied (10% Off)</div>`; 
            
            // --- NEW: Line-by-Line Discount Math to Match Shopify ---
            let totalDiscountAmount = 0;
            const discountMultiplier = DISCOUNT_CONFIG.DISCOUNT_PERCENTAGE / 100;

            console.group(`%c[Discount Math Debug] Calculating 10% Discount`, 'background: #222; color: #bada55; font-size: 13px;');
            console.log("Item Name | Raw Price | Calculated Discount | Final Price");

            // Helper to calculate and round the discount for a specific price
            const applyLineItemDiscount = (name, price) => {
                if (!price || typeof price !== 'number') return;
                
                // Shopify truncates (Math.floor) the decimal on per-item percentage discounts!
                const lineDiscount = Math.floor(price * discountMultiplier); 
                totalDiscountAmount += lineDiscount;
                
                console.log(`${name.padEnd(25)} | $${(price/100).toFixed(2)} | $${(lineDiscount/100).toFixed(2)} | $${((price - lineDiscount)/100).toFixed(2)}`);
            };

            // Calculate discount for every component individually
            positionsToProcess.forEach(pos => {
                mainComponentKeys.forEach(typeKey => {
                    const component = components[`${pos}${typeKey}`];
                    if (component?.price) applyLineItemDiscount(`${pos} ${typeKey}`, component.price);
                });
                if (components[`${pos}AssemblyService`]?.costInCents) {
                    applyLineItemDiscount(`${pos} Assembly`, components[`${pos}AssemblyService`].costInCents);
                }
                if (components[`${pos}RequiredAddons`]) {
                    components[`${pos}RequiredAddons`].forEach(addon => {
                        if (window.I9System?.isDiscountExempt(addon)) return; // I9-SYSTEM: Shopify does not discount the Custom Spoke Color Configuration fee
                        if (window.StandardStudio?.isDiscountExempt(addon)) return; // STANDARD-STUDIO: same for the three Standard fee variants
                        if (addon?.costInCents) applyLineItemDiscount(`${pos} Addon: ${addon.name}`, addon.costInCents);
                    });
                }
            });

            if (components.rearComponentFreehub?.price) applyLineItemDiscount(`Rear Freehub`, components.rearComponentFreehub.price);
            
            Object.values(selectedOptionalAddons).forEach(addon => {
                if (addon?.addonPriceCents) applyLineItemDiscount(`Addon: ${addon.addonName}`, addon.addonPriceCents);
            });

            console.log(`------------------------------------------------`);
            console.log(`TOTAL GROSS: $${(grossTotal/100).toFixed(2)}`);
            console.log(`TOTAL DISCOUNT: $${(totalDiscountAmount/100).toFixed(2)}`);
            finalTotal = grossTotal - totalDiscountAmount;
            console.log(`FINAL NET: $${(finalTotal/100).toFixed(2)}`);
            console.groupEnd();
            // --- END NEW MATH ---

            subtotalValueElement.innerHTML = `<strike>${formatPrice(grossTotal)}</strike> <strong>${formatPrice(finalTotal)}</strong>`;
        } else {
            finalTotal = grossTotal;
            subtotalValueElement.textContent = formatPrice(grossTotal);
        }
    }
    
    buildState.subtotal = finalTotal;

    // Mirror Subtotal to Sticky Footer
    if (stickySubtotal && subtotalValueElement) {
        stickySubtotal.innerHTML = subtotalValueElement.innerHTML;
    }
    
    let componentsHtml = '';
    if (buildState.step >= 3) {
        componentsHtml = '<h4>Components</h4><ul>';
        const componentTypes = [ { type: 'Rim', display: 'Rim' }, { type: 'Hub', display: 'Hub' }, { type: 'Spokes', display: 'Spokes' }, { type: 'Nipples', display: 'Nipples' }, { type: 'ValveStem', display: 'Valve Stem' } ];
        
        componentTypes.forEach(compTypeInfo => {
            const frontComponent = components[`front${compTypeInfo.type}`];
            const rearComponent = components[`rear${compTypeInfo.type}`];

            if (buildType === 'Wheel Set' && frontComponent && rearComponent && frontComponent.variantId === rearComponent.variantId && !(compTypeInfo.type === 'Spokes' && window.I9System?.isSystem()) /* I9-SYSTEM: System spokes list per wheel (colors can differ) */ && !window.StandardStudio?.splitSpokes(compTypeInfo.type) /* STANDARD-STUDIO: a custom-colored wheel lists per wheel */) {
                const itemDescription = frontComponent.variantTitle ? `${frontComponent.title} (${frontComponent.variantTitle})` : frontComponent.title;
                const combinedPrice = frontComponent.price * 2;
                componentsHtml += `<li><span class="summary-item-label-column">Front/Rear ${compTypeInfo.display}:</span><span class="summary-item-description-column"><strong>(2) ${itemDescription || 'Selected'}</strong></span><span class="summary-value">(${formatPrice(combinedPrice)})</span></li>`;
            } else {
                if ((buildType === 'Front' || buildType === 'Wheel Set') && frontComponent) {
                    let itemDescription = frontComponent.variantTitle ? `${frontComponent.title} (${frontComponent.variantTitle})` : frontComponent.title;
                    itemDescription = window.I9System?.summaryDescription(compTypeInfo.type, frontComponent, 'front') ?? itemDescription; // I9-SYSTEM
                    itemDescription = window.StandardStudio?.summaryDescription(compTypeInfo.type, frontComponent, 'front') ?? itemDescription; // STANDARD-STUDIO
                    componentsHtml += `<li><span class="summary-item-label-column">Front ${compTypeInfo.display}:</span><span class="summary-item-description-column"><strong>(1) ${itemDescription || 'Selected'}</strong></span> <span class="summary-value">(${formatPrice(frontComponent.price)})</span></li>`;
                }
                if ((buildType === 'Rear' || buildType === 'Wheel Set') && rearComponent) {
                    let itemDescription = rearComponent.variantTitle ? `${rearComponent.title} (${rearComponent.variantTitle})` : rearComponent.title;
                    itemDescription = window.I9System?.summaryDescription(compTypeInfo.type, rearComponent, 'rear') ?? itemDescription; // I9-SYSTEM
                    itemDescription = window.StandardStudio?.summaryDescription(compTypeInfo.type, rearComponent, 'rear') ?? itemDescription; // STANDARD-STUDIO
                    componentsHtml += `<li><span class="summary-item-label-column">Rear ${compTypeInfo.display}:</span><span class="summary-item-description-column"><strong>(1) ${itemDescription || 'Selected'}</strong></span> <span class="summary-value">(${formatPrice(rearComponent.price)})</span></li>`;
                    if (compTypeInfo.type === 'Hub') {
                        const freehubComponent = components.rearComponentFreehub;
                        if (freehubComponent) {
                            componentsHtml += `<li class="summary-item-indented"><span class="summary-item-label-column"></span><span class="summary-item-description-column"><strong>(1) ${freehubComponent.name}</strong></span><span class="summary-value">(${formatPrice(freehubComponent.price)})</span></li>`;
                        }
                    }
                }
            }
        });
        componentsHtml += '</ul>';
    }

    let costsHtml = ''; 
    let hasAnyCostsOrServices = false;
    let totalAssemblyCostCents = 0;
    let frontAssemblyService, rearAssemblyService, frontTape = false, rearTape = false, frontBerdInserts, rearBerdInserts;

    if (buildType === 'Front' || buildType === 'Wheel Set') {
        frontAssemblyService = components.frontAssemblyService;
        if (frontAssemblyService?.costInCents) totalAssemblyCostCents += frontAssemblyService.costInCents;
        if (components.frontRim) frontTape = true;
        if (components.frontRequiredAddons?.length > 0) frontBerdInserts = components.frontRequiredAddons.find(a => a.name === 'Berd Hub Inserts');
    }
    if (buildType === 'Rear' || buildType === 'Wheel Set') {
        rearAssemblyService = components.rearAssemblyService;
        if (rearAssemblyService?.costInCents) totalAssemblyCostCents += rearAssemblyService.costInCents;
        if (components.rearRim) rearTape = true;
        if (components.rearRequiredAddons?.length > 0) rearBerdInserts = components.rearRequiredAddons.find(a => a.name === 'Berd Hub Inserts');
    }

    if (totalAssemblyCostCents > 0 || (buildState.step === 3 && (components.frontRim || components.rearRim || components.frontHub || components.rearHub))) {
        costsHtml = '<h4>Assembly & Specialized Parts</h4><ul>';
        let assemblyLabelPrefix = ""; let assemblyQty = 0;
        if (buildState.buildType === 'Wheel Set' && (frontAssemblyService || rearAssemblyService)) { assemblyLabelPrefix = "Front/Rear:"; if (frontAssemblyService) assemblyQty++; if (rearAssemblyService) assemblyQty++; }
        else if (buildState.buildType === 'Front' && frontAssemblyService) { assemblyLabelPrefix = "Front:"; assemblyQty = 1; }
        else if (buildState.buildType === 'Rear' && rearAssemblyService) { assemblyLabelPrefix = "Rear:"; assemblyQty = 1; }
        const assemblyQtyDisplay = assemblyQty > 0 ? `(${assemblyQty}) ` : '';
        costsHtml += `<li><span class="summary-item-label-column">${assemblyLabelPrefix}</span><span class="summary-item-description-column"><strong>${assemblyQtyDisplay}Assembly Service</strong></span> <span class="summary-value">${totalAssemblyCostCents > 0 ? `(${formatPrice(totalAssemblyCostCents)})` : '($0.00)'}</span></li>`;
        hasAnyCostsOrServices = true;
    }

    let tapeLabel = ""; let tapeQty = 0;
    if (buildType === 'Wheel Set' && frontTape && rearTape) { tapeLabel = "Front/Rear:"; tapeQty = 2; }
    else if (frontTape) { tapeLabel = "Front:"; tapeQty = 1; }
    else if (rearTape) { tapeLabel = "Rear:"; tapeQty = 1; }
    if (tapeQty > 0) {
        if (!costsHtml) costsHtml = '<h4>Assembly & Specialized Parts</h4><ul>';
        const isChecked = buildState.tubelessTapeInstalled ? 'checked' : '';
        const isUncheckedClass = buildState.tubelessTapeInstalled ? '' : 'is-not-included';
        const TAPE_WEIGHT_DISPLAY = tapeQty * 10;
        const tapeDescription = `(${tapeQty}) Tubeless Tape (Installed) - Wt: ${TAPE_WEIGHT_DISPLAY}g`;
        const tapeDescriptionHtml = buildState.tubelessTapeInstalled ? `<strong>${tapeDescription}</strong>` : tapeDescription;
        const tapeHtml = `<li class="${isUncheckedClass}"><span class="summary-item-label-column">${tapeLabel}</span><span class="summary-item-description-column"><label for="tubeless-tape-toggle-checkbox" style="cursor: pointer; display: inline-flex; align-items: center; user-select: none;"><span>${tapeDescriptionHtml}</span><input type="checkbox" id="tubeless-tape-toggle-checkbox" ${isChecked} style="margin-left: 10px; flex-shrink: 0;"></label></span><span class="summary-value">($0.00)</span></li>`;
        costsHtml += tapeHtml;
        hasAnyCostsOrServices = true;
    }

    let berdLabel = ""; let berdDescription = ""; let berdPriceCents = 0;
    if (buildType === 'Wheel Set' && frontBerdInserts && rearBerdInserts) { berdLabel = "Front/Rear:"; berdDescription = "<strong>(2) Berd hub inserts (Required)</strong>"; berdPriceCents = frontBerdInserts.costInCents + rearBerdInserts.costInCents; }
    else if (frontBerdInserts) { berdLabel = "Front:"; berdDescription = "<strong>(1) Berd hub inserts (Required)</strong>"; berdPriceCents = frontBerdInserts.costInCents; }
    else if (rearBerdInserts) { berdLabel = "Rear:"; berdDescription = "<strong>(1) Berd hub inserts (Required)</strong>"; berdPriceCents = rearBerdInserts.costInCents; }
    if (berdDescription) {
        if (!costsHtml) costsHtml = '<h4>Assembly & Specialized Parts</h4><ul>';
        costsHtml += `<li><span class="summary-item-label-column">${berdLabel}</span><span class="summary-item-description-column">${berdDescription}</span> <span class="summary-value">(${formatPrice(berdPriceCents)})</span></li>`;
        hasAnyCostsOrServices = true;
    }
    // I9-SYSTEM: "Custom Spoke Color Configuration" fee rows (one per custom wheel)
    const i9FeeRowsHtml = (window.I9System?.summaryFeeRows?.() || '') + (window.StandardStudio?.summaryFeeRows?.() || ''); // STANDARD-STUDIO: the Standard fee rows (empty for System builds)
    if (i9FeeRowsHtml) {
        if (!costsHtml) costsHtml = '<h4>Assembly & Specialized Parts</h4><ul>';
        costsHtml += i9FeeRowsHtml;
        hasAnyCostsOrServices = true;
    }
    if (hasAnyCostsOrServices) { costsHtml += '</ul>'; } else { costsHtml = ''; }
    
    let optionalAddonsHtml = '';
    if (selectedOptionalAddons && Object.keys(selectedOptionalAddons).length > 0) {
        optionalAddonsHtml = '<h4>Optional Add-ons</h4><ul>';
        const consolidatedAddons = {};
        Object.values(selectedOptionalAddons).forEach(addon => {
            const key = addon.addonVariantId; if (!key) return;
            if (!consolidatedAddons[key]) {
                consolidatedAddons[key] = { name: addon.addonName, price: addon.addonPriceCents, baseComponentType: addon.baseComponentType, positions: new Set(), count: 0 };
            }
            consolidatedAddons[key].count++; consolidatedAddons[key].positions.add(addon.baseComponentPosition);
        });
        const sortedConsolidatedAddons = Object.values(consolidatedAddons).sort((a, b) => a.name.localeCompare(b.name));
        sortedConsolidatedAddons.forEach(item => {
            const positionsArray = Array.from(item.positions); let positionLabelText = (positionsArray.length > 1) ? "Front/Rear" : positionsArray[0];
            const baseTypeDisplayName = getDisplayName(item.baseComponentType.toLowerCase()); const fullLabel = `${positionLabelText} ${baseTypeDisplayName}:`;
            const itemDescription = item.name; const quantityDisplay = `(${item.count})`; const totalCost = item.price * item.count;
            optionalAddonsHtml += `<li class="summary-item-indented"><span class="summary-item-label-column">${fullLabel}</span><span class="summary-item-description-column"><strong>${quantityDisplay} ${itemDescription}</strong></span><span class="summary-value">(${formatPrice(totalCost)})</span></li>`;
        });
        optionalAddonsHtml += '</ul>';
    }

    let leadTimeHtml = '';
    if (buildState.step === 3 && buildState.estimatedLeadTime > 0) {
        leadTimeHtml = `<div class="summary-lead-time-info">Estimated Build Time: <strong>${formatLeadTime(buildState.estimatedLeadTime)}</strong></div>`;
    }

    summaryContentElement.innerHTML = '' + componentsHtml + costsHtml + optionalAddonsHtml + leadTimeHtml;

    const buildSummaryElement = document.getElementById('build-summary');
    if (buildSummaryElement) {
        let discountContainer = buildSummaryElement.querySelector('.summary-discount-container');
        if (!discountContainer) {
            discountContainer = document.createElement('div');
            discountContainer.className = 'summary-discount-container';
            buildSummaryElement.appendChild(discountContainer);
        }
        discountContainer.innerHTML = discountInfoHtml;
    }

    const estimatedWeightValueElement = document.getElementById('estimated-weight-value');
    if (estimatedWeightValueElement) {
        const calculatedWeights = calculateTotalEstimatedWeight();
        if (calculatedWeights.total > 0) {
            let weightHtml = `<strong>${Math.round(calculatedWeights.total)} g</strong>`;
            if (buildType === 'Wheel Set' && calculatedWeights.front > 0 && calculatedWeights.rear > 0) {
                weightHtml += `<div style="font-size: 0.85em; font-style: italic; color: #666; margin-top: 2px;">(Front: ${Math.round(calculatedWeights.front)}g | Rear: ${Math.round(calculatedWeights.rear)}g)</div>`;
            }
            estimatedWeightValueElement.innerHTML = weightHtml;
            // --- Update Sticky Weight ---
            if (stickyWeight) stickyWeight.textContent = `${Math.round(calculatedWeights.total)} g`;
        } else {
            estimatedWeightValueElement.textContent = '-- g';
            if (stickyWeight) stickyWeight.textContent = '-- g';
        }
    }
}
// [END] updateBuildSummary

async function showStep(stepNumber, options = {}) {
    console.log(`--> showStep Function Entered. Requested step: ${stepNumber}`);
    if (!builderContainer) { console.error("showStep: Builder container missing!"); return; }
    buildState.step = stepNumber;
    if (stepNumber >= 2) window.I9System?.ensureFreshCaches(); // I9-SYSTEM: a build loaded from another context (classic vs System, other hub model) must not use the previous context's product caches

    // --- NAVIGATION VISIBILITY RESET ---
    const nav1 = document.querySelector('.nav-step-1');
    const nav23 = document.querySelector('.nav-step-2-3');
    const navBottom3 = document.querySelector('.nav-bottom-step3');
    
    if (nav1) nav1.style.display = 'none';
    if (nav23) nav23.style.display = 'none';
    if (navBottom3) navBottom3.style.display = 'none';
    if (stickyFooter) stickyFooter.style.display = 'none';
    if (builderContainer) builderContainer.classList.remove('has-sticky-footer');

    builderContainer.querySelectorAll('.builder-step').forEach(step => { step.style.display = 'none'; });
    const targetStepElement = document.getElementById(`step-${stepNumber}`);
    
    if (targetStepElement) {
        targetStepElement.style.display = 'flex';
        
        // Show correct Nav Bar
        if (stepNumber === 1 && nav1) nav1.style.display = 'flex';
        if (stepNumber === 2 && nav23) nav23.style.display = 'flex';

        const stepHeader = targetStepElement.querySelector('h2');
        if (stepHeader && !options.skipScroll) {
            setTimeout(() => {
                stepHeader.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 50);
        }
    } else {
        console.error(`showStep: Step element step-${stepNumber} not found!`);
        return;
    }

    if (stepNumber !== 3 && buildState._ui.isChangingComponent) {
        cancelComponentChange();
    }
    if (stepNumber > 1) {
        buildState._ui.hasProgressedPastStep1 = true;
    }
    const step1ResetBtn = document.getElementById('step-1-reset-button');
    if (step1ResetBtn) {
        step1ResetBtn.style.display = (buildState._ui.hasProgressedPastStep1 && stepNumber === 1) ? '' : 'none';
    }

    try {
        if (stepNumber === 1) {
            updateStep1VisualFeedback();
            validateStep1();
        } else if (stepNumber === 2) {
            renderStep2();
            updateStep2OptionsVisibility();
            updateStep2VisualFeedback();
            validateStep2();
            window.PresetBuilds?.afterStep2Render(); // PRESET-BUILDS: lock the page's choices, drop the ones the builder does not offer

            // Dynamic Discovery Update
            Promise.all([componentFetchPromises.rims, componentFetchPromises.hubs]).then(() => {
                if (buildState.step === 2) {
                    console.log("[Data Ready] Re-rendering Step 2 Discovery.");
                    renderStep2();
                    updateStep2OptionsVisibility(); 
                    updateSpecAvailabilityCounters(); 
                    window.PresetBuilds?.afterStep2Render(); // PRESET-BUILDS
                }
            });
        } else if (stepNumber === 3) {
            console.log("showStep(3): Starting sequential build of Step 3 content.");
            syncValveColors(); // valve stem colors for the wheel pictures (resume, edit from cart, presets, share links)
            
            // UI Controls Visibility
            if (builderSaveLoadControls) builderSaveLoadControls.style.display = 'flex';
            if (navBottom3) navBottom3.style.display = 'flex';
            if (stickyFooter) stickyFooter.style.display = 'block';
            if (builderContainer) builderContainer.classList.add('has-sticky-footer');

            // Full Screen Overlay Logic
            if (step3RefreshOverlay) {
    if (!options.isRefreshing) {
        step3RefreshOverlay.style.display = 'flex';
    } else {
        step3RefreshOverlay.style.display = 'none';
    }
}
           
            renderStep3();
            renderQuickSpecAdjusters();
            updateComponentHeaderSpecs();

            // Fetch and Filter All Categories
            await loadAndFilterRims();
            await cachePreconfiguredPrices();
            await loadAndFilterHubs();
            await loadAndFilterSpokes();
            await loadAndFilterNipples();
            await loadAndFilterValveStems();

            if (!options.skipRevalidation) {
                await revalidateAllStep3Selections();
            }

            if (buildState.preset && !options.skipPreset) await window.PresetBuilds?.applyAtStep3(); // PRESET-BUILDS: rims, hubs and colors from a product page
            if (buildState.fullBuild && !options.skipPreset) await window.FullBuild?.applyAtStep3(); // FULL-BUILD-LINK: all parts of a LoamLabs preconfigured build

            // --- START: PRODUCT PAGE FUNNEL LOGIC (STARTCOMPONENT) ---
            if (buildState.startComponent && !buildState.startComponent.processed) {
              const { variantId, type } = buildState.startComponent;
              let { position } = buildState.startComponent;
              let productCache = type === 'hub' ? allHubProductsCache : allRimProductsCache;
              const originalProduct = productCache?.find(p => p.variants.some(v => v.id === variantId));

              if (originalProduct) {
                if (position === 'front/rear') position = 'front';
                const positionsToSelectIn = (type === 'rim' && buildState.buildType === 'Wheel Set') ? ['Front', 'Rear'] : [position.charAt(0).toUpperCase() + position.slice(1)];
                
                positionsToSelectIn.forEach(pos => {
                  const posLower = pos.toLowerCase();
                  const currentSpecs = {
                      spokeCount: buildState.specs[`${posLower}SpokeCount`],
                      wheelSize: buildState.specs[`${posLower}WheelSize`],
                      hubSpacing: buildState.specs[`${posLower}HubSpacing`],
                      brakeStyle: buildState.specs.brakeStyle
                  };

                  let variantToClickId = null;
                  const isVariantCompatible = (v) => {
                      if (!v || !v.availableForSale) return false;
                      if (type === 'rim') {
                          const sizeVal = v.spec_rim_size?.parsedValue;
                          const sizeMatch = Array.isArray(sizeVal) ? sizeVal.includes(currentSpecs.wheelSize) : sizeVal === currentSpecs.wheelSize;
                          return String(v.spec_spoke_count) === String(currentSpecs.spokeCount) && sizeMatch;
                      }
                      return String(v.spec_spoke_count) === String(currentSpecs.spokeCount) && v.spec_hub_spacing === currentSpecs.hubSpacing && (v.spec_brake_interface || []).includes(currentSpecs.brakeStyle);
                  };

                  const originalVariantNode = originalProduct.variants.find(v => v.id === variantId);
                  if (isVariantCompatible(originalVariantNode)) variantToClickId = variantId;
                  else {
                      const originalColor = originalVariantNode?.selectedOptions.find(opt => opt.name.toLowerCase() === 'color')?.value;
                      let fallback = originalProduct.variants.find(v => isVariantCompatible(v) && v.selectedOptions.find(o => o.name.toLowerCase() === 'color')?.value === originalColor);
                      if (!fallback) fallback = originalProduct.variants.find(isVariantCompatible);
                      if (fallback) variantToClickId = fallback.id;
                  }

                  if (variantToClickId) {
                      const vendorButton = document.querySelector(`.vendor-filter-btn[data-position="${pos}"][data-vendor="${originalProduct.vendor}"]`);
                      if (vendorButton) {
                          vendorButton.click();
                          setTimeout(() => {
                              const modelCard = document.querySelector(`#${posLower}-${type}-options-container .component-product-card[data-model-name="${originalProduct.wheelModel}"]`);
                              if (modelCard) modelCard.querySelector('.product-card-header')?.click();
                              setTimeout(() => {
                                  document.querySelector(`.component-variant-button[data-variant-id="${variantToClickId}"]`)?.click();
                              }, 150);
                          }, 150);
                      }
                  }
                });
              }
              buildState.startComponent.processed = true;
            }
            // --- END: FUNNEL LOGIC ---

            await applyCustomerSuppliedSelections();
            if (window.I9System?.isSystem()) await window.I9System.afterStep3Render(); // I9-SYSTEM: default base color, previews, Studio block, hub color sync
            else window.StandardStudio?.afterStep3Render(); // STANDARD-STUDIO: repair loaded painting, redraw the per-wheel cards

            if (buildState.buildType === 'Front' || buildState.buildType === 'Wheel Set') calculateWheelCosts('Front');
            if (buildState.buildType === 'Rear' || buildState.buildType === 'Wheel Set') calculateWheelCosts('Rear');

            validateStep3();
            updateStep3ButtonText();
            updateBuildSummary();
            if (typeof updateQuickBuildAvailability === 'function') updateQuickBuildAvailability();
            if (step3RefreshOverlay) step3RefreshOverlay.style.display = 'none';
        }

        if (stepNumber > 1) {
            saveLastActiveBuild();
        }

    } catch (error) {
        console.error(`showStep: Error during setup for step ${stepNumber}:`, error);
        displayInitializationError(`Runtime Error during step ${stepNumber} setup: ${error.message}`);
    }
  
    console.log(`<-- showStep Function Exited for step ${stepNumber}.`);
}
  
    function updateStep1VisualFeedback(gT=null, selB=null){ console.log(`updateStep1VisualFeedback called. GroupType: ${gT}, SelectedButton provided: ${!!selB}`); const c=document.getElementById('step-1'); if(!c) { console.error("updateStep1VisualFeedback: Step 1 container not found."); return; } if(gT && selB){ c.querySelectorAll(`button[data-selection-type="${gT}"]`).forEach(b => { const isActive = b === selB; b.classList.toggle('active', isActive); }); } else { console.log("  - Updating all Step 1 buttons based on current buildState."); c.querySelectorAll('button[data-selection-type]').forEach(b => { const type = b.dataset.selectionType; const value = b.dataset.value; const isActive = buildState[type] === value; b.classList.toggle('active', isActive); }); } window.I9System?.syncStep1UI(); /* I9-SYSTEM: lock/unlock Riding Style, hide customer-supplied for System */ }
    function validateStep1(){ const ridingStyleSelected = !!buildState.ridingStyle; const buildTypeSelected = !!buildState.buildType; const spokeInterfaceSelected = !!buildState.spokeInterface; /* I9-SYSTEM: the Spoke Interface must be chosen too */ const isValid = ridingStyleSelected && buildTypeSelected && spokeInterfaceSelected; console.log(`validateStep1: Riding Style = ${buildState.ridingStyle}, Build Type = ${buildState.buildType}, Spoke Interface = ${buildState.spokeInterface}, isValid = ${isValid}`); if(step1NextButton) { step1NextButton.disabled = !isValid; } else { console.warn("validateStep1: step1NextButton not found."); } return isValid; }

function updateCustomerSuppliedCheckboxesVisibility() {
  const section = document.getElementById('customer-supplied-section');
  if (!section) {
    // This guard is important. If the section isn't in the DOM yet, do nothing.
    return;
  }

  // Part 1: Handle the enabled/disabled state.
  const isEnabled = buildState.ridingStyle && buildState.buildType;
  section.classList.toggle('is-disabled', !isEnabled);

  // Part 2: Handle showing/hiding individual labels based on build type.
  // This logic now correctly handles the case where buildType is null (show all).
  const showFront = !buildState.buildType || buildState.buildType.includes('Front') || buildState.buildType.includes('Set');
  const showRear = !buildState.buildType || buildState.buildType.includes('Rear') || buildState.buildType.includes('Set');

  // Use safer queries that check for element existence before trying to set style.
  const frontRimLabel = section.querySelector('.customer-supplied-checkbox[data-position="front"][data-component="rim"]')?.parentElement;
  if (frontRimLabel) frontRimLabel.style.display = showFront ? '' : 'none';

  const frontHubLabel = section.querySelector('.customer-supplied-checkbox[data-position="front"][data-component="hub"]')?.parentElement;
  if (frontHubLabel) frontHubLabel.style.display = showFront ? '' : 'none';

  const rearRimLabel = section.querySelector('.customer-supplied-checkbox[data-position="rear"][data-component="rim"]')?.parentElement;
  if (rearRimLabel) rearRimLabel.style.display = showRear ? '' : 'none';

  const rearHubLabel = section.querySelector('.customer-supplied-checkbox[data-position="rear"][data-component="hub"]')?.parentElement;
  if (rearHubLabel) rearHubLabel.style.display = showRear ? '' : 'none';
}
  
    function updateMtbWheelSizeCompatibility() {
    const c = document.getElementById('step-2');
    if (!c) return;
    c.querySelectorAll('.spec-option-button').forEach(b => b.classList.remove('is-incompatible'));
    if (window.I9System?.isSystem()) { window.I9System.onSizeCompat(c); return; } // I9-SYSTEM: the pairing matrix (29"/700c mix, mullet) replaces the classic 27.5"/29" rule for System builds
    if (buildState.ridingStyle !== 'mtb' || buildState.buildType !== 'Wheel Set') return;

    const frontSize = buildState.specs.frontWheelSize;
    const rearSize = buildState.specs.rearWheelSize;

    // Use double-escaped backslashes for the inch symbol
    const f27Btn = c.querySelector('button[data-spec-group="frontWheelSize"][data-value="27.5\\""]');
    const r29Btn = c.querySelector('button[data-spec-group="rearWheelSize"][data-value="29\\""]');

    if (frontSize === '27.5"') r29Btn?.classList.add('is-incompatible');
    if (rearSize === '29"') f27Btn?.classList.add('is-incompatible');
}
    function updateStep2VisualFeedback() {
    const c = document.getElementById('step-2');
    if (!c) return;

    c.querySelectorAll('.spec-group.selection-row:not([style*="display: none"])').forEach(row => {
        const stateSpecKey = row.dataset.specName;
        if (!stateSpecKey) return;

        row.querySelectorAll('button.spec-option-button').forEach(btn => {
            const btnValue = btn.dataset.value;
            const currentValueInState = buildState.specs[stateSpecKey];
            
            // Highlight the button if it matches the current state
            btn.classList.toggle('active', btnValue === currentValueInState);
        });
    });
}
    
    function renderStep2() {
    const sC = document.getElementById('step-2-spec-container');
    if (!sC || !buildState.buildType) return;
    const bT = buildState.buildType;

    // Handle Row Visibility
    sC.querySelectorAll('.spec-group.selection-row').forEach(g => {
        const f = g.dataset.buildTypeFilter;
        let s = f ? f.split('|').includes(bT) : true;
        
        // --- ADD THIS SAFETY CHECK ---
        // Force Freehub Type to hide if the build is Front-only
        if (g.dataset.specName === 'freehubType' && bT === 'Front') {
            s = false;
        }
        // ------------------------------

        g.style.display = s ? 'flex' : 'none';
    });
    window.I9System?.syncStep2UI(); // I9-SYSTEM: Hub row visibility, brake lock, no Rim Brake, rows wait for a hub model

    // Populate Buttons (Standard ones show immediately, niche ones show after cache fills)
    if (bT === 'Front' || bT === 'Wheel Set') {
        generateDynamicWheelSizeButtons('front');
        generateDynamicSpokeButtons('front');
        generateDynamicHubSpacingButtons('front');
    }
    if (bT === 'Rear' || bT === 'Wheel Set') {
        generateDynamicWheelSizeButtons('rear');
        generateDynamicSpokeButtons('rear');
        generateDynamicHubSpacingButtons('rear');
    }

    validateStep2();
    updateSpecAvailabilityCounters(); // This fills the loading bubbles with numbers
}

function updateFreehubLockUI() {
    const step2Container = document.getElementById('step-2');
    if (!step2Container) return;
    window.I9System?.syncFreehubButtons(); // I9-SYSTEM: System builds offer the freehubs listed on the chosen spacing's hub variants (runs on every Step 2 click)
    
    const freehubRow = step2Container.querySelector('.spec-group.selection-row[data-spec-name="freehubType"]');
    if (freehubRow && (buildState.buildType === 'Rear' || buildState.buildType === 'Wheel Set')) {
        const prerequisitesMet = buildState.specs.brakeStyle && buildState.specs.rearWheelSize && buildState.specs.rearSpokeCount && buildState.specs.rearHubSpacing;
        const freehubOptionsContainer = freehubRow.querySelector('.spec-options');
        const freehubButtons = freehubRow.querySelectorAll('button.spec-option-button');
        
        let overlay = freehubOptionsContainer.querySelector('.freehub-lock-overlay');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.className = 'freehub-lock-overlay';
            freehubOptionsContainer.style.position = 'relative'; // Anchors the overlay
            freehubOptionsContainer.appendChild(overlay);
        }
        
        if (!prerequisitesMet) {
            // STATE 1: Waiting for user to select above specs
            freehubButtons.forEach(btn => btn.style.pointerEvents = 'none');
            overlay.innerHTML = "<span>Please make all selections above first</span>";
            overlay.style.display = 'flex';
            
            // Automatically clear the freehub selection if the user backtracks
            if (buildState.specs.freehubType !== null) {
                buildState.specs.freehubType = null;
                updateStep2VisualFeedback(); // Force UI refresh if cleared
            }
        } else if (allHubProductsCache.length === 0) {
            // STATE 2: Prerequisites met, but data is still downloading from Shopify
            freehubButtons.forEach(btn => btn.style.pointerEvents = 'none');
            overlay.innerHTML = '<div class="loading-spinner" style="width: 20px; height: 20px; border-width: 3px; margin-right: 10px; border-top-color: #007bff;"></div><span>Loading freehub data...</span>';
            overlay.style.display = 'flex';
        } else {
            // STATE 3: Unlocked and ready
            freehubButtons.forEach(btn => btn.style.pointerEvents = ''); 
            overlay.style.display = 'none';
        }
    }
}

function updateStep2OptionsVisibility() {
    const step2Container = document.getElementById('step-2');
    const ridingStyle = buildState.ridingStyle;
    if (!step2Container || !ridingStyle) {
        return;
    }
    let stateChanged = false;

    step2Container.querySelectorAll('.spec-group.selection-row:not([style*="display: none"])').forEach(groupElement => {
        const optionButtons = groupElement.querySelectorAll('button[data-spec-group][data-riding-style]');
        if (optionButtons.length === 0) return;

        const stateSpecKey = groupElement.dataset.specName;
        if (!stateSpecKey) return;

        let visibleOptions = [];
        optionButtons.forEach(buttonElement => {
            const supportedStyles = buttonElement.dataset.ridingStyle.split('|');
            
            // If ridingStyle is 'hybrid', force visibility (isVisible = true).
            // Otherwise, check if the button's supported styles include the current style.
            const isVisible = ridingStyle === 'hybrid' || supportedStyles.includes(ridingStyle) || supportedStyles.includes('both');

            buttonElement.style.display = isVisible ? '' : 'none';
            if (isVisible) {
                visibleOptions.push(buttonElement);
            } else if (buildState.specs[stateSpecKey] === buttonElement.dataset.value) {
                // If the currently selected option becomes invisible (e.g. switching from Hybrid back to MTB), clear it.
                buildState.specs[stateSpecKey] = null;
                if (buildState._ui.step2AutoSelected[stateSpecKey] === buttonElement.dataset.value) {
                    delete buildState._ui.step2AutoSelected[stateSpecKey];
                }
                stateChanged = true;
            }
        });

        // Auto-selection logic
        if (visibleOptions.length === 1 && buildState.specs[stateSpecKey] === null) {
            const singleButton = visibleOptions[0];
            const singleValue = singleButton.dataset.value;

            console.log(`Auto-selecting for ${stateSpecKey}: ${singleValue}`);
            buildState.specs[stateSpecKey] = singleValue;
            buildState._ui.step2AutoSelected[stateSpecKey] = singleValue;
            stateChanged = true;

            // We only auto-sync wheel size for gravel/road wheelsets. Hub spacing is ALWAYS independent.
            if (buildState.buildType === 'Wheel Set' && buildState.ridingStyle === 'gravelroad') {
                const isWheelSize = stateSpecKey === 'frontWheelSize' || stateSpecKey === 'rearWheelSize';
                if (isWheelSize) {
                    const oppositeKey = stateSpecKey === 'frontWheelSize' ? 'rearWheelSize' : 'frontWheelSize';
                    if(buildState.specs[oppositeKey] === null) {
                        buildState.specs[oppositeKey] = singleValue;
                    }
                }
            }
        }
    });

    if (ridingStyle === 'mtb') {
        updateMtbWheelSizeCompatibility();
    }
    window.I9System?.syncStep2UI(); // I9-SYSTEM: re-hide Rim Brake etc. after the generic visibility pass

    updateFreehubLockUI(); // Evaluates the lock when Step 2 loads

    if (stateChanged) {
        updateStep2VisualFeedback();
        validateStep2();
        updateBuildSummary();
        saveLastActiveBuild();
        window.I9System?.afterAutoSelect(); // I9-SYSTEM: a single-option auto-select (e.g. Solix 24h) recounts every row like a manual click
    }
}

function validateStep2() {
    let isValid = true;
    const { specs, buildType } = buildState;
    if (!specs || !buildType) return false;

    // 1. Check all selections exist
    if ((buildType === 'Front' || buildType === 'Wheel Set') && (!specs.frontWheelSize || !specs.frontSpokeCount || !specs.frontHubSpacing)) isValid = false;
    if ((buildType === 'Rear' || buildType === 'Wheel Set') && (!specs.rearWheelSize || !specs.rearSpokeCount || !specs.rearHubSpacing || !specs.freehubType)) isValid = false;
    if (!specs.brakeStyle) isValid = false;

    // 2. CRITICAL SAFETY GATE: Block "Next" if current build results in 0 components
    if (isValid) {
        const activeBubbles = document.querySelectorAll('button.spec-option-button.active .spec-count-bubble');
        activeBubbles.forEach(bbl => {
            if (bbl.classList.contains('is-zero')) {
                isValid = false;
                console.log(`[Validation] Blocking Next: Selection resulted in 0 availability.`);
            }
        });
    }

    // STEP2-NEEDS: assets/step2-needs-selection.js marks the missing rows and makes the Next button say what is missing (aria-disabled,
    // clickable, never navigates); without it the classic disabled attribute applies as before.
    if (window.Step2Needs) window.Step2Needs.applyNext(isValid); else if (step2NextButton) step2NextButton.disabled = !isValid;
    return isValid;
}

// --- START: PATH-AWARE COUNTERS (V5.4 - Cross Component) ---
function updateSpecAvailabilityCounters() {
    const buttons = document.querySelectorAll('button.spec-option-button[data-spec-group]');
    const { specs, buildType } = buildState;
    const hubsLoaded = allHubProductsCache.length > 0;
    const rimsLoaded = allRimProductsCache.length > 0;

    buttons.forEach(btn => {
        const group = btn.dataset.specGroup;
        const value = btn.dataset.value;
        const pos = (group.startsWith('rear') || buildType === 'Rear') ? 'Rear' : 'Front';
        
        let count = null;
        let bubbleClass = '';

        if (!rimsLoaded || !hubsLoaded) {
            count = "loading";
        } else {
                // Build hypothetical specs if this button were clicked
                const testSpecs = { ...specs, [group]: value };

                if (group === 'freehubType' || group === 'freehub') {
                    const { hubCount } = getValidCountsForPos(testSpecs, 'Rear');
                    btn.classList.toggle('is-unavailable', hubCount === 0);
                    count = hubCount; // Pass the count down to the UI phase so it cleans the bubble!
                } else if (group.toLowerCase().includes('size')) {
                    bubbleClass = 'is-rim';
                count = getValidCountsForPos(testSpecs, pos).rimCount;
            } else if (group.includes('HubSpacing')) {
                bubbleClass = 'is-hub';
                count = getValidCountsForPos(testSpecs, pos).hubCount;
            } else {
                // Joint Dependencies (Brake Style & Spoke Count)
                bubbleClass = group === 'brakeStyle' ? 'is-hub' : 'is-rim';
                if (group === 'brakeStyle' && buildType === 'Wheel Set') {
                    const fCounts = getValidCountsForPos(testSpecs, 'Front');
                    const rCounts = getValidCountsForPos(testSpecs, 'Rear');
                    count = Math.min(fCounts.rimCount, fCounts.hubCount, rCounts.rimCount, rCounts.hubCount);
                } else {
                    const counts = getValidCountsForPos(testSpecs, pos);
                    count = Math.min(counts.rimCount, counts.hubCount);
                }
            }
            btn.classList.toggle('is-unavailable', count === 0);
        }

        // --- UI DRAWING ---
            let bbl = btn.querySelector('.spec-count-bubble');

            if (group.includes('SpokeCount') || group === 'brakeStyle' || group === 'freehubType' || group === 'freehub' || group === 'systemHub' /* I9-SYSTEM */) {
                if (bbl) bbl.remove(); // Destroys the orphaned loading bubble!
                if (count === 0) {
                    const posPrefix = (group === 'brakeStyle' || group === 'freehubType' || group === 'freehub') ? '' : `${pos} `;
                    btn.title = `0 ${posPrefix}options available. Try adjusting other specs.`;
                } else {
                    btn.removeAttribute('title');
                }
                return; 
            }

        if (count !== null) {
            if (!bbl) { 
                bbl = document.createElement('span'); 
                btn.appendChild(bbl); 
            }
            
            let compType = bubbleClass === 'is-rim' ? 'Rims' : 'Hubs';
            if (count === "loading") bbl.title = "Calculating compatible options...";
            else if (count === 0) bbl.title = `0 ${pos} ${compType} available. Try adjusting other specs.`;
            else if (count === 1) bbl.title = `1 ${pos} ${compType.slice(0, -1)} available with your current specs.`;
            else bbl.title = `${count} ${pos} ${compType} available with your current specs.`;

            if (count === "loading") {
                bbl.className = 'spec-count-bubble is-loading';
                bbl.textContent = '';
            } else {
                bbl.className = `spec-count-bubble ${bubbleClass}`;
                bbl.textContent = count;
                bbl.classList.toggle('is-zero', count === 0);
            }
        } else if (bbl) bbl.remove();
    });

    validateStep2();
}
// --- END: PATH-AWARE COUNTERS (V5.4) ---


/**
 * Helper to manage individual bubble elements
 */
function updateSingleBubble(parentBtn, type, count) {
    const className = `spec-count-${type}`;
    let bubble = parentBtn.querySelector(`.${className}`);
    
    if (count === null) {
        if (bubble) bubble.remove();
        return;
    }

    if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = `spec-count-bubble ${className}`;
        parentBtn.appendChild(bubble);
    }
    
    bubble.textContent = count;
    bubble.classList.toggle('is-zero', count === 0);
}
  
function renderQuickSpecAdjusters() {
    const sectionContainer = document.getElementById('spec-adjuster-section');
    if (!sectionContainer) return;
    sectionContainer.classList.toggle('i9-quick', !!window.I9System?.isSystem()); // I9-SYSTEM: System layout class (four-column row); off for Standard builds
    if (window.I9System?.isSystem()) { window.I9System.renderQuickAdjusters(); return; } // I9-SYSTEM: wheel size + spoke count per wheel from the hub model and rims (brake style is set by the hub, not shown)

    const frontColumn = document.getElementById('front-spec-adjusters');
    const rearColumn = document.getElementById('rear-spec-adjusters');
    const centerColumn = document.getElementById('center-spec-adjusters');
    const wrapper = document.getElementById('spec-adjuster-wrapper');

    if (!frontColumn || !rearColumn || !centerColumn || !wrapper) return;

    const { buildType, specs } = buildState;
    let frontHtml = '';
    let rearHtml = '';
    let centerHtml = '';

    const createButtonGroup = (position, specKey, displayName) => {
        const specValue = specs[specKey];
        if (specValue === null) return '';
        const options = ['24h', '28h', '32h', '36h']; // Added 36h to adjuster
        let buttonsHtml = options.map(opt =>
            `<button type="button" class="builder-button spec-option-button ${specValue === opt ? 'active' : ''}" data-position="${position}" data-spec-key="${specKey}" data-value="${opt}">${opt}</button>`
        ).join('');
        return `<div class="quick-spec-group"><label>${displayName}</label><div class="spec-adjuster-options">${buttonsHtml}</div></div>`;
    };

    if (buildType === 'Front' || buildType === 'Wheel Set') frontHtml = createButtonGroup('Front', 'frontSpokeCount', 'Front Spoke Count');
    if (buildType === 'Rear' || buildType === 'Wheel Set') rearHtml = createButtonGroup('Rear', 'rearSpokeCount', 'Rear Spoke Count');

    // CENTER COLUMN LOGIC (Brake Style)
    // We only show this if it's NOT a Rim Brake build. 
    // Switching from Rim Brake to Disc requires an axle change, which is best handled in Step 2.
    if (buildType !== null && specs.brakeStyle !== 'Rim Brake') { 
        const brakeStyleValue = specs.brakeStyle;
        const brakeOptions = ['6-Bolt', 'Centerlock']; 
        let brakeButtonsHtml = brakeOptions.map(opt =>
            `<button type="button" class="builder-button spec-option-button ${brakeStyleValue === opt ? 'active' : ''}" data-position="Both" data-spec-key="brakeStyle" data-value="${opt}">${opt}</button>`
        ).join('');
        
        centerHtml = `
            <div class="quick-spec-group">
                <label>Brake Style</label>
                <div class="spec-adjuster-options">${brakeButtonsHtml}</div>
            </div>`;
    }

    frontColumn.innerHTML = frontHtml;
    rearColumn.innerHTML = rearHtml;
    centerColumn.innerHTML = centerHtml;
    
    frontColumn.style.display = frontHtml ? 'flex' : 'none';
    rearColumn.style.display = rearHtml ? 'flex' : 'none';
    centerColumn.style.display = centerHtml ? 'flex' : 'none';

    wrapper.classList.toggle('build-type-wheel-set', buildType === 'Wheel Set');
    wrapper.classList.toggle('build-type-single', buildType !== 'Wheel Set');
    sectionContainer.style.display = (frontHtml || rearHtml || centerHtml) ? 'block' : 'none';
}

function showSpecChangeModal(position, componentType, targetSpecValue, actionInfo = null) {
    if (!specChangeModal || !specChangeModalTitle || !specChangeModalBody) return;

    // --- Add the vendor of the component being cleared to our action plan ---
    const componentStateKey = `${position.toLowerCase()}${componentType}`;
    const componentToClear = buildState.components[componentStateKey];
    if (actionInfo && componentToClear) {
        actionInfo.vendorToSelect = componentToClear.vendor;
    }
    _tempActionAfterSpecChange = actionInfo;
    // --- END  ---

    specChangeModalTitle.textContent = `Update Spoke Count?`;
    const componentTypeLower = componentType.toLowerCase();
    const cleanTargetSpecValue = targetSpecValue.replace(/h/g, '') + 'h';
    const modelName = actionInfo?.modelToExpand || null;

    let messageHtml = modelName ?
        `<p>Components in the <strong>${modelName}</strong> model group require a <strong>${cleanTargetSpecValue}</strong> spoke count.</p>
         <p>This will clear your current ${position.toLowerCase()} ${componentTypeLower} selection. Would you like to proceed?</p>` :
        `<p>This ${componentTypeLower} requires a <strong>${cleanTargetSpecValue}</strong> spoke count.</p>
         <p>Would you like to update your ${position} wheel to use a ${cleanTargetSpecValue} configuration?</p>`;

    specChangeModalBody.innerHTML = messageHtml;

    const oldBtn = specChangeModalConfirmBtn;
    const newBtn = oldBtn.cloneNode(true);
    oldBtn.parentNode.replaceChild(newBtn, oldBtn);
    specChangeModalConfirmBtn = newBtn;

    specChangeModalConfirmBtn.onclick = () => {
        specChangeModal.style.display = 'none';

        if (componentToClear) {
            buildState.components[componentStateKey] = null;
        }

        const specKey = `${position.toLowerCase()}SpokeCount`;
        updateSpecAndRefreshStep3({
            [specKey]: cleanTargetSpecValue
        });
    };

    specChangeModal.style.display = 'flex';
}

function getHubBaseModelName(title) {
    if (!title) return '';
    
    // Convert to lowercase and remove brake-specific terms and extra spaces
    let cleanTitle = title.toLowerCase()
        .replace(/6-bolt|centerlock/g, '') // Remove brake types
        .replace(/\s+/g, ' ').trim(); // Collapse multiple spaces into one and trim ends
        
    return cleanTitle;
}

async function attemptSmartHubSwap(position, newBrakeStyle) {
    const posLower = position.toLowerCase();
    const stateKey = `${posLower}Hub`;
    const currentComponent = buildState.components[stateKey];

    if (!currentComponent || !currentComponent.title) {
        return; // Nothing to swap if there's no title
    }

    console.log(`%c[Smart Swap] Attempting for ${position} Hub. Target Brake Style: ${newBrakeStyle}`, "color: #007bff; font-weight: bold;");

    const originalBaseModel = getHubBaseModelName(currentComponent.title);
    const originalColor = currentComponent.selectedOptions?.find(o => o.name.toLowerCase() === 'color')?.value || null;

    console.log(`[Smart Swap] Original Base Model Key: "${originalBaseModel}"`);
    console.log(`[Smart Swap] Original Color: ${originalColor}`);

    let bestMatch = null;

    // Search the entire hub cache for a product with a matching base name
    for (const candidateProduct of allHubProductsCache) {
        const candidateBaseModel = getHubBaseModelName(candidateProduct.title);

        if (candidateBaseModel === originalBaseModel) {
            // Found a product with the same base name, now check its variants
            for (const variant of candidateProduct.variants) {
                const positionMatch = variant.spec_position === position || variant.spec_position === "Front/Rear";
                const brakeMatch = (variant.spec_brake_interface || []).includes(newBrakeStyle);
                const spacingMatch = normalizeSpacing(variant.spec_hub_spacing) === normalizeSpacing(buildState.specs[`${posLower}HubSpacing`]);
                const spokeMatch = String(variant.spec_spoke_count) === String(buildState.specs[`${posLower}SpokeCount`]);
                
                if (variant.availableForSale && positionMatch && brakeMatch && spacingMatch && spokeMatch) {
                    const variantColor = variant.selectedOptions?.find(o => o.name.toLowerCase() === 'color')?.value || null;
                    if (variantColor === originalColor) {
                        bestMatch = { variant, product: candidateProduct };
                        console.log(`%c[Smart Swap] Found perfect match!`, "color: green;", bestMatch);
                        break; // Found the best possible match
                    }
                }
            }
        }
        if (bestMatch) break;
    }

    if (bestMatch) {
        const { variant, product } = bestMatch;

        const newHubComponent = {
            variantId: variant.id, productId: product.id, productHandle: product.handle, title: product.title,
            variantTitle: variant.title, sku: variant.sku, price: variant.price.amount, vendor: product.vendor,
            image: variant.image, pairingKey: product.pairingKey, tags: product.tags,
            selectedOptions: variant.selectedOptions, optionalAddonProductGids: product.optionalAddonProductGidsFromProduct || [],
            quantityAvailable: variant.quantityAvailable, leadTimeDays: product.leadTimeDays, wheelModel: product.wheelModel,
            spec_spoke_count: String(variant.spec_spoke_count), spec_brake_interface: variant.spec_brake_interface, 
            spec_hub_spacing: variant.spec_hub_spacing, 
            spec_freehub: (position === 'Rear') ? buildState.specs.freehubType : null,
            weight_g: variant.weight_g ?? product.weight_g ?? null
        };

        buildState.components[stateKey] = newHubComponent;
    } else {
        console.log(`%c[Smart Swap] No compatible replacement found for ${position} Hub. Selection will be cleared.`, "color: #dc3545;");
    }
}

/**
 * Core engine for updating specs from within Step 3.
 * Passes an 'isRefreshing' flag to showStep to prevent full-screen blinking.
 */
async function updateSpecAndRefreshStep3(specUpdates) {
    
    let stateWasChanged = false;
    for (const key in specUpdates) {
        if (buildState.specs[key] !== specUpdates[key]) {
            buildState.specs[key] = specUpdates[key];
            stateWasChanged = true;
        }
    }

    // Always run if state changed, or if called with an empty object (like the toggle)
    if (stateWasChanged || Object.keys(specUpdates).length === 0) {
        // We pass the option 'isRefreshing: true' to suppress the blink
        await showStep(3, { isRefreshing: true });

        if (_tempActionAfterSpecChange) {
            // ... (keep the existing post-change logic for vendor/model expansion) ...
            const { modelToExpand, vendorToSelect } = _tempActionAfterSpecChange;
            const updatedSpecKey = Object.keys(specUpdates)[0];
            let position;
            if (updatedSpecKey?.startsWith('rear')) position = 'Rear';
            else if (updatedSpecKey?.startsWith('front')) position = 'Front';

            if (position && vendorToSelect) {
                const vendorButton = document.querySelector(`.vendor-filter-btn[data-position="${position}"][data-vendor="${vendorToSelect}"]`);
                if (vendorButton) vendorButton.click();
            }

            if (modelToExpand) {
                setTimeout(() => {
                    const cardToExpand = document.querySelector(`.component-product-card[data-model-name="${modelToExpand}"]`);
                    if (cardToExpand) {
                        const header = cardToExpand.querySelector('.product-card-header');
                        if (header) {
                            header.click();
                            setTimeout(() => { cardToExpand.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 150);
                        }
                    }
                }, 100);
            }
            _tempActionAfterSpecChange = null;
        }
    }
}

function renderStep3() {
    const s3C = document.getElementById('step-3');
    if (!s3C) return;
    const bT = buildState.buildType;
    const sF = bT === 'Front' || bT === 'Wheel Set'; // showFront
    const sR = bT === 'Rear' || bT === 'Wheel Set';  // showRear
    let sCl = false; // stateCleared

    ['rim', 'hub', 'spokes', 'nipples', 'valvestem'].forEach(t => { // t is component type lowercase
        let sId; // sectionId (e.g., component-section-rims)
        if (t === 'valvestem') sId = 'component-section-valvestems';
        else if (t === 'spokes' || t === 'nipples') sId = `component-section-${t}`;
        else sId = `component-section-${t}s`;

        const sE = s3C.querySelector(`#${sId}`); // The main section for this component type (e.g., #component-section-rims)
        if (!sE) return;

        const w = sE.querySelector('.component-position-wrapper'); // The container for front/rear subsections (e.g., for rims)
        if (!w) return;

        // Helper to manage individual front/rear subsections
        const managePositionSubsection = (positionName, showSubsection) => {
            const subSecEl = w.querySelector(`#${positionName.toLowerCase()}-${t}-subsection`);
            if (!subSecEl) return;

            subSecEl.style.display = showSubsection ? '' : 'none';

            if (bT === 'Wheel Set') {
                // If it's a wheel set, prevent subsections from stretching to match sibling height.
                // This assumes .component-position-wrapper.build-type-wheel-set is display: flex (row).
                subSecEl.style.alignSelf = 'flex-start';
            } else {
                // Reset for single builds if necessary (though likely not an issue if not flex row)
                subSecEl.style.alignSelf = '';
            }

            if (!showSubsection) { // If hiding, clear relevant state
                let typePascal = t.charAt(0).toUpperCase() + t.slice(1);
                if (t === 'valvestem') typePascal = 'ValveStem';
                else if (t === 'nipples') typePascal = 'Nipples';
                else if (t === 'spokes') typePascal = 'Spokes';

                const stateKey = `${positionName.toLowerCase()}${typePascal}`;
                if (buildState.components[stateKey]) {
                    buildState.components[stateKey] = null;
                    sCl = true; // Mark that state was cleared

                    // Also clear any selected optional addons for this cleared base component
                    const addonKeysToRemove = Object.keys(buildState.selectedOptionalAddons).filter(key => {
                        const addon = buildState.selectedOptionalAddons[key];
                        return addon.baseComponentPosition === positionName && addon.baseComponentType === typePascal;
                    });
                    addonKeysToRemove.forEach(key => delete buildState.selectedOptionalAddons[key]);
                    saveLastActiveBuild();
                }
            }
        };

        managePositionSubsection('Front', sF);
        managePositionSubsection('Rear', sR);

        // Adjust classes on the position wrapper for overall layout styling
        if (bT === 'Wheel Set') {
            w.classList.add('build-type-wheel-set');
            w.classList.remove('build-type-single');
        } else {
            w.classList.remove('build-type-wheel-set');
            w.classList.add('build-type-single');
        }
        sE.style.setProperty('display', ''); // Ensure the main component section is visible
    });
    window.I9System?.syncStep3Chrome(); // I9-SYSTEM: hide Nipples, Quick Build and spec adjusters for System builds; show the Studio block

    if (sCl) { // If any component state was cleared
        updateBuildSummary();
        updateSubtotal();
        validateStep3(); // Re-validate if components were removed
        saveLastActiveBuild();
    }
}

function clearStep3UI() { window.StandardStudio?.syncCards(); /* STANDARD-STUDIO: no spokes selected = no Studio card, no painting */ const s3=document.getElementById('step-3'); if(s3){['rim','hub','spokes','nipples','valvestem'].forEach(t=>{['front','rear'].forEach(p=>{const fE=document.getElementById(`${p}-${t}-filters`); const oE=document.getElementById(`${p}-${t}-options-container`); const iE=document.getElementById(`${p}-${t}-image-container`); const sE=document.querySelector(`#${p}-${t}-selection span`); const ssE=document.getElementById(`${p}-${t}-subsection`); const actionButtonsContainer = document.getElementById(`${p}-${t}-action-buttons`); const removeBtn = document.getElementById(`remove-${p}-${t}-button`); if(fE){const vA=fE.querySelector('.vendor-filter-area'); if(vA)vA.innerHTML='';} if(actionButtonsContainer) actionButtonsContainer.innerHTML = ''; if(oE)oE.innerHTML='<p>Select dependencies.</p>'; if(iE){iE.innerHTML='';iE.style.display='none';} if(sE){let typePascal = t.charAt(0).toUpperCase() + t.slice(1); if (t === 'valvestem') typePascal = 'ValveStem'; else if (t === 'nipples') typePascal = 'Nipples'; else if (t === 'spokes') typePascal = 'Spokes'; let l=`${p[0].toUpperCase()+p.slice(1)} ${typePascal}`;sE.innerHTML=`Selected ${l}: None`;} if(ssE)ssE.classList.remove('selection-made','change-in-progress'); if(removeBtn) removeBtn.style.display = 'none'; });});}}
    function resetComponentSelectionUI(position, typePascal) { const pL=position.toLowerCase(); const tL = typePascal.toLowerCase(); const sS=document.getElementById(`${pL}-${tL}-subsection`); const iC=document.getElementById(`${pL}-${tL}-image-container`); const oC=document.getElementById(`${pL}-${tL}-options-container`); const actionButtonsContainer = document.getElementById(`${pL}-${tL}-action-buttons`); const sSpan=document.querySelector(`#${pL}-${tL}-selection span`); const removeBtn = document.getElementById(`remove-${pL}-${tL}-button`); if(iC){iC.style.display='none';iC.innerHTML='';} if(oC){oC.innerHTML='<p>Select options...</p>';oC.style.display='flex';} if(actionButtonsContainer) actionButtonsContainer.innerHTML = ''; if(sSpan){ let l=`${position} ${typePascal.charAt(0).toUpperCase() + typePascal.slice(1)}`;sSpan.innerHTML=`Selected ${l}: None`;} if(sS)sS.classList.remove('selection-made','change-in-progress'); if(removeBtn) removeBtn.style.display = 'none'; if(buildState._ui.isChangingComponent?.position===position&&buildState._ui.isChangingComponent?.type===typePascal)cancelComponentChange(); }
    
    function areRimsPaired(rim1, rim2) {
    if (!rim1 || !rim2) return false;

    // 1. They must have the same pairing key. If not, they can't be a pair.
    if (rim1.pairingKey !== rim2.pairingKey) {
        return false;
    }

    // 2. Extract the color from each rim's variantTitle.
    const getColorFromTitle = (rim) => {
        if (!rim || !rim.variantTitle) return null;
        const parts = rim.variantTitle.split('/').map(part => part.trim());
        const color = parts[parts.length - 1];
        // Return the color only if it's a word, not a number, otherwise null.
        return isNaN(color) ? color.toLowerCase() : null;
    };

    const color1 = getColorFromTitle(rim1);
    const color2 = getColorFromTitle(rim2);

    // 3. Compare the colors. They must be identical.
    return color1 === color2;
}
  
    function areHubsPaired(hub1, hub2) { if (!hub1 || !hub2) return false; if (hub1.pairingKey !== hub2.pairingKey) return false; const getColor = (hub) => { if (!hub || !hub.selectedOptions) return null; const colorOption = hub.selectedOptions.find(opt => opt.name.toLowerCase() === 'color'); return colorOption ? colorOption.value : null; }; const color1 = getColor(hub1); const color2 = getColor(hub2); return color1 === color2; }
    function handleSelectedImageClick(e, imageContainer) { e.preventDefault(); if (imageContainer.dataset.i9Static) return; /* I9-SYSTEM: the System spoke preview is not a "click to change" image */ if (buildState._ui.isChangingComponent) return; const componentType = imageContainer.dataset.componentType; const position = imageContainer.dataset.position; if (!componentType || !position) { console.error("handleSelectedImageClick: Missing data-component-type or data-position on image container."); return; } console.log(`handleSelectedImageClick: Initiating change for ${position} ${componentType}`); const posLower = position.toLowerCase(); const typeLower = componentType.toLowerCase(); const subsection = document.getElementById(`${posLower}-${typeLower}-subsection`); const optionsContainer = document.getElementById(`${posLower}-${typeLower}-options-container`); const actionButtonsContainer = document.getElementById(`${posLower}-${typeLower}-action-buttons`); if (!subsection || !optionsContainer || !actionButtonsContainer) { console.error("handleSelectedImageClick: Critical UI elements missing for component change.", { subsection, optionsContainer, actionButtonsContainer }); return; } imageContainer.style.display = 'none'; optionsContainer.style.display = 'flex'; optionsContainer.innerHTML = '<p>Loading options...</p>'; actionButtonsContainer.style.display = 'flex'; /* <<< Ensure action buttons are visible */ showCancelChangeButtonIfNeeded(position, componentType, actionButtonsContainer); subsection.classList.add('change-in-progress'); buildState._ui.isChangingComponent = { position: position, type: componentType }; if (typeLower === 'rim') loadAndFilterRimsForPosition(position, true); else if (typeLower === 'hub') loadAndFilterHubsForPosition(position, true); else if (typeLower === 'spokes') loadAndFilterSpokesForPosition(position, true); else if (typeLower === 'nipples') loadAndFilterNipplesForPosition(position, true); else if (typeLower === 'valvestem') loadAndFilterValveStemsForPosition(position, true); else { optionsContainer.innerHTML = '<p>Error: Unknown component type.</p>'; } document.addEventListener('click', handleClickAway, true); }
    function handleClickAway(e) {
    const cI = buildState._ui.isChangingComponent;
    if (!cI) {
        document.removeEventListener('click', handleClickAway, true);
        return;
    }

    const cSS = document.getElementById(`${cI.position.toLowerCase()}-${cI.type.toLowerCase()}-subsection`);
    
    const isClickInsideSpecModal = specChangeModal && specChangeModal.contains(e.target);

    // Only cancel the change if the click is outside BOTH the component's subsection AND the spec change modal.
    if (cSS && !cSS.contains(e.target) && !isClickInsideSpecModal) {
        // console.log(`handleClickAway: Clicked outside ${cI.position} ${cI.type} subsection. Cancelling change.`);
        e.stopPropagation();
        e.preventDefault();
        cancelComponentChange();
    }
}

    function cancelComponentChange() {
        const cI = buildState._ui.isChangingComponent;
        if (!cI) return;

        // console.log(`cancelComponentChange: For ${cI.position} ${cI.type}`);
        const posLower = cI.position.toLowerCase();
        let typePascal = cI.type;
        const typeLowerForDOM = typePascal.toLowerCase() === 'valvestem' ? 'valvestem' : typePascal.toLowerCase();

        const subsection = document.getElementById(`${posLower}-${typeLowerForDOM}-subsection`);

        if (subsection) {
            subsection.classList.remove('change-in-progress');
        } else {
            console.warn(`cancelComponentChange: Subsection not found for ${posLower}-${typeLowerForDOM}`);
        }

        const stateKey = `${posLower}${typePascal}`;
        const currentComponentData = buildState.components[stateKey];

        updateComponentUI(cI.position, typePascal, currentComponentData);

        buildState._ui.isChangingComponent = null;
        document.removeEventListener('click', handleClickAway, true);
        // console.log(`cancelComponentChange: Change cancelled for ${cI.position} ${cI.type}. UI should be fully restored.`);
    }

function displayRimProductCards(position, allCompatibleProducts, optionsContainer, allowedModels = null) {
    if (!optionsContainer) return;
    const componentKeyForState = `${position.toLowerCase()}Rim`;
    const selectedVendor = buildState._ui.activeVendor[componentKeyForState];

    if (selectedVendor === null) {
        optionsContainer.innerHTML = '';
        return;
    }

    optionsContainer.innerHTML = '';

    // --- DEBUG 1: Vendor Filtering ---
    console.group(`[CardGen Debug] Displaying Rims for ${position}`);
    console.log(`Selected Vendor: "${selectedVendor}"`);
    
    // Find the infinity wheel in the raw input
    const infinityRaw = allCompatibleProducts.find(p => p.title.toLowerCase().includes('infinity'));
    if (infinityRaw) {
        console.log(`✅ Infinity Wheel FOUND in input list.`);
        console.log(`   - Vendor: "${infinityRaw.vendor}"`);
        console.log(`   - Model Metafield: "${infinityRaw.wheelModel}"`);
        console.log(`   - Vendor Match? ${infinityRaw.vendor === selectedVendor}`);
    } else {
        console.error(`❌ Infinity Wheel MISSING from input list (Loader issue?).`);
    }

    const productsFilteredByVendor = selectedVendor === 'all' ? allCompatibleProducts : allCompatibleProducts.filter(p => p.vendor === selectedVendor);

    if (productsFilteredByVendor.length === 0) {
        optionsContainer.innerHTML = `<p>No ${position.toLowerCase()} rims for vendor: ${selectedVendor} matching specs.</p>`;
        console.log("No products match vendor.");
        console.groupEnd();
        return;
    }

    // --- DEBUG 2: Grouping ---
    const groupedByModel = {};
    productsFilteredByVendor.forEach(p => {
        const model = p.wheelModel || 'Other';
        if (!groupedByModel[model]) groupedByModel[model] = [];
        groupedByModel[model].push(p);
    });

    console.log("Model Groups Created:", Object.keys(groupedByModel));
    
    // Check where Infinity ended up
    Object.keys(groupedByModel).forEach(key => {
        const hasInfinity = groupedByModel[key].some(p => p.title.toLowerCase().includes('infinity'));
        if (hasInfinity) console.log(`👉 Reserve Infinity is inside group: "${key}"`);
    });

    let displayedModelCount = 0;
    const modelsToDisplay = allowedModels ? Object.keys(groupedByModel).filter(modelName => allowedModels.includes(modelName)) : Object.keys(groupedByModel).sort((a, b) => getSortableName(a).localeCompare(getSortableName(b)));
    
    const currentSpokeCount = buildState.specs[`${position.toLowerCase()}SpokeCount`];

    modelsToDisplay.forEach(model => {
        const productsInGroup = groupedByModel[model];
        
        // CHECK IF INTEGRATED
        const isIntegratedGroup = productsInGroup.some(p => p.tags && p.tags.includes('type:integrated_wheel'));

        const availableSpokeCounts = [...new Set(
            productsInGroup.flatMap(p => p.variants
                .filter(v => v.availableForSale && (v.spec_position === position || v.spec_position === "Front/Rear"))
                .map(v => v.spec_spoke_count)
            ).filter(Boolean)
        )].sort((a, b) => a - b);

        // --- FILTER CHECK ---
        if (availableSpokeCounts.length === 0 && !isIntegratedGroup) {
            console.log(`Skipping Group "${model}": No spokes & Not integrated.`);
            return;
        }

        displayedModelCount++;
        console.log(`Rendering Card: "${model}"`);

        const card = document.createElement('div');
        card.className = 'component-product-card rim-model-card';
        card.dataset.modelName = model;

        if (!isIntegratedGroup) {
            const isCompatibleNow = availableSpokeCounts.includes(String(currentSpokeCount));
            if (!isCompatibleNow) {
                card.classList.add('is-spec-incompatible');
                card.dataset.targetSpec = availableSpokeCounts[0];
                card.title = `Requires ${availableSpokeCounts.join('h or ')}h spoke count. Click to change.`;
            }
        }
        
        card.innerHTML = `<div class="product-card-header"><h5>${model}</h5></div><div class="product-card-body"><p>Click to view options...</p><div class="component-variant-options" style="display:none;"></div></div>`;
        
        card.addEventListener('click', (e) => {
            if (e.target.closest('.component-variant-options button')) return;

            if (card.classList.contains('is-spec-incompatible')) {
                const targetSpokeCount = card.dataset.targetSpec + 'h';
                showSpecChangeModal(position, 'Rim', targetSpokeCount, { modelToExpand: model });
                return;
            }

            const vc = card.querySelector('.component-variant-options');
            if (!vc) return;
            const isTrigger = e.target.closest('.product-card-header') || e.target.closest('.product-card-body p');
            if (!isTrigger) return;

            const isVisible = vc.style.display !== 'none';

            optionsContainer.querySelectorAll('.component-product-card.expanded').forEach(c => {
                if (c !== card) {
                    c.classList.remove('expanded');
                    const ovc = c.querySelector('.component-variant-options');
                    if (ovc) ovc.style.display = 'none';
                }
            });
            
            vc.style.display = isVisible ? 'none' : 'block';
            card.classList.toggle('expanded', !isVisible);
            
            if (!isVisible) {
                displayRimVariantButtonsByProduct(position, productsInGroup, vc);
            }
        });
        optionsContainer.appendChild(card);
    });

    console.groupEnd();

    if (displayedModelCount === 0) {
        optionsContainer.innerHTML = `<p>No ${position.toLowerCase()} rim models for vendor ${selectedVendor} match specs.</p>`;
    }
}

  
// --- START: handleAutoPairing ---
async function handleAutoPairing(componentType, position, selectedComponent, isExplicitMatchClick = false) {
    if (buildState.buildType !== 'Wheel Set') return 'not_applicable';
    // I9-SYSTEM: System spokes are matched by the module (base color + hub color), never by writing a classic spoke component
    if (componentType === 'Spokes' && window.I9System?.isSystem()) return window.I9System.matchSpokes(position, isExplicitMatchClick);

    const oppositePosition = position === 'Front' ? 'Rear' : 'Front';
    const oppPosLower = oppositePosition.toLowerCase();
    const oppositeStateKey = `${oppPosLower}${componentType}`;

    const componentToBeReplaced = buildState.components[oppositeStateKey];

    if (componentToBeReplaced && !isExplicitMatchClick) return 'opposite_filled';

    const selectedPairingKey = selectedComponent.pairingKey;
    if (!selectedPairingKey) return 'no_pairing_key';
    
    let cacheToSearch;
    switch (componentType) {
        case 'Hub': cacheToSearch = allHubProductsCache; break;
        case 'Rim': cacheToSearch = allRimProductsCache; break;
        case 'Spokes': cacheToSearch = allSpokeProductsCache; break;
        case 'Nipples': cacheToSearch = allNippleProductsCache; break;
        case 'ValveStem': cacheToSearch = allValveStemProductsCache; break;
        default: return 'unsupported_type';
    }

    const oppSpecs = {
        brakeStyle: buildState.specs.brakeStyle,
        wheelSize: buildState.specs[`${oppPosLower}WheelSize`],
        spokeCount: buildState.specs[`${oppPosLower}SpokeCount`],
        hubSpacing: buildState.specs[`${oppPosLower}HubSpacing`],
        freehubType: (oppositePosition === 'Rear') ? buildState.specs.freehubType : null,
        rimDepth: buildState.components[`${oppPosLower}Rim`]?.rimDepth
    };

    const pairedProducts = cacheToSearch.filter(p => p.pairingKey === selectedPairingKey);
    const targetColor = selectedComponent.selectedOptions?.find(o => o.name.toLowerCase() === 'color')?.value || null;

    let perfectMatches = [];
    for (const p_pair of pairedProducts) {
        for (const v_pair of p_pair.variants) {
            if (!v_pair.availableForSale) continue;
            let isMatch = false;
            switch (componentType) {
                case 'Hub':
                    if (oppositePosition === 'Rear' && (!p_pair.availableFreehubs || !isFreehubCompatible(oppSpecs.freehubType, p_pair.availableFreehubs))) continue;
                    isMatch = (v_pair.spec_position === oppositePosition || v_pair.spec_position === "Front/Rear") && (v_pair.spec_brake_interface || []).includes(oppSpecs.brakeStyle) && normalizeSpacing(v_pair.spec_hub_spacing) === normalizeSpacing(oppSpecs.hubSpacing) && String(v_pair.spec_spoke_count) === String(oppSpecs.spokeCount);
                    break;
                case 'Rim':
                    const sizeValue = v_pair.spec_rim_size?.parsedValue;
                    const sizeMatch = Array.isArray(sizeValue) ? sizeValue.includes(oppSpecs.wheelSize) : sizeValue === oppSpecs.wheelSize;
                    isMatch = (v_pair.spec_position === oppositePosition || v_pair.spec_position === "Front/Rear") && sizeMatch && String(v_pair.spec_spoke_count) === String(oppSpecs.spokeCount);
                    break;
                case 'ValveStem':
                    if (typeof oppSpecs.rimDepth !== 'number') continue; 
                    isMatch = (oppSpecs.rimDepth >= v_pair.valve_min_depth && oppSpecs.rimDepth <= v_pair.valve_max_depth) || (v_pair.valve_min_depth === null || v_pair.valve_max_depth === null);
                    break;
                case 'Spokes':
                    const sourceSpokeColor = selectedComponent.selectedColor;
                    const isBuilderVariant = v_pair.selectedOptions.some(o => o.name === 'Length' && o.value === '-');
                    if (!isBuilderVariant) { isMatch = false; continue; }
                    const targetSpokeColor = v_pair.selectedOptions.find(o => o.name === 'Color')?.value;
                    isMatch = (sourceSpokeColor === targetSpokeColor);
                    break;
                case 'Nipples':
                    const sourceNippleColor = selectedComponent.selectedOptions.find(o => o.name === 'Color')?.value;
                    const targetNippleColor = v_pair.selectedOptions.find(o => o.name === 'Color')?.value;
                    isMatch = (sourceNippleColor === targetNippleColor);
                    break;
            }
            if (isMatch) {
                perfectMatches.push({ variant: v_pair, product: p_pair });
            }
        }
    }

    let finalVariantsToConsider = perfectMatches;
    if (perfectMatches.length > 1 && targetColor) {
        const colorMatchedVariants = perfectMatches.filter(match => {
            const variantColor = match.variant.selectedOptions?.find(o => o.name.toLowerCase() === 'color')?.value || null;
            return variantColor === targetColor;
        });
        if (colorMatchedVariants.length > 0) {
            finalVariantsToConsider = colorMatchedVariants;
        }
    }
    
    if (componentType === 'ValveStem' && finalVariantsToConsider.length > 1) {
        finalVariantsToConsider.sort((a,b) => (parseInt(a.variant.selectedOptions.find(opt=>opt.name==='Length')?.value.replace(/\D/g,''))||Infinity) - (parseInt(b.variant.selectedOptions.find(opt=>opt.name==='Length')?.value.replace(/\D/g,''))||Infinity));
    }

    if (finalVariantsToConsider.length === 1 || (['Spokes', 'Nipples', 'ValveStem'].includes(componentType) && finalVariantsToConsider.length > 0)) {
        const bestMatch = finalVariantsToConsider[0];
        const { variant, product } = bestMatch;

        if (componentType === 'Spokes') {
            const oppositeHub = buildState.components[`${oppPosLower}Hub`];
            if (oppositeHub) {
                const bestMatchSpokeInterface = product.spokeHubInterface;
                const oppositeHubTags = oppositeHub.tags || [];
                
                let isAutoPairIncompatible = false;
                // Standard Checks
                if ((bestMatchSpokeInterface === 'J-Bend' && oppositeHubTags.includes('hub_type:straight_pull')) ||
                    (bestMatchSpokeInterface === 'Straight Pull' && oppositeHubTags.includes('hub_type:j_bend'))) isAutoPairIncompatible = true;
                
                // --- NEW HOOK FLANGE CHECKS ---
                if (oppositeHubTags.includes('hub_type:hook_flange') && (bestMatchSpokeInterface === 'J-Bend' || bestMatchSpokeInterface === 'Straight Pull')) isAutoPairIncompatible = true;
                if (bestMatchSpokeInterface === 'Hook Flange' && !oppositeHubTags.includes('hub_type:hook_flange')) isAutoPairIncompatible = true;

                if (isAutoPairIncompatible) {
                    const actionButtonsContainer = document.getElementById(`${oppPosLower}-spokes-action-buttons`);
                    if (actionButtonsContainer) showCancelChangeButtonIfNeeded(oppositePosition, 'Spokes', actionButtonsContainer);
                    return 'cancelled_incompatible';
                }
            }
        }
        
        if (componentType === 'Hub') {
            const oppositeSpokes = buildState.components[`${oppPosLower}Spokes`];
            if (oppositeSpokes) {
                const bestMatchHubTags = product.tags || [];
                const oppositeSpokeProduct = allSpokeProductsCache.find(p => p.id === oppositeSpokes.productId);
                const oppositeSpokeInterface = oppositeSpokeProduct?.spokeHubInterface;
                
                let isAutoPairIncompatible = false;
                // Standard Checks
                if ((oppositeSpokeInterface === 'J-Bend' && bestMatchHubTags.includes('hub_type:straight_pull')) ||
                    (oppositeSpokeInterface === 'Straight Pull' && bestMatchHubTags.includes('hub_type:j_bend'))) isAutoPairIncompatible = true;

                // --- NEW HOOK FLANGE CHECKS ---
                if (bestMatchHubTags.includes('hub_type:hook_flange') && (oppositeSpokeInterface === 'J-Bend' || oppositeSpokeInterface === 'Straight Pull')) isAutoPairIncompatible = true;
                if (oppositeSpokeInterface === 'Hook Flange' && !bestMatchHubTags.includes('hub_type:hook_flange')) isAutoPairIncompatible = true;

                if (isAutoPairIncompatible) {
                    const actionButtonsContainer = document.getElementById(`${oppPosLower}-hub-action-buttons`);
                    if (actionButtonsContainer) showCancelChangeButtonIfNeeded(oppositePosition, 'Hub', actionButtonsContainer);
                    return 'cancelled_incompatible';
                }
            }
        }

        if (componentToBeReplaced && componentToBeReplaced.productId !== product.id) {
            const addonKeysToRemove = Object.keys(buildState.selectedOptionalAddons).filter(key => {
                const addon = buildState.selectedOptionalAddons[key];
                return addon.baseComponentPosition === oppositePosition && addon.baseComponentType === componentType && addon.baseComponentVariantId === componentToBeReplaced.variantId;
            });
            addonKeysToRemove.forEach(key => delete buildState.selectedOptionalAddons[key]);
            if (addonKeysToRemove.length > 0) saveLastActiveBuild();
        }

        // --- CONSTRUCT COMPONENT OBJECT ---
        // Ensure we grab the weight from the variant, or fallback to product
        const safeWeight = variant.weight_g !== undefined ? variant.weight_g : (product.weight_g !== undefined ? product.weight_g : null);

        const autoSelectedComponent = {
            variantId: variant.id, productId: product.id, productHandle: product.handle, title: product.title,
            variantTitle: variant.title, sku: variant.sku, price: variant.price.amount, vendor: product.vendor,
            image: variant.image, pairingKey: product.pairingKey, tags: product.tags,
            selectedOptions: variant.selectedOptions, optionalAddonProductGids: product.optionalAddonProductGidsFromProduct || [],
            quantityAvailable: variant.quantityAvailable, leadTimeDays: product.leadTimeDays, wheelModel: product.wheelModel,
            
            // --- Ensure weight is assigned ---
            weight_g: safeWeight
        };
        
        switch (componentType) {
            case 'Hub':
                Object.assign(autoSelectedComponent, { spec_spoke_count: String(variant.spec_spoke_count), spec_brake_interface: variant.spec_brake_interface, spec_hub_spacing: variant.spec_hub_spacing, spec_freehub: oppSpecs.freehubType });
                if (oppositePosition === 'Rear') setComponentFreehubForHub({ ...variant, freehubVariantMap: product.freehubVariantMap });
                break;
            case 'Rim':
                Object.assign(autoSelectedComponent, { spokeCount: String(variant.spec_spoke_count), wheelSize: oppSpecs.wheelSize, rimDepth: product.rimDepth, internal_width_mm: variant.internal_width_mm });
                // Ensure ERD is passed
                if (variant.rim_erd) autoSelectedComponent.rim_erd = variant.rim_erd;
                else if (product.rim_erd) autoSelectedComponent.rim_erd = product.rim_erd;
                break;
            case 'Spokes':
                const colorOption = variant.selectedOptions.find(o => o.name.toLowerCase() === 'color');
                if (colorOption) autoSelectedComponent.selectedColor = colorOption.value;
                break;
        }

        buildState.components[oppositeStateKey] = autoSelectedComponent;
        if (componentType === 'Spokes') window.StandardStudio?.onSpokesAssigned(oppositePosition); // STANDARD-STUDIO: Match / auto-pair copies the list color only; the other wheel's painting is cleared
        if (componentType === 'Rim') {
            const isIntegrated = autoSelectedComponent.tags && autoSelectedComponent.tags.includes('type:integrated_wheel');
            if (isIntegrated) {
                applyIntegratedWheelLogic(oppositePosition, autoSelectedComponent);
            } else {
                // If we matched to a standard rim, we MUST unlock the hub/spokes/nipples
                resetIntegratedWheelLogic(oppositePosition);
            }
        }
        buildState._ui.activeVendor[oppositeStateKey] = autoSelectedComponent.vendor;
        updateVendorButtonHighlight(oppositeStateKey, autoSelectedComponent.vendor);
        calculateWheelCosts(oppositePosition);
        
        // Update the UI, which will now see the weight_g we just assigned
        updateComponentUI(oppositePosition, componentType, autoSelectedComponent);
        
        switch (componentType) {
            case 'Hub':
            case 'Spokes':
                updateHubSpokeCompatibilityUI();
                break;
            case 'Rim':
                evaluateValveStemForRimChange(oppositePosition);
                break;
        }

        updateSubtotal();
        updateBuildSummary();
        validateStep3();
        saveLastActiveBuild();
        updateMismatchHints();
        return 'single_match_selected';

    } else if (finalVariantsToConsider.length > 1) {
        if (buildState.components[oppositeStateKey]) {
            clearComponentAndItsAddons(oppositePosition, componentType);
            updateSubtotal();
            updateBuildSummary();
            validateStep3();
        }
        const oppOptionsContainer = document.getElementById(`${oppPosLower}-${componentType.toLowerCase()}-options-container`);
        if (oppOptionsContainer) {
            const vendorOfMatchingModels = finalVariantsToConsider[0].product.vendor;
            buildState._ui.activeVendor[oppositeStateKey] = vendorOfMatchingModels;
            updateVendorButtonHighlight(oppositeStateKey, vendorOfMatchingModels);
            
            const allowedModelNames = [...new Set(finalVariantsToConsider.map(match => match.product.wheelModel))];
            if (componentType === 'Hub') displayHubProductCards(oppositePosition, pairedProducts, oppOptionsContainer, allowedModelNames);
            else if (componentType === 'Rim') displayRimProductCards(oppositePosition, pairedProducts, oppOptionsContainer, allowedModelNames);
        }
        return 'multiple_matches_shown';
    }

    return 'no_match_found';
}
// --- END: handleAutoPairing ---
  
    // --- START: Contextual Mismatch Notification Display (Task 6.13) ---
function displayMismatchNotification(position, componentType, failedSpecName, requestedSpecValue, availableSpecValues) {
    const posLower = position.toLowerCase();
    const typeLower = componentType.toLowerCase();
    const optionsContainer = document.getElementById(`${posLower}-${typeLower}-options-container`);

    if (!optionsContainer) {
        console.error(`displayMismatchNotification: Could not find options container for ${position} ${componentType}`);
        return;
    }

    // Ensure availableSpecValues is sorted numerically for a clean "24h or 28h" display
    const sortedAvailable = availableSpecValues.sort((a, b) => parseInt(a) - parseInt(b));
    const availableSpecsString = sortedAvailable.map(s => `<strong>${s}</strong>`).join(' or ');

    const messageHtml = `
        <div class="mismatch-notification">
            <p>No <strong>${requestedSpecValue}</strong> ${getDisplayName(typeLower).toLowerCase()} was found for this model.</p>
            <p>However, compatible ${availableSpecsString} options are available.</p>
            <p>To select one, please return to Step 2 and adjust the <strong>${failedSpecName}</strong> for the <strong>${position}</strong> wheel.</p>
        </div>
    `;

    optionsContainer.innerHTML = messageHtml;

    // Also clear the vendor filters for that section to avoid confusion and an inconsistent UI state
    const filterContainer = document.getElementById(`${posLower}-${typeLower}-filters`);
    if (filterContainer) {
        const vendorArea = filterContainer.querySelector('.vendor-filter-area');
        if (vendorArea) vendorArea.innerHTML = '';
    }
}
// --- END: Contextual Mismatch Notification Display (Task 6.13) ---
  
    function handleVendorFilterClick(event, vendorButton) {
    event.preventDefault();
    const componentKeyFromButton = vendorButton.dataset.componentKey;
    const position = vendorButton.dataset.position;
    const clickedVendor = vendorButton.dataset.vendor;

    // I9-SYSTEM: System spokes have one vendor and their own UI; a vendor click just closes the dropdown
    if (window.I9System?.isSystem() && componentKeyFromButton && componentKeyFromButton.endsWith('Spokes')) { vendorButton.closest('.vendor-filter-dropdown')?.classList.remove('is-open'); return; }

    const dropdown = vendorButton.closest('.vendor-filter-dropdown');
    if (dropdown) {
        const toggle = dropdown.querySelector('.dropdown-toggle');
        if (toggle) {
            let newToggleContent = ''; // Start empty

            if (clickedVendor === 'all') {
                newToggleContent = '<span class="toggle-all-vendors-button">All Vendors</span>';
            } else {
                const vendorInfo = vendorLogoMap[clickedVendor];
                const logoUrl = vendorInfo?.logoUrl;
                newToggleContent = `<span>
                                        ${logoUrl ? `<img src="${logoUrl}" alt="${clickedVendor}" class="toggle-vendor-logo">` : `<span>${clickedVendor}</span>`}
                                   </span>`;
            }

            toggle.innerHTML = newToggleContent;
        }
        dropdown.classList.remove('is-open');
    }

    let derivedComponentTypePascal = "";
    if (componentKeyFromButton && position && componentKeyFromButton.toLowerCase().startsWith(position.toLowerCase())) {
        derivedComponentTypePascal = componentKeyFromButton.substring(position.length);
    } else {
        console.error(`handleVendorFilterClick: Cannot derive component type from componentKey "${componentKeyFromButton}" and position "${position}"`);
        return;
    }
    if (derivedComponentTypePascal.toLowerCase() === "valvestem") derivedComponentTypePascal = "ValveStem";

    const componentTypeLower = derivedComponentTypePascal.toLowerCase();
    buildState._ui.activeVendor[componentKeyFromButton] = clickedVendor;

    const menuOptions = dropdown?.querySelector('.vendor-filter-options');
    if(menuOptions){
        menuOptions.querySelectorAll('.vendor-filter-btn').forEach(btn => btn.classList.remove('active'));
        vendorButton.classList.add('active');
    }

    const isComponentSelectedInState = !!buildState.components[componentKeyFromButton];
    const isCurrentlyChangingThisSlot = buildState._ui.isChangingComponent &&
                                    buildState._ui.isChangingComponent.position === position &&
                                    buildState._ui.isChangingComponent.type === derivedComponentTypePascal;

    if (isComponentSelectedInState && !isCurrentlyChangingThisSlot) {
        const posLower = position.toLowerCase();
        const typeLowerForDomId = componentTypeLower;
        const imageContainer = document.getElementById(`${posLower}-${typeLowerForDomId}-image-container`);
        const optionsContainerForChange = document.getElementById(`${posLower}-${typeLowerForDomId}-options-container`);
        const subsection = document.getElementById(`${posLower}-${typeLowerForDomId}-subsection`);
        const actionButtonsContainer = document.getElementById(`${posLower}-${typeLowerForDomId}-action-buttons`);
        if (imageContainer && optionsContainerForChange && subsection && actionButtonsContainer) {
            imageContainer.style.display = 'none';
            optionsContainerForChange.style.display = 'flex';
            actionButtonsContainer.style.display = 'flex';
            showCancelChangeButtonIfNeeded(position, derivedComponentTypePascal, actionButtonsContainer);
            subsection.classList.add('change-in-progress');
            buildState._ui.isChangingComponent = { position: position, type: derivedComponentTypePascal };
            document.addEventListener('click', handleClickAway, true);
        } else {
            console.error(`handleVendorFilterClick: Missing UI elements for initiating change mode for ${position} ${derivedComponentTypePascal}. Check DOM IDs like ${posLower}-${typeLowerForDomId}-image-container`);
        }
    }

    const optionsContainer = document.getElementById(`${position.toLowerCase()}-${componentTypeLower}-options-container`);
    if (!optionsContainer) {
        return;
    }
    optionsContainer.innerHTML = '<p>Filtering options...</p>';

    if (componentTypeLower === 'rim') {
        const cachedProducts = allRimProductsCache;
        const size = position === 'Front' ? buildState.specs.frontWheelSize : buildState.specs.rearWheelSize;
        const spokeCount = position === 'Front' ? buildState.specs.frontSpokeCount : buildState.specs.rearSpokeCount;
        
        if (!size) {
            optionsContainer.innerHTML = '<p>Select Wheel Size in Step 2 to see Rim options.</p>'; return;
        }

        const compatibleProducts = cachedProducts.filter(p => {
            // CHECK FOR INTEGRATED WHEEL
            const isIntegrated = p.tags && p.tags.includes('type:integrated_wheel');

            return p.variants.some(v => {
                // Common Checks
                const sizeValue = v.spec_rim_size?.parsedValue;
                const sizeMatch = (sizeValue === size || (Array.isArray(sizeValue) && sizeValue.includes(size)));
                const positionMatch = (v.spec_position === position || v.spec_position === "Front/Rear");
                const availMatch = v.availableForSale;

                if (isIntegrated) {
                    // --- NEW LOGIC for Vendor Click: Bypass Spoke Count ---
                    const posLower = position.toLowerCase();
                    const hubSpacing = buildState.specs[`${posLower}HubSpacing`];
                    const brakeStyle = buildState.specs.brakeStyle;
                    
                    const spacingMatch = normalizeSpacing(v.spec_hub_spacing) === normalizeSpacing(hubSpacing);
                    const brakeMatch = (v.spec_brake_interface || []).includes(brakeStyle);
                    
                    return sizeMatch && positionMatch && availMatch && spacingMatch && brakeMatch;
                } else {
                    // --- STANDARD LOGIC ---
                    const spokeMatch = (!spokeCount || (String(v.spec_spoke_count) === String(spokeCount)));
                    return sizeMatch && positionMatch && availMatch && spokeMatch;
                }
            });
        });
        displayRimProductCards(position, compatibleProducts, optionsContainer);
    } else if (componentTypeLower === 'hub') {
        const cachedProducts = allHubProductsCache;
        const brakeStyle = buildState.specs.brakeStyle;
        const hubSpacing = position === 'Front' ? buildState.specs.frontHubSpacing : buildState.specs.rearHubSpacing;
        const freehubType = position === 'Rear' ? buildState.specs.freehubType : null;
        const spokeCount = buildState.specs[`${position.toLowerCase()}SpokeCount`];
        
        const compatibleProducts = cachedProducts.filter(product => {
            // Wildcard exception for customer-supplied parts
            if (product.vendor === 'Your Own Component') {
                return true;
            }

            // Product-level check for rear hubs
            if (position === 'Rear') {
                if (!product.availableFreehubs || !isFreehubCompatible(freehubType, product.availableFreehubs)) {
                    return false;
                }
            }
            
            // Variant-level check: Verify the hub matches your specific selections
            return product.variants.some(variant => {
                const positionMatch = variant.spec_position === position || variant.spec_position === "Front/Rear";
                const brakeMatch = (variant.spec_brake_interface || []).includes(brakeStyle);
                const spacingMatch = normalizeSpacing(variant.spec_hub_spacing) === normalizeSpacing(hubSpacing);
                const spokeMatch = String(variant.spec_spoke_count) === String(spokeCount);
                
                return variant.availableForSale && positionMatch && brakeMatch && spacingMatch && spokeMatch;
            });
        });

        displayHubProductCards(position, compatibleProducts, optionsContainer);
    } else if (componentTypeLower === 'spokes') {
        const cachedSpokes = allSpokeProductsCache;
        displaySpokeProductCards(position, cachedSpokes, optionsContainer);
    } else if (componentTypeLower === 'nipples') {
        const cachedNipples = allNippleProductsCache;
        displayNippleProductCards(position, cachedNipples, optionsContainer);
    } else if (componentTypeLower === 'valvestem') {
        const cachedValveStems = allValveStemProductsCache;
        const currentRimKey = `${position.toLowerCase()}Rim`;
        const currentSelectedRim = buildState.components[currentRimKey];
        const currentRimDepth = currentSelectedRim ? currentSelectedRim.rimDepth : null;
        displayValveStemProductCards(position, cachedValveStems, optionsContainer, currentRimDepth);
    } else {
        optionsContainer.innerHTML = `<p>Options for ${derivedComponentTypePascal} from vendor '${clickedVendor}' coming soon.</p>`;
    }
    updateHubSpokeCompatibilityUI();
}

function handleStep3Clicks(event) {
    const mswCheckbox = event.target.closest('.msw-global-checkbox');
    if (mswCheckbox) {
        // 1. Identify which dropdown is currently open so we can restore it
        const openDropdown = document.querySelector('.vendor-filter-dropdown.is-open');
        const openPosition = openDropdown ? openDropdown.closest('.position-subsection')?.dataset.position : null;

        // 2. Update global state
        buildState._ui.showRimBrakeRims = mswCheckbox.checked;
        
        // 3. Refresh Rims
        const refreshPromises = [];
        if (buildState.buildType === 'Front' || buildState.buildType === 'Wheel Set') {
            refreshPromises.push(loadAndFilterRimsForPosition('Front', buildState._ui.isChangingComponent?.position === 'Front'));
        }
        if (buildState.buildType === 'Rear' || buildState.buildType === 'Wheel Set') {
            refreshPromises.push(loadAndFilterRimsForPosition('Rear', buildState._ui.isChangingComponent?.position === 'Rear'));
        }

        // 4. Once refreshed, re-open the dropdown if it was open
        Promise.all(refreshPromises).then(() => {
            if (openPosition) {
                const newDropdown = document.querySelector(`.position-subsection[data-position="${openPosition}"] .vendor-filter-dropdown`);
                if (newDropdown) newDropdown.classList.add('is-open');
            }
        });
        
        return; 
    }
    // This now looks for EITHER the old hint class OR the new button class.
    const mismatchHint = event.target.closest('.mismatch-hint, .match-pair-button--from-hint');

    if (mismatchHint) {
        const positionToChange = mismatchHint.dataset.position;
        const typeToChange = mismatchHint.dataset.type;

        if (positionToChange && typeToChange) {
            event.preventDefault();
            event.stopPropagation();
            
            const oppositePosition = positionToChange === 'Front' ? 'Rear' : 'Front';
            const oppositeComponentStateKey = `${oppositePosition.toLowerCase()}${typeToChange}`;
            const oppositeComponent = buildState.components[oppositeComponentStateKey];

            if (oppositeComponent) {
                console.log(`Matching ${positionToChange} ${typeToChange} from a valid hint click.`);
                handleAutoPairing(typeToChange, oppositePosition, oppositeComponent, true);
            }
            return;
        }
    }

    const removeComponentIcon = event.target.closest('[data-action="remove-component"]');
    const imageContainer = event.target.closest('.component-selected-image');
    const vendorButton = event.target.closest('.vendor-filter-btn');
    const dropdownToggle = event.target.closest('.vendor-filter-dropdown .dropdown-toggle');

    if (removeComponentIcon) {
        const positionFromButton = removeComponentIcon.dataset.position;
        if (positionFromButton) {
            const posPascal = positionFromButton.charAt(0).toUpperCase() + positionFromButton.slice(1);
            const posLower = positionFromButton.toLowerCase();
            const stateKeyForValveInComponents = `${posLower}ValveStem`;
            const baseComponentTypeForAddonCheck = 'ValveStem';
            const valveBeingRemoved = buildState.components[stateKeyForValveInComponents];

            if (valveBeingRemoved && valveBeingRemoved.variantId) {
                const removedValveVariantId = valveBeingRemoved.variantId;
                const addonKeysToRemove = Object.keys(buildState.selectedOptionalAddons).filter(key => {
                    const addon = buildState.selectedOptionalAddons[key];
                    return addon.baseComponentPosition === posPascal &&
                           addon.baseComponentType === baseComponentTypeForAddonCheck &&
                           addon.baseComponentVariantId === removedValveVariantId;
                });
                addonKeysToRemove.forEach(key => {
                    delete buildState.selectedOptionalAddons[key];
                });
            }

            buildState.components[stateKeyForValveInComponents] = null;
            buildState._ui.hasChanges = true;
            updateStep3ButtonText();
            buildState._ui.valveStemExplicitlyRemoved[posLower] = true;
            
            updateSubtotal();
            updateBuildSummary();
            validateStep3();
            saveLastActiveBuild();

            const correspondingRimKeyForCheck = `${posLower}Rim`;
            if (buildState.components[correspondingRimKeyForCheck]) {
                updateComponentUI(posPascal, baseComponentTypeForAddonCheck, null);
                loadAndFilterValveStemsForPosition(posPascal, true);
            } else {
                updateComponentUI(posPascal, baseComponentTypeForAddonCheck, null);
            }
            
            const otherPosition = positionFromButton === 'Front' ? 'Rear' : 'Front';
            const otherPosLower = otherPosition.toLowerCase();
            const otherActionButtonsContainer = document.getElementById(`${otherPosLower}-valvestem-action-buttons`);

            const isOtherSlotInOptionsView = !buildState.components[`${otherPosLower}ValveStem`] || 
                                           (buildState._ui.isChangingComponent?.position === otherPosition && 
                                            buildState._ui.isChangingComponent?.type === 'ValveStem');

            if (otherActionButtonsContainer && isOtherSlotInOptionsView) {
                showCancelChangeButtonIfNeeded(otherPosition, 'ValveStem', otherActionButtonsContainer);
            }
        }
    } else if (imageContainer) {
        if (!event.target.closest('.optional-addons-btn') && !event.target.closest('.mismatch-hint')) {
            handleSelectedImageClick(event, imageContainer);
        }
    } else if (vendorButton) {
        handleVendorFilterClick(event, vendorButton);
    } else if (dropdownToggle) {
        const dropdown = dropdownToggle.closest('.vendor-filter-dropdown');
        const currentlyOpen = dropdown.classList.contains('is-open');
        
        document.querySelectorAll('.vendor-filter-dropdown.is-open').forEach(d => {
            d.classList.remove('is-open');
        });

        if (!currentlyOpen) {
            dropdown.classList.add('is-open');
        }
    } else if (!event.target.closest('.vendor-filter-dropdown')) {
        document.querySelectorAll('.vendor-filter-dropdown.is-open').forEach(d => {
            d.classList.remove('is-open');
        });
    }
}
  
function validateStep3() {
    let isSelectionComplete = true;
    const buildType = buildState.buildType;
    const components = buildState.components;
    const mandatoryComponentTypes = window.I9System?.isSystem() ? ['Rim', 'Hub', 'Spokes'] : ['Rim', 'Hub', 'Spokes', 'Nipples']; // I9-SYSTEM: no nipple requirement

    if (buildType === 'Front' || buildType === 'Wheel Set') {
        mandatoryComponentTypes.forEach(type => { if (!components[`front${type}`]) isSelectionComplete = false; });
    }
    if (buildType === 'Rear' || buildType === 'Wheel Set') {
        mandatoryComponentTypes.forEach(type => { if (!components[`rear${type}`]) isSelectionComplete = false; });
    }
    
    // Update all relevant Add to Cart buttons
    document.querySelectorAll('#step-3-add-to-cart-button, #step-3-add-to-cart-button-bottom, #sticky-add-to-cart-button').forEach(btn => {
        btn.disabled = false; // Never natively block clicks
        btn.classList.toggle('is-incomplete', !isSelectionComplete);
    });
    
    // Also manage the state of the admin-only share button
    const adminShareButton = document.getElementById('admin-share-build-button');
    if (adminShareButton) {
        adminShareButton.disabled = !isSelectionComplete;
    }
  
    updateValidationSummary();

    return isSelectionComplete;
}

// [START] packageBuildDataForCart - Updated V2
function packageBuildDataForCart() {
    window.StandardStudio?.refresh(); // STANDARD-STUDIO: the fee lines and painting are current before the cart is built
    const { buildType, components, buildId, selectedOptionalAddons, estimatedLeadTime, customerSupplied } = buildState;

    // 1. Define Base Properties
    const baseItemProperties = { "_BuildID": buildId, "_bundle_id": buildId };

    // 2. Helper: Add Item to Raw List (Defined here to capture scope)
    const rawItems = [];
    const addRawItem = (position, componentType, componentData) => {
        if (!componentData) return;
        if (componentData.isVirtual) return; // Skip virtual hubs/spokes
        if (componentData.isIncluded) return; // Skip the free valve

        // I9-SYSTEM: System spokes become one cart line per color with quantity = spokes of that color
        if (componentType === 'Spokes' && window.I9System?.isSystem()) { rawItems.push(...window.I9System.spokeCartLines(position, baseItemProperties)); return; }

        let componentGid = componentData.variantId || componentData.variantGid;
        if (componentType === 'Spokes' && window.StandardStudio) componentGid = window.StandardStudio.lineVariantGid(position, componentData) || componentGid; // STANDARD-STUDIO: a custom-colored wheel's one spoke line is its most-used color (the list keeps the base color)
        if (componentGid) {
            const itemProps = { ...baseItemProperties, "Wheel": position };
            
            // Pass Freehub selection to the Hub Line Item
            if (componentType === 'Hub' && position === 'Rear' && componentData.spec_freehub) {
                itemProps["_Freehub_Type"] = componentData.spec_freehub;
            }
            
            rawItems.push({
                id: getNumericIdFromShopifyGid(componentGid),
                quantity: 1,
                properties: itemProps
            });
        }
    };

    // 3. Clean State for Saving (Remove Virtual Items from JSON)
    const cleanStateForSaving = getCleanBuildStateForSaving();
    const stateForCart = JSON.parse(JSON.stringify(cleanStateForSaving));
    
    if (stateForCart.components) {
        Object.keys(stateForCart.components).forEach(key => {
            const comp = stateForCart.components[key];
            if (comp) {
                if (comp.isVirtual) {
                    stateForCart.components[key] = null;
                } else {
                    delete comp.image; delete comp.tags; delete comp.pairingKey;
                    delete comp.productHandle; delete comp.productId; delete comp.optionalAddonProductGids;
                }
            }
        });
    }
    saveBuildState(buildId, cleanStateForSaving);

    // 4. Check for Pre-configured Match
    const preconfiguredMatch = checkForPreconfiguredMatch();

    if (preconfiguredMatch && preconfiguredMatch.masterVariantGid) {
        // === PATH A: PRE-CONFIGURED MATCH ===
        console.log(`[Cart] Adding Pre-configured Match: ${preconfiguredMatch.name}`);
        // PRECONFIGURED-RULES: tell the accessories page this build is one master line (valves are offered there when the rule says "extra")
        try { localStorage.setItem('ll_precfg_' + buildId, JSON.stringify({ v: 1, rule: preconfiguredMatch.name, valves: window.PreconfiguredRules && window.PreconfiguredRules.valvesExtra(preconfiguredMatch) ? 'extra' : 'included', freehub: preconfiguredMatch.freehubLine === true, at: Date.now() })); } catch (e) { /* the page then treats the build as a normal one */ }
        const masterVariantId = getNumericIdFromShopifyGid(preconfiguredMatch.masterVariantGid);

        const readableSpecs = {};
        const addSpec = (label, comp) => {
            if (comp) {
                let val = comp.title;
                if (comp.selectedOptions) {
                    const details = comp.selectedOptions.map(o => o.value).filter(v => v !== 'Default Title').join(' / ');
                    if (details) val += ` (${details})`;
                } else if (comp.variantTitle && comp.variantTitle !== 'Default Title') {
                    val += ` (${comp.variantTitle})`;
                }
                readableSpecs[label] = val;
            }
        };

        if (buildType === 'Wheel Set') {
            addSpec('Front Rim', components.frontRim);
            addSpec('Rear Rim', components.rearRim);
            addSpec('Front Hub', components.frontHub);
            addSpec('Rear Hub', components.rearHub);
            if (components.rearHub && components.rearHub.spec_freehub) readableSpecs['Freehub Body'] = components.rearHub.spec_freehub;
            else if (components.rearComponentFreehub) addSpec('Freehub Component', components.rearComponentFreehub);
            addSpec('Front Spokes', components.frontSpokes);
            addSpec('Rear Spokes', components.rearSpokes);
            addSpec('Front Nipples', components.frontNipples);
            addSpec('Rear Nipples', components.rearNipples);
        }

        rawItems.push({
            id: masterVariantId,
            quantity: 1,
            properties: {
                ...baseItemProperties,
                ...readableSpecs,
                "_is_custom_wheel_build": "true",
                "_EstLeadTime": formatLeadTime(estimatedLeadTime),
                "_build": JSON.stringify(stateForCart),
                "_Preconfigured_Rule": preconfiguredMatch.name,
                ...(window.StandardStudio?.readableProperties() || {}) // STANDARD-STUDIO: readable colors for a custom-colored wheel (empty otherwise)
            }
        });
        if (window.StandardStudio) rawItems.push(...window.StandardStudio.feeCartLines(baseItemProperties)); // STANDARD-STUDIO: fee lines next to the master variant
        // PRECONFIGURED-RULES: valves: "extra" -> the kept valve stems are normal separate lines (none when declined)
        if (window.PreconfiguredRules && window.PreconfiguredRules.valvesExtra(preconfiguredMatch) && buildType === 'Wheel Set') {
            addRawItem('Front', 'ValveStem', components.frontValveStem);
            addRawItem('Rear', 'ValveStem', components.rearValveStem);
        }
        // PRECONFIGURED-RULES: the freehub body as its own line at its REAL price ($0 bodies add a $0 line), only for a rule that sets freehubLine: true (the Reserve rules do not, so their orders are unchanged). Backend 1 confirmed the webhook ignores that line (AGENT_BACKEND1_PRECONFIGURED_LENGTHS_REPORT.md, task 2). Switch: PreconfiguredRules.CFG.freehubLine. The master price never includes a freehub body.
        if (window.PreconfiguredRules && window.PreconfiguredRules.CFG.freehubLine && preconfiguredMatch.freehubLine === true && buildType === 'Wheel Set' && components.rearComponentFreehub?.variantId) {
            rawItems.push({ id: getNumericIdFromShopifyGid(components.rearComponentFreehub.variantId), quantity: 1, properties: { ...baseItemProperties, "Wheel": "Rear", "Component": "Freehub" } });
        }

        if (selectedOptionalAddons) {
            Object.values(selectedOptionalAddons).forEach(addon => {
                if (addon?.addonVariantId) {
                    rawItems.push({
                        id: getNumericIdFromShopifyGid(addon.addonVariantId),
                        quantity: 1,
                        properties: { ...baseItemProperties, "Wheel": addon.baseComponentPosition, "_AttachedTo": `${addon.baseComponentType} Add-on` }
                    });
                }
            });
        }

   } else {
        // === PATH B: CUSTOM BUILD (Standard & Integrated) ===
        try { localStorage.removeItem('ll_precfg_' + buildId); } catch (e) { /* none */ } // a build that changed after an earlier rule match is a normal build again
        
        // FRONT components: Only add if Front or Wheel Set
        if (buildType === 'Front' || buildType === 'Wheel Set') {
            addRawItem('Front', 'Rim', components.frontRim);
            addRawItem('Front', 'Hub', components.frontHub);
            addRawItem('Front', 'Spokes', components.frontSpokes);
            addRawItem('Front', 'Nipples', components.frontNipples);
            addRawItem('Front', 'ValveStem', components.frontValveStem);
            addRawItem('Front', 'AssemblyService', components.frontAssemblyService);
            addRawItem('Front', 'TubelessTape', components.frontTubelessTape);
            (components.frontRequiredAddons || []).forEach(addon => addRawItem('Front', 'RequiredAddon', addon));
        }

        // REAR components: Only add if Rear or Wheel Set
        if (buildType === 'Rear' || buildType === 'Wheel Set') {
            addRawItem('Rear', 'Rim', components.rearRim);
            addRawItem('Rear', 'Hub', components.rearHub);
            addRawItem('Rear', 'Spokes', components.rearSpokes);
            addRawItem('Rear', 'Nipples', components.rearNipples);
            addRawItem('Rear', 'ValveStem', components.rearValveStem);
            addRawItem('Rear', 'AssemblyService', components.rearAssemblyService);
            addRawItem('Rear', 'TubelessTape', components.rearTubelessTape);
            (components.rearRequiredAddons || []).forEach(addon => addRawItem('Rear', 'RequiredAddon', addon));

            // Guard the Freehub inside the Rear check
            if (components.rearComponentFreehub?.variantId) {
                rawItems.push({
                    id: getNumericIdFromShopifyGid(components.rearComponentFreehub.variantId),
                    quantity: 1,
                    properties: { ...baseItemProperties, "Wheel": "Rear", "Component": "Freehub" }
                });
            }
        }

        if (selectedOptionalAddons) {
            Object.values(selectedOptionalAddons).forEach(addon => {
                if (addon?.addonVariantId) {
                    rawItems.push({
                        id: getNumericIdFromShopifyGid(addon.addonVariantId),
                        quantity: 1,
                        properties: { ...baseItemProperties, "Wheel": addon.baseComponentPosition, "_AttachedTo": `${addon.baseComponentType} Add-on` }
                    });
                }
            });
        }

        const isSupplyingOwnParts = Object.values(customerSupplied.front).some(v => v) || Object.values(customerSupplied.rear).some(v => v);
        const placeholderProperties = {
            ...baseItemProperties,
            "_is_custom_wheel_build": "true",
            "_EstLeadTime": formatLeadTime(estimatedLeadTime),
            "_build": JSON.stringify(stateForCart)
        };
        if (isSupplyingOwnParts) placeholderProperties['_Customer_Parts_Confirmed'] = 'true';
        // I9-SYSTEM: human-readable spoke color counts and per-spoke maps as order properties; logs the _build size for the limit check
        if (window.I9System?.isSystem()) { Object.assign(placeholderProperties, window.I9System.readableProperties()); window.I9System.reportBuildSize(placeholderProperties); }
        else if (window.StandardStudio) Object.assign(placeholderProperties, window.StandardStudio.readableProperties()); // STANDARD-STUDIO: readable colors for a custom-colored wheel only

        rawItems.unshift({
            id: getNumericIdFromShopifyGid(PLACEHOLDER_PRODUCT_VARIANT_ID),
            quantity: 1,
            properties: placeholderProperties
        });
    }

    // 5. Consolidate duplicates (e.g. tape)
    const consolidatedItems = {};
    for (const item of rawItems) {
        if (!item.id) continue;
        const lineKey = item.properties?._spoke_bundle ? item.id + ':' + item.properties.Wheel : item.id; // I9-SYSTEM: a System wheel's spoke bundle is always its own line (two wheels in the same color stay two lines, each with its own colors)
        if (consolidatedItems[lineKey]) {
            consolidatedItems[lineKey].quantity += item.quantity;
            if (consolidatedItems[lineKey].properties.Wheel && item.properties.Wheel && consolidatedItems[lineKey].properties.Wheel !== item.properties.Wheel) {
                 consolidatedItems[lineKey].properties.Wheel = 'Front/Rear';
            }
        } else {
            consolidatedItems[lineKey] = item;
        }
    }

    return { itemsForShopifyCart: Object.values(consolidatedItems) };
}
// [END] packageBuildDataForCart

/**
 * V4.6 Build Check Engine: Pairing-Aware & Valve Stem Interceptor
 * Warns about missing valves and unmatched paired add-ons.
 */
function performBuildCheck() {
    const warnings = [];
    const { buildType, components, selectedOptionalAddons } = buildState;

    if (!buildType) return warnings;

    // --- Check 1: Valve Stem Missing or Mismatch ---
    // Only nag the user if this is a brand new build (NOT in Edit Mode)
    if (!buildState._ui.inEditMode) {
        const fValve = components.frontValveStem;
        const rValve = components.rearValveStem;

        if (buildType === 'Wheel Set') {
            if (!fValve && !rValve) {
                warnings.push({
                    type: 'ValveStem',
                    message: 'No Valve Stems selected. We recommend adding them for a complete tubeless setup.',
                    targetId: 'front-valvestem-subsection'
                });
            } else if (!fValve && rValve) {
                warnings.push({
                    type: 'ValveStem',
                    message: 'Your Front Wheel is missing a Valve Stem.',
                    targetId: 'front-valvestem-subsection'
                });
            } else if (fValve && !rValve) {
                warnings.push({
                    type: 'ValveStem',
                    message: 'Your Rear Wheel is missing a Valve Stem.',
                    targetId: 'rear-valvestem-subsection'
                });
            }
        } else if (buildType === 'Front' && !fValve) {
            warnings.push({
                type: 'ValveStem',
                message: 'Your wheel is missing a Valve Stem. We recommend adding one for a complete tubeless setup.',
                targetId: 'front-valvestem-subsection'
            });
        } else if (buildType === 'Rear' && !rValve) {
            warnings.push({
                type: 'ValveStem',
                message: 'Your wheel is missing a Valve Stem. We recommend adding one for a complete tubeless setup.',
                targetId: 'rear-valvestem-subsection'
            });
        }
    }

    window.I9System?.addStudioReminder(warnings); // I9-SYSTEM: prompt the Spoke Color Studio if it was never opened

    // --- Check 2: Paired Add-on Mismatch (Only applies to Wheel Sets) ---
    // We KEEP this active in Edit Mode so they don't accidentally mismatch bearings while editing
    if (buildType === 'Wheel Set') {
        const addonKeys = Object.keys(selectedOptionalAddons);
        const checkedPairingKeys = new Set();

        addonKeys.forEach(key => {
            const addon = selectedOptionalAddons[key];
            const pKey = addon.addonProductPairingKey;
            const compType = addon.baseComponentType; // e.g. 'Hub' or 'Rim'
            const pos = addon.baseComponentPosition; // 'Front' or 'Rear'
            const oppPos = pos === 'Front' ? 'Rear' : 'Front';

            if (pKey && !checkedPairingKeys.has(pKey)) {
                
                const currentBase = components[`${pos.toLowerCase()}${compType}`];
                const partnerBase = components[`${oppPos.toLowerCase()}${compType}`];

                const isBaseComponentPair = currentBase && partnerBase && 
                                            currentBase.pairingKey === partnerBase.pairingKey;

                if (isBaseComponentPair) {
                    const hasPartner = addonKeys.some(otherKey => {
                        const otherAddon = selectedOptionalAddons[otherKey];
                        return otherAddon.baseComponentPosition === oppPos &&
                               otherAddon.baseComponentType === compType &&
                               otherAddon.addonProductPairingKey === pKey;
                    });

                    if (!hasPartner) {
                        warnings.push({
                            type: 'Addon',
                            message: `The ${pos} ${getDisplayName(compType.toLowerCase())} has the "${addon.addonName}" upgrade, but the ${oppPos} does not.`,
                            targetId: `${oppPos.toLowerCase()}-${compType.toLowerCase()}-subsection`
                        });
                        checkedPairingKeys.add(pKey);
                    }
                }
            }
        });
    }

    return warnings;
}

/**
 * Displays the Build Warning Modal.
 * @param {Array} warnings - The list of warnings.
 * @param {Function} onContinue - Callback if user clicks "Continue Anyway".
 * @param {Boolean} isHardStop - If true, hides the Continue button.
 */
function showBuildWarningModal(warnings, onContinue, isHardStop = false) {
    const modal = document.getElementById('spec-change-confirm-modal');
    const title = document.getElementById('spec-change-modal-title');
    const body = document.getElementById('spec-change-modal-body');
    const confirmBtn = document.getElementById('spec-change-modal-confirm-btn');
    const cancelBtn = document.getElementById('spec-change-modal-cancel-btn');

    if (!modal || !body) return;

    title.textContent = isHardStop ? "Build Incomplete" : "Review Your Build";
    
    let warningHtml = '';

    if (warnings.length === 1 && warnings[0].type === 'ValveStem') {
        warningHtml = `
            <p style="font-size: 1.1em; text-align: center; margin-bottom: 20px;">
                <strong>${warnings[0].message}</strong>
            </p>
            <p style="text-align: center; margin-bottom: 0;">Would you like to go back and add them, or continue to checkout?</p>
        `;
    } else {
        const i9OptionalOnly = !isHardStop && warnings.some(w => w.type === 'Studio'); // I9-SYSTEM: softer header when the Studio reminder is in the list
        warningHtml = `<p>${i9OptionalOnly ? 'A few optional items to review before checkout:' : 'We noticed a few missing required components:'}</p><ul class="build-check-list">`;
        warnings.forEach(w => {
            warningHtml += `<li><strong>${w.message}</strong></li>`;
        });
        warningHtml += `</ul>`;
    }
    
    body.innerHTML = warningHtml;

    // Toggle button visibility based on whether they are allowed to proceed
    if (isHardStop) {
        confirmBtn.style.display = 'none';
        cancelBtn.textContent = "Take me to missing items";
    } else {
        confirmBtn.style.display = 'block';
        confirmBtn.textContent = "Continue to Checkout";
        cancelBtn.textContent = "Go Back & Fix";
    }

    // Setup "Continue" action
    confirmBtn.onclick = () => {
        modal.style.display = 'none';
        if (onContinue) onContinue();
    };

    // Setup "Go Back" action (Snapping to the first issue)
    cancelBtn.onclick = () => {
        modal.style.display = 'none';
        const firstWarning = warnings[0];
        const targetElement = document.getElementById(firstWarning.targetId);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            targetElement.classList.add('flash-highlight');
            setTimeout(() => targetElement.classList.remove('flash-highlight'), 2000);
        }
    };

    modal.style.display = 'flex';
}


// [START] addToCart logic with Build Check
async function addToCart() {
    console.log("%c[Action] addToCart logic started", "background: #222; color: #bada55; padding: 2px;");
    
    const { buildType, components } = buildState;

    // 1. INCOMPLETE BUILD CHECK (The Hard Stop Interceptor)
    if (!validateStep3()) {
        const missing = [];
        const mandatoryComponentTypes = [
            { key: 'Rim', display: 'Rim' },
            { key: 'Hub', display: 'Hub' },
            { key: 'Spokes', display: 'Spokes' },
            { key: 'Nipples', display: 'Nipples' }
        ].filter(t => t.key !== 'Nipples' || !window.I9System?.isSystem()); // I9-SYSTEM

        if (buildType === 'Front' || buildType === 'Wheel Set') {
            mandatoryComponentTypes.forEach(type => {
                if (!components[`front${type.key}`]) missing.push({ message: `Missing Front ${type.display}`, targetId: `front-${type.key.toLowerCase()}-subsection` });
            });
        }
        if (buildType === 'Rear' || buildType === 'Wheel Set') {
            mandatoryComponentTypes.forEach(type => {
                if (!components[`rear${type.key}`]) missing.push({ message: `Missing Rear ${type.display}`, targetId: `rear-${type.key.toLowerCase()}-subsection` });
            });
        }

        // Fire the modal with the Hard Stop flag = true
        showBuildWarningModal(missing, null, true);
        return;
    }

    // 2. STANDARD ENGINEERING CHECK (Valves & Add-ons)
    if (!buildState._ui.inEditMode || buildState._ui.hasChanges) {
        const warnings = performBuildCheck();
        if (warnings.length > 0) {
            // Fire the modal with the Hard Stop flag = false
            showBuildWarningModal(warnings, () => proceedWithAddToCart(), false);
            return; 
        }
    }

    // 3. PROCEED IF CLEAR
    proceedWithAddToCart();
}

/**
 * The actual cart submission logic, isolated so it can be called after a warning is acknowledged.
 */
async function proceedWithAddToCart() {
    const { buildType } = buildState;
    if (window.FullBuild && window.FullBuild.checkAdd && !window.FullBuild.checkAdd()) return; // FULL-BUILD-LINK: a build opened from a master page and left unchanged is only added when the rule matches its master at the master price

    // 1. Run final cost/engineering calculations
    if (buildType === 'Front' || buildType === 'Wheel Set') calculateWheelCosts('Front');
    if (buildType === 'Rear' || buildType === 'Wheel Set') calculateWheelCosts('Rear');
    updateSubtotal();

    // 2. Package the build data
    const { itemsForShopifyCart } = packageBuildDataForCart();
    const validItems = itemsForShopifyCart.filter(item => item.id);

    // 3. UI Feedback
    const isEditMode = buildState._ui.inEditMode === true;
    const allCartButtons = document.querySelectorAll('#step-3-add-to-cart-button, #step-3-add-to-cart-button-bottom');
    allCartButtons.forEach(btn => {
        btn.disabled = true;
        btn.textContent = isEditMode ? 'Updating Cart...' : 'Adding to Cart...';
    });

    try {
        if (isEditMode) {
            const cartRes = await fetch('/cart.js');
            const cartData = await cartRes.json();
            const others = cartData.items.filter(item => !item.properties || item.properties._BuildID !== buildState.buildId);
            await fetch('/cart/clear.js', { method: 'POST' });
            const itemsToReAdd = [...others.map(i => ({ id: i.variant_id, quantity: i.quantity, properties: i.properties })), ...validItems];
            await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: itemsToReAdd }) });
        } else {
            await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: validItems }) });
        }

        if (isEditMode) {
            sessionStorage.setItem(`ll_main_build_edited_${buildState.buildId}`, 'true');
            window.location.href = '/cart';
        } else {
            window.location.href = `/pages/accessories?build_id=${buildState.buildId}`;
        }
    } catch (error) {
        console.error('[Cart Error] addToCart failed:', error);
        alert("An error occurred while adding to cart.");
        allCartButtons.forEach(btn => btn.disabled = false);
        updateStep3ButtonText(); 
    }
}
// [END] addToCart logic

    // --- Listener Setup Functions (Keep existing, ensure step3 listener calls new addToCart) ---
    function setupStep1Listeners() {
    const step1Element = document.getElementById('step-1');
    if (!step1Element) {
        console.error("setupStep1Listeners: Step 1 element not found.");
        return;
    }

    // 1. Handle Main Button Clicks (Build Type & Riding Style)
    step1Element.addEventListener('click', (e) => {
        const targetButton = e.target.closest('button.selection-button');
        if (!targetButton || targetButton.id === 'step-1-next-button') return;
        
        const selectionType = targetButton.dataset.selectionType;
        const value = targetButton.dataset.value;
        const displayText = targetButton.textContent.trim();

        if (!selectionType || !value) {
            console.warn("Step 1 button clicked without type/value", targetButton);
            return;
        }

        // I9-SYSTEM: the Spoke Interface row is owned by assets/i9-system.js (locks Riding Style to Hybrid, confirms a change after progress)
        if (selectionType === 'spokeInterface') { window.I9System?.onSpokeInterfaceClick(value, targetButton); return; }

        if (buildState[selectionType] !== value) {
            const previousRidingStyle = buildState.ridingStyle;
            buildState[selectionType] = value;

            if (selectionType === 'ridingStyle') {
                buildState.ridingStyleDisplay = displayText;
            }

            updateStep1VisualFeedback(selectionType, targetButton);
            validateStep1();

            // --- START: THE CLEANER (Build Type Change Logic) ---
            if (selectionType === 'buildType') {
                let stateModified = false;
                const specsToClear = [];
                const componentsToClear = [];

                // Wiping data for the side that is now hidden
                if (value === 'Front') {
                    specsToClear.push('rearWheelSize', 'rearSpokeCount', 'rearHubSpacing', 'freehubType');
                    componentsToClear.push(
                        'rearRim', 'rearHub', 'rearSpokes', 'rearNipples', 'rearValveStem', 
                        'rearComponentFreehub', 'rearAssemblyService', 'rearTubelessTape', 'rearRequiredAddons'
                    );
                } else if (value === 'Rear') {
                    specsToClear.push('frontWheelSize', 'frontSpokeCount', 'frontHubSpacing');
                    componentsToClear.push(
                        'frontRim', 'frontHub', 'frontSpokes', 'frontNipples', 'frontValveStem', 
                        'frontAssemblyService', 'frontTubelessTape', 'frontRequiredAddons'
                    );
                }

                // A. Wipe the Technical Specs
                specsToClear.forEach(key => {
                    if (buildState.specs[key] !== null) {
                        buildState.specs[key] = null;
                        stateModified = true;
                        if (buildState._ui.step2AutoSelected[key]) delete buildState._ui.step2AutoSelected[key];
                    }
                });

                // B. Wipe the Physical Selections (The Ghost-Killer)
                componentsToClear.forEach(key => {
                    if (buildState.components[key]) {
                        buildState.components[key] = (key.endsWith('Addons')) ? [] : null;
                        stateModified = true;
                    }
                });

                if (stateModified) {
                    updateSubtotal();
                    updateBuildSummary();
                    saveLastActiveBuild();
                }
                updateCustomerSuppliedCheckboxesVisibility(); 

            } else if (selectionType === 'ridingStyle') {
                // Handle Riding Style Reset
                if (previousRidingStyle !== null && previousRidingStyle !== value) {
                    console.log(`Riding style changed. Resetting build.`);
                    const preservedUiState = buildState._ui;
                    const preservedBuildId = buildState.buildId;
                    Object.keys(buildState.specs).forEach(k => buildState.specs[k] = null);
                    Object.keys(buildState.components).forEach(k => buildState.components[k] = null);
                    buildState.selectedOptionalAddons = {};
                    buildState._ui = preservedUiState;
                    buildState.buildId = preservedBuildId;
                    buildState._ui.step2AutoSelected = {};
                    allRimProductsCache = [];
                    allHubProductsCache = [];
                    componentFetchPromises.rims = null;
                    componentFetchPromises.hubs = null;
                    clearStep3UI();
                    updateBuildSummary();
                    saveLastActiveBuild();
                    if (buildState.step >= 2) {
                        renderStep2();
                        updateStep2OptionsVisibility();
                        updateStep2VisualFeedback();
                        validateStep2();
                    }
                }
                
                triggerEarlyComponentFetches();
                updateBuildSummary();
                updateCustomerSuppliedCheckboxesVisibility();
            }
            
            // Final summary refresh
            updateBuildSummary();
        }
    });

    // 2. Handle Customer Supplied Checkboxes
    const customerSuppliedSection = document.getElementById('customer-supplied-section');
    if (customerSuppliedSection) {
        customerSuppliedSection.addEventListener('change', event => {
            const checkbox = event.target;
            if (!checkbox || !checkbox.matches('.customer-supplied-checkbox')) return;

            const position = checkbox.dataset.position;
            const component = checkbox.dataset.component;

            if (buildState?.customerSupplied?.[position]) {
                buildState.customerSupplied[position][component] = checkbox.checked;
            }
        });
    }
}
      
// --- START: SMART HEALING ALGORITHM HELPER (V2 - Cross Component) ---
function getValidCountsForPos(testSpecs, pos) {
    if (window.I9System?.isSystem()) return window.I9System.validCounts(testSpecs, pos); // I9-SYSTEM: System hubs and ratio-matched rims only
    const posL = pos.toLowerCase();
    const clean = (val) => val ? String(val).replace(/\D/g, '') : "";
    
    // 1. Gather Rims
    const validRimsByProduct = new Map();
    allRimProductsCache.forEach(p => {
        if (p.vendor === 'Your Own Component') return;
        if (p.tags && p.tags.includes('i9_system')) return;
        const validVariants = [];
        p.variants.forEach(v => {
            if (v.spec_position !== pos && v.spec_position !== "Front/Rear") return;
            if (!v.availableForSale) return;
            const sizeVal = v.spec_rim_size?.parsedValue;
            if (testSpecs[`${posL}WheelSize`] && sizeVal !== testSpecs[`${posL}WheelSize`] && !(Array.isArray(sizeVal) && sizeVal.includes(testSpecs[`${posL}WheelSize`]))) return;
            if (testSpecs[`${posL}SpokeCount`] && clean(v.spec_spoke_count) !== clean(testSpecs[`${posL}SpokeCount`])) return;
            
            const isRimBrake = (v.spec_brake_interface || []).includes('Rim Brake');
            const supportsDisc = !isRimBrake;
            if (testSpecs.brakeStyle) {
                if (testSpecs.brakeStyle === 'Rim Brake' && !isRimBrake) return;
                if (testSpecs.brakeStyle !== 'Rim Brake' && !supportsDisc) return;
            }
            
            validVariants.push({ spokeCount: clean(v.spec_spoke_count), supportsRimBrake: isRimBrake, supportsDisc: supportsDisc });
        });
        if (validVariants.length > 0) validRimsByProduct.set(p.id, validVariants);
    });

    // 2. Gather Hubs
    const validHubsByProduct = new Map();
    allHubProductsCache.forEach(p => {
        if (p.vendor === 'Your Own Component') return;
        if (p.tags && p.tags.includes('i9_system')) return;
        if (pos === 'Rear' && testSpecs.freehubType && (!p.availableFreehubs || !isFreehubCompatible(testSpecs.freehubType, p.availableFreehubs))) return;
        
        const validVariants = [];
        p.variants.forEach(v => {
            if (v.spec_position !== pos && v.spec_position !== "Front/Rear") return;
            if (!v.availableForSale) return;
            if (testSpecs[`${posL}HubSpacing`] && normalizeSpacing(v.spec_hub_spacing) !== normalizeSpacing(testSpecs[`${posL}HubSpacing`])) return;
            if (testSpecs[`${posL}SpokeCount`] && clean(v.spec_spoke_count) !== clean(testSpecs[`${posL}SpokeCount`])) return;
            
            const isRimBrake = (v.spec_brake_interface || []).includes('Rim Brake');
            const is6Bolt = (v.spec_brake_interface || []).includes('6-Bolt');
            const isCenterlock = (v.spec_brake_interface || []).includes('Centerlock');
            
            if (testSpecs.brakeStyle) {
                if (testSpecs.brakeStyle === 'Rim Brake' && !isRimBrake) return;
                if (testSpecs.brakeStyle === '6-Bolt' && !is6Bolt) return;
                if (testSpecs.brakeStyle === 'Centerlock' && !isCenterlock) return;
            }
            
            validVariants.push({ spokeCount: clean(v.spec_spoke_count), supportsRimBrake: isRimBrake, supportsDisc: is6Bolt || isCenterlock });
        });
        if (validVariants.length > 0) validHubsByProduct.set(p.id, validVariants);
    });

    // 3. CROSS-REFERENCE: Only count products that mathematically pair together!
    const confirmedRimProducts = new Set();
    const confirmedHubProducts = new Set();

    validRimsByProduct.forEach((rimVariants, rimId) => {
        validHubsByProduct.forEach((hubVariants, hubId) => {
            const matchFound = rimVariants.some(r => {
                return hubVariants.some(h => {
                    if (r.spokeCount !== h.spokeCount) return false;
                    if (r.supportsRimBrake && h.supportsRimBrake) return true;
                    if (r.supportsDisc && h.supportsDisc) return true;
                    return false;
                });
            });
            if (matchFound) {
                confirmedRimProducts.add(rimId);
                confirmedHubProducts.add(hubId);
            }
        });
    });

    return { rimCount: confirmedRimProducts.size, hubCount: confirmedHubProducts.size };
}

function isValidCombination(testSpecs) {
    // --- START: LOADING GUARD ---
    // Bypass healing and trust the user's selections if background data is still downloading
    if (allRimProductsCache.length === 0 || allHubProductsCache.length === 0) {
        return true; 
    }
    // --- END: LOADING GUARD ---

    if (buildState.buildType === 'Front' || buildState.buildType === 'Wheel Set') {
        const counts = getValidCountsForPos(testSpecs, 'Front');
        if (counts.rimCount === 0 || counts.hubCount === 0) return false;
    }
    if (buildState.buildType === 'Rear' || buildState.buildType === 'Wheel Set') {
        const counts = getValidCountsForPos(testSpecs, 'Rear');
        if (counts.rimCount === 0 || counts.hubCount === 0) return false;
    }
    return true;
}
// --- END: SMART HEALING ALGORITHM HELPER (V2 - Cross Component) ---

function setupStep2Listeners() {
    const step2Element = document.getElementById('step-2');
    if (!step2Element) return;

    if (!document.getElementById('loamlabs-unavailable-css')) {
        const style = document.createElement('style');
        style.id = 'loamlabs-unavailable-css';
        style.innerHTML = `
            button.spec-option-button.is-unavailable:not(.active):active {
                background-color: #f8f9fa !important;
                color: #6c757d !important;
            }
        `;
        document.head.appendChild(style);
    }

    step2Element.addEventListener('click', function(e) {
        const button = e.target.closest('button.spec-option-button');
        if (!button) return;

        const specGroupDiv = button.closest('.spec-group');
        const domSpecKey = specGroupDiv.dataset.specName;
        const specValue = button.dataset.value;

        // I9-SYSTEM: the Hub row (Solix / Hydra2) sets brake style, counts, spacings and freehubs through the module
        if (domSpecKey === 'systemHub') { window.I9System?.onHubModelChange(specValue, button); return; }
        // I9-SYSTEM: a wheel size the other wheel's size does not pair with asks "Change both" first (the module re-clicks the button on confirm)
        if (window.I9System?.onSizeClick?.(domSpecKey, specValue, button)) return;

        // Block Freehub clicks as they are a true dead end
        if (button.classList.contains('is-unavailable') && domSpecKey === 'freehubType') return;

        let stateChanged = false;

        if (buildState.specs[domSpecKey] !== specValue) {
            
            // 1. Stage the new specs
            const currentSpecs = { ...buildState.specs };
            currentSpecs[domSpecKey] = specValue;

            // 2. Apply forced compatibility for wheel sizes (Mullet fallback)
            if (button.classList.contains('is-incompatible')) {
                if (domSpecKey === 'frontWheelSize' && specValue === '27.5"') currentSpecs.rearWheelSize = '27.5"'; 
                else if (domSpecKey === 'rearWheelSize' && specValue === '29"') currentSpecs.frontWheelSize = '29"'; 
            }

            // 3. Apply Gravel/Road Smart Sync
            if (buildState.ridingStyle === 'gravelroad' && buildState.buildType === 'Wheel Set') {
                if (domSpecKey === 'frontWheelSize' || domSpecKey === 'rearWheelSize') {
                    currentSpecs.frontWheelSize = specValue;
                    currentSpecs.rearWheelSize = specValue;
                }
                if (domSpecKey === 'brakeStyle') {
                    if (specValue === 'Rim Brake') {
                        currentSpecs.frontHubSpacing = "9x100mm QR";
                        currentSpecs.rearHubSpacing = "10x130mm QR";
                    } else if (specValue === '6-Bolt' || specValue === 'Centerlock') {
                        currentSpecs.frontHubSpacing = "12x100mm";
                        currentSpecs.rearHubSpacing = "12x142mm";
                    }
                }
                if (domSpecKey === 'frontHubSpacing' || domSpecKey === 'rearHubSpacing') {
                    if (specValue.includes('QR')) {
                        currentSpecs.brakeStyle = "Rim Brake";
                        currentSpecs.frontHubSpacing = "9x100mm QR";
                        currentSpecs.rearHubSpacing = "10x130mm QR";
                    } else if (specValue === "12x100mm" || specValue === "12x142mm") {
                        currentSpecs.frontHubSpacing = "12x100mm";
                        currentSpecs.rearHubSpacing = "12x142mm";
                        if (currentSpecs.brakeStyle === "Rim Brake") currentSpecs.brakeStyle = null;
                    }
                }
            }

            // --- 4. THE SMART HEALING ENGINE ---
            if (!isValidCombination(currentSpecs)) {
                // The combination is invalid. Start salvage operation.
                const healedSpecs = {
                    frontWheelSize: null, rearWheelSize: null,
                    frontSpokeCount: null, rearSpokeCount: null,
                    brakeStyle: null,
                    frontHubSpacing: null, rearHubSpacing: null,
                    freehubType: currentSpecs.freehubType
                };
                window.I9System?.protectSpecs(healedSpecs, currentSpecs); // I9-SYSTEM: healing must keep systemHub and the hub-dictated brake style

                // Keep what they just clicked
                healedSpecs[domSpecKey] = currentSpecs[domSpecKey];
                
                // Keep the sync'd items
                if (button.classList.contains('is-incompatible')) {
                    if (domSpecKey === 'frontWheelSize' && specValue === '27.5"') healedSpecs.rearWheelSize = '27.5"'; 
                    else if (domSpecKey === 'rearWheelSize' && specValue === '29"') healedSpecs.frontWheelSize = '29"'; 
                }
                if (buildState.ridingStyle === 'gravelroad' && buildState.buildType === 'Wheel Set') {
                    if (domSpecKey === 'frontWheelSize' || domSpecKey === 'rearWheelSize') { healedSpecs.frontWheelSize = specValue; healedSpecs.rearWheelSize = specValue; }
                    if (domSpecKey === 'brakeStyle') {
                        if (specValue === 'Rim Brake') { healedSpecs.frontHubSpacing = "9x100mm QR"; healedSpecs.rearHubSpacing = "10x130mm QR"; }
                        else if (specValue === '6-Bolt' || specValue === 'Centerlock') { healedSpecs.frontHubSpacing = "12x100mm"; healedSpecs.rearHubSpacing = "12x142mm"; }
                    }
                    if (domSpecKey === 'frontHubSpacing' || domSpecKey === 'rearHubSpacing') {
                        if (specValue.includes('QR')) { healedSpecs.brakeStyle = "Rim Brake"; healedSpecs.frontHubSpacing = "9x100mm QR"; healedSpecs.rearHubSpacing = "10x130mm QR"; }
                        else if (specValue === "12x100mm" || specValue === "12x142mm") { healedSpecs.frontHubSpacing = "12x100mm"; healedSpecs.rearHubSpacing = "12x142mm"; if (healedSpecs.brakeStyle === "Rim Brake") healedSpecs.brakeStyle = null; }
                    }
                }

                // Add back previously selected specs one by one
                const priorityKeys = ['brakeStyle', 'frontWheelSize', 'rearWheelSize', 'frontHubSpacing', 'rearHubSpacing', 'frontSpokeCount', 'rearSpokeCount'];
                
                for (const pKey of priorityKeys) {
                    if (!buildState.specs[pKey] || healedSpecs[pKey]) continue; 
                    
                    healedSpecs[pKey] = buildState.specs[pKey]; // Try adding it
                    
                    if (!isValidCombination(healedSpecs)) {
                        healedSpecs[pKey] = null; // Revert! It conflicts with the new selection
                    }
                }
                buildState.specs = healedSpecs;
            } else {
                // It's valid as-is. Just apply it.
                buildState.specs = currentSpecs;
            }

            stateChanged = true;
        }

        if (stateChanged) {
            updateMtbWheelSizeCompatibility(); 
            updateStep2VisualFeedback();      
            updateSpecAvailabilityCounters(); // Validates Step 2 and Auto-selects
            updateFreehubLockUI();            // Check if we should unlock the Freehub row!
            saveLastActiveBuild();           
        }
    });
}

function setupNavigationListeners() {
    step1NextButton?.addEventListener('click', () => {
        if (!step1NextButton.disabled) {
            const hasCustomerSupplied = Object.values(buildState.customerSupplied.front).some(v => v) || Object.values(buildState.customerSupplied.rear).some(v => v);

            if (hasCustomerSupplied) {
                // If user is supplying parts, show the consolidated modal first.
                // The modal's confirm button will then trigger the move to Step 2.
                showConsolidatedConfirmationModal();
            } else {
                // If not supplying parts, proceed directly to Step 2.
                triggerEarlyComponentFetches();
                showStep(2);
            }
        }
    });

    step2NextButton?.addEventListener('click', async () => {
        if (!step2NextButton.disabled) {
            step2NextButton.disabled = true;
            step2NextButton.textContent = 'Building...';
            try {
                await showStep(3);
            } catch (error) {
                console.error("Error during Step 3 build process:", error);
                alert("An error occurred while preparing the next step. Please try again.");
            } finally {
                step2NextButton.disabled = false;
                step2NextButton.textContent = 'Next: Components';
                validateStep2();
            }
        }
    });

    // Back button logic remains the same
    document.getElementById('step-2-back-button')?.addEventListener('click', () => showStep(1));
    document.querySelectorAll('#step-3-back-button-TOP, #step-3-back-button, #step-3-back-button-bottom').forEach(button => {
        button.addEventListener('click', () => showStep(2));
    });
}

/**
 * Generates a simple Version 4 UUID for anonymous user tracking.
 * @returns {string} A unique identifier string.
 */
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * Determines the visitor's identity for tracking purposes.
 * It prioritizes the server-rendered customer data object.
 * @returns {object} An object containing visitor identification data.
 */
function getVisitorIdentifier() {
    // Priority 1: Check for our custom, server-rendered customer object.
    if (window._loamlabs_customer_data && window._loamlabs_customer_data.isLoggedIn) {
        const customer = window._loamlabs_customer_data;
        return {
            isLoggedIn: true,
            customerId: customer.id,
            email: customer.email,
            firstName: customer.first_name,
            lastName: customer.last_name
        };
    }

    // Fallback to anonymous tracking using localStorage
    const anonymousIdKey = 'loamlabs_visitor_id';
    let visitorId = localStorage.getItem(anonymousIdKey);

    if (!visitorId) {
        // Assuming generateUUID() function exists elsewhere in this file
        visitorId = generateUUID(); 
        localStorage.setItem(anonymousIdKey, visitorId);
    }

    return {
        isLoggedIn: false,
        anonymousId: visitorId
    };
}

/**
 * Checks if the current build is "significant" enough to be logged as an abandonment.
 * A significant build is defined as one in Step 3 with all mandatory components selected
 * for the given build type.
 * @returns {boolean} True if the build is significant.
 */
function isBuildSignificant() {
    // A build is never significant if we're not on the component selection step.
    if (buildState.step !== 3) {
        return false;
    }

    const { buildType, components } = buildState;
    const mandatoryComponentTypes = window.I9System?.isSystem() ? ['Rim', 'Hub', 'Spokes'] : ['Rim', 'Hub', 'Spokes', 'Nipples']; // I9-SYSTEM

    if (buildType === 'Front') {
        // For a Front wheel, every mandatory front component must exist.
        return mandatoryComponentTypes.every(type => components[`front${type}`]);
    }
    
    if (buildType === 'Rear') {
        // For a Rear wheel, every mandatory rear component must exist.
        return mandatoryComponentTypes.every(type => components[`rear${type}`]);
    }
    
    if (buildType === 'Wheel Set') {
        // For a Wheel Set, every mandatory component for BOTH front and rear must exist.
        const isFrontComplete = mandatoryComponentTypes.every(type => components[`front${type}`]);
        const isRearComplete = mandatoryComponentTypes.every(type => components[`rear${type}`]);
        return isFrontComplete && isRearComplete;
    }

    // If the buildType is not one of the above, it's not a significant build.
    return false;
}

/**
 * Sets up a listener to report significant builds that are abandoned.
 * This fires when the user navigates away from or closes the page.
 */
function setupAbandonmentTracking() {
    window.addEventListener('beforeunload', () => {
        if (isBuildSignificant()) {

            // --- START: EXCLUSION LOGIC ---
            const customerData = window._loamlabs_customer_data || {};
            if (customerData.isLoggedIn && customerData.tags && customerData.tags.includes('staff_builder')) {
                return; // Skip reporting for staff
            }
            // --- END: EXCLUSION LOGIC ---

            const stateToReport = getMinimalBuildStateForReporting();
            stateToReport.visitor = getVisitorIdentifier();

            // 1. Point back to the data-audit project
            const reportUrl = 'https://loamlabs-data-audit.vercel.app/api/log-abandoned-build';

            try {
              // 2. Removed Content-Type header to bypass CORS preflight during tab-close
              fetch(reportUrl, {
                method: 'POST',
                body: JSON.stringify(stateToReport),
                keepalive: true 
              });
              console.log("Abandoned build report sent.", stateToReport);
            } catch (e) {
              console.error("Failed to send abandoned build report:", e);
            }
        }
    });
}

    // --- Function to update the Add to Cart / Update Cart / Back to Cart button text ---
function updateStep3ButtonText() {
    const allAddToCartButtons = document.querySelectorAll('#step-3-add-to-cart-button, #step-3-add-to-cart-button-bottom, #sticky-add-to-cart-button');
    if (allAddToCartButtons.length === 0) return;

    const isEditMode = !!buildState._ui.originalCartItemKeys;
    const hasChanges = buildState._ui.hasChanges;
    const isComplete = validateStep3();

    const backToCartButton = document.getElementById('step-3-back-to-cart-button'); // This is a separate button for the "no changes" state

    if (isEditMode) {
        if (hasChanges) {
            allAddToCartButtons.forEach(btn => {
                btn.textContent = 'Update Cart';
                btn.disabled = false;
                btn.classList.toggle('is-incomplete', !isComplete);
                btn.style.display = '';
            });
            if (backToCartButton) backToCartButton.style.display = 'none';
        } else {
            allAddToCartButtons.forEach(btn => { btn.style.display = 'none'; });
            if (backToCartButton) {
                backToCartButton.style.display = '';
                backToCartButton.disabled = false;
            }
        }
    } else {
        allAddToCartButtons.forEach(btn => {
            btn.textContent = 'Add Build to Cart';
            btn.disabled = false;
            btn.classList.toggle('is-incomplete', !isComplete);
            btn.style.display = '';
        });
        if (backToCartButton) backToCartButton.style.display = 'none';
    }
}

// Helper for "Back to Cart"
function redirectToCart() {
    window.location.href = '/cart';
}
      
function setupStep3Listeners() {
    const step3Container = document.getElementById('step-3');
    if (!step3Container) return;

    console.log("Step 3 Listeners Initializing...");

    // Event Delegation: Listen for clicks on the document to handle cart and validation links.
    // This ensures buttons work even after they are refreshed via AJAX.
    document.addEventListener('click', function(event) {
        // A. Detect "Add to Cart" Clicks
        const isCartClick = event.target.closest('#step-3-add-to-cart-button-bottom') || 
                           event.target.closest('#step-3-add-to-cart-button') ||
                           event.target.closest('#sticky-add-to-cart-button') ||
                           event.target.closest('.add-to-cart-button');

        if (isCartClick) {
            console.log("%c[Click] Add to Cart Button Detected", "color: green; font-weight: bold;");
            event.preventDefault();
            event.stopPropagation();
            addToCart();
            return;
        }

        // B. Detect Validation Summary Links (The "Flash" effect)
        const validationLink = event.target.closest('.validation-summary-link');
        if (validationLink) {
            event.preventDefault();
            const targetId = validationLink.dataset.targetId;
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                targetElement.classList.add('flash-highlight');
                setTimeout(() => targetElement.classList.remove('flash-highlight'), 1500);
            }
        }
    });

    // Handle standard Step 3 component clicks (Vendors, Images, etc)
    step3Container.addEventListener('click', handleStep3Clicks);
    
    updateStep3ButtonText(); 
}
      
function setupResetButtonListeners() {
    document.querySelectorAll('.reset-build-button').forEach(button => {
        button.addEventListener('click', () => {
            if (confirm('Are you sure you want to reset your custom wheel build? All selections will be lost.')) {
                
                // Use our new, safe reset function
                resetBuildStateToDefaults();

                // Disable navigation buttons
                if (step1NextButton) step1NextButton.disabled = true;
                if (step2NextButton) step2NextButton.disabled = true;
                if (step3AddToCartButton) step3AddToCartButton.disabled = true;

                // Clear data caches and promises
                allRimProductsCache = []; allHubProductsCache = []; allSpokeProductsCache = []; allNippleProductsCache = []; allValveStemProductsCache = []; vendorLogoMap = {};
                componentFetchPromises = { rims: null, hubs: null, spokes: null, nipples: null, valves: null, freehubs: null };
                step3PreRenderPromise = null;

                // Update the UI
                showStep(1);
                clearStep3UI();
                updateBuildSummary();
                cancelComponentChange();
                updateCustomerSuppliedCheckboxesVisibility(); // Also call it here for safety
                console.log("Build state reset complete.");
            }
        });
    });
}

    function areSpokesPaired(spoke1, spoke2) {
    if (!spoke1 || !spoke2) return false;
    if (spoke1.pairingKey !== spoke2.pairingKey) return false;
    const getColor = (spoke) => { if (!spoke || !spoke.selectedOptions) return null; const colorOption = spoke.selectedOptions.find(opt => opt.name.toLowerCase() === 'color'); return colorOption ? colorOption.value : null; };
    const color1 = getColor(spoke1); const color2 = getColor(spoke2);
    if ((color1 === null && color2 !== null) || (color1 !== null && color2 === null)) return false;
    if (color1 !== null && color2 !== null && color1 !== color2) return false;
    return true;
}
    function areNipplesPaired(nipple1, nipple2) {
    if (!nipple1 || !nipple2) return false;
    if (nipple1.pairingKey !== nipple2.pairingKey) return false;
    const getColor = (nipple) => { if (!nipple || !nipple.selectedOptions) return null; const colorOption = nipple.selectedOptions.find(opt => opt.name.toLowerCase() === 'color'); return colorOption ? colorOption.value : null; };
    const color1 = getColor(nipple1); const color2 = getColor(nipple2);
    if ((color1 === null && color2 !== null) || (color1 !== null && color2 === null)) return false;
    if (color1 !== null && color2 !== null && color1 !== color2) return false;
    return true;
}
    function areValveStemsPaired(valve1, valve2) {
    if (!valve1 || !valve2) return false;
    if (valve1.pairingKey !== valve2.pairingKey) return false;
    const getColor = (valve) => { if (!valve || !valve.selectedOptions) return null; const colorOption = valve.selectedOptions.find(opt => opt.name.toLowerCase() === 'color'); return colorOption ? colorOption.value : null; };
    const color1 = getColor(valve1); const color2 = getColor(valve2);
    if (color1 !== null && color2 !== null && color1 !== color2) return false;
    return true;
}
    function showCancelChangeButtonIfNeeded(positionBeingChanged, typeBeingChanged, actionButtonsContainerElement) {
    if (!actionButtonsContainerElement) return;

    actionButtonsContainerElement.innerHTML = ''; // Always start fresh
    actionButtonsContainerElement.style.display = 'none';

    let typePascal = typeBeingChanged.charAt(0).toUpperCase() + typeBeingChanged.slice(1).toLowerCase();
    if (typeBeingChanged.toLowerCase() === "valvestem") typePascal = "ValveStem";
    else if (typeBeingChanged.toLowerCase() === "spokes") typePascal = "Spokes";
    else if (typeBeingChanged.toLowerCase() === "nipples") typePascal = "Nipples";

    const isTrulyChanging = buildState._ui.isChangingComponent &&
                           buildState._ui.isChangingComponent.position === positionBeingChanged &&
                           buildState._ui.isChangingComponent.type === typePascal;

    if (isTrulyChanging) {
        const cancelButton = document.createElement('button');
        cancelButton.type = 'button';
        cancelButton.className = 'builder-button cancel-change-button button--link-style';
        cancelButton.textContent = 'Cancel Change';
        cancelButton.addEventListener('click', (e) => { e.preventDefault(); cancelComponentChange(); });
        actionButtonsContainerElement.appendChild(cancelButton);
        actionButtonsContainerElement.style.display = 'flex';
    }
}

async function handleMatchPairButtonClick(event) {
    event.preventDefault();
    event.stopPropagation(); // Stop the click from triggering handleClickAway.

    const button = event.currentTarget;
    const positionToChange = button.dataset.positionToChange;
    const typeToChangePascal = button.dataset.typeToChange;
    const posLowerToChange = positionToChange.toLowerCase();
    const stateKeyToChange = `${posLowerToChange}${typeToChangePascal}`;

    if (!positionToChange || !typeToChangePascal) return;

    const oppositePosition = positionToChange === 'Front' ? 'Rear' : 'Front';
    const stateKeyOppositeComponent = `${oppositePosition.toLowerCase()}${typeToChangePascal}`;
    const oppositeComponent = buildState.components[stateKeyOppositeComponent];

    // I9-SYSTEM: System spokes: copy the other wheel's base color (and hub color when available). The classic branch below would
    // overwrite the System spoke component with a classic one and blank the card.
    if (typeToChangePascal === 'Spokes' && window.I9System?.isSystem()) { window.I9System.matchSpokes(oppositePosition, true); cancelComponentChange(); return; }

    // --- START: SYMMETRICAL PRE-FLIGHT CHECK (UPDATED V2.19) ---
    if (typeToChangePascal === 'Spokes') {
        const hubOnSideToChange = buildState.components[`${posLowerToChange}Hub`];
        if (hubOnSideToChange && oppositeComponent) { 
            const sourceSpokeProduct = allSpokeProductsCache.find(p => p.id === oppositeComponent.productId);
            const sourceSpokeInterface = sourceSpokeProduct?.spokeHubInterface; 
            const hubTags = hubOnSideToChange.tags || [];

            let isIncompatible = false;
            let errorMsg = "";

            // 1. Standard Steel Logic
            if (sourceSpokeInterface === 'J-Bend' && hubTags.includes('hub_type:straight_pull')) { isIncompatible = true; errorMsg = "J-Bend spokes are not compatible with Straight Pull hubs."; }
            if (sourceSpokeInterface === 'Straight Pull' && hubTags.includes('hub_type:j_bend')) { isIncompatible = true; errorMsg = "Straight Pull spokes are not compatible with J-Bend hubs."; }

            // 2. Hook Flange Hub Logic (Steel Spokes vs Hook Flange Hub)
            if (hubTags.includes('hub_type:hook_flange') && (sourceSpokeInterface === 'J-Bend' || sourceSpokeInterface === 'Straight Pull')) {
                isIncompatible = true; 
                errorMsg = "Steel spokes are not compatible with Hook Flange hubs.";
            }

            // 3. PolyLightX Logic (Hook Flange Spoke vs Standard Hub)
            if (sourceSpokeInterface === 'Hook Flange' && !hubTags.includes('hub_type:hook_flange')) {
                isIncompatible = true;
                errorMsg = "Hook Flange spokes are not compatible with this hub.";
            }

            if (isIncompatible) {
                const confirmed = confirm(`${errorMsg} Clicking OK will clear the ${positionToChange} Hub to continue.`);
                if (confirmed) {
                    clearComponentAndItsAddons(positionToChange, 'Hub');
                } else {
                    if(buildState._ui.isChangingComponent) cancelComponentChange();
                    return; // ABORT THE MATCH
                }
            }
        }
    } else if (typeToChangePascal === 'Hub') {
        const spokesOnSideToChange = buildState.components[`${posLowerToChange}Spokes`];
        if (spokesOnSideToChange && oppositeComponent) { 
            const spokeProduct = allSpokeProductsCache.find(p => p.id === spokesOnSideToChange.productId);
            const spokeInterface = spokeProduct?.spokeHubInterface;
            
            // Find the tags of the hub we are ABOUT to match to
            const potentialMatchProduct = allHubProductsCache.find(p => p.pairingKey === oppositeComponent.pairingKey && p.id !== oppositeComponent.productId);
            const hubSourceProduct = potentialMatchProduct || allHubProductsCache.find(p => p.id === oppositeComponent.productId);
            const hubTags = hubSourceProduct?.tags || [];

            let isIncompatible = false;
            let errorMsg = "";

            // 1. Standard Steel Logic
            if (spokeInterface === 'J-Bend' && hubTags.includes('hub_type:straight_pull')) { isIncompatible = true; errorMsg = "Current J-Bend spokes not compatible with Straight Pull hub."; }
            if (spokeInterface === 'Straight Pull' && hubTags.includes('hub_type:j_bend')) { isIncompatible = true; errorMsg = "Current Straight Pull spokes not compatible with J-Bend hub."; }

            // 2. Hook Flange Hub Logic (Hook Flange Hub vs Steel Spokes)
            if (hubTags.includes('hub_type:hook_flange') && (spokeInterface === 'J-Bend' || spokeInterface === 'Straight Pull')) {
                isIncompatible = true;
                errorMsg = "Hook Flange hubs require Berd spokes. Current spokes are steel.";
            }

            // 3. PolyLightX Logic (Standard Hub vs Hook Flange Spokes)
            if (!hubTags.includes('hub_type:hook_flange') && spokeInterface === 'Hook Flange') {
                isIncompatible = true;
                errorMsg = "Current Hook Flange spokes require a Hook Flange hub.";
            }

            if (isIncompatible) {
                const confirmed = confirm(`${errorMsg} This will clear your current ${positionToChange} spoke selection. Continue?`);
                if (confirmed) {
                    clearComponentAndItsAddons(positionToChange, 'Spokes');
                } else {
                    if(buildState._ui.isChangingComponent) cancelComponentChange();
                    return; // ABORT THE MATCH
                }
            }
        }
    }
    // --- END: SYMMETRICAL PRE-FLIGHT CHECK ---
    // --- END: SYMMETRICAL PRE-FLIGHT CHECK ---

    if (typeToChangePascal === 'Hub' || typeToChangePascal === 'Rim') {

        // --- START: PRE-FLIGHT CHECK ---
        const componentToBeReplaced = buildState.components[stateKeyToChange]; // The hub slot we are about to fill
        const oppositeSpokes = buildState.components[`${oppositePosition.toLowerCase()}Spokes`]; // The spokes on the OTHER wheel
        
        if (typeToChangePascal === 'Hub' && oppositeSpokes && !componentToBeReplaced) {
            const oppositeSpokeProduct = allSpokeProductsCache.find(p => p.id === oppositeSpokes.productId);
            const oppositeSpokeInterface = oppositeSpokeProduct?.spokeHubInterface;

            // Find the tags of the hub that WILL be matched
            const potentialMatchProduct = allHubProductsCache.find(p => p.pairingKey === oppositeComponent.pairingKey);
            const potentialMatchTags = potentialMatchProduct?.tags || [];
            
            let isMatchIncompatible = false;
            if (oppositeSpokeInterface === 'J-Bend' && potentialMatchTags.includes('hub_type:straight_pull')) isMatchIncompatible = true;
            if (oppositeSpokeInterface === 'Straight Pull' && potentialMatchTags.includes('hub_type:j_bend')) isMatchIncompatible = true;

            if (isMatchIncompatible) {
                const requiredHubType = (potentialMatchTags.includes('hub_type:j_bend')) ? 'J-Bend' : 'Straight Pull';
                const confirmed = confirm(`The selected ${oppositePosition} spokes are not compatible with this ${requiredHubType} hub. Clicking OK will clear the ${oppositePosition} spokes to continue.`);
                if (confirmed) {
                    clearComponentAndItsAddons(oppositePosition, 'Spokes');
                } else {
                    cancelComponentChange();
                    return; // Abort
                }
            }
        }
        // --- END: PRE-FLIGHT CHECK ---

        const result = await handleAutoPairing(typeToChangePascal, oppositePosition, oppositeComponent, true);

        // If multiple matches were shown, the UI is now waiting for user input.
        // We should NOT cancel the change mode in this case.
        if (result !== 'multiple_matches_shown') {
            cancelComponentChange();
            updateMismatchHints();
        }

    } else if (typeToChangePascal === 'Spokes' || typeToChangePascal === 'Nipples') {
        // This logic handles simpler components that auto-select without presenting multiple model options.
        const cacheToSearch = (typeToChangePascal === 'Spokes') ? allSpokeProductsCache : allNippleProductsCache;
        const targetColor = oppositeComponent.selectedOptions?.find(opt => opt.name.toLowerCase() === 'color')?.value || null;

        const pairedProducts = cacheToSearch.filter(p => p.pairingKey === oppositeComponent.pairingKey);
        let potentialMatches = [];

        for (const p_pair of pairedProducts) {
            for (const v_pair of p_pair.variants) {
                if (!v_pair.availableForSale) continue;
                
                const variantColor = v_pair.selectedOptions?.find(opt => opt.name.toLowerCase() === 'color')?.value || null;
                if (variantColor === targetColor) {
                    potentialMatches.push({ variant: v_pair, product: p_pair });
                }
            }
        }
        
        if (potentialMatches.length > 0) {
            const bestMatch = potentialMatches[0];

            const newComponent = {
                variantId: bestMatch.variant.id, productId: bestMatch.product.id, productHandle: bestMatch.product.handle,
                title: bestMatch.product.title, variantTitle: bestMatch.variant.title, sku: bestMatch.variant.sku,
                price: bestMatch.variant.price.amount, vendor: bestMatch.product.vendor, image: bestMatch.variant.image,
                pairingKey: bestMatch.product.pairingKey, selectedOptions: bestMatch.variant.selectedOptions,
                optionalAddonProductGids: bestMatch.product.optionalAddonProductGidsFromProduct || [],
                quantityAvailable: bestMatch.variant.quantityAvailable, leadTimeDays: bestMatch.product.leadTimeDays || 0,
                weight_g: bestMatch.variant.weight_g ?? bestMatch.product.weight_g ?? null
            };

            buildState.components[stateKeyToChange] = newComponent;
            
            updateComponentUI(positionToChange, typeToChangePascal, newComponent);
            calculateWheelCosts(positionToChange);
            updateSubtotal();
            updateBuildSummary();
            validateStep3();
            if (typeToChangePascal === 'Spokes') {
                updateHubSpokeCompatibilityUI();
            }
            cancelComponentChange();
            saveLastActiveBuild();
            updateMismatchHints();

        } else {
            alert(`Could not find a matching ${getDisplayName(typeToChangePascal.toLowerCase())}.`);
            cancelComponentChange();
        }

    } else if (typeToChangePascal === 'ValveStem') {
        // Logic for Valve Stems
        const targetRim = buildState.components[`${posLowerToChange}Rim`];
        if (!targetRim) {
            alert(`Please select a ${positionToChange} Rim before matching the Valve Stem.`);
            cancelComponentChange();
            return;
        }
        const targetRimDepth = targetRim.rimDepth;
        const targetColor = oppositeComponent.selectedOptions?.find(opt => opt.name.toLowerCase() === 'color')?.value || null;

        const pairedProducts = allValveStemProductsCache.filter(p => p.pairingKey === oppositeComponent.pairingKey);
        let potentialMatches = [];

        for (const p_pair of pairedProducts) {
            for (const v_pair of p_pair.variants) {
                if (!v_pair.availableForSale) continue;

                let isDepthCompatible = false;
                if (targetRimDepth === null || typeof targetRimDepth === 'undefined' || v_pair.valve_min_depth === null || v_pair.valve_max_depth === null) {
                    isDepthCompatible = true;
                } else {
                    isDepthCompatible = targetRimDepth >= v_pair.valve_min_depth && targetRimDepth <= v_pair.valve_max_depth;
                }

                if (isDepthCompatible) {
                    const variantColor = v_pair.selectedOptions?.find(opt => opt.name.toLowerCase() === 'color')?.value || null;
                    if (variantColor === targetColor) {
                        potentialMatches.push({ variant: v_pair, product: p_pair });
                    }
                }
            }
        }

        if (potentialMatches.length > 0) {
            potentialMatches.sort((a, b) => (parseInt(a.variant.selectedOptions.find(opt=>opt.name==='Length')?.value.replace(/\D/g,''))||Infinity) - (parseInt(b.variant.selectedOptions.find(opt=>opt.name==='Length')?.value.replace(/\D/g,''))||Infinity));
            const bestMatch = potentialMatches[0];

            const newComponent = {
                variantId: bestMatch.variant.id, productId: bestMatch.product.id, productHandle: bestMatch.product.handle,
                title: bestMatch.product.title, variantTitle: bestMatch.variant.title, sku: bestMatch.variant.sku,
                price: bestMatch.variant.price.amount, vendor: bestMatch.product.vendor, image: bestMatch.variant.image,
                pairingKey: bestMatch.product.pairingKey, selectedOptions: bestMatch.variant.selectedOptions,
                selectedWithRimDepth: targetRimDepth, valveMinDepth: bestMatch.variant.valve_min_depth, valveMaxDepth: bestMatch.variant.valve_max_depth,
                optionalAddonProductGids: bestMatch.product.optionalAddonProductGidsFromProduct || [],
                quantityAvailable: bestMatch.variant.quantityAvailable, leadTimeDays: bestMatch.product.leadTimeDays || 0,
                weight_g: bestMatch.variant.weight_g ?? bestMatch.product.weight_g ?? null
            };

            buildState.components[stateKeyToChange] = newComponent;
            buildState._ui.valveStemExplicitlyRemoved[posLowerToChange] = false;
            
            updateComponentUI(positionToChange, typeToChangePascal, newComponent);
            updateSubtotal();
            updateBuildSummary();
            validateStep3();
            cancelComponentChange();
            saveLastActiveBuild();
            updateMismatchHints();

        } else {
            alert(`Could not find a compatible matching ${getDisplayName(typeToChangePascal.toLowerCase())}. Please check rim depth or color compatibility.`);
            cancelComponentChange();
        }
    }
}

// --- START: FUNCTION to initialize the Step 1 Image Slider ---
function initializeStep1Slider() {
    const sliderContainer = document.querySelector('#step-1 .image-slider-container');
    if (!sliderContainer) return;

    const slides = sliderContainer.querySelectorAll('.slider-image-item');
    if (slides.length <= 1) {
        if (slides[0]) slides[0].classList.add('active');
        return;
    }

    let currentIndex = 0; // Always start with the first image (index 0)
    let shuffledPlaylist = [];
    const slideInterval = 5000;

    // A modern and reliable shuffle algorithm
    const shuffleArray = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]]; // Swap elements
        }
    };

    const createShuffledPlaylist = () => {
        // STEP1-CARDS: the second <li> (Industry Nine collage) always follows the logo slide; only the rest are shuffled
        const otherImageIndices = Array.from({ length: slides.length - 2 }, (_, i) => i + 2);
        shuffleArray(otherImageIndices);
        shuffledPlaylist = [1, ...otherImageIndices];
        console.log("New shuffled playlist created:", shuffledPlaylist);
    };

    const showNextSlide = () => {
        // Hide the current slide
        slides[currentIndex].classList.remove('active');

        // Check if our playlist is empty
        if (shuffledPlaylist.length === 0) {
            // If the playlist is empty, it means we've shown all the other images.
            // It's time to show the main image (index 0) and then create a new playlist.
            currentIndex = 0;
            createShuffledPlaylist(); // Create a new random order for the next cycle
        } else {
            // If the playlist is not empty, pull the next image index from the front of the list
            currentIndex = shuffledPlaylist.shift(); // .shift() removes and returns the first item
        }

        // Show the new slide
        slides[currentIndex].classList.add('active');
    };

    // --- Initial Setup ---
    // Immediately show the first slide (the main logo)
    slides[currentIndex].classList.add('active');
    // Immediately create the first shuffled playlist for the other images
    createShuffledPlaylist();
    // Start the interval to begin the rotation after the first image has been displayed
    setInterval(showNextSlide, slideInterval);
}
  
// --- Initialization on DOM Load ---
document.addEventListener('DOMContentLoaded', async () => {
    // --- STEP 1: ALWAYS assign DOM element variables first ---
    builderContainer = document.getElementById('variant-builder-container');
    if (!builderContainer) {
        console.error("CRITICAL INIT ERROR: Builder container #variant-builder-container not found.");
        return;
    }
    step1NextButton = document.getElementById('step-1-next-button');
    step2NextButton = document.getElementById('step-2-next-button');
    step3AddToCartButton = document.getElementById('step-3-add-to-cart-button');
    summaryContainer = document.getElementById('build-summary');
    subtotalValueElement = document.getElementById('subtotal-value');
    summaryContentElement = document.getElementById('summary-content');
    frontRimFilters = document.getElementById('front-rim-filters'); frontRimLoading = document.getElementById('front-rim-loading'); frontRimError = document.getElementById('front-rim-error'); frontRimOptionsContainer = document.getElementById('front-rim-options-container'); frontRimImageContainer = document.getElementById('front-rim-image-container');
    rearRimFilters = document.getElementById('rear-rim-filters'); rearRimLoading = document.getElementById('rear-rim-loading'); rearRimError = document.getElementById('rear-rim-error'); rearRimOptionsContainer = document.getElementById('rear-rim-options-container'); rearRimImageContainer = document.getElementById('rear-rim-image-container');
    frontHubFilters = document.getElementById('front-hub-filters'); frontHubLoading = document.getElementById('front-hub-loading'); frontHubError = document.getElementById('front-hub-error'); frontHubOptionsContainer = document.getElementById('front-hub-options-container'); frontHubImageContainer = document.getElementById('front-hub-image-container');
    rearHubFilters = document.getElementById('rear-hub-filters'); rearHubLoading = document.getElementById('rear-hub-loading'); rearHubError = document.getElementById('rear-hub-error'); rearHubOptionsContainer = document.getElementById('rear-hub-options-container'); rearHubImageContainer = document.getElementById('rear-hub-image-container');
    frontSpokesFilters = document.getElementById('front-spokes-filters'); frontSpokesLoading = document.getElementById('front-spokes-loading'); frontSpokesError = document.getElementById('front-spokes-error'); frontSpokesOptionsContainer = document.getElementById('front-spokes-options-container'); frontSpokesImageContainer = document.getElementById('front-spokes-image-container');
    rearSpokesFilters = document.getElementById('rear-spokes-filters'); rearSpokesLoading = document.getElementById('rear-spokes-loading'); rearSpokesError = document.getElementById('rear-spokes-error'); rearSpokesOptionsContainer = document.getElementById('rear-spokes-options-container'); rearSpokesImageContainer = document.getElementById('rear-spokes-image-container');
    frontNipplesFilters = document.getElementById('front-nipples-filters'); frontNipplesLoading = document.getElementById('front-nipples-loading'); frontNipplesError = document.getElementById('front-nipples-error'); frontNipplesOptionsContainer = document.getElementById('front-nipples-options-container'); frontNipplesImageContainer = document.getElementById('front-nipples-image-container');
    rearNipplesFilters = document.getElementById('rear-nipples-filters'); rearNipplesLoading = document.getElementById('rear-nipples-loading'); rearNipplesError = document.getElementById('rear-nipples-error'); rearNipplesOptionsContainer = document.getElementById('rear-nipples-options-container'); rearNipplesImageContainer = document.getElementById('rear-nipples-image-container');
    frontValveStemFilters = document.getElementById('front-valvestem-filters'); frontValveStemLoading = document.getElementById('front-valvestem-loading'); frontValveStemError = document.getElementById('front-valvestem-error'); frontValveStemOptionsContainer = document.getElementById('front-valvestem-options-container'); frontValveStemImageContainer = document.getElementById('front-valvestem-image-container'); removeFrontValveStemButton = document.getElementById('remove-front-valvestem-button');
    rearValveStemFilters = document.getElementById('rear-valvestem-filters'); rearValveStemLoading = document.getElementById('rear-valvestem-loading'); rearValveStemError = document.getElementById('rear-valvestem-error'); rearValveStemOptionsContainer = document.getElementById('rear-valvestem-options-container'); rearValveStemImageContainer = document.getElementById('rear-valvestem-image-container'); removeRearValveStemButton = document.getElementById('remove-rear-valvestem-button');
    addonsModal = document.getElementById('addons-modal');
    addonsModalTitle = document.getElementById('addons-modal-title');
    addonsModalBody = document.getElementById('addons-modal-body');
    addonsModalCloseBtn = document.querySelector('.addons-modal-close-btn');
    addonsModalDoneBtn = document.getElementById('addons-modal-done-btn');
    builderSaveLoadControls = document.getElementById('builder-save-load-controls');
    saveCurrentBuildBtn = document.getElementById('save-current-build-btn');
    mySavedBuildsBtn = document.getElementById('my-saved-builds-btn');
    savedBuildsModal = document.getElementById('saved-builds-modal');
    savedBuildsModalTitle = document.getElementById('saved-builds-modal-title');
    savedBuildsModalBody = document.getElementById('saved-builds-modal-body');
    savedBuildsModalCloseBtn = document.getElementById('saved-builds-modal-close-btn');
    savedBuildsModalDoneBtn = document.getElementById('saved-builds-modal-done-btn');
    lastActiveBuildPromptModal = document.getElementById('last-active-build-prompt-modal');
    resumeLastActiveBtn = document.getElementById('resume-last-active-btn');
    startNewActiveBtn = document.getElementById('start-new-active-btn');
    quickSpecAdjustersContainer = document.getElementById('quick-spec-adjusters-container');
    step3RefreshOverlay = document.getElementById('builder-step3-refresh-overlay');
    specChangeModal = document.getElementById('spec-change-confirm-modal');
    specChangeModalTitle = document.getElementById('spec-change-modal-title');
    specChangeModalBody = document.getElementById('spec-change-modal-body');
    specChangeModalCloseBtn = document.getElementById('spec-change-modal-close-btn');
    specChangeModalCancelBtn = document.getElementById('spec-change-modal-cancel-btn');
    specChangeModalConfirmBtn = document.getElementById('spec-change-modal-confirm-btn');
    stickyFooter = document.getElementById('sticky-checkout-footer');
    stickySubtotal = document.getElementById('sticky-subtotal-value');
    stickyWeight = document.getElementById('sticky-weight-value');
    stickyDetailsBtn = document.getElementById('sticky-view-details-btn');
    stickyDrawer = document.getElementById('sticky-summary-drawer');
    stickyDrawerOverlay = document.getElementById('sticky-drawer-overlay');
    stickyDrawerCloseBtn = document.getElementById('sticky-drawer-close-btn');
    stickyDrawerBody = document.getElementById('sticky-drawer-body-content');
    stickyAddToCartBtn = document.getElementById('sticky-add-to-cart-button');

    // --- 18.1 Sticky Drawer Event Listeners ---
    if (stickyDetailsBtn) {
        stickyDetailsBtn.addEventListener('click', () => {
            const mainSummaryContent = document.querySelector('.build-summary-main-content');
            
            if (mainSummaryContent && stickyDrawerBody) {
                // Clone the entire summary (Weight, Components, Discounts)
                stickyDrawerBody.innerHTML = mainSummaryContent.innerHTML;
                
                // Remove the duplicate "Your Build Summary" H2 from inside the drawer
                const duplicateH2 = stickyDrawerBody.querySelector('h2');
                if (duplicateH2) duplicateH2.remove();
            }
            stickyDrawerOverlay.style.display = 'block';
            
            setTimeout(() => {
                stickyDrawerOverlay.classList.add('is-active');
                stickyDrawer.classList.add('is-open');
            }, 10);
        });
    }

    const closeDrawer = () => {
        stickyDrawer.classList.remove('is-open');
        stickyDrawerOverlay.classList.remove('is-active');
        setTimeout(() => { stickyDrawerOverlay.style.display = 'none'; }, 300);
    };

    if (stickyDrawerCloseBtn) stickyDrawerCloseBtn.addEventListener('click', closeDrawer);
    if (stickyDrawerOverlay) stickyDrawerOverlay.addEventListener('click', closeDrawer);

    // --- STEP 2: ALWAYS initialize the API token configuration ---
    try {
        if (window.loamlabs?.builderConfig?.storefrontApiToken) {
            config.storefrontApiToken = window.loamlabs.builderConfig.storefrontApiToken;
        } else {
            throw new Error("Storefront API Token missing!");
        }
    } catch (error) {
        displayInitializationError(`Configuration Error: ${error.message}`);
        return;
    }

    // --- STEP 3: ALWAYS set up all event listeners to make the page interactive ---
    if (step1NextButton) step1NextButton.disabled = true;
    if (step2NextButton) step2NextButton.disabled = true;
    if (step3AddToCartButton) step3AddToCartButton.disabled = true;

    setupStep1Listeners();
    setupStep2Listeners();
    setupNavigationListeners();
    setupStep3Listeners();
    setupResetButtonListeners();
    initializeStep1Slider();
    initializeInfoTooltips();
    updateCustomerSuppliedCheckboxesVisibility();
    setupAbandonmentTracking();

    if (specChangeModal) {
        specChangeModal.addEventListener('click', (event) => { if (event.target === specChangeModal) specChangeModal.style.display = 'none'; });
    }
    if (specChangeModalCloseBtn) specChangeModalCloseBtn.addEventListener('click', () => specChangeModal.style.display = 'none');
    if (specChangeModalCancelBtn) specChangeModalCancelBtn.addEventListener('click', () => specChangeModal.style.display = 'none');
    const specAdjusterSection = document.getElementById('spec-adjuster-section');
    if (specAdjusterSection) {
        // 1. Handle Button Clicks (Spoke Counts / Brake Style)
        specAdjusterSection.addEventListener('click', (e) => {
            const button = e.target.closest('button.spec-option-button');
            // Ensure it's one of the adjuster buttons and isn't already the active one
            if (!button || !button.closest('.quick-spec-group') || button.classList.contains('active')) return;

            const specKey = button.dataset.specKey;
            const value = button.dataset.value;
            
            console.log(`[Quick Adjuster] Button Clicked: Setting ${specKey} to ${value}`);
            if (window.I9System?.onAdjusterClick?.(specKey, value, button)) return; // I9-SYSTEM: brake style is set by the hub; a non-pairing size asks "Change both" first
            updateSpecAndRefreshStep3({ [specKey]: value });
        });

        // 2. Handle Checkbox Changes (Rim Brake Toggle)
        specAdjusterSection.addEventListener('change', (e) => {
            if (e.target.id === 'global-msw-toggle') {
                buildState._ui.showRimBrakeRims = e.target.checked;
                console.log(`[Global Toggle] MSW Checkbox Changed: ${e.target.checked}`);
                // Refresh Step 3 to apply new filters
                updateSpecAndRefreshStep3({}); 
            }
        });
    }
    const adminShareButton = document.getElementById('admin-share-build-button');
    if (adminShareButton) {
      adminShareButton.addEventListener('click', handleAdminShareBuildClick);
    }
    if (addonsModalCloseBtn) addonsModalCloseBtn.addEventListener('click', closeAddonsModal);
    if (addonsModalDoneBtn) addonsModalDoneBtn.addEventListener('click', closeAddonsModal);
    if (addonsModal) { addonsModal.addEventListener('click', (event) => { if (event.target === addonsModal) closeAddonsModal(); }); }
    const csModalCloseBtn = document.getElementById('customer-supplied-modal-close-btn');
    if (csModalCloseBtn) {
        csModalCloseBtn.addEventListener('click', () => {
            const { component, position } = currentModalConfirmation;
            const checkboxToUncheck = document.querySelector(`.customer-supplied-checkbox[data-component='${component}'][data-position='${position}']`);
            if (checkboxToUncheck) {
                checkboxToUncheck.checked = false;
                buildState.customerSupplied[position][component] = false;
            }
            hideConfirmationModal();
        });
    }
    const csModalCheckbox = document.getElementById('customer-supplied-modal-checkbox');
    if (csModalCheckbox) {
        csModalCheckbox.addEventListener('change', event => {
            const confirmBtn = document.getElementById('customer-supplied-modal-confirm-btn');
            if(confirmBtn) confirmBtn.disabled = !event.target.checked;
        });
    }
    const csModalConfirmBtn = document.getElementById('customer-supplied-modal-confirm-btn');
    if (csModalConfirmBtn) {
        csModalConfirmBtn.addEventListener('click', () => {
            hideConfirmationModal();
            triggerEarlyComponentFetches();
            showStep(2);
        });
    }
    saveCurrentBuildBtn?.addEventListener('click', saveCurrentBuild);
    mySavedBuildsBtn?.addEventListener('click', () => { renderSavedBuildsList(); if (savedBuildsModal) savedBuildsModal.style.display = 'flex'; });
    savedBuildsModalCloseBtn?.addEventListener('click', () => { if (savedBuildsModal) savedBuildsModal.style.display = 'none'; });
    savedBuildsModalDoneBtn?.addEventListener('click', () => { if (savedBuildsModal) savedBuildsModal.style.display = 'none'; });
    savedBuildsModal?.addEventListener('click', (event) => {
        if (event.target === savedBuildsModal) savedBuildsModal.style.display = 'none';
        const loadBtn = event.target.closest('.saved-build-load-btn'); const deleteBtn = event.target.closest('.saved-build-delete-btn');
        if (loadBtn) { const buildId = loadBtn.dataset.buildId; if (buildId) loadBuildFromStorage(buildId); }
        else if (deleteBtn) { const deleteBuildIdVal = deleteBtn.dataset.buildId; if (deleteBuildIdVal) deleteSavedBuild(deleteBuildIdVal); }
    });
    resumeLastActiveBtn?.addEventListener('click', async () => { if (lastActiveBuildPromptModal) lastActiveBuildPromptModal.style.display = 'none'; await loadBuildFromStorage(LAST_ACTIVE_BUILD_KEY, true); });
    startNewActiveBtn?.addEventListener('click', async () => {
        if (lastActiveBuildPromptModal) lastActiveBuildPromptModal.style.display = 'none';
        localStorage.removeItem(LAST_ACTIVE_BUILD_KEY);
        resetBuildStateToDefaults();
        clearStep3UI();
        await showStep(1);
        updateCustomerSuppliedCheckboxesVisibility();
        updateSubtotal();
        updateBuildSummary();
    });

    // --- START: 18.3 Ghost User Engine (Deterministic Auto-Fill) ---
async function generateCuratedBuild(selectedMaterial, selectedGoal) {
    const { specs, buildType } = buildState;
    if (!buildType) return;

    // Helper to verify a strict, valid number
    const isNum = (val) => typeof val === 'number' && !isNaN(val);

    // Resolve active options from DOM if JS state was reset or loaded from a legacy session
    const matActiveBtn = document.getElementById('qb-material-options')?.querySelector('.qb-toggle-btn.active');
    const material = selectedMaterial || buildState._ui.qbMaterial || (matActiveBtn ? matActiveBtn.dataset.val : 'Aluminum');

    const goalActiveBtn = document.getElementById('qb-goal-options')?.querySelector('.qb-toggle-btn.active');
    const goal = selectedGoal || buildState._ui.qbGoal || (goalActiveBtn ? goalActiveBtn.dataset.val : 'Best Value');

    const frontActiveBtn = document.getElementById('qb-front-depth-options')?.querySelector('.qb-toggle-btn.active');
    const frontMin = isNum(buildState._ui.qbFrontDepthMin) ? buildState._ui.qbFrontDepthMin : (frontActiveBtn ? parseInt(frontActiveBtn.dataset.min) : 0);
    const frontMax = isNum(buildState._ui.qbFrontDepthMax) ? buildState._ui.qbFrontDepthMax : (frontActiveBtn ? parseInt(frontActiveBtn.dataset.max) : 35);

    const rearActiveBtn = document.getElementById('qb-rear-depth-options')?.querySelector('.qb-toggle-btn.active');
    const rearMin = isNum(buildState._ui.qbRearDepthMin) ? buildState._ui.qbRearDepthMin : (rearActiveBtn ? parseInt(rearActiveBtn.dataset.min) : 0);
    const rearMax = isNum(buildState._ui.qbRearDepthMax) ? buildState._ui.qbRearDepthMax : (rearActiveBtn ? parseInt(rearActiveBtn.dataset.max) : 35);

    console.groupCollapsed(`%c[Ghost User] ⚡ Generating: ${material} | ${goal}`, 'background: #222; color: #bada55; font-size: 1.2em; padding: 4px;');
    console.log(`Target Specs: Size=${specs.frontWheelSize}, Spokes=${specs.frontSpokeCount}, Brake=${specs.brakeStyle}`);

    const overlay = document.getElementById('builder-step3-refresh-overlay');
    if (overlay) {
        overlay.querySelector('p').textContent = `Engineering your ${material} ${goal} build...`;
        overlay.style.display = 'flex';
    }

    // DATA LOCK: Await all background Shopify fetches
    const promisesToAwait = [
        componentFetchPromises.rims, componentFetchPromises.hubs,
        componentFetchPromises.spokes, componentFetchPromises.nipples,
        componentFetchPromises.valves, componentFetchPromises.freehubs
    ].filter(Boolean);
    
    if (promisesToAwait.length > 0) {
        console.log(`[Ghost User] Waiting for background data caches to finish syncing...`);
        await Promise.all(promisesToAwait);
    }
    
    // Force a 500ms minimum delay so the user sees the "Engineering..." screen
    await new Promise(resolve => setTimeout(resolve, 500)); 

    const positions = [];
    if (buildType === 'Front' || buildType === 'Wheel Set') positions.push('Front');
    if (buildType === 'Rear' || buildType === 'Wheel Set') positions.push('Rear');

    // --- Core Helper Functions ---
    const getPrice = (v) => v.price?.amount ? parseFloat(v.price.amount) : Infinity;
    const getWeight = (v, p) => v.weight_g ?? p.weight_g ?? Infinity;
    const getCrossSection = (p) => p.spoke_cross_section_area_mm2 || 0;

    const hasMatchingRear = (frontProduct, cache, isHub, enforcePriceBounds) => {
        if (buildType !== 'Wheel Set') return true; 
        return cache.some(rearP => {
            if (rearP.pairingKey !== frontProduct.pairingKey) return false;
            if (isHub && (!rearP.availableFreehubs || !rearP.availableFreehubs.includes(specs.freehubType))) return false;
            
            return rearP.variants.some(rearV => {
                if (!rearV.availableForSale) return false;
                const posMatch = rearV.spec_position === 'Rear' || rearV.spec_position === "Front/Rear";
                const spokeMatch = String(rearV.spec_spoke_count) === String(specs.rearSpokeCount);
                const brakeMatch = specs.brakeStyle === 'Rim Brake' ? (rearV.spec_brake_interface || []).includes('Rim Brake') : !(rearV.spec_brake_interface || []).includes('Rim Brake');
                
                if (isHub) {
                    const spacingMatch = normalizeSpacing(rearV.spec_hub_spacing) === normalizeSpacing(specs.rearHubSpacing);
                    let priceMatch = true;
                    if (enforcePriceBounds && goal === 'Max Durability') {
                        const rPrice = getPrice(rearV) / 100;
                        if (rPrice < 150 || rPrice > 450) priceMatch = false;
                    }
                    return posMatch && spokeMatch && brakeMatch && spacingMatch && priceMatch;
                }
                
                const sizeVal = rearV.spec_rim_size?.parsedValue;
                const sizeMatch = Array.isArray(sizeVal) ? sizeVal.includes(specs.rearWheelSize) : sizeVal === specs.rearWheelSize;
                return posMatch && spokeMatch && brakeMatch && sizeMatch;
            });
        });
    };

    const enforceSymmetry = (candidates, frontComponentKey) => {
        if (buildType === 'Wheel Set' && buildState.components[frontComponentKey]) {
            const frontPairingKey = buildState.components[frontComponentKey].pairingKey;
            return candidates.filter(c => c.product.pairingKey === frontPairingKey); 
        }
        return candidates;
    };

    // Wipe slate clean for all active positions before building
positions.forEach(p => {
    const pL = p.toLowerCase();
    ['Rim', 'Hub', 'Spokes', 'Nipples', 'ValveStem'].forEach(type => buildState.components[`${pL}${type}`] = null);
});

// --- Build Loop ---
for (const pos of positions) {
    const posL = pos.toLowerCase();
    const stateKeys = { rim: `${posL}Rim`, hub: `${posL}Hub`, spokes: `${posL}Spokes`, nipples: `${posL}Nipples` };

    // 1. SELECT RIM
        if (!buildState.components[stateKeys.rim]) {
            console.log(`%c--- Selecting Rim Pair Jointly for ${pos} ---`, 'color: #007bff; font-weight: bold;');
            
            // --- DIAGNOSTIC DEBUGGING ---
            console.log(`[Ghost User] Applying Rim Depth Filters -> Front: ${frontMin}-${frontMax}mm | Rear: ${rearMin}-${rearMax}mm`);

            const rimProducts = allRimProductsCache.filter(p => {
                if (p.vendor === 'Your Own Component' || (p.tags && p.tags.includes('type:integrated_wheel'))) return false;
                const wheelModelStr = (p.wheelModel || '').toLowerCase().trim();
                const isCarbon = wheelModelStr.includes('carbon');
                const isAluminum = wheelModelStr.includes('aluminum') || wheelModelStr.includes('alloy') || wheelModelStr.includes('alum');
                if (material === 'Carbon' && !isCarbon) return false;
                if (material === 'Aluminum' && !isAluminum) return false;
                return true;
            });

            const validFronts = [];
            const validRears = [];

        rimProducts.forEach(p => {
            p.variants.forEach(v => {
                if (!v.availableForSale) return;
                const brakeMatch = specs.brakeStyle === 'Rim Brake' 
                    ? (v.spec_brake_interface || []).includes('Rim Brake') 
                    : !(v.spec_brake_interface || []).includes('Rim Brake');
                if (!brakeMatch) return;

                const sizeVal = v.spec_rim_size?.parsedValue;
                const pDepth = p.rimDepth !== null && p.rimDepth !== undefined ? p.rimDepth : null;

                if (buildType === 'Front' || buildType === 'Wheel Set') {
                    const sizeMatch = Array.isArray(sizeVal) ? sizeVal.includes(specs.frontWheelSize) : sizeVal === specs.frontWheelSize;
                    const posMatch = v.spec_position === 'Front' || v.spec_position === "Front/Rear";
                    const spokeMatch = String(v.spec_spoke_count) === String(specs.frontSpokeCount);
                    const depthCompatible = buildState.ridingStyle === 'mtb' || (pDepth !== null && pDepth >= frontMin && pDepth <= frontMax);

                    if (sizeMatch && posMatch && spokeMatch && depthCompatible) {
                        validFronts.push({ variant: v, product: p });
                    }
                }

                if (buildType === 'Rear' || buildType === 'Wheel Set') {
                    const sizeMatch = Array.isArray(sizeVal) ? sizeVal.includes(specs.rearWheelSize) : sizeVal === specs.rearWheelSize;
                    const posMatch = v.spec_position === 'Rear' || v.spec_position === "Front/Rear";
                    const spokeMatch = String(v.spec_spoke_count) === String(specs.rearSpokeCount);
                    const depthCompatible = buildState.ridingStyle === 'mtb' || (pDepth !== null && pDepth >= rearMin && pDepth <= rearMax);

                    if (sizeMatch && posMatch && spokeMatch && depthCompatible) {
                        validRears.push({ variant: v, product: p });
                    }
                }
            });
        });

        let selectedFrontRim = null;
        let selectedRearRim = null;

        if (buildType === 'Wheel Set') {
            const validPairs = [];
            validFronts.forEach(f => {
                validRears.forEach(r => {
                    const sameVendor = f.product.vendor === r.product.vendor;
                    if (!sameVendor) return;

                    const fpKey = f.product.pairingKey;
                    const rpKey = r.product.pairingKey;
                    const pairingKeysClash = fpKey && rpKey && fpKey !== rpKey;

                    if (!pairingKeysClash) {
                        validPairs.push({ front: f, rear: r });
                    }
                });
            });

            // FALLBACK: If no pairing-key matched pairs exist, bypass the pairing-key constraint
            // and pair purely by vendor so the build succeeds.
            if (validPairs.length === 0) {
                console.log(`[Quick Build] No pairing-key matches found. Reverting to same-vendor matching.`);
                validFronts.forEach(f => {
                    validRears.forEach(r => {
                        const sameVendor = f.product.vendor === r.product.vendor;
                        if (sameVendor) {
                            validPairs.push({ front: f, rear: r });
                        }
                    });
                });
            }

            if (validPairs.length > 0) {
                const sameDepthRange = (frontMin === rearMin && frontMax === rearMax);

                validPairs.sort((a, b) => {
                    // Priority 1: Aero Stagger Preference
                    if (sameDepthRange && buildState.ridingStyle !== 'mtb') {
                        const depthAF = a.front.product.rimDepth || 0;
                        const depthAR = a.rear.product.rimDepth || 0;
                        const depthBF = b.front.product.rimDepth || 0;
                        const depthBR = b.rear.product.rimDepth || 0;

                        const staggerA = depthAR > depthAF;
                        const staggerB = depthBR > depthBF;

                        if (staggerA && !staggerB) return -1;
                        if (!staggerA && staggerB) return 1;

                        if (staggerA && staggerB) {
                            const gapA = depthAR - depthAF;
                            const gapB = depthBR - depthBF;
                            const idealGapA = gapA >= 3 && gapA <= 15;
                            const idealGapB = gapB >= 3 && gapB <= 15;
                            
                            if (idealGapA && !idealGapB) return -1;
                            if (!idealGapA && idealGapB) return 1;
                        }
                    }

                    // Priority 2: Goal sorting
                    const priceA = getPrice(a.front.variant) + getPrice(a.rear.variant);
                    const priceB = getPrice(b.front.variant) + getPrice(b.rear.variant);
                    const weightA = getWeight(a.front.variant, a.front.product) + getWeight(a.rear.variant, a.rear.product);
                    const weightB = getWeight(b.front.variant, b.front.product) + getWeight(b.rear.variant, b.rear.product);

                    if (goal === 'Best Value') return priceA - priceB;
                    if (goal === 'Max Durability') return weightB - weightA;
                    return weightA - weightB;
                });

                selectedFrontRim = validPairs[0].front;
                selectedRearRim = validPairs[0].rear;
            }
        } else if (buildType === 'Front') {
            if (validFronts.length > 0) {
                validFronts.sort((a, b) => {
                    if (goal === 'Best Value') return getPrice(a.variant) - getPrice(b.variant);
                    if (goal === 'Max Durability') return getWeight(b.variant, b.product) - getWeight(a.variant, a.product);
                    return getWeight(a.variant, a.product) - getWeight(b.variant, b.product);
                });
                selectedFrontRim = validFronts[0];
            }
        } else if (buildType === 'Rear') {
            if (validRears.length > 0) {
                validRears.sort((a, b) => {
                    if (goal === 'Best Value') return getPrice(a.variant) - getPrice(b.variant);
                    if (goal === 'Max Durability') return getWeight(b.variant, b.product) - getWeight(a.variant, a.product);
                    return getWeight(a.variant, a.product) - getWeight(b.variant, b.product);
                });
                selectedRearRim = validRears[0];
            }
        }

        if (selectedFrontRim) {
            buildState.components.frontRim = {
                variantId: selectedFrontRim.variant.id, productId: selectedFrontRim.product.id, productHandle: selectedFrontRim.product.handle, title: selectedFrontRim.product.title, 
                variantTitle: selectedFrontRim.variant.title, sku: selectedFrontRim.variant.sku, price: selectedFrontRim.variant.price.amount, vendor: selectedFrontRim.product.vendor, 
                image: selectedFrontRim.variant.image, pairingKey: selectedFrontRim.product.pairingKey, rimDepth: selectedFrontRim.product.rimDepth, 
                weight_g: getWeight(selectedFrontRim.variant, selectedFrontRim.product), tags: selectedFrontRim.product.tags || [], selectedOptions: selectedFrontRim.variant.selectedOptions,
                optionalAddonProductGids: selectedFrontRim.product.optionalAddonProductGidsFromProduct || [],
                quantityAvailable: selectedFrontRim.variant.quantityAvailable, leadTimeDays: selectedFrontRim.product.leadTimeDays || 0, wheelModel: selectedFrontRim.product.wheelModel
            };
            console.log(`✅ Selected Front Rim: ${selectedFrontRim.product.title}`);
        }

        if (selectedRearRim) {
            buildState.components.rearRim = {
                variantId: selectedRearRim.variant.id, productId: selectedRearRim.product.id, productHandle: selectedRearRim.product.handle, title: selectedRearRim.product.title, 
                variantTitle: selectedRearRim.variant.title, sku: selectedRearRim.variant.sku, price: selectedRearRim.variant.price.amount, vendor: selectedRearRim.product.vendor, 
                image: selectedRearRim.variant.image, pairingKey: selectedRearRim.product.pairingKey, rimDepth: selectedRearRim.product.rimDepth, 
                weight_g: getWeight(selectedRearRim.variant, selectedRearRim.product), tags: selectedRearRim.product.tags || [], selectedOptions: selectedRearRim.variant.selectedOptions,
                optionalAddonProductGids: selectedRearRim.product.optionalAddonProductGidsFromProduct || [],
                quantityAvailable: selectedRearRim.variant.quantityAvailable, leadTimeDays: selectedRearRim.product.leadTimeDays || 0, wheelModel: selectedRearRim.product.wheelModel
            };
            console.log(`✅ Selected Rear Rim: ${selectedRearRim.product.title}`);
        }
    }

        // 2. SELECT HUB
        console.log(`%c--- Selecting ${pos} Hub ---`, 'color: #fd7e14; font-weight: bold;');
        const getHubCandidates = (enforcePriceBounds) => {
            let cands = [];
            allHubProductsCache.forEach(p => {
                if (p.vendor === 'Your Own Component') return;
                if (pos === 'Rear' && (!p.availableFreehubs || !p.availableFreehubs.includes(specs.freehubType))) return;
                if (pos === 'Front' && !hasMatchingRear(p, allHubProductsCache, true, enforcePriceBounds)) return; 

                const isHookFlange = p.tags && p.tags.includes('hub_type:hook_flange');
                if (goal !== 'Ultra-Light' && isHookFlange) return;

                p.variants.forEach(v => {
                    if (enforcePriceBounds && goal === 'Max Durability') {
                        const fPrice = getPrice(v) / 100;
                        if (fPrice < 150 || fPrice > 450) return; 
                    }

                    const posMatch = v.spec_position === pos || v.spec_position === "Front/Rear";
                    const brakeMatch = (v.spec_brake_interface || []).includes(specs.brakeStyle);
                    const spacingMatch = normalizeSpacing(v.spec_hub_spacing) === normalizeSpacing(specs[`${posL}HubSpacing`]);
                    const spokeMatch = String(v.spec_spoke_count) === String(specs[`${posL}SpokeCount`]);

                    if (v.availableForSale && posMatch && brakeMatch && spacingMatch && spokeMatch) {
                        cands.push({ variant: v, product: p });
                    }
                });
            });
            return cands;
        };

        let hubCandidates = getHubCandidates(true);
        
        if (pos === 'Rear') {
            let symCands = enforceSymmetry(hubCandidates, 'frontHub');
            if (symCands.length === 0 && goal === 'Max Durability') {
                console.log(`[Alert] Price filter eliminated the matching Rear Hub. Relaxing price constraints.`);
                hubCandidates = getHubCandidates(false);
                symCands = enforceSymmetry(hubCandidates, 'frontHub'); 
            }
            hubCandidates = symCands;
            console.log(`[Symmetry Check] Valid matching ${pos} Hubs found:`, hubCandidates.length);
        } else if (hubCandidates.length === 0 && goal === 'Max Durability') {
            console.log(`[Alert] No valid $150-$450 Front Hubs found. Relaxing price constraints.`);
            hubCandidates = getHubCandidates(false);
        }

        if (hubCandidates.length > 0) {
            hubCandidates.sort((a, b) => {
                if (goal === 'Best Value') return getPrice(a.variant) - getPrice(b.variant);
                if (goal === 'Max Durability') return getWeight(b.variant, b.product) - getWeight(a.variant, a.product);
                return getWeight(a.variant, a.product) - getWeight(b.variant, b.product);
            });
            
            const bestHub = hubCandidates[0];
            buildState.components[stateKeys.hub] = {
                variantId: bestHub.variant.id, productId: bestHub.product.id, productHandle: bestHub.product.handle, title: bestHub.product.title, 
                variantTitle: bestHub.variant.title, sku: bestHub.variant.sku, price: bestHub.variant.price.amount, vendor: bestHub.product.vendor, 
                image: bestHub.variant.image, pairingKey: bestHub.product.pairingKey, tags: bestHub.product.tags || [], spec_freehub: pos === 'Rear' ? specs.freehubType : null, 
                weight_g: getWeight(bestHub.variant, bestHub.product), selectedOptions: bestHub.variant.selectedOptions,
                optionalAddonProductGids: bestHub.product.optionalAddonProductGidsFromProduct || [],
                quantityAvailable: bestHub.variant.quantityAvailable, leadTimeDays: bestHub.product.leadTimeDays || 0, wheelModel: bestHub.product.wheelModel,
                spec_spoke_count: String(bestHub.variant.spec_spoke_count), spec_brake_interface: bestHub.variant.spec_brake_interface, spec_hub_spacing: bestHub.variant.spec_hub_spacing
            };
            if (pos === 'Rear') setComponentFreehubForHub({ ...bestHub.variant, freehubVariantMap: bestHub.product.freehubVariantMap });
            console.log(`✅ Selected ${pos} Hub: ${bestHub.product.title} ($${getPrice(bestHub.variant)/100})`);
        }

        // 3. SELECT SPOKES
        console.log(`%c--- Selecting ${pos} Spokes ---`, 'color: #20c997; font-weight: bold;');
        const selectedHub = buildState.components[stateKeys.hub];
        const hubTags = selectedHub?.tags || [];
        
        const filterSpokes = (forceBerd) => {
            let cands = [];
            allSpokeProductsCache.forEach(p => {
                const isHookFlangeSpoke = p.spokeHubInterface === 'Hook Flange';
                const isBerd = p.vendor === 'Berd';

                if (forceBerd && !isBerd) return;
                if (!forceBerd && isBerd) return;

                if (hubTags.includes('hub_type:hook_flange') && (p.spokeHubInterface === 'J-Bend' || p.spokeHubInterface === 'Straight Pull')) return;
                if (isHookFlangeSpoke && !hubTags.includes('hub_type:hook_flange')) return;
                if (hubTags.includes('hub_type:straight_pull') && p.spokeHubInterface === 'J-Bend') return;
                if (hubTags.includes('hub_type:j_bend') && p.spokeHubInterface === 'Straight Pull') return;

                p.variants.forEach(v => {
                    if (v.availableForSale && v.selectedOptions.some(opt => opt.name === 'Length' && opt.value === '-')) {
                        cands.push({ variant: v, product: p });
                    }
                });
            });
            return cands;
        };

        let spokeCandidates = filterSpokes(goal === 'Ultra-Light');
        if (spokeCandidates.length === 0 && goal === 'Ultra-Light') {
            console.log(`[Alert] No Berd spokes available for ${pos} Hub. Falling back to steel.`);
            spokeCandidates = filterSpokes(false);
        }
        
        if (pos === 'Rear') spokeCandidates = enforceSymmetry(spokeCandidates, 'frontSpokes');

        if (spokeCandidates.length > 0) {
            spokeCandidates.sort((a, b) => {
                if (goal === 'Max Durability') return getCrossSection(b.product) - getCrossSection(a.product); 
                if (goal === 'Best Value') return getPrice(a.variant) - getPrice(b.variant);
                return getWeight(a.variant, a.product) - getWeight(b.variant, b.product); 
            });
            const bestSpoke = spokeCandidates[0];
            buildState.components[stateKeys.spokes] = {
                variantId: bestSpoke.variant.id, productId: bestSpoke.product.id, productHandle: bestSpoke.product.handle, title: bestSpoke.product.title, 
                variantTitle: bestSpoke.variant.title, sku: bestSpoke.variant.sku, price: bestSpoke.variant.price.amount, vendor: bestSpoke.product.vendor, 
                image: bestSpoke.variant.image, pairingKey: bestSpoke.product.pairingKey, selectedColor: bestSpoke.variant.selectedOptions.find(o => o.name === 'Color')?.value, 
                weight_g: getWeight(bestSpoke.variant, bestSpoke.product), selectedOptions: bestSpoke.variant.selectedOptions,
                optionalAddonProductGids: bestSpoke.product.optionalAddonProductGidsFromProduct || [],
                quantityAvailable: bestSpoke.variant.quantityAvailable, leadTimeDays: bestSpoke.product.leadTimeDays || 0, wheelModel: bestSpoke.product.wheelModel
            };
            console.log(`✅ Selected ${pos} Spoke: ${bestSpoke.product.title}`);
        }

        // 4. SELECT NIPPLES
        let nippleCandidates = [];
        allNippleProductsCache.forEach(p => {
            p.variants.forEach(v => { if (v.availableForSale) nippleCandidates.push({ variant: v, product: p }); });
        });

        if (pos === 'Rear') nippleCandidates = enforceSymmetry(nippleCandidates, 'frontNipples');

        if (nippleCandidates.length > 0) {
            nippleCandidates.sort((a, b) => {
                if (goal === 'Max Durability') return getWeight(b.variant, b.product) - getWeight(a.variant, a.product); 
                if (goal === 'Best Value') return getPrice(a.variant) - getPrice(b.variant);
                return getWeight(a.variant, a.product) - getWeight(b.variant, b.product); 
            });
            const bestNipple = nippleCandidates[0];
            buildState.components[stateKeys.nipples] = {
                variantId: bestNipple.variant.id, productId: bestNipple.product.id, productHandle: bestNipple.product.handle, title: bestNipple.product.title, 
                variantTitle: bestNipple.variant.title, sku: bestNipple.variant.sku, price: bestNipple.variant.price.amount, vendor: bestNipple.product.vendor, 
                image: bestNipple.variant.image, pairingKey: bestNipple.product.pairingKey, weight_g: getWeight(bestNipple.variant, bestNipple.product), 
                selectedOptions: bestNipple.variant.selectedOptions, optionalAddonProductGids: bestNipple.product.optionalAddonProductGidsFromProduct || [],
                quantityAvailable: bestNipple.variant.quantityAvailable, leadTimeDays: bestNipple.product.leadTimeDays || 0, wheelModel: bestNipple.product.wheelModel
            };
        }

        calculateWheelCosts(pos);
    } 

    // --- Flag this build as having been quick-generated ---
    buildState.quickBuildGenerated = true;

    // --- REFRESH UI ---
    buildState._ui.hasChanges = true;

    console.groupEnd();

    buildState._ui.hasChanges = true;
    updateSubtotal();
    updateBuildSummary();
    validateStep3();
    
    await showStep(3, { isRefreshing: true });
    
    // Explicitly call Lead Time calculation since we just injected new items
    handleComponentChangeForLeadTime();
    updateHubSpokeCompatibilityUI();
    saveLastActiveBuild();

    if (overlay) overlay.style.display = 'none';
}
// --- END: 18.3 Ghost User Engine ---

    // --- 18.3 Quick Build UI Listeners ---
    // FORCE-ASSIGN to the global variable (No 'const' or 'let' keyword here)
    updateQuickBuildAvailability = () => {
        const { specs, buildType } = buildState;
        if (!buildType) return;

        console.groupCollapsed(`%c[Quick Build UI Sync] Re-evaluating Matrix...`, 'color: #007bff; font-weight: bold; font-size: 1.1em;');
        console.log(`Current Specs: F_Spoke=${specs.frontSpokeCount}, R_Spoke=${specs.rearSpokeCount}, Brake=${specs.brakeStyle}, Size=${specs.frontWheelSize}`);

        // 1. Helper: Check if valid matching Hub Pairs exist
        const hasValidHubs = () => {
            if (buildType !== 'Wheel Set') {
                const pos = buildType === 'Front' ? 'Front' : 'Rear';
                const posL = pos.toLowerCase();
                const singleHubExist = allHubProductsCache.some(p => {
                    if (p.vendor === 'Your Own Component') return false;
                    if (pos === 'Rear' && (!p.availableFreehubs || !p.availableFreehubs.includes(specs.freehubType))) return false;
                    return p.variants.some(v => v.availableForSale && (v.spec_position === pos || v.spec_position === "Front/Rear") && (v.spec_brake_interface || []).includes(specs.brakeStyle) && normalizeSpacing(v.spec_hub_spacing) === normalizeSpacing(specs[`${posL}HubSpacing`]) && String(v.spec_spoke_count) === String(specs[`${posL}SpokeCount`]));
                });
                console.log(`[Hub Sync] Single Wheel Hub Exist:`, singleHubExist);
                return singleHubExist;
            }
            
            const frontKeys = new Set();
            const rearKeys = new Set();
            
            allHubProductsCache.forEach(p => {
                if (p.vendor === 'Your Own Component' || !p.pairingKey) return;
                p.variants.forEach(v => {
                    if (!v.availableForSale) return;
                    const brakeMatch = (v.spec_brake_interface || []).includes(specs.brakeStyle);
                    if (!brakeMatch) return;

                    if (v.spec_position === 'Front' || v.spec_position === 'Front/Rear') {
                        if (normalizeSpacing(v.spec_hub_spacing) === normalizeSpacing(specs.frontHubSpacing) && String(v.spec_spoke_count) === String(specs.frontSpokeCount)) frontKeys.add(p.pairingKey);
                    }
                    if (v.spec_position === 'Rear' || v.spec_position === 'Front/Rear') {
                        if (normalizeSpacing(v.spec_hub_spacing) === normalizeSpacing(specs.rearHubSpacing) && String(v.spec_spoke_count) === String(specs.rearSpokeCount) && (!p.availableFreehubs || p.availableFreehubs.includes(specs.freehubType))) rearKeys.add(p.pairingKey);
                    }
                });
            });
            
            let matchedPair = false;
            for (let key of frontKeys) { if (rearKeys.has(key)) matchedPair = true; }
            console.log(`[Hub Sync] Symmetrical Hub Pairs Available:`, matchedPair, `(Front Keys: ${frontKeys.size}, Rear Keys: ${rearKeys.size})`);
            return matchedPair;
        };

        // 2. Helper: Check if valid matching Rim Pairs exist for a Material/Depth
    const hasValidRims = (checkMaterial, customFrontMin = null, customFrontMax = null, customRearMin = null, customRearMax = null) => {
        const specs = buildState.specs;
        const buildType = buildState.buildType;
        const isMtb = buildState.ridingStyle === 'mtb';

        // Dynamically query active DOM elements if internal JS state is uninitialized
        const frontActiveBtn = document.getElementById('qb-front-depth-options')?.querySelector('.qb-toggle-btn.active');
    const rearActiveBtn = document.getElementById('qb-rear-depth-options')?.querySelector('.qb-toggle-btn.active');

    // Helper to verify a strict, valid number
    const isNum = (val) => typeof val === 'number' && !isNaN(val);

    const fMin = customFrontMin !== null ? customFrontMin : (isNum(buildState._ui.qbFrontDepthMin) ? buildState._ui.qbFrontDepthMin : (frontActiveBtn ? parseInt(frontActiveBtn.dataset.min) : 0));
    const fMax = customFrontMax !== null ? customFrontMax : (isNum(buildState._ui.qbFrontDepthMax) ? buildState._ui.qbFrontDepthMax : (frontActiveBtn ? parseInt(frontActiveBtn.dataset.max) : 35));
    const rMin = customRearMin !== null ? customRearMin : (isNum(buildState._ui.qbRearDepthMin) ? buildState._ui.qbRearDepthMin : (rearActiveBtn ? parseInt(rearActiveBtn.dataset.min) : 0));
    const rMax = customRearMax !== null ? customRearMax : (isNum(buildState._ui.qbRearDepthMax) ? buildState._ui.qbRearDepthMax : (rearActiveBtn ? parseInt(rearActiveBtn.dataset.max) : 35));

        // Initial filter by material to keep loop performance high
        const candidateProducts = allRimProductsCache.filter(p => {
        if (p.vendor === 'Your Own Component' || (p.tags && p.tags.includes('type:integrated_wheel'))) return false;
        const wheelModelStr = (p.wheelModel || '').toLowerCase().trim();
        const isCarbon = wheelModelStr.includes('carbon');
        const isAluminum = wheelModelStr.includes('aluminum') || wheelModelStr.includes('alloy') || wheelModelStr.includes('alum');
        if (checkMaterial === 'Carbon' && !isCarbon) return false;
        if (checkMaterial === 'Aluminum' && !isAluminum) return false;
        return true;
    });

    const validFrontVariants = [];
    const validRearVariants = [];

    candidateProducts.forEach(p => {
        p.variants.forEach(v => {
            if (!v.availableForSale) return;
            
            // Check brake interfaces
            const brakeMatch = specs.brakeStyle === 'Rim Brake' 
                ? (v.spec_brake_interface || []).includes('Rim Brake') 
                : !(v.spec_brake_interface || []).includes('Rim Brake');
            if (!brakeMatch) return;

            const sizeVal = v.spec_rim_size?.parsedValue;
            
            // Explicitly preserve null depth so it doesn't default to 0
            const pDepth = p.rimDepth !== null && p.rimDepth !== undefined ? p.rimDepth : null;
            const isMtb = buildState.ridingStyle === 'mtb';

            // Map valid Front configurations
            if (buildType === 'Front' || buildType === 'Wheel Set') {
                const sizeMatchFront = Array.isArray(sizeVal) ? sizeVal.includes(specs.frontWheelSize) : sizeVal === specs.frontWheelSize;
                const posMatchFront = v.spec_position === 'Front' || v.spec_position === 'Front/Rear';
                const spokeMatchFront = String(v.spec_spoke_count) === String(specs.frontSpokeCount);
                const depthCompatibleFront = isMtb || (pDepth !== null && pDepth >= fMin && pDepth <= fMax);

                if (sizeMatchFront && posMatchFront && spokeMatchFront && depthCompatibleFront) {
                    validFrontVariants.push({ variant: v, product: p });
                }
            }

            // Map valid Rear configurations
            if (buildType === 'Rear' || buildType === 'Wheel Set') {
                const sizeMatchRear = Array.isArray(sizeVal) ? sizeVal.includes(specs.rearWheelSize) : sizeVal === specs.rearWheelSize;
                const posMatchRear = v.spec_position === 'Rear' || v.spec_position === 'Front/Rear';
                const spokeMatchRear = String(v.spec_spoke_count) === String(specs.rearSpokeCount);
                const depthCompatibleRear = isMtb || (pDepth !== null && pDepth >= rMin && pDepth <= rMax);

                if (sizeMatchRear && posMatchRear && spokeMatchRear && depthCompatibleRear) {
                    validRearVariants.push({ variant: v, product: p });
                }
            }
        });
    });

    if (buildType === 'Front') return validFrontVariants.length > 0;
    if (buildType === 'Rear') return validRearVariants.length > 0;

    // For Wheel Sets, evaluate co-dependent pairs sharing the same vendor
    return validFrontVariants.some(front => {
        return validRearVariants.some(rear => {
            const sameVendor = front.product.vendor === rear.product.vendor;
            if (!sameVendor) return false;

            const fpKey = front.product.pairingKey;
            const rpKey = rear.product.pairingKey;
            const pairingKeysClash = fpKey && rpKey && fpKey !== rpKey;
            
            return !pairingKeysClash;
        });
    });
};

const hubsExist = hasValidHubs();

// 3. Update Material Buttons
const matButtons = document.getElementById('qb-material-options').querySelectorAll('.qb-toggle-btn');
let currentMaterial = buildState._ui.qbMaterial || 'Aluminum';
let activeMatBtn = Array.from(matButtons).find(btn => btn.classList.contains('active'));

matButtons.forEach(btn => {
    const mat = btn.dataset.val;
    const isPossible = hubsExist && hasValidRims(mat);
    
    btn.classList.toggle('is-unavailable', !isPossible);
    btn.disabled = !isPossible;

    if (!isPossible && btn.classList.contains('active')) {
        btn.classList.remove('active');
        activeMatBtn = null;
    }
});

if (!activeMatBtn) {
    const firstPossibleMat = Array.from(matButtons).find(b => !b.disabled);
    if (firstPossibleMat) {
        firstPossibleMat.classList.add('active');
        currentMaterial = firstPossibleMat.dataset.val;
        buildState._ui.qbMaterial = currentMaterial;
    } else {
        currentMaterial = '';
        buildState._ui.qbMaterial = null;
    }
}

// 4. Update Independent Front and Rear Depth Buttons
const frontDepthRow = document.getElementById('qb-front-depth-row');
if (frontDepthRow && (buildType === 'Front' || buildType === 'Wheel Set') && buildState.ridingStyle !== 'mtb') {
    frontDepthRow.style.display = 'flex';
    const frontDepthButtons = document.getElementById('qb-front-depth-options').querySelectorAll('.qb-toggle-btn');
    let activeFrontBtn = Array.from(frontDepthButtons).find(b => b.classList.contains('active'));

    frontDepthButtons.forEach(btn => {
        const min = parseInt(btn.dataset.min);
        const max = parseInt(btn.dataset.max);
        
        // Evaluate front option while preserving the current rear depth state
        const isPossible = hubsExist && hasValidRims(currentMaterial, min, max, null, null);
        
        btn.classList.toggle('is-unavailable', !isPossible);
        btn.disabled = !isPossible;

        if (!isPossible && btn.classList.contains('active')) {
            btn.classList.remove('active');
            activeFrontBtn = null;
        }
    });

    if (!activeFrontBtn && currentMaterial) {
        const firstPossibleDepth = Array.from(frontDepthButtons).find(b => !b.disabled);
        if (firstPossibleDepth) {
            firstPossibleDepth.classList.add('active');
            buildState._ui.qbFrontDepthMin = parseInt(firstPossibleDepth.dataset.min);
            buildState._ui.qbFrontDepthMax = parseInt(firstPossibleDepth.dataset.max);
        }
    }
} else if (frontDepthRow) {
    frontDepthRow.style.display = 'none';
}

const rearDepthRow = document.getElementById('qb-rear-depth-row');
if (rearDepthRow && (buildType === 'Rear' || buildType === 'Wheel Set') && buildState.ridingStyle !== 'mtb') {
    rearDepthRow.style.display = 'flex';
    const rearDepthButtons = document.getElementById('qb-rear-depth-options').querySelectorAll('.qb-toggle-btn');
    let activeRearBtn = Array.from(rearDepthButtons).find(b => b.classList.contains('active'));

    rearDepthButtons.forEach(btn => {
        const min = parseInt(btn.dataset.min);
        const max = parseInt(btn.dataset.max);
        
        // Evaluate rear option while preserving the current front depth state
        const isPossible = hubsExist && hasValidRims(currentMaterial, null, null, min, max);
        
        btn.classList.toggle('is-unavailable', !isPossible);
        btn.disabled = !isPossible;

        if (!isPossible && btn.classList.contains('active')) {
            btn.classList.remove('active');
            activeRearBtn = null;
        }
    });

    if (!activeRearBtn && currentMaterial) {
        const firstPossibleDepth = Array.from(rearDepthButtons).find(b => !b.disabled);
        if (firstPossibleDepth) {
            firstPossibleDepth.classList.add('active');
            buildState._ui.qbRearDepthMin = parseInt(firstPossibleDepth.dataset.min);
            buildState._ui.qbRearDepthMax = parseInt(firstPossibleDepth.dataset.max);
        }
    }
} else if (rearDepthRow) {
    rearDepthRow.style.display = 'none';
}

// 5. Evaluate overall generation viability using current matrix choices
const genBtn = document.getElementById('qb-generate-btn');
const warningBox = document.getElementById('qb-no-match-warning');
const troubleshootElement = document.getElementById('qb-dynamic-troubleshoot');

const isBuildPossible = hubsExist && hasValidRims(currentMaterial);
        
        console.log(`[Diagnostic Summary] Is Complete Symmetrical Build Possible? ${isBuildPossible}`);
        console.groupEnd(); // Close Console Group

        const goalButtons = document.getElementById('qb-goal-options').querySelectorAll('.qb-toggle-btn');
        let activeGoalBtn = Array.from(goalButtons).find(b => b.classList.contains('active'));

        goalButtons.forEach(btn => {
            btn.classList.toggle('is-unavailable', !isBuildPossible);
            btn.disabled = !isBuildPossible;

            if (!isBuildPossible && btn.classList.contains('active')) {
                btn.classList.remove('active');
                activeGoalBtn = null;
            }
        });

        // GOAL RECOVERY: If build is possible but no goal is active, auto-select first possible option
        if (isBuildPossible && !activeGoalBtn) {
            const firstPossibleGoal = Array.from(goalButtons).find(b => !b.disabled);
            if (firstPossibleGoal) {
                firstPossibleGoal.classList.add('active');
                buildState._ui.qbGoal = firstPossibleGoal.dataset.val;
            }
        }

        // Toggle the specs advisory box
        if (warningBox) {
            if (isBuildPossible) {
                warningBox.style.display = 'none';
            } else {
                warningBox.style.display = 'block';
                
                if (troubleshootElement) {
                    const fSpoke = parseInt(specs.frontSpokeCount) || 0;
                    const rSpoke = parseInt(specs.rearSpokeCount) || 0;
                    const spokeDiff = Math.abs(fSpoke - rSpoke);

                    let advisoryHtml = '';
                    
                    if (fSpoke > rSpoke) {
                        advisoryHtml = `<strong>Odd Spec Detected:</strong> You have selected a higher spoke count for your Front wheel (<strong>${fSpoke}h</strong>) than your Rear wheel (<strong>${rSpoke}h</strong>). In custom wheel building, rear wheels almost always require equal or more spokes than fronts to support driving torque. Aligning these will unlock the generator.`;
                    } else if (spokeDiff >= 8) {
                        advisoryHtml = `<strong>Specs Multiple Steps Apart:</strong> Your Front and Rear spoke counts (<strong>${fSpoke}h Front / ${rSpoke}h Rear</strong>) are multiple steps apart. Bringing them closer together (e.g., pairing 24h/28h or 28h/32h) will instantly make matching symmetrical pairs available in our catalog.`;
                    } else {
                        advisoryHtml = `<strong>Want to use the Generator?</strong> Bringing your specifications into symmetry (such as choosing the same spoke count for both front and rear) will immediately unlock our automated building options.`;
                    }
                    
                    troubleshootElement.innerHTML = advisoryHtml;
                }
            }
        }

        // Disable and gray-out the Generate button
        if (genBtn) {
            genBtn.classList.toggle('is-disabled', !isBuildPossible);
            genBtn.disabled = !isBuildPossible;
            if (!isBuildPossible) {
                genBtn.textContent = 'No Components Match Specs';
            } else {
                genBtn.innerHTML = '⚡ Generate Build';
            }
        }
    };

    // --- 18.3 UI Variable Declarations ---
    const qbWrapper = document.getElementById('qb-dropdown-wrapper');
    const qbToggle = document.getElementById('qb-dropdown-toggle');
    const qbMatrix = document.querySelector('.quick-build-matrix');
    
    // 1. Dropdown Toggle Logic
    if (qbToggle && qbWrapper) {
        qbToggle.addEventListener('click', (e) => {
            e.stopPropagation(); 
            qbWrapper.classList.toggle('is-open');
            qbToggle.classList.remove('is-pulsing');
            // Re-evaluate what is available every time they open it
            if (qbWrapper.classList.contains('is-open')) updateQuickBuildAvailability();
        });

        document.addEventListener('click', (e) => {
            if (qbWrapper.classList.contains('is-open') && !qbWrapper.contains(e.target)) {
                qbWrapper.classList.remove('is-open');
            }
        });
    }

    // 2. Matrix Selection Logic
    if (qbMatrix) {
        qbMatrix.addEventListener('click', (e) => {
            const btn = e.target.closest('.qb-toggle-btn');
            if (!btn || btn.disabled) return;
            
            const type = btn.dataset.type; 
            const val = btn.dataset.val;

            if (type === 'material') {
    document.getElementById('qb-material-options').querySelectorAll('.qb-toggle-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    buildState._ui.qbMaterial = val;
    updateQuickBuildAvailability(); 
} else if (type === 'front-depth') {
    document.getElementById('qb-front-depth-options').querySelectorAll('.qb-toggle-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    buildState._ui.qbFrontDepthMin = parseInt(btn.dataset.min);
    buildState._ui.qbFrontDepthMax = parseInt(btn.dataset.max);
    updateQuickBuildAvailability();
} else if (type === 'rear-depth') {
    document.getElementById('qb-rear-depth-options').querySelectorAll('.qb-toggle-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    buildState._ui.qbRearDepthMin = parseInt(btn.dataset.min);
    buildState._ui.qbRearDepthMax = parseInt(btn.dataset.max);
    updateQuickBuildAvailability();
} else if (type === 'goal') {
    document.getElementById('qb-goal-options').querySelectorAll('.qb-toggle-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    buildState._ui.qbGoal = val;
}
        });
    }

    // 3. Generate Button
    const qbGenerateBtn = document.getElementById('qb-generate-btn');
    if (qbGenerateBtn) {
        qbGenerateBtn.addEventListener('click', async () => {
            const mat = buildState._ui.qbMaterial || 'Aluminum'; 
            const goal = buildState._ui.qbGoal || 'Best Value';  
            
            const coreKeys = ['frontRim', 'rearRim', 'frontHub', 'rearHub', 'frontSpokes', 'rearSpokes', 'frontNipples', 'rearNipples'];
            const hasSelections = coreKeys.some(key => buildState.components[key] !== null);
            
            if (hasSelections) {
                const confirmed = confirm(`You already have components selected. Generating a ${mat} ${goal} build will overwrite your current selections. Do you want to continue?`);
                if (!confirmed) return; 
            }

            if (qbWrapper) qbWrapper.classList.remove('is-open');
            qbToggle.classList.remove('is-pulsing');
            
            await generateCuratedBuild(mat, goal);
        });
    }

    // 4. Kill Pulse on Manual Component Selection
    const step3Container = document.getElementById('step-3');
    if (step3Container && qbToggle) {
        step3Container.addEventListener('click', (e) => {
            if (e.target.closest('.component-variant-button') || e.target.closest('.vendor-filter-btn')) {
                qbToggle.classList.remove('is-pulsing');
            }
        });
    }

    // --- STEP 4: Now that the page is "live", decide which build to show ---
    try {
        console.log('[Builder] Entering final loading sequence.');
        
        // --- START: CORRECTED INITIALIZATION LOGIC ---
        // PRESET-BUILDS: ?preset=...&step=3 (Add to cart from a product page) opens Step 3 with the preset loaded
        // FULL-BUILD-LINK: ?fullbuild=... (a LoamLabs preconfigured build) opens Step 3 with every part filled in; nothing is added to the cart
        const fullBuildFromUrl = window.FullBuild ? window.FullBuild.fromSearch() : null;
        if (fullBuildFromUrl) {
            history.replaceState(null, document.title, window.location.pathname);
            window.FullBuild.adopt(fullBuildFromUrl.data); updateStep1VisualFeedback(); validateStep1();
            await window.FullBuild.run();
            updateSubtotal(); updateBuildSummary(); handleComponentChangeForLeadTime();
            return;
        }
        const presetFromUrl = window.PresetBuilds ? window.PresetBuilds.fromSearch() : null;
        if (presetFromUrl) {
            history.replaceState(null, document.title, window.location.pathname);
            window.PresetBuilds.adopt(presetFromUrl.data); updateStep1VisualFeedback(); validateStep1();
            if (presetFromUrl.step3) await window.PresetBuilds.runToStep3(); else await showStep(2); // release 6: a preset's Add to cart opens Step 3, it never adds by itself
            updateSubtotal(); updateBuildSummary(); handleComponentChangeForLeadTime();
            return;
        }
        const prebuildHandled = handlePrebuildState(); 

        if (!prebuildHandled) {
            // Check for modern Database Share Links (?share=)
            const urlParams = new URLSearchParams(window.location.search);
            const databaseShareId = urlParams.get('share');
            
            // Check for legacy LZString Hash Links (#...)
            const legacyHash = window.location.hash.substring(1);

            if (databaseShareId) {
                // Modern Share System
                await loadSharedBuildFromDatabase(databaseShareId);
            } else if (legacyHash && !legacyHash.startsWith('prebuild=')) {
                // Legacy Share System Fallback
                await loadBuildFromLegacyHash(legacyHash);
            } else {
                // Check for Cart Edit mode (?buildId=) or local saved sessions
                let buildLoadedFromUrlForEdit = loadBuildFromUrlParams();
                if (buildLoadedFromUrlForEdit) {
                    await showStep(3);
                } else {
                    const promptShown = await checkForLastActiveBuildAndShowPrompt();
                    if (!promptShown) {
                        await showStep(1); // Normal fresh start.
                    }
                }
            }
        } else {
            await showStep(buildState.preset ? 2 : 1); // PRESET-BUILDS: a product page's Customize opens Step 2 with its choices filled in
        }
        
        // Final updates
        updateSubtotal();

        // FINAL RE-SYNC AFTER DATA IS CACHED
        // This ensures bubbles update from "0" to real numbers once the download finishes
        Promise.all([componentFetchPromises.rims, componentFetchPromises.hubs]).then(() => {
            console.log("[Bubbles] Data caches ready, running initial count.");
            updateSpecAvailabilityCounters();
        });

        updateBuildSummary();
        handleComponentChangeForLeadTime();
        saveLastActiveBuild();

    } catch (error) {
        console.error('%c[Builder] CRITICAL ERROR during final build loading sequence:', 'color: red; font-weight: bold;', error);
        displayInitializationError(`Error during build loading: ${error.message}`);
    }
});

// I9-SYSTEM: bridge for assets/i9-system.js. Everything in this file is block-scoped, so the System module reads
// state and caches through these getters and calls builder functions through `fns`. Nothing here changes classic behavior.
window.__loamBuilderInternals = {
    get buildState() { return buildState; },
    get config() { return config; },
    get caches() { return { rims: allRimProductsCache, hubs: allHubProductsCache, spokes: allSpokeProductsCache, nipples: allNippleProductsCache, valves: allValveStemProductsCache, freehubs: allFreehubComponentProductsCache }; },
    get componentFetchPromises() { return componentFetchPromises; },
    get vendorLogoMap() { return vendorLogoMap; },
    fns: {
        normalizeSpacing, isFreehubCompatible, formatPrice, getNumericIdFromShopifyGid, debounce,
        storefrontApiQuery, fetchBuilderComponentProducts, fetchRimProducts, fetchHubProducts, fetchSpokeProducts,
        i9ResetProductCaches, i9SetProductCaches, triggerEarlyComponentFetches,
        updateComponentUI, updateSubtotal, updateBuildSummary, validateStep3, validateStep2, validateStep1, updateSpecAndRefreshStep3,
        saveLastActiveBuild, calculateWheelCosts, updateStep3ButtonText, handleComponentChangeForLeadTime,
        clearComponentAndItsAddons, displayComponentVendorFilters, showStep, clearStep3UI,
        updateStep1VisualFeedback, renderStep2, updateStep2OptionsVisibility, updateStep2VisualFeedback,
        updateSpecAvailabilityCounters, updateFreehubLockUI, updateCustomerSuppliedCheckboxesVisibility,
        cancelComponentChange, scrollToComponentSection, setComponentFreehubForHub, updateHubSpokeCompatibilityUI,
        calculateTotalEstimatedWeight, updateMismatchHints,
        getEstimatedCrossPattern, manageStickyAddonsForChangedBaseVariant, // STANDARD-STUDIO
        proceedWithAddToCart, fetchFreehubComponentProducts, checkForPreconfiguredMatch // PRESET-BUILDS (+ FULL-BUILD-LINK: the one-click add checks the rule first)
    }
};

} // End of Execution Guard 'else' block